(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global = global || self, global.xha = factory());
}(this, (function () { 'use strict';

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function unwrapExports (x) {
		return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	}

	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}

	var _global = createCommonjsModule(function (module) {
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
	});

	var _core = createCommonjsModule(function (module) {
	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
	});
	var _core_1 = _core.version;

	var _isObject = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

	var _anObject = function (it) {
	  if (!_isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};

	var _fails = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};

	// Thank's IE8 for his funny defineProperty
	var _descriptors = !_fails(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});

	var document$1 = _global.document;
	// typeof document.createElement is 'object' in old IE
	var is = _isObject(document$1) && _isObject(document$1.createElement);
	var _domCreate = function (it) {
	  return is ? document$1.createElement(it) : {};
	};

	var _ie8DomDefine = !_descriptors && !_fails(function () {
	  return Object.defineProperty(_domCreate('div'), 'a', { get: function () { return 7; } }).a != 7;
	});

	// 7.1.1 ToPrimitive(input [, PreferredType])

	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	var _toPrimitive = function (it, S) {
	  if (!_isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};

	var dP = Object.defineProperty;

	var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  _anObject(O);
	  P = _toPrimitive(P, true);
	  _anObject(Attributes);
	  if (_ie8DomDefine) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};

	var _objectDp = {
		f: f
	};

	var _propertyDesc = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};

	var _hide = _descriptors ? function (object, key, value) {
	  return _objectDp.f(object, key, _propertyDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};

	var hasOwnProperty = {}.hasOwnProperty;
	var _has = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};

	var id = 0;
	var px = Math.random();
	var _uid = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

	var _library = false;

	var _shared = createCommonjsModule(function (module) {
	var SHARED = '__core-js_shared__';
	var store = _global[SHARED] || (_global[SHARED] = {});

	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: _core.version,
	  mode:  'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});
	});

	var _functionToString = _shared('native-function-to-string', Function.toString);

	var _redefine = createCommonjsModule(function (module) {
	var SRC = _uid('src');

	var TO_STRING = 'toString';
	var TPL = ('' + _functionToString).split(TO_STRING);

	_core.inspectSource = function (it) {
	  return _functionToString.call(it);
	};

	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) _has(val, 'name') || _hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) _has(val, SRC) || _hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === _global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    _hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    _hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || _functionToString.call(this);
	});
	});

	var _aFunction = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};

	// optional / simple context binding

	var _ctx = function (fn, that, length) {
	  _aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};

	var PROTOTYPE = 'prototype';

	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] || (_global[name] = {}) : (_global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? _ctx(out, _global) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out;
	    // extend global
	    if (target) _redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) _hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	_global.core = _core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	var _export = $export;

	var toString = {}.toString;

	var _cof = function (it) {
	  return toString.call(it).slice(8, -1);
	};

	// fallback for non-array-like ES3 and non-enumerable old V8 strings

	// eslint-disable-next-line no-prototype-builtins
	var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return _cof(it) == 'String' ? it.split('') : Object(it);
	};

	// 7.2.1 RequireObjectCoercible(argument)
	var _defined = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};

	// to indexed object, toObject with fallback for non-array-like ES3 strings


	var _toIobject = function (it) {
	  return _iobject(_defined(it));
	};

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	var _toInteger = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

	// 7.1.15 ToLength

	var min = Math.min;
	var _toLength = function (it) {
	  return it > 0 ? min(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

	var max = Math.max;
	var min$1 = Math.min;
	var _toAbsoluteIndex = function (index, length) {
	  index = _toInteger(index);
	  return index < 0 ? max(index + length, 0) : min$1(index, length);
	};

	// false -> Array#indexOf
	// true  -> Array#includes



	var _arrayIncludes = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = _toIobject($this);
	    var length = _toLength(O.length);
	    var index = _toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

	var shared = _shared('keys');

	var _sharedKey = function (key) {
	  return shared[key] || (shared[key] = _uid(key));
	};

	var arrayIndexOf = _arrayIncludes(false);
	var IE_PROTO = _sharedKey('IE_PROTO');

	var _objectKeysInternal = function (object, names) {
	  var O = _toIobject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) _has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (_has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

	// IE 8- don't enum bug keys
	var _enumBugKeys = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)

	var hiddenKeys = _enumBugKeys.concat('length', 'prototype');

	var f$1 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return _objectKeysInternal(O, hiddenKeys);
	};

	var _objectGopn = {
		f: f$1
	};

	var f$2 = Object.getOwnPropertySymbols;

	var _objectGops = {
		f: f$2
	};

	// all object keys, includes non-enumerable and symbols



	var Reflect = _global.Reflect;
	var _ownKeys = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = _objectGopn.f(_anObject(it));
	  var getSymbols = _objectGops.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};

	var f$3 = {}.propertyIsEnumerable;

	var _objectPie = {
		f: f$3
	};

	var gOPD = Object.getOwnPropertyDescriptor;

	var f$4 = _descriptors ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = _toIobject(O);
	  P = _toPrimitive(P, true);
	  if (_ie8DomDefine) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (_has(O, P)) return _propertyDesc(!_objectPie.f.call(O, P), O[P]);
	};

	var _objectGopd = {
		f: f$4
	};

	var _createProperty = function (object, index, value) {
	  if (index in object) _objectDp.f(object, index, _propertyDesc(0, value));
	  else object[index] = value;
	};

	// https://github.com/tc39/proposal-object-getownpropertydescriptors






	_export(_export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = _toIobject(object);
	    var getDesc = _objectGopd.f;
	    var keys = _ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) _createProperty(result, key, desc);
	    }
	    return result;
	  }
	});

	var _meta = createCommonjsModule(function (module) {
	var META = _uid('meta');


	var setDesc = _objectDp.f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !_fails(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!_isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!_has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!_has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !_has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};
	});
	var _meta_1 = _meta.KEY;
	var _meta_2 = _meta.NEED;
	var _meta_3 = _meta.fastKey;
	var _meta_4 = _meta.getWeak;
	var _meta_5 = _meta.onFreeze;

	var _wks = createCommonjsModule(function (module) {
	var store = _shared('wks');

	var Symbol = _global.Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';

	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid)('Symbol.' + name));
	};

	$exports.store = store;
	});

	var def = _objectDp.f;

	var TAG = _wks('toStringTag');

	var _setToStringTag = function (it, tag, stat) {
	  if (it && !_has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};

	var f$5 = _wks;

	var _wksExt = {
		f: f$5
	};

	var defineProperty = _objectDp.f;
	var _wksDefine = function (name) {
	  var $Symbol = _core.Symbol || (_core.Symbol =  _global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: _wksExt.f(name) });
	};

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)



	var _objectKeys = Object.keys || function keys(O) {
	  return _objectKeysInternal(O, _enumBugKeys);
	};

	// all enumerable object keys, includes symbols



	var _enumKeys = function (it) {
	  var result = _objectKeys(it);
	  var getSymbols = _objectGops.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = _objectPie.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};

	// 7.2.2 IsArray(argument)

	var _isArray = Array.isArray || function isArray(arg) {
	  return _cof(arg) == 'Array';
	};

	// 7.1.13 ToObject(argument)

	var _toObject = function (it) {
	  return Object(_defined(it));
	};

	var _objectDps = _descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
	  _anObject(O);
	  var keys = _objectKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) _objectDp.f(O, P = keys[i++], Properties[P]);
	  return O;
	};

	var document$2 = _global.document;
	var _html = document$2 && document$2.documentElement;

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])



	var IE_PROTO$1 = _sharedKey('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE$1 = 'prototype';

	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = _domCreate('iframe');
	  var i = _enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  _html.appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE$1][_enumBugKeys[i]];
	  return createDict();
	};

	var _objectCreate = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE$1] = _anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE$1] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO$1] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : _objectDps(result, Properties);
	};

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window

	var gOPN = _objectGopn.f;
	var toString$1 = {}.toString;

	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];

	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};

	var f$6 = function getOwnPropertyNames(it) {
	  return windowNames && toString$1.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(_toIobject(it));
	};

	var _objectGopnExt = {
		f: f$6
	};

	// ECMAScript 6 symbols shim





	var META = _meta.KEY;





















	var gOPD$1 = _objectGopd.f;
	var dP$1 = _objectDp.f;
	var gOPN$1 = _objectGopnExt.f;
	var $Symbol = _global.Symbol;
	var $JSON = _global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE$2 = 'prototype';
	var HIDDEN = _wks('_hidden');
	var TO_PRIMITIVE = _wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = _shared('symbol-registry');
	var AllSymbols = _shared('symbols');
	var OPSymbols = _shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE$2];
	var USE_NATIVE = typeof $Symbol == 'function' && !!_objectGops.f;
	var QObject = _global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE$2] || !QObject[PROTOTYPE$2].findChild;

	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = _descriptors && _fails(function () {
	  return _objectCreate(dP$1({}, 'a', {
	    get: function () { return dP$1(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD$1(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP$1(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP$1(ObjectProto, key, protoDesc);
	} : dP$1;

	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _objectCreate($Symbol[PROTOTYPE$2]);
	  sym._k = tag;
	  return sym;
	};

	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};

	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  _anObject(it);
	  key = _toPrimitive(key, true);
	  _anObject(D);
	  if (_has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!_has(it, HIDDEN)) dP$1(it, HIDDEN, _propertyDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (_has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _objectCreate(D, { enumerable: _propertyDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP$1(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  _anObject(it);
	  var keys = _enumKeys(P = _toIobject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _objectCreate(it) : $defineProperties(_objectCreate(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = _toPrimitive(key, true));
	  if (this === ObjectProto && _has(AllSymbols, key) && !_has(OPSymbols, key)) return false;
	  return E || !_has(this, key) || !_has(AllSymbols, key) || _has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = _toIobject(it);
	  key = _toPrimitive(key, true);
	  if (it === ObjectProto && _has(AllSymbols, key) && !_has(OPSymbols, key)) return;
	  var D = gOPD$1(it, key);
	  if (D && _has(AllSymbols, key) && !(_has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN$1(_toIobject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!_has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN$1(IS_OP ? OPSymbols : _toIobject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (_has(AllSymbols, key = names[i++]) && (IS_OP ? _has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};

	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = _uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (_has(this, HIDDEN) && _has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, _propertyDesc(1, value));
	    };
	    if (_descriptors && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  _redefine($Symbol[PROTOTYPE$2], 'toString', function toString() {
	    return this._k;
	  });

	  _objectGopd.f = $getOwnPropertyDescriptor;
	  _objectDp.f = $defineProperty;
	  _objectGopn.f = _objectGopnExt.f = $getOwnPropertyNames;
	  _objectPie.f = $propertyIsEnumerable;
	  _objectGops.f = $getOwnPropertySymbols;

	  if (_descriptors && !_library) {
	    _redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }

	  _wksExt.f = function (name) {
	    return wrap(_wks(name));
	  };
	}

	_export(_export.G + _export.W + _export.F * !USE_NATIVE, { Symbol: $Symbol });

	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)_wks(es6Symbols[j++]);

	for (var wellKnownSymbols = _objectKeys(_wks.store), k = 0; wellKnownSymbols.length > k;) _wksDefine(wellKnownSymbols[k++]);

	_export(_export.S + _export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return _has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});

	_export(_export.S + _export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});

	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = _fails(function () { _objectGops.f(1); });

	_export(_export.S + _export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return _objectGops.f(_toObject(it));
	  }
	});

	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && _export(_export.S + _export.F * (!USE_NATIVE || _fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!_isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!_isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});

	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE$2][TO_PRIMITIVE] || _hide($Symbol[PROTOTYPE$2], TO_PRIMITIVE, $Symbol[PROTOTYPE$2].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	_setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	_setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	_setToStringTag(_global.JSON, 'JSON', true);

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = _wks('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) _hide(ArrayProto, UNSCOPABLES, {});
	var _addToUnscopables = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};

	var _iterStep = function (done, value) {
	  return { value: value, done: !!done };
	};

	var _iterators = {};

	var IteratorPrototype = {};

	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	_hide(IteratorPrototype, _wks('iterator'), function () { return this; });

	var _iterCreate = function (Constructor, NAME, next) {
	  Constructor.prototype = _objectCreate(IteratorPrototype, { next: _propertyDesc(1, next) });
	  _setToStringTag(Constructor, NAME + ' Iterator');
	};

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)


	var IE_PROTO$2 = _sharedKey('IE_PROTO');
	var ObjectProto$1 = Object.prototype;

	var _objectGpo = Object.getPrototypeOf || function (O) {
	  O = _toObject(O);
	  if (_has(O, IE_PROTO$2)) return O[IE_PROTO$2];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto$1 : null;
	};

	var ITERATOR = _wks('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';

	var returnThis = function () { return this; };

	var _iterDefine = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  _iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = _objectGpo($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      _setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if ( typeof IteratorPrototype[ITERATOR] != 'function') _hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ( (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    _hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  _iterators[NAME] = $default;
	  _iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) _redefine(proto, key, methods[key]);
	    } else _export(_export.P + _export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	var es6_array_iterator = _iterDefine(Array, 'Array', function (iterated, kind) {
	  this._t = _toIobject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return _iterStep(1);
	  }
	  if (kind == 'keys') return _iterStep(0, index);
	  if (kind == 'values') return _iterStep(0, O[index]);
	  return _iterStep(0, [index, O[index]]);
	}, 'values');

	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	_iterators.Arguments = _iterators.Array;

	_addToUnscopables('keys');
	_addToUnscopables('values');
	_addToUnscopables('entries');

	var ITERATOR$1 = _wks('iterator');
	var TO_STRING_TAG = _wks('toStringTag');
	var ArrayValues = _iterators.Array;

	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};

	for (var collections = _objectKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = _global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR$1]) _hide(proto, ITERATOR$1, ArrayValues);
	    if (!proto[TO_STRING_TAG]) _hide(proto, TO_STRING_TAG, NAME);
	    _iterators[NAME] = ArrayValues;
	    if (explicit) for (key in es6_array_iterator) if (!proto[key]) _redefine(proto, key, es6_array_iterator[key], true);
	  }
	}

	// getting tag from 19.1.3.6 Object.prototype.toString()

	var TAG$1 = _wks('toStringTag');
	// ES3 wrong here
	var ARG = _cof(function () { return arguments; }()) == 'Arguments';

	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};

	var _classof = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG$1)) == 'string' ? T
	    // builtinTag case
	    : ARG ? _cof(O)
	    // ES3 arguments fallback
	    : (B = _cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

	// 19.1.3.6 Object.prototype.toString()

	var test = {};
	test[_wks('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  _redefine(Object.prototype, 'toString', function toString() {
	    return '[object ' + _classof(this) + ']';
	  }, true);
	}

	// most Object methods by ES6 should accept primitives



	var _objectSap = function (KEY, exec) {
	  var fn = (_core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  _export(_export.S + _export.F * _fails(function () { fn(1); }), 'Object', exp);
	};

	// 19.1.2.14 Object.keys(O)



	_objectSap('keys', function () {
	  return function keys(it) {
	    return _objectKeys(_toObject(it));
	  };
	});

	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }

	  return obj;
	}

	var defineProperty$1 = _defineProperty;

	var SPECIES = _wks('species');

	var _arraySpeciesConstructor = function (original) {
	  var C;
	  if (_isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || _isArray(C.prototype))) C = undefined;
	    if (_isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)


	var _arraySpeciesCreate = function (original, length) {
	  return new (_arraySpeciesConstructor(original))(length);
	};

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex





	var _arrayMethods = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || _arraySpeciesCreate;
	  return function ($this, callbackfn, that) {
	    var O = _toObject($this);
	    var self = _iobject(O);
	    var f = _ctx(callbackfn, that, 3);
	    var length = _toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};

	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)

	var $find = _arrayMethods(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	_export(_export.P + _export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	_addToUnscopables(KEY);

	var dP$2 = _objectDp.f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME$1 = 'name';

	// 19.2.4.2 name
	NAME$1 in FProto || _descriptors && dP$2(FProto, NAME$1, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});

	// https://github.com/tc39/Array.prototype.includes

	var $includes = _arrayIncludes(true);

	_export(_export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

	_addToUnscopables('includes');

	// 7.2.8 IsRegExp(argument)


	var MATCH = _wks('match');
	var _isRegexp = function (it) {
	  var isRegExp;
	  return _isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : _cof(it) == 'RegExp');
	};

	// helper for String#{startsWith, endsWith, includes}



	var _stringContext = function (that, searchString, NAME) {
	  if (_isRegexp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(_defined(that));
	};

	var MATCH$1 = _wks('match');
	var _failsIsRegexp = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH$1] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};

	var INCLUDES = 'includes';

	_export(_export.P + _export.F * _failsIsRegexp(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~_stringContext(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

	// 19.1.2.1 Object.assign(target, source, ...)






	var $assign = Object.assign;

	// should work with symbols and should have deterministic property order (V8 bug)
	var _objectAssign = !$assign || _fails(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = _toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = _objectGops.f;
	  var isEnum = _objectPie.f;
	  while (aLen > index) {
	    var S = _iobject(arguments[index++]);
	    var keys = getSymbols ? _objectKeys(S).concat(getSymbols(S)) : _objectKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!_descriptors || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;

	// 19.1.3.1 Object.assign(target, source)


	_export(_export.S + _export.F, 'Object', { assign: _objectAssign });

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}

	var classCallCheck = _classCallCheck;

	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}

	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}

	var createClass = _createClass;

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */


	var check = function (O, proto) {
	  _anObject(O);
	  if (!_isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	var _setProto = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = _ctx(Function.call, _objectGopd.f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

	var setPrototypeOf = _setProto.set;
	var _inheritIfRequired = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && _isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};

	// 21.2.5.3 get RegExp.prototype.flags

	var _flags = function () {
	  var that = _anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};

	var SPECIES$1 = _wks('species');

	var _setSpecies = function (KEY) {
	  var C = _global[KEY];
	  if (_descriptors && C && !C[SPECIES$1]) _objectDp.f(C, SPECIES$1, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};

	var dP$3 = _objectDp.f;
	var gOPN$2 = _objectGopn.f;


	var $RegExp = _global.RegExp;
	var Base = $RegExp;
	var proto$1 = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;

	if (_descriptors && (!CORRECT_NEW || _fails(function () {
	  re2[_wks('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = _isRegexp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : _inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? _flags.call(p) : f)
	      , tiRE ? this : proto$1, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP$3($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN$2(Base), i$1 = 0; keys.length > i$1;) proxy(keys[i$1++]);
	  proto$1.constructor = $RegExp;
	  $RegExp.prototype = proto$1;
	  _redefine(_global, 'RegExp', $RegExp);
	}

	_setSpecies('RegExp');

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;

	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;

	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}

	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);

	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}

	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();

	/** Built-in value references. */
	var Symbol$1 = root.Symbol;

	/** Used for built-in method references. */
	var objectProto = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$1 = objectProto.hasOwnProperty;

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;

	/** Built-in value references. */
	var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : undefined;

	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty$1.call(value, symToStringTag),
	      tag = value[symToStringTag];

	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}

	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}

	/** Used for built-in method references. */
	var objectProto$1 = Object.prototype;

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString$1 = objectProto$1.toString;

	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString$1.call(value);
	}

	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';

	/** Built-in value references. */
	var symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : undefined;

	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag$1 && symToStringTag$1 in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}

	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';

	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}

	/** Used for built-in method references. */
	var objectProto$2 = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

	/** Built-in value references. */
	var propertyIsEnumerable = objectProto$2.propertyIsEnumerable;

	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty$2.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}

	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Built-in value references. */
	var Buffer$1 = moduleExports ? root.Buffer : undefined;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer$1 ? Buffer$1.isBuffer : undefined;

	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;

	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;

	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;

	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER$1 = 9007199254740991;

	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
	}

	/** `Object#toString` result references. */
	var argsTag$1 = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';

	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';

	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;

	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}

	/** Detect free variable `exports`. */
	var freeExports$1 = typeof exports == 'object' && exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule$1 = freeExports$1 && typeof module == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;

	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports$1 && freeGlobal.process;

	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule$1 && freeModule$1.require && freeModule$1.require('util').types;

	    if (types) {
	      return types;
	    }

	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());

	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

	/** Used for built-in method references. */
	var objectProto$3 = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$3 = objectProto$3.hasOwnProperty;

	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;

	  for (var key in value) {
	    if ((inherited || hasOwnProperty$3.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}

	/** Used for built-in method references. */
	var objectProto$4 = Object.prototype;

	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$4;

	  return value === proto;
	}

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);

	/** Used for built-in method references. */
	var objectProto$5 = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$4 = objectProto$5.hasOwnProperty;

	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty$4.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}

	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag$1 = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';

	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
	}

	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}

	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys$1(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}

	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys$1);
	}

	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);

	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}

	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}

	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}

	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, castFunction(iteratee));
	}

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];

	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}

	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}

	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}

	/** Used for built-in method references. */
	var arrayProto = Array.prototype;

	/** Built-in value references. */
	var splice = arrayProto.splice;

	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}

	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  return index < 0 ? undefined : data[index][1];
	}

	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}

	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}

	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;

	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);

	  this.size = data.size;
	  return result;
	}

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}

	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];

	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());

	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}

	/** Used for built-in method references. */
	var funcProto = Function.prototype;

	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;

	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}

	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;

	/** Used for built-in method references. */
	var funcProto$1 = Function.prototype,
	    objectProto$6 = Object.prototype;

	/** Used to resolve the decompiled source of functions. */
	var funcToString$1 = funcProto$1.toString;

	/** Used to check objects for own properties. */
	var hasOwnProperty$5 = objectProto$6.hasOwnProperty;

	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString$1.call(hasOwnProperty$5).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);

	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}

	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}

	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');

	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');

	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';

	/** Used for built-in method references. */
	var objectProto$7 = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$6 = objectProto$7.hasOwnProperty;

	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty$6.call(data, key) ? data[key] : undefined;
	}

	/** Used for built-in method references. */
	var objectProto$8 = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$7 = objectProto$8.hasOwnProperty;

	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty$7.call(data, key);
	}

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
	  return this;
	}

	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;

	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}

	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}

	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}

	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}

	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}

	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;

	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}

	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;

	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;

	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}

	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}

	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED$2);
	  return this;
	}

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}

	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;

	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}

	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;

	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;

	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;

	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

	  stack.set(array, other);
	  stack.set(other, array);

	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];

	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}

	/** Built-in value references. */
	var Uint8Array$1 = root.Uint8Array;

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);

	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);

	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG$1 = 1,
	    COMPARE_UNORDERED_FLAG$1 = 2;

	/** `Object#toString` result references. */
	var boolTag$1 = '[object Boolean]',
	    dateTag$1 = '[object Date]',
	    errorTag$1 = '[object Error]',
	    mapTag$1 = '[object Map]',
	    numberTag$1 = '[object Number]',
	    regexpTag$1 = '[object RegExp]',
	    setTag$1 = '[object Set]',
	    stringTag$1 = '[object String]',
	    symbolTag = '[object Symbol]';

	var arrayBufferTag$1 = '[object ArrayBuffer]',
	    dataViewTag$1 = '[object DataView]';

	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag$1:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;

	    case arrayBufferTag$1:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array$1(object), new Uint8Array$1(other))) {
	        return false;
	      }
	      return true;

	    case boolTag$1:
	    case dateTag$1:
	    case numberTag$1:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);

	    case errorTag$1:
	      return object.name == other.name && object.message == other.message;

	    case regexpTag$1:
	    case stringTag$1:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');

	    case mapTag$1:
	      var convert = mapToArray;

	    case setTag$1:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1;
	      convert || (convert = setToArray);

	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG$1;

	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;

	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;

	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}

	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}

	/** Used for built-in method references. */
	var objectProto$9 = Object.prototype;

	/** Built-in value references. */
	var propertyIsEnumerable$1 = objectProto$9.propertyIsEnumerable;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;

	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable$1.call(object, symbol);
	  });
	};

	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys$1, getSymbols);
	}

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG$2 = 1;

	/** Used for built-in method references. */
	var objectProto$a = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$8 = objectProto$a.hasOwnProperty;

	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;

	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty$8.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);

	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];

	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;

	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}

	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');

	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');

	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');

	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');

	/** `Object#toString` result references. */
	var mapTag$2 = '[object Map]',
	    objectTag$1 = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag$2 = '[object Set]',
	    weakMapTag$1 = '[object WeakMap]';

	var dataViewTag$2 = '[object DataView]';

	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);

	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;

	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag$2) ||
	    (Map && getTag(new Map) != mapTag$2) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag$2) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag$1)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag$1 ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';

	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag$2;
	        case mapCtorString: return mapTag$2;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag$2;
	        case weakMapCtorString: return weakMapTag$1;
	      }
	    }
	    return result;
	  };
	}

	var getTag$1 = getTag;

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG$3 = 1;

	/** `Object#toString` result references. */
	var argsTag$2 = '[object Arguments]',
	    arrayTag$1 = '[object Array]',
	    objectTag$2 = '[object Object]';

	/** Used for built-in method references. */
	var objectProto$b = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$9 = objectProto$b.hasOwnProperty;

	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag$1 : getTag$1(object),
	      othTag = othIsArr ? arrayTag$1 : getTag$1(other);

	  objTag = objTag == argsTag$2 ? objectTag$2 : objTag;
	  othTag = othTag == argsTag$2 ? objectTag$2 : othTag;

	  var objIsObj = objTag == objectTag$2,
	      othIsObj = othTag == objectTag$2,
	      isSameTag = objTag == othTag;

	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG$3)) {
	    var objIsWrapped = objIsObj && hasOwnProperty$9.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty$9.call(other, '__wrapped__');

	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;

	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}

	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG$4 = 1,
	    COMPARE_UNORDERED_FLAG$2 = 2;

	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;

	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];

	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$4 | COMPARE_UNORDERED_FLAG$2, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}

	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}

	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys$1(object),
	      length = result.length;

	  while (length--) {
	    var key = result[length],
	        value = object[key];

	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}

	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}

	/** `Object#toString` result references. */
	var symbolTag$1 = '[object Symbol]';

	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol$1(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag$1);
	}

	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;

	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol$1(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}

	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';

	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;

	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}

	// Expose `MapCache`.
	memoize.Cache = MapCache;

	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;

	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });

	  var cache = result.cache;
	  return result;
	}

	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;

	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);

	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}

	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;

	/** Used to convert symbols to primitives and strings. */
	var symbolProto$1 = Symbol$1 ? Symbol$1.prototype : undefined,
	    symbolToString = symbolProto$1 ? symbolProto$1.toString : undefined;

	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol$1(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}

	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString$2(value) {
	  return value == null ? '' : baseToString(value);
	}

	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString$2(value));
	}

	/** Used as references for various `Number` constants. */
	var INFINITY$1 = 1 / 0;

	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol$1(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
	}

	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);

	  var index = 0,
	      length = path.length;

	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}

	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}

	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);

	  var index = -1,
	      length = path.length,
	      result = false;

	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}

	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG$5 = 1,
	    COMPARE_UNORDERED_FLAG$3 = 2;

	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$5 | COMPARE_UNORDERED_FLAG$3);
	  };
	}

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}

	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}

	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}

	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}

	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * **Note:** Unlike `_.remove`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.reject
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate));
	}

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)


	var SPECIES$2 = _wks('species');
	var _speciesConstructor = function (O, D) {
	  var C = _anObject(O).constructor;
	  var S;
	  return C === undefined || (S = _anObject(C)[SPECIES$2]) == undefined ? D : _aFunction(S);
	};

	// true  -> String#at
	// false -> String#codePointAt
	var _stringAt = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(_defined(that));
	    var i = _toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

	var at = _stringAt(true);

	 // `AdvanceStringIndex` abstract operation
	// https://tc39.github.io/ecma262/#sec-advancestringindex
	var _advanceStringIndex = function (S, index, unicode) {
	  return index + (unicode ? at(S, index).length : 1);
	};

	var builtinExec = RegExp.prototype.exec;

	 // `RegExpExec` abstract operation
	// https://tc39.github.io/ecma262/#sec-regexpexec
	var _regexpExecAbstract = function (R, S) {
	  var exec = R.exec;
	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);
	    if (typeof result !== 'object') {
	      throw new TypeError('RegExp exec method returned something other than an Object or null');
	    }
	    return result;
	  }
	  if (_classof(R) !== 'RegExp') {
	    throw new TypeError('RegExp#exec called on incompatible receiver');
	  }
	  return builtinExec.call(R, S);
	};

	var nativeExec = RegExp.prototype.exec;
	// This always refers to the native implementation, because the
	// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
	// which loads this file before patching the method.
	var nativeReplace = String.prototype.replace;

	var patchedExec = nativeExec;

	var LAST_INDEX = 'lastIndex';

	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/,
	      re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
	})();

	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;

	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + re.source + '$(?!\\s)', _flags.call(re));
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

	    match = nativeExec.call(re, str);

	    if (UPDATES_LAST_INDEX_WRONG && match) {
	      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      // eslint-disable-next-line no-loop-func
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }

	    return match;
	  };
	}

	var _regexpExec = patchedExec;

	_export({
	  target: 'RegExp',
	  proto: true,
	  forced: _regexpExec !== /./.exec
	}, {
	  exec: _regexpExec
	});

	var SPECIES$3 = _wks('species');

	var REPLACE_SUPPORTS_NAMED_GROUPS = !_fails(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  return ''.replace(re, '$<a>') !== '7';
	});

	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
	  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
	})();

	var _fixReWks = function (KEY, length, exec) {
	  var SYMBOL = _wks(KEY);

	  var DELEGATES_TO_SYMBOL = !_fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });

	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !_fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	    re.exec = function () { execCalled = true; return null; };
	    if (KEY === 'split') {
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES$3] = function () { return re; };
	    }
	    re[SYMBOL]('');
	    return !execCalled;
	  }) : undefined;

	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
	    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var fns = exec(
	      _defined,
	      SYMBOL,
	      ''[KEY],
	      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
	        if (regexp.exec === _regexpExec) {
	          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	            // The native String method already delegates to @@method (this
	            // polyfilled function), leasing to infinite recursion.
	            // We avoid it by directly calling the native @@method method.
	            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
	          }
	          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
	        }
	        return { done: false };
	      }
	    );
	    var strfn = fns[0];
	    var rxfn = fns[1];

	    _redefine(String.prototype, KEY, strfn);
	    _hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};

	var $min = Math.min;
	var $push = [].push;
	var $SPLIT = 'split';
	var LENGTH = 'length';
	var LAST_INDEX$1 = 'lastIndex';
	var MAX_UINT32 = 0xffffffff;

	// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
	var SUPPORTS_Y = !_fails(function () { RegExp(MAX_UINT32, 'y'); });

	// @@split logic
	_fixReWks('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
	  var internalSplit;
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!_isRegexp(separator)) return $split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = _regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy[LAST_INDEX$1];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX$1] === match.index) separatorCopy[LAST_INDEX$1]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
	    };
	  } else {
	    internalSplit = $split;
	  }

	  return [
	    // `String.prototype.split` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = defined(this);
	      var splitter = separator == undefined ? undefined : separator[SPLIT];
	      return splitter !== undefined
	        ? splitter.call(separator, O, limit)
	        : internalSplit.call(String(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (regexp, limit) {
	      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
	      if (res.done) return res.value;

	      var rx = _anObject(regexp);
	      var S = String(this);
	      var C = _speciesConstructor(rx, RegExp);

	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (SUPPORTS_Y ? 'y' : 'g');

	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return _regexpExecAbstract(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = SUPPORTS_Y ? q : 0;
	        var z = _regexpExecAbstract(splitter, SUPPORTS_Y ? S : S.slice(q));
	        var e;
	        if (
	          z === null ||
	          (e = $min(_toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
	        ) {
	          q = _advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          A.push(S.slice(p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            A.push(z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      A.push(S.slice(p));
	      return A;
	    }
	  ];
	});

	// @@match logic
	_fixReWks('match', 1, function (defined, MATCH, $match, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[MATCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
	    function (regexp) {
	      var res = maybeCallNative($match, regexp, this);
	      if (res.done) return res.value;
	      var rx = _anObject(regexp);
	      var S = String(this);
	      if (!rx.global) return _regexpExecAbstract(rx, S);
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = _regexpExecAbstract(rx, S)) !== null) {
	        var matchStr = String(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = _advanceStringIndex(S, _toLength(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});

	var max$1 = Math.max;
	var min$2 = Math.min;
	var floor$1 = Math.floor;
	var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};

	// @@replace logic
	_fixReWks('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = defined(this);
	      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	      return fn !== undefined
	        ? fn.call(searchValue, O, replaceValue)
	        : $replace.call(String(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
	    function (regexp, replaceValue) {
	      var res = maybeCallNative($replace, regexp, this, replaceValue);
	      if (res.done) return res.value;

	      var rx = _anObject(regexp);
	      var S = String(this);
	      var functionalReplace = typeof replaceValue === 'function';
	      if (!functionalReplace) replaceValue = String(replaceValue);
	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = _regexpExecAbstract(rx, S);
	        if (result === null) break;
	        results.push(result);
	        if (!global) break;
	        var matchStr = String(result[0]);
	        if (matchStr === '') rx.lastIndex = _advanceStringIndex(S, _toLength(rx.lastIndex), fullUnicode);
	      }
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	        var matched = String(result[0]);
	        var position = max$1(min$2(_toInteger(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = [matched].concat(captures, position, S);
	          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	          var replacement = String(replaceValue.apply(undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + S.slice(nextSourcePosition);
	    }
	  ];

	    // https://tc39.github.io/ecma262/#sec-getsubstitution
	  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
	    var tailPos = position + matched.length;
	    var m = captures.length;
	    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	    if (namedCaptures !== undefined) {
	      namedCaptures = _toObject(namedCaptures);
	      symbols = SUBSTITUTION_SYMBOLS;
	    }
	    return $replace.call(replacement, symbols, function (match, ch) {
	      var capture;
	      switch (ch.charAt(0)) {
	        case '$': return '$';
	        case '&': return matched;
	        case '`': return str.slice(0, position);
	        case "'": return str.slice(tailPos);
	        case '<':
	          capture = namedCaptures[ch.slice(1, -1)];
	          break;
	        default: // \d\d?
	          var n = +ch;
	          if (n === 0) return match;
	          if (n > m) {
	            var f = floor$1(n / 10);
	            if (f === 0) return match;
	            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	            return match;
	          }
	          capture = captures[n - 1];
	      }
	      return capture === undefined ? '' : capture;
	    });
	  }
	});

	/** `Object#toString` result references. */
	var stringTag$2 = '[object String]';

	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag$2);
	}

	/**
	 * Checks if `value` is `undefined`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	 * @example
	 *
	 * _.isUndefined(void 0);
	 * // => true
	 *
	 * _.isUndefined(null);
	 * // => false
	 */
	function isUndefined(value) {
	  return value === undefined;
	}

	var _stringWs = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

	var space = '[' + _stringWs + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');

	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = _fails(function () {
	    return !!_stringWs[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : _stringWs[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  _export(_export.P + _export.F * FORCE, 'String', exp);
	};

	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(_defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};

	var _stringTrim = exporter;

	var gOPN$3 = _objectGopn.f;
	var gOPD$2 = _objectGopd.f;
	var dP$4 = _objectDp.f;
	var $trim = _stringTrim.trim;
	var NUMBER = 'Number';
	var $Number = _global[NUMBER];
	var Base$1 = $Number;
	var proto$2 = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = _cof(_objectCreate(proto$2)) == NUMBER;
	var TRIM = 'trim' in String.prototype;

	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = _toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};

	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? _fails(function () { proto$2.valueOf.call(that); }) : _cof(that) != NUMBER)
	        ? _inheritIfRequired(new Base$1(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys$2 = _descriptors ? gOPN$3(Base$1) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j$1 = 0, key$1; keys$2.length > j$1; j$1++) {
	    if (_has(Base$1, key$1 = keys$2[j$1]) && !_has($Number, key$1)) {
	      dP$4($Number, key$1, gOPD$2(Base$1, key$1));
	    }
	  }
	  $Number.prototype = proto$2;
	  proto$2.constructor = $Number;
	  _redefine(_global, NUMBER, $Number);
	}

	/* eslint-disable */
	var cookie = function cookie(name, value, ttl, path, domain, secure) {
	  if (arguments.length > 1) {
	    return document.cookie = name + '=' + encodeURIComponent(value) + (ttl ? '; expires=' + new Date(Number(new Date()) + ttl * 1000).toUTCString() : '') + (path ? '; path=' + path : '') + (domain ? '; domain=' + domain : '') + (secure ? '; secure' : '');
	  }

	  return decodeURIComponent((('; ' + document.cookie).split('; ' + name + '=')[1] || '').split(';')[0]);
	};

	var cookie$1 = {
	  cookie: cookie
	};

	/**
	 * Cleans up the page title
	 */

	var fixupTitle = function fixupTitle(title) {
	  if (!isString(title)) {
	    title = title.text || '';
	    var tmp = document.getElementsByTagName('title');

	    if (tmp && !isUndefined(tmp[0])) {
	      title = tmp[0].text;
	    }
	  }

	  return title;
	};
	/**
	 * Extract hostname from URL
	 */

	var getHostName = function getHostName(url) {
	  // scheme : // [username [: password] @] hostname [: port] [/ [path] [? query] [# fragment]]
	  var e = new RegExp('^(?:(?:https?|ftp):)/*(?:[^@]+@)?([^:/#]+)');
	  var matches = e.exec(url);
	  return matches ? matches[1] : url;
	};
	/**
	 * Fix-up domain
	 */

	var fixupDomain = function fixupDomain(domain) {
	  var dl = domain.length; // remove trailing '.'

	  if (domain.charAt(--dl) === '.') {
	    domain = domain.slice(0, dl);
	  } // remove leading '*'


	  if (domain.slice(0, 2) === '*.') {
	    domain = domain.slice(1);
	  }

	  return domain;
	};
	/**
	 * Get page referrer. In the case of a single-page app,
	 * if the URL changes without the page reloading, pass
	 * in the old URL. It will be returned unless overriden
	 * by a "refer(r)er" parameter in the querystring.
	 *
	 * @param string oldLocation Optional.
	 * @return string The referrer
	 */

	var getReferrer = function getReferrer(oldLocation) {
	  var referrer = '';
	  var fromQs = fromQuerystring('referrer', window.location.href) || fromQuerystring('referer', window.location.href); // Short-circuit

	  if (fromQs) {
	    return fromQs;
	  } // In the case of a single-page app, return the old URL


	  if (oldLocation) {
	    return oldLocation;
	  }

	  try {
	    referrer = window.top.document.referrer;
	  } catch (e) {
	    if (window.parent) {
	      try {
	        referrer = window.parent.document.referrer;
	      } catch (e2) {
	        referrer = '';
	      }
	    }
	  }

	  if (referrer === '') {
	    referrer = document.referrer;
	  }

	  return referrer;
	};
	/**
	 * Cross-browser helper function to add event handler
	 */

	var addEventListener = function addEventListener(element, eventType, eventHandler, useCapture) {
	  if (element.addEventListener) {
	    element.addEventListener(eventType, eventHandler, useCapture);
	    return true;
	  }

	  if (element.attachEvent) {
	    return element.attachEvent('on' + eventType, eventHandler);
	  }

	  element['on' + eventType] = eventHandler;
	};
	/**
	 * Return value from name-value pair in querystring
	 */

	var fromQuerystring = function fromQuerystring(field, url) {
	  var match = new RegExp('^[^#]*[?&]' + field + '=([^&#]*)').exec(url);

	  if (!match) {
	    return null;
	  }

	  return decodeURIComponent(match[1].replace(/\+/g, ' '));
	};
	/**
	 * Only log deprecation warnings if they won't cause an error
	 */

	var warn = function warn(message) {
	};
	/**
	 * List the classes of a DOM element without using elt.classList (for compatibility with IE 9)
	 */

	var getCssClasses = function getCssClasses(elt) {
	  return elt.className.match(/\S+/g) || [];
	};
	/**
	 * Check whether an element has at least one class from a given list
	 */

	function checkClass(elt, classList) {
	  var classes = getCssClasses(elt);
	  var i;

	  for (i = 0; i < classes.length; i++) {
	    if (classList[classes[i]]) {
	      return true;
	    }
	  }

	  return false;
	}
	/**
	 * Convert a criterion object to a filter function
	 *
	 * @param object criterion Either {whitelist: [array of allowable strings]}
	 *                             or {blacklist: [array of allowable strings]}
	 *                             or {filter: function (elt) {return whether to track the element}
	 * @param boolean byClass Whether to whitelist/blacklist based on an element's classes (for forms)
	 *                        or name attribute (for fields)
	 */


	var getFilter = function getFilter(criterion, byClass) {
	  // If the criterion argument is not an object, add listeners to all elements
	  if (isArray(criterion) || !isObject(criterion)) {
	    return function () {
	      return true;
	    };
	  }

	  if (criterion.hasOwnProperty('filter')) {
	    return criterion.filter;
	  }

	  var inclusive = criterion.hasOwnProperty('whitelist');
	  var specifiedClasses = criterion.whitelist || criterion.blacklist;

	  if (!isArray(specifiedClasses)) {
	    specifiedClasses = [specifiedClasses];
	  } // Convert the array of classes to an object of the form {class1: true, class2: true, ...}


	  var specifiedClassesSet = {};

	  for (var i = 0; i < specifiedClasses.length; i++) {
	    specifiedClassesSet[specifiedClasses[i]] = true;
	  }

	  if (byClass) {
	    return function (elt) {
	      return checkClass(elt, specifiedClassesSet) === inclusive;
	    };
	  }

	  return function (elt) {
	    return elt.name in specifiedClassesSet === inclusive;
	  };
	};
	/**
	 * Convert a criterion object to a transform function
	 *
	 * @param object criterion {transform: function (elt) {return the result of transform function applied to element}
	 */

	var getTransform = function getTransform(criterion) {
	  if (!isObject(criterion)) {
	    return function (x) {
	      return x;
	    };
	  }

	  if (criterion.hasOwnProperty('transform')) {
	    return criterion.transform;
	  }

	  return function (x) {
	    return x;
	  };
	};
	/**
	 * Add a name-value pair to the querystring of a URL
	 *
	 * @param string url URL to decorate
	 * @param string name Name of the querystring pair
	 * @param string value Value of the querystring pair
	 */

	var decorateQuerystring = function decorateQuerystring(url, name, value) {
	  var initialQsParams = name + '=' + value;
	  var hashSplit = url.split('#');
	  var qsSplit = hashSplit[0].split('?');
	  var beforeQuerystring = qsSplit.shift(); // Necessary because a querystring may contain multiple question marks

	  var querystring = qsSplit.join('?');

	  if (!querystring) {
	    querystring = initialQsParams;
	  } else {
	    // Whether this is the first time the link has been decorated
	    var initialDecoration = true;
	    var qsFields = querystring.split('&');

	    for (var i = 0; i < qsFields.length; i++) {
	      if (qsFields[i].substr(0, name.length + 1) === name + '=') {
	        initialDecoration = false;
	        qsFields[i] = initialQsParams;
	        querystring = qsFields.join('&');
	        break;
	      }
	    }

	    if (initialDecoration) {
	      querystring = initialQsParams + '&' + querystring;
	    }
	  }

	  hashSplit[0] = beforeQuerystring + '?' + querystring;
	  return hashSplit.join('#');
	};
	/**
	 * Attempt to get a value from localStorage
	 *
	 * @param string key
	 * @return string The value obtained from localStorage, or
	 *                undefined if localStorage is inaccessible
	 */

	var attemptGetLocalStorage = function attemptGetLocalStorage(key) {
	  try {
	    return localStorage.getItem(key);
	  } catch (e) {}
	};
	/**
	 * Attempt to write a value to localStorage
	 *
	 * @param string key
	 * @param string value
	 * @return boolean Whether the operation succeeded
	 */

	var attemptWriteLocalStorage = function attemptWriteLocalStorage(key, value) {
	  try {
	    localStorage.setItem(key, value);
	    return true;
	  } catch (e) {
	    return false;
	  }
	};
	/**
	 * Finds the root domain
	 */

	var findRootDomain = function findRootDomain() {
	  var cookiePrefix = '_sp_root_domain_test_';
	  var cookieName = cookiePrefix + new Date().getTime();
	  var cookieValue = '_test_value_' + new Date().getTime();
	  var split = window.location.hostname.split('.');
	  var position = split.length - 1;

	  while (position >= 0) {
	    var currentDomain = split.slice(position, split.length).join('.');
	    cookie$1.cookie(cookieName, cookieValue, 0, '/', currentDomain);

	    if (cookie$1.cookie(cookieName) === cookieValue) {
	      // Clean up created cookie(s)
	      deleteCookie(cookieName, currentDomain);
	      var cookieNames = getCookiesWithPrefix(cookiePrefix);

	      for (var i = 0; i < cookieNames.length; i++) {
	        deleteCookie(cookieNames[i], currentDomain);
	      }

	      return currentDomain;
	    }

	    position -= 1;
	  } // Cookies cannot be read


	  return window.location.hostname;
	};
	/**
	 * Checks whether a value is present within an array
	 *
	 * @param val The value to check for
	 * @param array The array to check within
	 * @return boolean Whether it exists
	 */

	var isValueInArray = function isValueInArray(val, array) {
	  for (var i = 0; i < array.length; i++) {
	    if (array[i] === val) {
	      return true;
	    }
	  }

	  return false;
	};
	/**
	 * Deletes an arbitrary cookie by setting the expiration date to the past
	 *
	 * @param cookieName The name of the cookie to delete
	 * @param domainName The domain the cookie is in
	 */

	var deleteCookie = function deleteCookie(cookieName, domainName) {
	  cookie$1.cookie(cookieName, '', -1, '/', domainName);
	};
	/**
	 * Fetches the name of all cookies beginning with a certain prefix
	 *
	 * @param cookiePrefix The prefix to check for
	 * @return array The cookies that begin with the prefix
	 */

	var getCookiesWithPrefix = function getCookiesWithPrefix(cookiePrefix) {
	  var cookies = document.cookie.split('; ');
	  var cookieNames = [];

	  for (var i = 0; i < cookies.length; i++) {
	    if (cookies[i].substring(0, cookiePrefix.length) === cookiePrefix) {
	      cookieNames.push(cookies[i]);
	    }
	  }

	  return cookieNames;
	};
	/**
	 * Parses an object and returns either the
	 * integer or undefined.
	 *
	 * @param obj The object to parse
	 * @return the result of the parse operation
	 */

	var parseInt$1 = function parseInt(obj) {
	  var result = parseInt();
	  return isNaN(result) ? undefined : result;
	};
	/**
	 * Parses an object and returns either the
	 * number or undefined.
	 *
	 * @param obj The object to parse
	 * @return the result of the parse operation
	 */

	var parseFloat = function parseFloat(obj) {
	  var result = parseFloat();
	  return isNaN(result) ? undefined : result;
	};

	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];

	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}

	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee));
	}

	/************************************************************
	 * Proxy object
	 * - this allows the caller to continue push()'ing to _snaq
	 *   after the Tracker has been initialized and loaded
	 ************************************************************/

	var InQueueManager = function InQueueManager(TrackerConstructor, version, mutSnowplowState, asyncQueue, functionName) {
	  // Page view ID should be shared between all tracker instances
	  var trackerDictionary = {};
	  /**
	   * Get an array of trackers to which a function should be applied.
	   *
	   * @param array names List of namespaces to use. If empty, use all namespaces.
	   */

	  function getNamedTrackers(names) {
	    var namedTrackers = [];

	    if (!names || names.length === 0) {
	      namedTrackers = map(trackerDictionary);
	    } else {
	      for (var i = 0; i < names.length; i++) {
	        if (trackerDictionary.hasOwnProperty(names[i])) {
	          namedTrackers.push(trackerDictionary[names[i]]);
	        } else {
	          warn('Warning: Tracker namespace "' + names[i] + '" not configured');
	        }
	      }
	    }

	    if (namedTrackers.length === 0) ;

	    return namedTrackers;
	  }
	  /**
	   * Legacy support for input of the form _snaq.push(['setCollectorCf', 'd34uzc5hjrimh8'])
	   *
	   * @param string f Either 'setCollectorCf' or 'setCollectorUrl'
	   * @param string endpoint
	   * @param string namespace Optional tracker name
	   *
	   * TODO: remove this in 2.1.0
	   */


	  function legacyCreateNewNamespace(f, endpoint, namespace) {
	    var name;

	    if (isUndefined(namespace)) {
	      name = 'sp';
	    } else {
	      name = namespace;
	    }

	    createNewNamespace(name);
	    trackerDictionary[name][f](endpoint);
	  }
	  /**
	   * Initiate a new tracker namespace
	   *
	   * @param string namespace
	   * @param string endpoint Of the form d3rkrsqld9gmqf.cloudfront.net
	   */


	  function createNewNamespace(namespace, endpoint, argmap) {
	    argmap = argmap || {};

	    if (!trackerDictionary.hasOwnProperty(namespace)) {
	      trackerDictionary[namespace] = new TrackerConstructor(functionName, namespace, version, mutSnowplowState, argmap);
	      trackerDictionary[namespace].setCollectorUrl(endpoint);
	    }
	  }
	  /**
	   * Output an array of the form ['functionName', [trackerName1, trackerName2, ...]]
	   *
	   * @param string inputString
	   */


	  function parseInputString(inputString) {
	    var separatedString = inputString.split(':');
	    var extractedFunction = separatedString[0];
	    var extractedNames = separatedString.length > 1 ? separatedString[1].split(';') : [];
	    return [extractedFunction, extractedNames];
	  }
	  /**
	   * apply wrapper
	   *
	   * @param array parameterArray An array comprising either:
	   *      [ 'methodName', optional_parameters ]
	   * or:
	   *      [ functionObject, optional_parameters ]
	   */


	  function applyAsyncFunction() {
	    var i;
	    var j;
	    var f;
	    var parameterArray;
	    var input;
	    var parsedString;
	    var names;
	    var namedTrackers; // Outer loop in case someone push'es in zarg of arrays

	    for (i = 0; i < arguments.length; i += 1) {
	      parameterArray = arguments[i]; // Arguments is not an array, so we turn it into one

	      input = Array.prototype.shift.call(parameterArray); // Custom callback rather than tracker method, called with trackerDictionary as the context

	      if (isFunction(input)) {
	        input.apply(trackerDictionary, parameterArray);
	        continue;
	      }

	      parsedString = parseInputString(input);
	      f = parsedString[0];
	      names = parsedString[1];

	      if (f === 'newTracker') {
	        createNewNamespace(parameterArray[0], parameterArray[1], parameterArray[2]);
	        continue;
	      }

	      if ((f === 'setCollectorCf' || f === 'setCollectorUrl') && (!names || names.length === 0)) {
	        legacyCreateNewNamespace(f, parameterArray[0], parameterArray[1]);
	        continue;
	      }

	      namedTrackers = getNamedTrackers(names);

	      for (j = 0; j < namedTrackers.length; j++) {
	        namedTrackers[j][f].apply(namedTrackers[j], parameterArray);
	      }
	    }
	  } // We need to manually apply any events collected before this initialization


	  for (var i = 0; i < asyncQueue.length; i++) {
	    applyAsyncFunction(asyncQueue[i]);
	  }

	  return {
	    push: applyAsyncFunction
	  };
	};

	// 21.2.5.3 get RegExp.prototype.flags()
	if (_descriptors && /./g.flags != 'g') _objectDp.f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: _flags
	});

	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];

	var define = function (fn) {
	  _redefine(RegExp.prototype, TO_STRING, fn, true);
	};

	// 21.2.5.14 RegExp.prototype.toString()
	if (_fails(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = _anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !_descriptors && R instanceof RegExp ? _flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING$1 = 'toString';
	var $toString$1 = DateProto[TO_STRING$1];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  _redefine(DateProto, TO_STRING$1, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString$1.call(this) : INVALID_DATE;
	  });
	}

	/*
	  * Test whether a string is an IP address
	  */

	function isIpAddress(string) {
	  var IPRegExp = new RegExp('^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$');
	  return IPRegExp.test(string);
	}
	/*
	  * If the hostname is an IP address, look for text indicating
	  * that the page is cached by Yahoo
	  */


	function isYahooCachedPage(hostName) {
	  var initialDivText;
	  var cachedIndicator;

	  if (isIpAddress(hostName)) {
	    try {
	      initialDivText = document.body.children[0].children[0].children[0].children[0].children[0].children[0].innerHTML;
	      cachedIndicator = 'You have reached the cached page for';
	      return initialDivText.slice(0, cachedIndicator.length) === cachedIndicator;
	    } catch (e) {
	      return false;
	    }
	  }
	}
	/*
	  * Extract parameter from URL
	  */


	function getParameter(url, name) {
	  // scheme : // [username [: password] @] hostname [: port] [/ [path] [? query] [# fragment]]
	  var e = new RegExp('^(?:https?|ftp)(?::/*(?:[^?]+))([?][^#]+)');
	  var matches = e.exec(url);
	  var result = fromQuerystring(name, matches[1]);
	  return result;
	}
	/*
	  * Fix-up URL when page rendered from search engine cache or translated page.
	  * TODO: it would be nice to generalise this and/or move into the ETL phase.
	  */


	var fixupUrl = function fixupUrl(hostName, href, referrer) {
	  if (hostName === 'translate.googleusercontent.com') {
	    // Google
	    if (referrer === '') {
	      referrer = href;
	    }

	    href = getParameter(href, 'u');
	    hostName = getHostName(href);
	  } else if (hostName === 'cc.bingj.com' || // Bing
	  hostName === 'webcache.googleusercontent.com' || // Google
	  isYahooCachedPage(hostName)) {
	    // Yahoo (via Inktomi 74.6.0.0/16)
	    href = document.links[0].href;
	    hostName = getHostName(href);
	  }

	  return [hostName, href, referrer];
	};

	var _strictMethod = function (method, arg) {
	  return !!method && _fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};

	var $sort = [].sort;
	var test$1 = [1, 2, 3];

	_export(_export.P + _export.F * (_fails(function () {
	  // IE8-
	  test$1.sort(undefined);
	}) || !_fails(function () {
	  // V8 bug
	  test$1.sort(null);
	  // Old WebKit
	}) || !_strictMethod($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(_toObject(this))
	      : $sort.call(_toObject(this), _aFunction(comparefn));
	  }
	});

	var murmurhash = createCommonjsModule(function (module) {
	(function(){

	  /**
	   * JS Implementation of MurmurHash2
	   *
	   * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
	   * @see http://github.com/garycourt/murmurhash-js
	   * @author <a href="mailto:aappleby@gmail.com">Austin Appleby</a>
	   * @see http://sites.google.com/site/murmurhash/
	   *
	   * @param {string} str ASCII only
	   * @param {number} seed Positive integer only
	   * @return {number} 32-bit positive integer hash
	   */
	  function MurmurHashV2(str, seed) {
	    var
	      l = str.length,
	      h = seed ^ l,
	      i = 0,
	      k;

	    while (l >= 4) {
	      k =
	        ((str.charCodeAt(i) & 0xff)) |
	        ((str.charCodeAt(++i) & 0xff) << 8) |
	        ((str.charCodeAt(++i) & 0xff) << 16) |
	        ((str.charCodeAt(++i) & 0xff) << 24);

	      k = (((k & 0xffff) * 0x5bd1e995) + ((((k >>> 16) * 0x5bd1e995) & 0xffff) << 16));
	      k ^= k >>> 24;
	      k = (((k & 0xffff) * 0x5bd1e995) + ((((k >>> 16) * 0x5bd1e995) & 0xffff) << 16));

	    h = (((h & 0xffff) * 0x5bd1e995) + ((((h >>> 16) * 0x5bd1e995) & 0xffff) << 16)) ^ k;

	      l -= 4;
	      ++i;
	    }

	    switch (l) {
	    case 3: h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
	    case 2: h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
	    case 1: h ^= (str.charCodeAt(i) & 0xff);
	            h = (((h & 0xffff) * 0x5bd1e995) + ((((h >>> 16) * 0x5bd1e995) & 0xffff) << 16));
	    }

	    h ^= h >>> 13;
	    h = (((h & 0xffff) * 0x5bd1e995) + ((((h >>> 16) * 0x5bd1e995) & 0xffff) << 16));
	    h ^= h >>> 15;

	    return h >>> 0;
	  }
	  /**
	   * JS Implementation of MurmurHash3 (r136) (as of May 20, 2011)
	   *
	   * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
	   * @see http://github.com/garycourt/murmurhash-js
	   * @author <a href="mailto:aappleby@gmail.com">Austin Appleby</a>
	   * @see http://sites.google.com/site/murmurhash/
	   *
	   * @param {string} key ASCII only
	   * @param {number} seed Positive integer only
	   * @return {number} 32-bit positive integer hash
	   */
	  function MurmurHashV3(key, seed) {
	    var remainder, bytes, h1, h1b, c1, c2, k1, i;

	    remainder = key.length & 3; // key.length % 4
	    bytes = key.length - remainder;
	    h1 = seed;
	    c1 = 0xcc9e2d51;
	    c2 = 0x1b873593;
	    i = 0;

	    while (i < bytes) {
	        k1 =
	          ((key.charCodeAt(i) & 0xff)) |
	          ((key.charCodeAt(++i) & 0xff) << 8) |
	          ((key.charCodeAt(++i) & 0xff) << 16) |
	          ((key.charCodeAt(++i) & 0xff) << 24);
	      ++i;

	      k1 = ((((k1 & 0xffff) * c1) + ((((k1 >>> 16) * c1) & 0xffff) << 16))) & 0xffffffff;
	      k1 = (k1 << 15) | (k1 >>> 17);
	      k1 = ((((k1 & 0xffff) * c2) + ((((k1 >>> 16) * c2) & 0xffff) << 16))) & 0xffffffff;

	      h1 ^= k1;
	          h1 = (h1 << 13) | (h1 >>> 19);
	      h1b = ((((h1 & 0xffff) * 5) + ((((h1 >>> 16) * 5) & 0xffff) << 16))) & 0xffffffff;
	      h1 = (((h1b & 0xffff) + 0x6b64) + ((((h1b >>> 16) + 0xe654) & 0xffff) << 16));
	    }

	    k1 = 0;

	    switch (remainder) {
	      case 3: k1 ^= (key.charCodeAt(i + 2) & 0xff) << 16;
	      case 2: k1 ^= (key.charCodeAt(i + 1) & 0xff) << 8;
	      case 1: k1 ^= (key.charCodeAt(i) & 0xff);

	      k1 = (((k1 & 0xffff) * c1) + ((((k1 >>> 16) * c1) & 0xffff) << 16)) & 0xffffffff;
	      k1 = (k1 << 15) | (k1 >>> 17);
	      k1 = (((k1 & 0xffff) * c2) + ((((k1 >>> 16) * c2) & 0xffff) << 16)) & 0xffffffff;
	      h1 ^= k1;
	    }

	    h1 ^= key.length;

	    h1 ^= h1 >>> 16;
	    h1 = (((h1 & 0xffff) * 0x85ebca6b) + ((((h1 >>> 16) * 0x85ebca6b) & 0xffff) << 16)) & 0xffffffff;
	    h1 ^= h1 >>> 13;
	    h1 = ((((h1 & 0xffff) * 0xc2b2ae35) + ((((h1 >>> 16) * 0xc2b2ae35) & 0xffff) << 16))) & 0xffffffff;
	    h1 ^= h1 >>> 16;

	    return h1 >>> 0;
	  }

	  var murmur = MurmurHashV3;
	  murmur.v2 = MurmurHashV2;
	  murmur.v3 = MurmurHashV3;

	  {
	    module.exports = murmur;
	  }
	}());
	});

	var jstz = createCommonjsModule(function (module) {
	(function (root) {/*global exports, Intl*/
	/**
	 * This script gives you the zone info key representing your device's time zone setting.
	 *
	 * @name jsTimezoneDetect
	 * @version 1.0.6
	 * @author Jon Nylander
	 * @license MIT License - https://bitbucket.org/pellepim/jstimezonedetect/src/default/LICENCE.txt
	 *
	 * For usage and examples, visit:
	 * http://pellepim.bitbucket.org/jstz/
	 *
	 * Copyright (c) Jon Nylander
	 */


	/**
	 * Namespace to hold all the code for timezone detection.
	 */
	var jstz = (function () {
	    var HEMISPHERE_SOUTH = 's',

	        consts = {
	            DAY: 86400000,
	            HOUR: 3600000,
	            MINUTE: 60000,
	            SECOND: 1000,
	            BASELINE_YEAR: 2014,
	            MAX_SCORE: 864000000, // 10 days
	            AMBIGUITIES: {
	                'America/Denver':       ['America/Mazatlan'],
	                'Europe/London':        ['Africa/Casablanca'],
	                'America/Chicago':      ['America/Mexico_City'],
	                'America/Asuncion':     ['America/Campo_Grande', 'America/Santiago'],
	                'America/Montevideo':   ['America/Sao_Paulo', 'America/Santiago'],
	                // Europe/Minsk should not be in this list... but Windows.
	                'Asia/Beirut':          ['Asia/Amman', 'Asia/Jerusalem', 'Europe/Helsinki', 'Asia/Damascus', 'Africa/Cairo', 'Asia/Gaza', 'Europe/Minsk'],
	                'Pacific/Auckland':     ['Pacific/Fiji'],
	                'America/Los_Angeles':  ['America/Santa_Isabel'],
	                'America/New_York':     ['America/Havana'],
	                'America/Halifax':      ['America/Goose_Bay'],
	                'America/Godthab':      ['America/Miquelon'],
	                'Asia/Dubai':           ['Asia/Yerevan'],
	                'Asia/Jakarta':         ['Asia/Krasnoyarsk'],
	                'Asia/Shanghai':        ['Asia/Irkutsk', 'Australia/Perth'],
	                'Australia/Sydney':     ['Australia/Lord_Howe'],
	                'Asia/Tokyo':           ['Asia/Yakutsk'],
	                'Asia/Dhaka':           ['Asia/Omsk'],
	                // In the real world Yerevan is not ambigous for Baku... but Windows.
	                'Asia/Baku':            ['Asia/Yerevan'],
	                'Australia/Brisbane':   ['Asia/Vladivostok'],
	                'Pacific/Noumea':       ['Asia/Vladivostok'],
	                'Pacific/Majuro':       ['Asia/Kamchatka', 'Pacific/Fiji'],
	                'Pacific/Tongatapu':    ['Pacific/Apia'],
	                'Asia/Baghdad':         ['Europe/Minsk', 'Europe/Moscow'],
	                'Asia/Karachi':         ['Asia/Yekaterinburg'],
	                'Africa/Johannesburg':  ['Asia/Gaza', 'Africa/Cairo']
	            }
	        },

	        /**
	         * Gets the offset in minutes from UTC for a certain date.
	         * @param {Date} date
	         * @returns {Number}
	         */
	        get_date_offset = function get_date_offset(date) {
	            var offset = -date.getTimezoneOffset();
	            return (offset !== null ? offset : 0);
	        },

	        /**
	         * This function does some basic calculations to create information about
	         * the user's timezone. It uses REFERENCE_YEAR as a solid year for which
	         * the script has been tested rather than depend on the year set by the
	         * client device.
	         *
	         * Returns a key that can be used to do lookups in jstz.olson.timezones.
	         * eg: "720,1,2".
	         *
	         * @returns {String}
	         */
	        lookup_key = function lookup_key() {
	            var january_offset = get_date_offset(new Date(consts.BASELINE_YEAR, 0, 2)),
	                june_offset = get_date_offset(new Date(consts.BASELINE_YEAR, 5, 2)),
	                diff = january_offset - june_offset;

	            if (diff < 0) {
	                return january_offset + ",1";
	            } else if (diff > 0) {
	                return june_offset + ",1," + HEMISPHERE_SOUTH;
	            }

	            return january_offset + ",0";
	        },


	        /**
	         * Tries to get the time zone key directly from the operating system for those
	         * environments that support the ECMAScript Internationalization API.
	         */
	        get_from_internationalization_api = function get_from_internationalization_api() {
	            var format, timezone;
	            if (typeof Intl === "undefined" || typeof Intl.DateTimeFormat === "undefined") {
	                return;
	            }

	            format = Intl.DateTimeFormat();

	            if (typeof format === "undefined" || typeof format.resolvedOptions === "undefined") {
	                return;
	            }

	            timezone = format.resolvedOptions().timeZone;

	            if (timezone && (timezone.indexOf("/") > -1 || timezone === 'UTC')) {
	                return timezone;
	            }

	        },

	        /**
	         * Starting point for getting all the DST rules for a specific year
	         * for the current timezone (as described by the client system).
	         *
	         * Returns an object with start and end attributes, or false if no
	         * DST rules were found for the year.
	         *
	         * @param year
	         * @returns {Object} || {Boolean}
	         */
	        dst_dates = function dst_dates(year) {
	            var yearstart = new Date(year, 0, 1, 0, 0, 1, 0).getTime();
	            var yearend = new Date(year, 12, 31, 23, 59, 59).getTime();
	            var current = yearstart;
	            var offset = (new Date(current)).getTimezoneOffset();
	            var dst_start = null;
	            var dst_end = null;

	            while (current < yearend - 86400000) {
	                var dateToCheck = new Date(current);
	                var dateToCheckOffset = dateToCheck.getTimezoneOffset();

	                if (dateToCheckOffset !== offset) {
	                    if (dateToCheckOffset < offset) {
	                        dst_start = dateToCheck;
	                    }
	                    if (dateToCheckOffset > offset) {
	                        dst_end = dateToCheck;
	                    }
	                    offset = dateToCheckOffset;
	                }

	                current += 86400000;
	            }

	            if (dst_start && dst_end) {
	                return {
	                    s: find_dst_fold(dst_start).getTime(),
	                    e: find_dst_fold(dst_end).getTime()
	                };
	            }

	            return false;
	        },

	        /**
	         * Probably completely unnecessary function that recursively finds the
	         * exact (to the second) time when a DST rule was changed.
	         *
	         * @param a_date - The candidate Date.
	         * @param padding - integer specifying the padding to allow around the candidate
	         *                  date for finding the fold.
	         * @param iterator - integer specifying how many milliseconds to iterate while
	         *                   searching for the fold.
	         *
	         * @returns {Date}
	         */
	        find_dst_fold = function find_dst_fold(a_date, padding, iterator) {
	            if (typeof padding === 'undefined') {
	                padding = consts.DAY;
	                iterator = consts.HOUR;
	            }

	            var date_start = new Date(a_date.getTime() - padding).getTime();
	            var date_end = a_date.getTime() + padding;
	            var offset = new Date(date_start).getTimezoneOffset();

	            var current = date_start;

	            var dst_change = null;
	            while (current < date_end - iterator) {
	                var dateToCheck = new Date(current);
	                var dateToCheckOffset = dateToCheck.getTimezoneOffset();

	                if (dateToCheckOffset !== offset) {
	                    dst_change = dateToCheck;
	                    break;
	                }
	                current += iterator;
	            }

	            if (padding === consts.DAY) {
	                return find_dst_fold(dst_change, consts.HOUR, consts.MINUTE);
	            }

	            if (padding === consts.HOUR) {
	                return find_dst_fold(dst_change, consts.MINUTE, consts.SECOND);
	            }

	            return dst_change;
	        },

	        windows7_adaptations = function windows7_adaptions(rule_list, preliminary_timezone, score, sample) {
	            if (score !== 'N/A') {
	                return score;
	            }
	            if (preliminary_timezone === 'Asia/Beirut') {
	                if (sample.name === 'Africa/Cairo') {
	                    if (rule_list[6].s === 1398376800000 && rule_list[6].e === 1411678800000) {
	                        return 0;
	                    }
	                }
	                if (sample.name === 'Asia/Jerusalem') {
	                    if (rule_list[6].s === 1395964800000 && rule_list[6].e === 1411858800000) {
	                        return 0;
	                }
	            }
	            } else if (preliminary_timezone === 'America/Santiago') {
	                if (sample.name === 'America/Asuncion') {
	                    if (rule_list[6].s === 1412481600000 && rule_list[6].e === 1397358000000) {
	                        return 0;
	                    }
	                }
	                if (sample.name === 'America/Campo_Grande') {
	                    if (rule_list[6].s === 1413691200000 && rule_list[6].e === 1392519600000) {
	                        return 0;
	                    }
	                }
	            } else if (preliminary_timezone === 'America/Montevideo') {
	                if (sample.name === 'America/Sao_Paulo') {
	                    if (rule_list[6].s === 1413687600000 && rule_list[6].e === 1392516000000) {
	                        return 0;
	                    }
	                }
	            } else if (preliminary_timezone === 'Pacific/Auckland') {
	                if (sample.name === 'Pacific/Fiji') {
	                    if (rule_list[6].s === 1414245600000 && rule_list[6].e === 1396101600000) {
	                        return 0;
	                    }
	                }
	            }

	            return score;
	        },

	        /**
	         * Takes the DST rules for the current timezone, and proceeds to find matches
	         * in the jstz.olson.dst_rules.zones array.
	         *
	         * Compares samples to the current timezone on a scoring basis.
	         *
	         * Candidates are ruled immediately if either the candidate or the current zone
	         * has a DST rule where the other does not.
	         *
	         * Candidates are ruled out immediately if the current zone has a rule that is
	         * outside the DST scope of the candidate.
	         *
	         * Candidates are included for scoring if the current zones rules fall within the
	         * span of the samples rules.
	         *
	         * Low score is best, the score is calculated by summing up the differences in DST
	         * rules and if the consts.MAX_SCORE is overreached the candidate is ruled out.
	         *
	         * Yah follow? :)
	         *
	         * @param rule_list
	         * @param preliminary_timezone
	         * @returns {*}
	         */
	        best_dst_match = function best_dst_match(rule_list, preliminary_timezone) {
	            var score_sample = function score_sample(sample) {
	                var score = 0;

	                for (var j = 0; j < rule_list.length; j++) {

	                    // Both sample and current time zone report DST during the year.
	                    if (!!sample.rules[j] && !!rule_list[j]) {

	                        // The current time zone's DST rules are inside the sample's. Include.
	                        if (rule_list[j].s >= sample.rules[j].s && rule_list[j].e <= sample.rules[j].e) {
	                            score = 0;
	                            score += Math.abs(rule_list[j].s - sample.rules[j].s);
	                            score += Math.abs(sample.rules[j].e - rule_list[j].e);

	                        // The current time zone's DST rules are outside the sample's. Discard.
	                        } else {
	                            score = 'N/A';
	                            break;
	                        }

	                        // The max score has been reached. Discard.
	                        if (score > consts.MAX_SCORE) {
	                            score = 'N/A';
	                            break;
	                        }
	                    }
	                }

	                score = windows7_adaptations(rule_list, preliminary_timezone, score, sample);

	                return score;
	            };
	            var scoreboard = {};
	            var dst_zones = jstz.olson.dst_rules.zones;
	            var dst_zones_length = dst_zones.length;
	            var ambiguities = consts.AMBIGUITIES[preliminary_timezone];

	            for (var i = 0; i < dst_zones_length; i++) {
	                var sample = dst_zones[i];
	                var score = score_sample(dst_zones[i]);

	                if (score !== 'N/A') {
	                    scoreboard[sample.name] = score;
	                }
	            }

	            for (var tz in scoreboard) {
	                if (scoreboard.hasOwnProperty(tz)) {
	                    for (var j = 0; j < ambiguities.length; j++) {
	                        if (ambiguities[j] === tz) {
	                            return tz;
	                        }
	                    }
	                }
	            }

	            return preliminary_timezone;
	        },

	        /**
	         * Takes the preliminary_timezone as detected by lookup_key().
	         *
	         * Builds up the current timezones DST rules for the years defined
	         * in the jstz.olson.dst_rules.years array.
	         *
	         * If there are no DST occurences for those years, immediately returns
	         * the preliminary timezone. Otherwise proceeds and tries to solve
	         * ambiguities.
	         *
	         * @param preliminary_timezone
	         * @returns {String} timezone_name
	         */
	        get_by_dst = function get_by_dst(preliminary_timezone) {
	            var get_rules = function get_rules() {
	                var rule_list = [];
	                for (var i = 0; i < jstz.olson.dst_rules.years.length; i++) {
	                    var year_rules = dst_dates(jstz.olson.dst_rules.years[i]);
	                    rule_list.push(year_rules);
	                }
	                return rule_list;
	            };
	            var check_has_dst = function check_has_dst(rules) {
	                for (var i = 0; i < rules.length; i++) {
	                    if (rules[i] !== false) {
	                        return true;
	                    }
	                }
	                return false;
	            };
	            var rules = get_rules();
	            var has_dst = check_has_dst(rules);

	            if (has_dst) {
	                return best_dst_match(rules, preliminary_timezone);
	            }

	            return preliminary_timezone;
	        },

	        /**
	         * Uses get_timezone_info() to formulate a key to use in the olson.timezones dictionary.
	         *
	         * Returns an object with one function ".name()"
	         *
	         * @returns Object
	         */
	        determine = function determine() {
	            var preliminary_tz = get_from_internationalization_api();

	            if (!preliminary_tz) {
	                preliminary_tz = jstz.olson.timezones[lookup_key()];

	                if (typeof consts.AMBIGUITIES[preliminary_tz] !== 'undefined') {
	                    preliminary_tz = get_by_dst(preliminary_tz);
	                }
	            }

	            return {
	                name: function () {
	                    return preliminary_tz;
	                }
	            };
	        };

	    return {
	        determine: determine
	    };
	}());


	jstz.olson = jstz.olson || {};

	/**
	 * The keys in this dictionary are comma separated as such:
	 *
	 * First the offset compared to UTC time in minutes.
	 *
	 * Then a flag which is 0 if the timezone does not take daylight savings into account and 1 if it
	 * does.
	 *
	 * Thirdly an optional 's' signifies that the timezone is in the southern hemisphere,
	 * only interesting for timezones with DST.
	 *
	 * The mapped arrays is used for constructing the jstz.TimeZone object from within
	 * jstz.determine();
	 */
	jstz.olson.timezones = {
	    '-720,0': 'Etc/GMT+12',
	    '-660,0': 'Pacific/Pago_Pago',
	    '-660,1,s': 'Pacific/Apia', // Why? Because windows... cry!
	    '-600,1': 'America/Adak',
	    '-600,0': 'Pacific/Honolulu',
	    '-570,0': 'Pacific/Marquesas',
	    '-540,0': 'Pacific/Gambier',
	    '-540,1': 'America/Anchorage',
	    '-480,1': 'America/Los_Angeles',
	    '-480,0': 'Pacific/Pitcairn',
	    '-420,0': 'America/Phoenix',
	    '-420,1': 'America/Denver',
	    '-360,0': 'America/Guatemala',
	    '-360,1': 'America/Chicago',
	    '-360,1,s': 'Pacific/Easter',
	    '-300,0': 'America/Bogota',
	    '-300,1': 'America/New_York',
	    '-270,0': 'America/Caracas',
	    '-240,1': 'America/Halifax',
	    '-240,0': 'America/Santo_Domingo',
	    '-240,1,s': 'America/Asuncion',
	    '-210,1': 'America/St_Johns',
	    '-180,1': 'America/Godthab',
	    '-180,0': 'America/Argentina/Buenos_Aires',
	    '-180,1,s': 'America/Montevideo',
	    '-120,0': 'America/Noronha',
	    '-120,1': 'America/Noronha',
	    '-60,1': 'Atlantic/Azores',
	    '-60,0': 'Atlantic/Cape_Verde',
	    '0,0': 'UTC',
	    '0,1': 'Europe/London',
	    '60,1': 'Europe/Berlin',
	    '60,0': 'Africa/Lagos',
	    '60,1,s': 'Africa/Windhoek',
	    '120,1': 'Asia/Beirut',
	    '120,0': 'Africa/Johannesburg',
	    '180,0': 'Asia/Baghdad',
	    '180,1': 'Europe/Moscow',
	    '210,1': 'Asia/Tehran',
	    '240,0': 'Asia/Dubai',
	    '240,1': 'Asia/Baku',
	    '270,0': 'Asia/Kabul',
	    '300,1': 'Asia/Yekaterinburg',
	    '300,0': 'Asia/Karachi',
	    '330,0': 'Asia/Kolkata',
	    '345,0': 'Asia/Kathmandu',
	    '360,0': 'Asia/Dhaka',
	    '360,1': 'Asia/Omsk',
	    '390,0': 'Asia/Rangoon',
	    '420,1': 'Asia/Krasnoyarsk',
	    '420,0': 'Asia/Jakarta',
	    '480,0': 'Asia/Shanghai',
	    '480,1': 'Asia/Irkutsk',
	    '525,0': 'Australia/Eucla',
	    '525,1,s': 'Australia/Eucla',
	    '540,1': 'Asia/Yakutsk',
	    '540,0': 'Asia/Tokyo',
	    '570,0': 'Australia/Darwin',
	    '570,1,s': 'Australia/Adelaide',
	    '600,0': 'Australia/Brisbane',
	    '600,1': 'Asia/Vladivostok',
	    '600,1,s': 'Australia/Sydney',
	    '630,1,s': 'Australia/Lord_Howe',
	    '660,1': 'Asia/Kamchatka',
	    '660,0': 'Pacific/Noumea',
	    '690,0': 'Pacific/Norfolk',
	    '720,1,s': 'Pacific/Auckland',
	    '720,0': 'Pacific/Majuro',
	    '765,1,s': 'Pacific/Chatham',
	    '780,0': 'Pacific/Tongatapu',
	    '780,1,s': 'Pacific/Apia',
	    '840,0': 'Pacific/Kiritimati'
	};

	/* Build time: 2015-11-02 13:01:00Z Build by invoking python utilities/dst.py generate */
	jstz.olson.dst_rules = {
	    "years": [
	        2008,
	        2009,
	        2010,
	        2011,
	        2012,
	        2013,
	        2014
	    ],
	    "zones": [
	        {
	            "name": "Africa/Cairo",
	            "rules": [
	                {
	                    "e": 1219957200000,
	                    "s": 1209074400000
	                },
	                {
	                    "e": 1250802000000,
	                    "s": 1240524000000
	                },
	                {
	                    "e": 1285880400000,
	                    "s": 1284069600000
	                },
	                false,
	                false,
	                false,
	                {
	                    "e": 1411678800000,
	                    "s": 1406844000000
	                }
	            ]
	        },
	        {
	            "name": "Africa/Casablanca",
	            "rules": [
	                {
	                    "e": 1220223600000,
	                    "s": 1212278400000
	                },
	                {
	                    "e": 1250809200000,
	                    "s": 1243814400000
	                },
	                {
	                    "e": 1281222000000,
	                    "s": 1272758400000
	                },
	                {
	                    "e": 1312066800000,
	                    "s": 1301788800000
	                },
	                {
	                    "e": 1348970400000,
	                    "s": 1345428000000
	                },
	                {
	                    "e": 1382839200000,
	                    "s": 1376100000000
	                },
	                {
	                    "e": 1414288800000,
	                    "s": 1406944800000
	                }
	            ]
	        },
	        {
	            "name": "America/Asuncion",
	            "rules": [
	                {
	                    "e": 1205031600000,
	                    "s": 1224388800000
	                },
	                {
	                    "e": 1236481200000,
	                    "s": 1255838400000
	                },
	                {
	                    "e": 1270954800000,
	                    "s": 1286078400000
	                },
	                {
	                    "e": 1302404400000,
	                    "s": 1317528000000
	                },
	                {
	                    "e": 1333854000000,
	                    "s": 1349582400000
	                },
	                {
	                    "e": 1364094000000,
	                    "s": 1381032000000
	                },
	                {
	                    "e": 1395543600000,
	                    "s": 1412481600000
	                }
	            ]
	        },
	        {
	            "name": "America/Campo_Grande",
	            "rules": [
	                {
	                    "e": 1203217200000,
	                    "s": 1224388800000
	                },
	                {
	                    "e": 1234666800000,
	                    "s": 1255838400000
	                },
	                {
	                    "e": 1266721200000,
	                    "s": 1287288000000
	                },
	                {
	                    "e": 1298170800000,
	                    "s": 1318737600000
	                },
	                {
	                    "e": 1330225200000,
	                    "s": 1350792000000
	                },
	                {
	                    "e": 1361070000000,
	                    "s": 1382241600000
	                },
	                {
	                    "e": 1392519600000,
	                    "s": 1413691200000
	                }
	            ]
	        },
	        {
	            "name": "America/Goose_Bay",
	            "rules": [
	                {
	                    "e": 1225594860000,
	                    "s": 1205035260000
	                },
	                {
	                    "e": 1257044460000,
	                    "s": 1236484860000
	                },
	                {
	                    "e": 1289098860000,
	                    "s": 1268539260000
	                },
	                {
	                    "e": 1320555600000,
	                    "s": 1299988860000
	                },
	                {
	                    "e": 1352005200000,
	                    "s": 1331445600000
	                },
	                {
	                    "e": 1383454800000,
	                    "s": 1362895200000
	                },
	                {
	                    "e": 1414904400000,
	                    "s": 1394344800000
	                }
	            ]
	        },
	        {
	            "name": "America/Havana",
	            "rules": [
	                {
	                    "e": 1224997200000,
	                    "s": 1205643600000
	                },
	                {
	                    "e": 1256446800000,
	                    "s": 1236488400000
	                },
	                {
	                    "e": 1288501200000,
	                    "s": 1268542800000
	                },
	                {
	                    "e": 1321160400000,
	                    "s": 1300597200000
	                },
	                {
	                    "e": 1352005200000,
	                    "s": 1333256400000
	                },
	                {
	                    "e": 1383454800000,
	                    "s": 1362891600000
	                },
	                {
	                    "e": 1414904400000,
	                    "s": 1394341200000
	                }
	            ]
	        },
	        {
	            "name": "America/Mazatlan",
	            "rules": [
	                {
	                    "e": 1225008000000,
	                    "s": 1207472400000
	                },
	                {
	                    "e": 1256457600000,
	                    "s": 1238922000000
	                },
	                {
	                    "e": 1288512000000,
	                    "s": 1270371600000
	                },
	                {
	                    "e": 1319961600000,
	                    "s": 1301821200000
	                },
	                {
	                    "e": 1351411200000,
	                    "s": 1333270800000
	                },
	                {
	                    "e": 1382860800000,
	                    "s": 1365325200000
	                },
	                {
	                    "e": 1414310400000,
	                    "s": 1396774800000
	                }
	            ]
	        },
	        {
	            "name": "America/Mexico_City",
	            "rules": [
	                {
	                    "e": 1225004400000,
	                    "s": 1207468800000
	                },
	                {
	                    "e": 1256454000000,
	                    "s": 1238918400000
	                },
	                {
	                    "e": 1288508400000,
	                    "s": 1270368000000
	                },
	                {
	                    "e": 1319958000000,
	                    "s": 1301817600000
	                },
	                {
	                    "e": 1351407600000,
	                    "s": 1333267200000
	                },
	                {
	                    "e": 1382857200000,
	                    "s": 1365321600000
	                },
	                {
	                    "e": 1414306800000,
	                    "s": 1396771200000
	                }
	            ]
	        },
	        {
	            "name": "America/Miquelon",
	            "rules": [
	                {
	                    "e": 1225598400000,
	                    "s": 1205038800000
	                },
	                {
	                    "e": 1257048000000,
	                    "s": 1236488400000
	                },
	                {
	                    "e": 1289102400000,
	                    "s": 1268542800000
	                },
	                {
	                    "e": 1320552000000,
	                    "s": 1299992400000
	                },
	                {
	                    "e": 1352001600000,
	                    "s": 1331442000000
	                },
	                {
	                    "e": 1383451200000,
	                    "s": 1362891600000
	                },
	                {
	                    "e": 1414900800000,
	                    "s": 1394341200000
	                }
	            ]
	        },
	        {
	            "name": "America/Santa_Isabel",
	            "rules": [
	                {
	                    "e": 1225011600000,
	                    "s": 1207476000000
	                },
	                {
	                    "e": 1256461200000,
	                    "s": 1238925600000
	                },
	                {
	                    "e": 1288515600000,
	                    "s": 1270375200000
	                },
	                {
	                    "e": 1319965200000,
	                    "s": 1301824800000
	                },
	                {
	                    "e": 1351414800000,
	                    "s": 1333274400000
	                },
	                {
	                    "e": 1382864400000,
	                    "s": 1365328800000
	                },
	                {
	                    "e": 1414314000000,
	                    "s": 1396778400000
	                }
	            ]
	        },
	        {
	            "name": "America/Santiago",
	            "rules": [
	                {
	                    "e": 1206846000000,
	                    "s": 1223784000000
	                },
	                {
	                    "e": 1237086000000,
	                    "s": 1255233600000
	                },
	                {
	                    "e": 1270350000000,
	                    "s": 1286683200000
	                },
	                {
	                    "e": 1304823600000,
	                    "s": 1313899200000
	                },
	                {
	                    "e": 1335668400000,
	                    "s": 1346558400000
	                },
	                {
	                    "e": 1367118000000,
	                    "s": 1378612800000
	                },
	                {
	                    "e": 1398567600000,
	                    "s": 1410062400000
	                }
	            ]
	        },
	        {
	            "name": "America/Sao_Paulo",
	            "rules": [
	                {
	                    "e": 1203213600000,
	                    "s": 1224385200000
	                },
	                {
	                    "e": 1234663200000,
	                    "s": 1255834800000
	                },
	                {
	                    "e": 1266717600000,
	                    "s": 1287284400000
	                },
	                {
	                    "e": 1298167200000,
	                    "s": 1318734000000
	                },
	                {
	                    "e": 1330221600000,
	                    "s": 1350788400000
	                },
	                {
	                    "e": 1361066400000,
	                    "s": 1382238000000
	                },
	                {
	                    "e": 1392516000000,
	                    "s": 1413687600000
	                }
	            ]
	        },
	        {
	            "name": "Asia/Amman",
	            "rules": [
	                {
	                    "e": 1225404000000,
	                    "s": 1206655200000
	                },
	                {
	                    "e": 1256853600000,
	                    "s": 1238104800000
	                },
	                {
	                    "e": 1288303200000,
	                    "s": 1269554400000
	                },
	                {
	                    "e": 1319752800000,
	                    "s": 1301608800000
	                },
	                false,
	                false,
	                {
	                    "e": 1414706400000,
	                    "s": 1395957600000
	                }
	            ]
	        },
	        {
	            "name": "Asia/Damascus",
	            "rules": [
	                {
	                    "e": 1225486800000,
	                    "s": 1207260000000
	                },
	                {
	                    "e": 1256850000000,
	                    "s": 1238104800000
	                },
	                {
	                    "e": 1288299600000,
	                    "s": 1270159200000
	                },
	                {
	                    "e": 1319749200000,
	                    "s": 1301608800000
	                },
	                {
	                    "e": 1351198800000,
	                    "s": 1333058400000
	                },
	                {
	                    "e": 1382648400000,
	                    "s": 1364508000000
	                },
	                {
	                    "e": 1414702800000,
	                    "s": 1395957600000
	                }
	            ]
	        },
	        {
	            "name": "Asia/Dubai",
	            "rules": [
	                false,
	                false,
	                false,
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Asia/Gaza",
	            "rules": [
	                {
	                    "e": 1219957200000,
	                    "s": 1206655200000
	                },
	                {
	                    "e": 1252015200000,
	                    "s": 1238104800000
	                },
	                {
	                    "e": 1281474000000,
	                    "s": 1269640860000
	                },
	                {
	                    "e": 1312146000000,
	                    "s": 1301608860000
	                },
	                {
	                    "e": 1348178400000,
	                    "s": 1333058400000
	                },
	                {
	                    "e": 1380229200000,
	                    "s": 1364508000000
	                },
	                {
	                    "e": 1414098000000,
	                    "s": 1395957600000
	                }
	            ]
	        },
	        {
	            "name": "Asia/Irkutsk",
	            "rules": [
	                {
	                    "e": 1224957600000,
	                    "s": 1206813600000
	                },
	                {
	                    "e": 1256407200000,
	                    "s": 1238263200000
	                },
	                {
	                    "e": 1288461600000,
	                    "s": 1269712800000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Asia/Jerusalem",
	            "rules": [
	                {
	                    "e": 1223161200000,
	                    "s": 1206662400000
	                },
	                {
	                    "e": 1254006000000,
	                    "s": 1238112000000
	                },
	                {
	                    "e": 1284246000000,
	                    "s": 1269561600000
	                },
	                {
	                    "e": 1317510000000,
	                    "s": 1301616000000
	                },
	                {
	                    "e": 1348354800000,
	                    "s": 1333065600000
	                },
	                {
	                    "e": 1382828400000,
	                    "s": 1364515200000
	                },
	                {
	                    "e": 1414278000000,
	                    "s": 1395964800000
	                }
	            ]
	        },
	        {
	            "name": "Asia/Kamchatka",
	            "rules": [
	                {
	                    "e": 1224943200000,
	                    "s": 1206799200000
	                },
	                {
	                    "e": 1256392800000,
	                    "s": 1238248800000
	                },
	                {
	                    "e": 1288450800000,
	                    "s": 1269698400000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Asia/Krasnoyarsk",
	            "rules": [
	                {
	                    "e": 1224961200000,
	                    "s": 1206817200000
	                },
	                {
	                    "e": 1256410800000,
	                    "s": 1238266800000
	                },
	                {
	                    "e": 1288465200000,
	                    "s": 1269716400000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Asia/Omsk",
	            "rules": [
	                {
	                    "e": 1224964800000,
	                    "s": 1206820800000
	                },
	                {
	                    "e": 1256414400000,
	                    "s": 1238270400000
	                },
	                {
	                    "e": 1288468800000,
	                    "s": 1269720000000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Asia/Vladivostok",
	            "rules": [
	                {
	                    "e": 1224950400000,
	                    "s": 1206806400000
	                },
	                {
	                    "e": 1256400000000,
	                    "s": 1238256000000
	                },
	                {
	                    "e": 1288454400000,
	                    "s": 1269705600000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Asia/Yakutsk",
	            "rules": [
	                {
	                    "e": 1224954000000,
	                    "s": 1206810000000
	                },
	                {
	                    "e": 1256403600000,
	                    "s": 1238259600000
	                },
	                {
	                    "e": 1288458000000,
	                    "s": 1269709200000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Asia/Yekaterinburg",
	            "rules": [
	                {
	                    "e": 1224968400000,
	                    "s": 1206824400000
	                },
	                {
	                    "e": 1256418000000,
	                    "s": 1238274000000
	                },
	                {
	                    "e": 1288472400000,
	                    "s": 1269723600000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Asia/Yerevan",
	            "rules": [
	                {
	                    "e": 1224972000000,
	                    "s": 1206828000000
	                },
	                {
	                    "e": 1256421600000,
	                    "s": 1238277600000
	                },
	                {
	                    "e": 1288476000000,
	                    "s": 1269727200000
	                },
	                {
	                    "e": 1319925600000,
	                    "s": 1301176800000
	                },
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Australia/Lord_Howe",
	            "rules": [
	                {
	                    "e": 1207407600000,
	                    "s": 1223134200000
	                },
	                {
	                    "e": 1238857200000,
	                    "s": 1254583800000
	                },
	                {
	                    "e": 1270306800000,
	                    "s": 1286033400000
	                },
	                {
	                    "e": 1301756400000,
	                    "s": 1317483000000
	                },
	                {
	                    "e": 1333206000000,
	                    "s": 1349537400000
	                },
	                {
	                    "e": 1365260400000,
	                    "s": 1380987000000
	                },
	                {
	                    "e": 1396710000000,
	                    "s": 1412436600000
	                }
	            ]
	        },
	        {
	            "name": "Australia/Perth",
	            "rules": [
	                {
	                    "e": 1206813600000,
	                    "s": 1224957600000
	                },
	                false,
	                false,
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Europe/Helsinki",
	            "rules": [
	                {
	                    "e": 1224982800000,
	                    "s": 1206838800000
	                },
	                {
	                    "e": 1256432400000,
	                    "s": 1238288400000
	                },
	                {
	                    "e": 1288486800000,
	                    "s": 1269738000000
	                },
	                {
	                    "e": 1319936400000,
	                    "s": 1301187600000
	                },
	                {
	                    "e": 1351386000000,
	                    "s": 1332637200000
	                },
	                {
	                    "e": 1382835600000,
	                    "s": 1364691600000
	                },
	                {
	                    "e": 1414285200000,
	                    "s": 1396141200000
	                }
	            ]
	        },
	        {
	            "name": "Europe/Minsk",
	            "rules": [
	                {
	                    "e": 1224979200000,
	                    "s": 1206835200000
	                },
	                {
	                    "e": 1256428800000,
	                    "s": 1238284800000
	                },
	                {
	                    "e": 1288483200000,
	                    "s": 1269734400000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Europe/Moscow",
	            "rules": [
	                {
	                    "e": 1224975600000,
	                    "s": 1206831600000
	                },
	                {
	                    "e": 1256425200000,
	                    "s": 1238281200000
	                },
	                {
	                    "e": 1288479600000,
	                    "s": 1269730800000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Pacific/Apia",
	            "rules": [
	                false,
	                false,
	                false,
	                {
	                    "e": 1301752800000,
	                    "s": 1316872800000
	                },
	                {
	                    "e": 1333202400000,
	                    "s": 1348927200000
	                },
	                {
	                    "e": 1365256800000,
	                    "s": 1380376800000
	                },
	                {
	                    "e": 1396706400000,
	                    "s": 1411826400000
	                }
	            ]
	        },
	        {
	            "name": "Pacific/Fiji",
	            "rules": [
	                false,
	                false,
	                {
	                    "e": 1269698400000,
	                    "s": 1287842400000
	                },
	                {
	                    "e": 1327154400000,
	                    "s": 1319292000000
	                },
	                {
	                    "e": 1358604000000,
	                    "s": 1350741600000
	                },
	                {
	                    "e": 1390050000000,
	                    "s": 1382796000000
	                },
	                {
	                    "e": 1421503200000,
	                    "s": 1414850400000
	                }
	            ]
	        },
	        {
	            "name": "Europe/London",
	            "rules": [
	                {
	                    "e": 1224982800000,
	                    "s": 1206838800000
	                },
	                {
	                    "e": 1256432400000,
	                    "s": 1238288400000
	                },
	                {
	                    "e": 1288486800000,
	                    "s": 1269738000000
	                },
	                {
	                    "e": 1319936400000,
	                    "s": 1301187600000
	                },
	                {
	                    "e": 1351386000000,
	                    "s": 1332637200000
	                },
	                {
	                    "e": 1382835600000,
	                    "s": 1364691600000
	                },
	                {
	                    "e": 1414285200000,
	                    "s": 1396141200000
	                }
	            ]
	        }
	    ]
	};
	{
	    module.exports = jstz;
	}
	}());
	});

	var tz = jstz.determine();
	var murmurhash3_32_gc = murmurhash.v3;
	var windowAlias = window;
	var navigatorAlias = navigator;
	var screenAlias = screen;
	var documentAlias = document;
	/*
	  * Checks whether sessionStorage is available, in a way that
	  * does not throw a SecurityError in Firefox if "always ask"
	  * is enabled for cookies (https://github.com/snowplow/snowplow/issues/163).
	  */

	var hasSessionStorage = function hasSessionStorage() {
	  try {
	    return !!windowAlias.sessionStorage;
	  } catch (e) {
	    return true; // SecurityError when referencing it means it exists
	  }
	};
	/*
	  * Checks whether localStorage is available, in a way that
	  * does not throw a SecurityError in Firefox if "always ask"
	  * is enabled for cookies (https://github.com/snowplow/snowplow/issues/163).
	  */

	var hasLocalStorage = function hasLocalStorage() {
	  try {
	    return !!windowAlias.localStorage;
	  } catch (e) {
	    return true; // SecurityError when referencing it means it exists
	  }
	};
	/*
	  * Checks whether localStorage is accessible
	  * sets and removes an item to handle private IOS5 browsing
	  * (http://git.io/jFB2Xw)
	  */

	var localStorageAccessible = function localStorageAccessible() {
	  var mod = 'modernizr';

	  if (!hasLocalStorage()) {
	    return false;
	  }

	  try {
	    windowAlias.localStorage.setItem(mod, mod);
	    windowAlias.localStorage.removeItem(mod);
	    return true;
	  } catch (e) {
	    return false;
	  }
	};
	/*
	  * Does browser have cookies enabled (for this site)?
	  */

	var hasCookies = function hasCookies(testCookieName) {
	  var cookieName = testCookieName || 'testcookie';

	  if (isUndefined(navigatorAlias.cookieEnabled)) {
	    cookie$1.cookie(cookieName, '1');
	    return cookie$1.cookie(cookieName) === '1' ? '1' : '0';
	  }

	  return navigatorAlias.cookieEnabled ? '1' : '0';
	};
	/**
	 * JS Implementation for browser fingerprint.
	 * Does not require any external resources.
	 * Based on https://github.com/carlo/jquery-browser-fingerprint
	 * @return {number} 32-bit positive integer hash
	 */

	var detectSignature = function detectSignature(hashSeed) {
	  var fingerprint = [navigatorAlias.userAgent, [screenAlias.height, screenAlias.width, screenAlias.colorDepth].join('x'), new Date().getTimezoneOffset(), hasSessionStorage(), hasLocalStorage()];
	  var plugins = [];

	  if (navigatorAlias.plugins) {
	    for (var i = 0; i < navigatorAlias.plugins.length; i++) {
	      if (navigatorAlias.plugins[i]) {
	        var mt = [];

	        for (var j = 0; j < navigatorAlias.plugins[i].length; j++) {
	          mt.push([navigatorAlias.plugins[i][j].type, navigatorAlias.plugins[i][j].suffixes]);
	        }

	        plugins.push([navigatorAlias.plugins[i].name + '::' + navigatorAlias.plugins[i].description, mt.join('~')]);
	      }
	    }
	  }

	  return murmurhash3_32_gc(fingerprint.join('###') + '###' + plugins.sort().join(';'), hashSeed);
	};
	/*
	  * Returns visitor timezone
	  */

	var detectTimezone = function detectTimezone() {
	  return typeof tz === 'undefined' ? '' : tz.name();
	};
	/**
	 * Gets the current viewport.
	 *
	 * Code based on:
	 * - http://andylangton.co.uk/articles/javascript/get-viewport-size-javascript/
	 * - http://responsejs.com/labs/dimensions/
	 */

	var detectViewport = function detectViewport() {
	  var e = windowAlias;
	  var a = 'inner';

	  if (!('innerWidth' in windowAlias)) {
	    a = 'client';
	    e = documentAlias.documentElement || documentAlias.body;
	  }

	  var width = e[a + 'Width'];
	  var height = e[a + 'Height'];

	  if (width >= 0 && height >= 0) {
	    return width + 'x' + height;
	  }

	  return null;
	};
	/**
	 * Gets the dimensions of the current
	 * document.
	 *
	 * Code based on:
	 * - http://andylangton.co.uk/articles/javascript/get-viewport-size-javascript/
	 */

	var detectDocumentSize = function detectDocumentSize() {
	  var de = documentAlias.documentElement; // Alias

	  var be = documentAlias.body; // document.body may not have rendered, so check whether be.offsetHeight is null

	  var bodyHeight = be ? Math.max(be.offsetHeight, be.scrollHeight) : 0;
	  var w = Math.max(de.clientWidth, de.offsetWidth, de.scrollWidth);
	  var h = Math.max(de.clientHeight, de.offsetHeight, de.scrollHeight, bodyHeight);
	  return isNaN(w) || isNaN(h) ? '' : w + 'x' + h;
	};
	/**
	 * Returns browser features (plugins, resolution, cookies)
	 *
	 * @param boolean useCookies Whether to test for cookies
	 * @param string testCookieName Name to use for the test cookie
	 * @return Object containing browser features
	 */

	var detectBrowserFeatures = function detectBrowserFeatures(useCookies, testCookieName) {
	  var i;
	  var mimeType;
	  var pluginMap = {
	    // document types
	    pdf: 'application/pdf',
	    // media players
	    qt: 'video/quicktime',
	    realp: 'audio/x-pn-realaudio-plugin',
	    wma: 'application/x-mplayer2',
	    // interactive multimedia
	    dir: 'application/x-director',
	    fla: 'application/x-shockwave-flash',
	    // RIA
	    java: 'application/x-java-vm',
	    gears: 'application/x-googlegears',
	    ag: 'application/x-silverlight'
	  };
	  var features = {}; // General plugin detection

	  if (navigatorAlias.mimeTypes && navigatorAlias.mimeTypes.length) {
	    for (i in pluginMap) {
	      if (Object.prototype.hasOwnProperty.call(pluginMap, i)) {
	        mimeType = navigatorAlias.mimeTypes[pluginMap[i]];
	        features[i] = mimeType && mimeType.enabledPlugin ? '1' : '0';
	      }
	    }
	  } // Safari and Opera
	  // IE6/IE7 navigator.javaEnabled can't be aliased, so test directly


	  if (navigatorAlias.constructor === window.Navigator && typeof navigatorAlias.javaEnabled !== 'unknown' && !isUndefined(navigatorAlias.javaEnabled) && navigatorAlias.javaEnabled()) {
	    features.java = '1';
	  } // Firefox


	  if (isFunction(windowAlias.GearsFactory)) {
	    features.gears = '1';
	  } // Other browser features


	  features.res = screenAlias.width + 'x' + screenAlias.height;
	  features.cd = screenAlias.colorDepth;

	  if (useCookies) {
	    features.cookie = hasCookies(testCookieName);
	  }

	  return features;
	};

	var crypt = createCommonjsModule(function (module) {
	(function() {
	  var base64map
	      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',

	  crypt = {
	    // Bit-wise rotation left
	    rotl: function(n, b) {
	      return (n << b) | (n >>> (32 - b));
	    },

	    // Bit-wise rotation right
	    rotr: function(n, b) {
	      return (n << (32 - b)) | (n >>> b);
	    },

	    // Swap big-endian to little-endian and vice versa
	    endian: function(n) {
	      // If number given, swap endian
	      if (n.constructor == Number) {
	        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
	      }

	      // Else, assume array and swap all items
	      for (var i = 0; i < n.length; i++)
	        n[i] = crypt.endian(n[i]);
	      return n;
	    },

	    // Generate an array of any length of random bytes
	    randomBytes: function(n) {
	      for (var bytes = []; n > 0; n--)
	        bytes.push(Math.floor(Math.random() * 256));
	      return bytes;
	    },

	    // Convert a byte array to big-endian 32-bit words
	    bytesToWords: function(bytes) {
	      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
	        words[b >>> 5] |= bytes[i] << (24 - b % 32);
	      return words;
	    },

	    // Convert big-endian 32-bit words to a byte array
	    wordsToBytes: function(words) {
	      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
	        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
	      return bytes;
	    },

	    // Convert a byte array to a hex string
	    bytesToHex: function(bytes) {
	      for (var hex = [], i = 0; i < bytes.length; i++) {
	        hex.push((bytes[i] >>> 4).toString(16));
	        hex.push((bytes[i] & 0xF).toString(16));
	      }
	      return hex.join('');
	    },

	    // Convert a hex string to a byte array
	    hexToBytes: function(hex) {
	      for (var bytes = [], c = 0; c < hex.length; c += 2)
	        bytes.push(parseInt(hex.substr(c, 2), 16));
	      return bytes;
	    },

	    // Convert a byte array to a base-64 string
	    bytesToBase64: function(bytes) {
	      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
	        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
	        for (var j = 0; j < 4; j++)
	          if (i * 8 + j * 6 <= bytes.length * 8)
	            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
	          else
	            base64.push('=');
	      }
	      return base64.join('');
	    },

	    // Convert a base-64 string to a byte array
	    base64ToBytes: function(base64) {
	      // Remove non-base-64 characters
	      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');

	      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
	          imod4 = ++i % 4) {
	        if (imod4 == 0) continue;
	        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
	            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
	            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
	      }
	      return bytes;
	    }
	  };

	  module.exports = crypt;
	})();
	});

	var charenc = {
	  // UTF-8 encoding
	  utf8: {
	    // Convert a string to a byte array
	    stringToBytes: function(str) {
	      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
	    },

	    // Convert a byte array to a string
	    bytesToString: function(bytes) {
	      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
	    }
	  },

	  // Binary encoding
	  bin: {
	    // Convert a string to a byte array
	    stringToBytes: function(str) {
	      for (var bytes = [], i = 0; i < str.length; i++)
	        bytes.push(str.charCodeAt(i) & 0xFF);
	      return bytes;
	    },

	    // Convert a byte array to a string
	    bytesToString: function(bytes) {
	      for (var str = [], i = 0; i < bytes.length; i++)
	        str.push(String.fromCharCode(bytes[i]));
	      return str.join('');
	    }
	  }
	};

	var charenc_1 = charenc;

	var sha1 = createCommonjsModule(function (module) {
	(function() {
	  var crypt$1 = crypt,
	      utf8 = charenc_1.utf8,
	      bin = charenc_1.bin,

	  // The core
	  sha1 = function (message) {
	    // Convert to byte array
	    if (message.constructor == String)
	      message = utf8.stringToBytes(message);
	    else if (typeof Buffer !== 'undefined' && typeof Buffer.isBuffer == 'function' && Buffer.isBuffer(message))
	      message = Array.prototype.slice.call(message, 0);
	    else if (!Array.isArray(message))
	      message = message.toString();

	    // otherwise assume byte array

	    var m  = crypt$1.bytesToWords(message),
	        l  = message.length * 8,
	        w  = [],
	        H0 =  1732584193,
	        H1 = -271733879,
	        H2 = -1732584194,
	        H3 =  271733878,
	        H4 = -1009589776;

	    // Padding
	    m[l >> 5] |= 0x80 << (24 - l % 32);
	    m[((l + 64 >>> 9) << 4) + 15] = l;

	    for (var i = 0; i < m.length; i += 16) {
	      var a = H0,
	          b = H1,
	          c = H2,
	          d = H3,
	          e = H4;

	      for (var j = 0; j < 80; j++) {

	        if (j < 16)
	          w[j] = m[i + j];
	        else {
	          var n = w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16];
	          w[j] = (n << 1) | (n >>> 31);
	        }

	        var t = ((H0 << 5) | (H0 >>> 27)) + H4 + (w[j] >>> 0) + (
	                j < 20 ? (H1 & H2 | ~H1 & H3) + 1518500249 :
	                j < 40 ? (H1 ^ H2 ^ H3) + 1859775393 :
	                j < 60 ? (H1 & H2 | H1 & H3 | H2 & H3) - 1894007588 :
	                         (H1 ^ H2 ^ H3) - 899497514);

	        H4 = H3;
	        H3 = H2;
	        H2 = (H1 << 30) | (H1 >>> 2);
	        H1 = H0;
	        H0 = t;
	      }

	      H0 += a;
	      H1 += b;
	      H2 += c;
	      H3 += d;
	      H4 += e;
	    }

	    return [H0, H1, H2, H3, H4];
	  },

	  // Public API
	  api = function (message, options) {
	    var digestbytes = crypt$1.wordsToBytes(sha1(message));
	    return options && options.asBytes ? digestbytes :
	        options && options.asString ? bin.bytesToString(digestbytes) :
	        crypt$1.bytesToHex(digestbytes);
	  };

	  api._blocksize = 16;
	  api._digestsize = 20;

	  module.exports = api;
	})();
	});

	/**
	 * Object for handling automatic link tracking
	 *
	 * @param object core The tracker core
	 * @param string trackerId Unique identifier for the tracker instance, used to mark tracked links
	 * @param function contextAdder Function to add common contexts like PerformanceTiming to all events
	 * @return object linkTrackingManager instance
	 */

	var getLinkTrackingManager = function getLinkTrackingManager(core, trackerId, contextAdder) {
	  // Filter function used to determine whether clicks on a link should be tracked
	  var linkTrackingFilter; // Whether pseudo clicks are tracked

	  var linkTrackingPseudoClicks; // Whether to track the  innerHTML of clicked links

	  var linkTrackingContent; // The context attached to link click events

	  var linkTrackingContext; // Internal state of the pseudo click handler

	  var lastButton;
	  var lastTarget;
	  /*
	   * Process clicks
	   */

	  function processClick(sourceElement, context) {
	    var parentElement;
	    var tag;
	    var elementId;
	    var elementClasses;
	    var elementTarget;
	    var elementContent;

	    while ((parentElement = sourceElement.parentNode) !== null && !isUndefined(parentElement) && (tag = sourceElement.tagName.toUpperCase()) !== 'A' && tag !== 'AREA') {
	      sourceElement = parentElement;
	    }

	    if (!isUndefined(sourceElement.href)) {
	      // browsers, such as Safari, don't downcase hostname and href
	      var originalSourceHostName = sourceElement.hostname || getHostName(sourceElement.href);
	      var sourceHostName = originalSourceHostName.toLowerCase();
	      var sourceHref = sourceElement.href.replace(originalSourceHostName, sourceHostName);
	      var scriptProtocol = new RegExp('^(javascript|vbscript|jscript|mocha|livescript|ecmascript|mailto):', 'i'); // Ignore script pseudo-protocol links

	      if (!scriptProtocol.test(sourceHref)) {
	        elementId = sourceElement.id;
	        elementClasses = getCssClasses(sourceElement);
	        elementTarget = sourceElement.target;
	        elementContent = linkTrackingContent ? sourceElement.innerHTML : null; // decodeUrl %xx

	        sourceHref = unescape(sourceHref);
	        core.trackLinkClick(sourceHref, elementId, elementClasses, elementTarget, elementContent, contextAdder(context));
	      }
	    }
	  }
	  /*
	   * Return function to handle click event
	   */


	  function getClickHandler(context) {
	    return function (evt) {
	      var button;
	      var target;
	      evt = evt || window.event;
	      button = evt.which || evt.button;
	      target = evt.target || evt.srcElement; // Using evt.type (added in IE4), we avoid defining separate handlers for mouseup and mousedown.

	      if (evt.type === 'click') {
	        if (target) {
	          processClick(target, context);
	        }
	      } else if (evt.type === 'mousedown') {
	        if ((button === 1 || button === 2) && target) {
	          lastButton = button;
	          lastTarget = target;
	        } else {
	          lastButton = lastTarget = null;
	        }
	      } else if (evt.type === 'mouseup') {
	        if (button === lastButton && target === lastTarget) {
	          processClick(target, context);
	        }

	        lastButton = lastTarget = null;
	      }
	    };
	  }
	  /*
	   * Add click listener to a DOM element
	   */


	  function addClickListener(element) {
	    if (linkTrackingPseudoClicks) {
	      // for simplicity and performance, we ignore drag events
	      addEventListener(element, 'mouseup', getClickHandler(linkTrackingContext), false);
	      addEventListener(element, 'mousedown', getClickHandler(linkTrackingContext), false);
	    } else {
	      addEventListener(element, 'click', getClickHandler(linkTrackingContext), false);
	    }
	  }

	  return {
	    /*
	     * Configures link click tracking: how to filter which links will be tracked,
	     * whether to use pseudo click tracking, and what context to attach to link_click events
	     */
	    configureLinkClickTracking: function configureLinkClickTracking(criterion, pseudoClicks, trackContent, context) {
	      linkTrackingContent = trackContent;
	      linkTrackingContext = context;
	      linkTrackingPseudoClicks = pseudoClicks;
	      linkTrackingFilter = getFilter(criterion, true);
	    },

	    /*
	     * Add click handlers to anchor and AREA elements, except those to be ignored
	     */
	    addClickListeners: function addClickListeners() {
	      var linkElements = document.links;
	      var i;

	      for (i = 0; i < linkElements.length; i++) {
	        // Add a listener to link elements which pass the filter and aren't already tracked
	        if (linkTrackingFilter(linkElements[i]) && !linkElements[i][trackerId]) {
	          addClickListener(linkElements[i]);
	          linkElements[i][trackerId] = true;
	        }
	      }
	    }
	  };
	};

	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate);
	      collection = keys$1(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);

	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}

	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;

	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;

	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;

	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;

	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;

	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber$1(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol$1(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}

	/** Used as references for various `Number` constants. */
	var INFINITY$2 = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;

	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber$1(value);
	  if (value === INFINITY$2 || value === -INFINITY$2) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}

	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;

	  return result === result ? (remainder ? result - remainder : result) : 0;
	}

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;

	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate), index);
	}

	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);

	/*
	 * JavaScript tracker for Snowplow: forms.js
	 *
	 * Significant portions copyright 2010 Anthon Pang. Remainder copyright
	 * 2012-2014 Snowplow Analytics Ltd. All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * * Redistributions of source code must retain the above copyright
	 *   notice, this list of conditions and the following disclaimer.
	 *
	 * * Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * * Neither the name of Anthon Pang nor Snowplow Analytics Ltd nor the
	 *   names of their contributors may be used to endorse or promote products
	 *   derived from this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
	 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
	 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
	 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
	 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
	 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	/**
	 * Object for handling automatic form tracking
	 *
	 * @param object core The tracker core
	 * @param string trackerId Unique identifier for the tracker instance, used to mark tracked elements
	 * @param function contextAdder Function to add common contexts like PerformanceTiming to all events
	 * @return object formTrackingManager instance
	 */

	var getFormTrackingManager = function getFormTrackingManager(core, trackerId, contextAdder) {
	  // Tag names of mutable elements inside a form
	  var innerElementTags = ['textarea', 'input', 'select']; // Used to mark elements with event listeners

	  var trackingMarker = trackerId + 'form'; // Filter to determine which forms should be tracked

	  var formFilter = function formFilter() {
	    return true;
	  }; // Filter to determine which form fields should be tracked


	  var fieldFilter = function fieldFilter() {
	    return true;
	  }; // Default function applied to all elements, optionally overridden by transform field


	  var fieldTransform = function fieldTransform(x) {
	    return x;
	  };
	  /*
	  * Get an identifier for a form, input, textarea, or select element
	  */


	  function getFormElementName(elt) {
	    return elt[find(['name', 'id', 'type', 'nodeName'], function (propName) {
	      // If elt has a child whose name is "id", that element will be returned
	      // instead of the actual id of elt unless we ensure that a string is returned
	      return elt[propName] && typeof elt[propName] === 'string';
	    })];
	  }
	  /*
	  * Identifies the parent form in which an element is contained
	  */


	  function getParentFormName(elt) {
	    while (elt && elt.nodeName && elt.nodeName.toUpperCase() !== 'HTML' && elt.nodeName.toUpperCase() !== 'FORM') {
	      elt = elt.parentNode;
	    }

	    if (elt && elt.nodeName && elt.nodeName.toUpperCase() === 'FORM') {
	      return getFormElementName(elt);
	    }
	  }
	  /*
	  * Returns a list of the input, textarea, and select elements inside a form along with their values
	  */


	  function getInnerFormElements(elt) {
	    var innerElements = [];
	    forEach(innerElementTags, function (tagname) {
	      var trackedChildren = filter(elt.getElementsByTagName(tagname), function (child) {
	        return child.hasOwnProperty(trackingMarker);
	      });
	      forEach(trackedChildren, function (child) {
	        if (child.type === 'submit') {
	          return;
	        }

	        var elementJson = {
	          name: getFormElementName(child),
	          value: child.value,
	          nodeName: child.nodeName
	        };

	        if (child.type && child.nodeName.toUpperCase() === 'INPUT') {
	          elementJson.type = child.type;
	        }

	        if ((child.type === 'checkbox' || child.type === 'radio') && !child.checked) {
	          elementJson.value = null;
	        }

	        innerElements.push(elementJson);
	      });
	    });
	    return innerElements;
	  }
	  /*
	  * Return function to handle form field change event
	  */


	  function getFormChangeListener(context) {
	    return function (e) {
	      var elt = e.target;
	      var type = elt.nodeName && elt.nodeName.toUpperCase() === 'INPUT' ? elt.type : null;
	      var value = elt.type === 'checkbox' && !elt.checked ? null : fieldTransform(elt.value);
	      core.trackFormChange(getParentFormName(elt), getFormElementName(elt), elt.nodeName, type, getCssClasses(elt), value, contextAdder(context));
	    };
	  }
	  /*
	  * Return function to handle form submission event
	  */


	  function getFormSubmissionListener(context) {
	    return function (e) {
	      var elt = e.target;
	      var innerElements = getInnerFormElements(elt);
	      forEach(innerElements, function (innerElement) {
	        innerElement.value = fieldTransform(innerElement.value);
	      });
	      core.trackFormSubmission(getFormElementName(elt), getCssClasses(elt), innerElements, contextAdder(context));
	    };
	  }

	  return {
	    /*
	    * Configures form tracking: which forms and fields will be tracked, and the context to attach
	    */
	    configureFormTracking: function configureFormTracking(config) {
	      if (config) {
	        formFilter = getFilter(config.forms, true);
	        fieldFilter = getFilter(config.fields, false);
	        fieldTransform = getTransform(config.fields);
	      }
	    },

	    /*
	    * Add submission event listeners to all form elements
	    * Add value change event listeners to all mutable inner form elements
	    */
	    addFormListeners: function addFormListeners(context) {
	      forEach(document.getElementsByTagName('form'), function (form) {
	        if (formFilter(form) && !form[trackingMarker]) {
	          forEach(innerElementTags, function (tagname) {
	            forEach(form.getElementsByTagName(tagname), function (innerElement) {
	              if (fieldFilter(innerElement) && !innerElement[trackingMarker] && innerElement.type.toLowerCase() !== 'password') {
	                addEventListener(innerElement, 'change', getFormChangeListener(context), false);
	                innerElement[trackingMarker] = true;
	              }
	            });
	          });
	          addEventListener(form, 'submit', getFormSubmissionListener(context));
	          form[trackingMarker] = true;
	        }
	      });
	    }
	  };
	};

	/*
	 * JavaScript tracker for Snowplow: tracker.js
	 *
	 * Significant portions copyright 2010 Anthon Pang. Remainder copyright
	 * 2012-2016 Snowplow Analytics Ltd. All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * * Redistributions of source code must retain the above copyright
	 *   notice, this list of conditions and the following disclaimer.
	 *
	 * * Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * * Neither the name of Anthon Pang nor Snowplow Analytics Ltd nor the
	 *   names of their contributors may be used to endorse or promote products
	 *   derived from this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
	 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
	 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
	 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
	 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
	 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	var windowAlias$1 = window;
	var errorManager = function errorManager(core) {
	  /**
	  * Send error as self-describing event
	  *
	  * @param message string Message appeared in console
	  * @param filename string Source file (not used)
	  * @param lineno number Line number
	  * @param colno number Column number (not used)
	  * @param error Error error object (not present in all browsers)
	  * @param contexts Array of custom contexts
	  */
	  function track(message, filename, lineno, colno, error, contexts) {
	    var stack = error && error.stack ? error.stack : null;
	    core.trackSelfDescribingEvent({
	      schema: 'iglu:com.snowplowanalytics.snowplow/application_error/jsonschema/1-0-1',
	      data: {
	        programmingLanguage: 'JAVASCRIPT',
	        message: message || "JS Exception. Browser doesn't support ErrorEvent API",
	        stackTrace: stack,
	        lineNumber: lineno,
	        lineColumn: colno,
	        fileName: filename
	      }
	    }, contexts);
	  }
	  /**
	  * Attach custom contexts using `contextAdder`
	  *
	  *
	  * @param contextsAdder function to get details from internal browser state
	  * @returns {Array} custom contexts
	  */


	  function sendError(errorEvent, commonContexts, contextsAdder) {
	    var contexts;

	    if (isFunction(contextsAdder)) {
	      contexts = commonContexts.concat(contextsAdder(errorEvent));
	    } else {
	      contexts = commonContexts;
	    }

	    track(errorEvent.message, errorEvent.filename, errorEvent.lineno, errorEvent.colno, errorEvent.error, contexts);
	  }

	  return {
	    /**
	    * Track unhandled exception.
	    * This method supposed to be used inside try/catch block or with window.onerror
	    * (contexts won't be attached), but NOT with `addEventListener` - use
	    * `enableErrorTracker` for this
	    *
	    * @param message string Message appeared in console
	    * @param filename string Source file (not used)
	    * @param lineno number Line number
	    * @param colno number Column number (not used)
	    * @param error Error error object (not present in all browsers)
	    * @param contexts Array of custom contexts
	    */
	    trackError: track,

	    /**
	         * Curried function to enable tracking of unhandled exceptions.
	    * Listen for `error` event and
	    *
	    * @param filter Function ErrorEvent => Bool to check whether error should be tracker
	    * @param contextsAdder Function ErrorEvent => Array<Context> to add custom contexts with
	    *                     internal state based on particular error
	    */
	    enableErrorTracking: function enableErrorTracking(filter, contextsAdder, contexts) {
	      /**
	      * Closure callback to filter, contextualize and track unhandled exceptions
	      *
	      * @param errorEvent ErrorEvent passed to event listener
	      */
	      function captureError(errorEvent) {
	        if (isFunction(filter) && filter(errorEvent) || filter == null) {
	          sendError(errorEvent, contexts, contextsAdder);
	        }
	      }

	      addEventListener(windowAlias$1, 'error', captureError, true);
	    }
	  };
	};

	var _typeof_1 = createCommonjsModule(function (module) {
	function _typeof(obj) {
	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    module.exports = _typeof = function _typeof(obj) {
	      return typeof obj;
	    };
	  } else {
	    module.exports = _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }

	  return _typeof(obj);
	}

	module.exports = _typeof;
	});

	var defineProperty$2 = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());

	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty$2) {
	    defineProperty$2(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}

	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee);

	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, key, iteratee(value, key, object));
	  });
	  return result;
	}

	/**
	 * Object handling sending events to a collector.
	 * Instantiated once per tracker instance.
	 *
	 * @param string functionName The Snowplow function name (used to generate the localStorage key)
	 * @param string namespace The tracker instance's namespace (used to generate the localStorage key)
	 * @param object mutSnowplowState Gives the pageUnloadGuard a reference to the outbound queue
	 *                                so it can unload the page when all queues are empty
	 * @param boolean useLocalStorage Whether to use localStorage at all
	 * @param boolean usePost Whether to send events by POST or GET
	 * @param int bufferSize How many events to batch in localStorage before sending them all.
	 *                       Only applies when sending POST requests and when localStorage is available.
	 * @param int maxPostBytes Maximum combined size in bytes of the event JSONs in a POST request
	 * @return object OutQueueManager instance
	 */

	var OutQueueManager = function OutQueueManager(functionName, namespace, mutSnowplowState, useLocalStorage, usePost, bufferSize, maxPostBytes) {
	  var queueName;
	  var executingQueue = false;
	  var configCollectorUrl;
	  var outQueue; // Fall back to GET for browsers which don't support CORS XMLHttpRequests (e.g. IE <= 9)

	  usePost = usePost && window.XMLHttpRequest && 'withCredentials' in new XMLHttpRequest();
	  var path = usePost ? '/com.snowplowanalytics.snowplow/tp2' : '/i';
	  bufferSize = localStorageAccessible() && useLocalStorage && usePost && bufferSize || 1; // Different queue names for GET and POST since they are stored differently

	  queueName = ['snowplowOutQueue', functionName, namespace, usePost ? 'post2' : 'get'].join('_');

	  if (useLocalStorage) {
	    // Catch any JSON parse errors or localStorage that might be thrown
	    try {
	      // TODO: backward compatibility with the old version of the queue for POST requests
	      outQueue = JSON.parse(localStorage.getItem(queueName));
	    } catch (e) {}
	  } // Initialize to and empty array if we didn't get anything out of localStorage


	  if (!isArray(outQueue)) {
	    outQueue = [];
	  } // Used by pageUnloadGuard


	  mutSnowplowState.outQueues.push(outQueue);

	  if (usePost && bufferSize > 1) {
	    mutSnowplowState.bufferFlushers.push(function () {
	      if (!executingQueue) {
	        executeQueue();
	      }
	    });
	  }
	  /*
	    * Convert a dictionary to a querystring
	    * The context field is the last in the querystring
	    */


	  function getQuerystring(request) {
	    var querystring = '?';
	    var lowPriorityKeys = {
	      co: true,
	      cx: true
	    };
	    var firstPair = true;

	    for (var key in request) {
	      if (request.hasOwnProperty(key) && !lowPriorityKeys.hasOwnProperty(key)) {
	        if (!firstPair) {
	          querystring += '&';
	        } else {
	          firstPair = false;
	        }

	        querystring += encodeURIComponent(key) + '=' + encodeURIComponent(request[key]);
	      }
	    }

	    for (var contextKey in lowPriorityKeys) {
	      if (request.hasOwnProperty(contextKey) && lowPriorityKeys.hasOwnProperty(contextKey)) {
	        querystring += '&' + contextKey + '=' + encodeURIComponent(request[contextKey]);
	      }
	    }

	    return querystring;
	  }
	  /*
	    * Convert numeric fields to strings to match payload_data schema
	    */


	  function getBody(request) {
	    var cleanedRequest = mapValues(request, function (v) {
	      return v.toString();
	    });
	    return {
	      evt: cleanedRequest,
	      bytes: getUTF8Length(JSON.stringify(cleanedRequest))
	    };
	  }
	  /**
	   * Count the number of bytes a string will occupy when UTF-8 encoded
	   * Taken from http://stackoverflow.com/questions/2848462/count-bytes-in-textarea-using-javascript/
	   *
	   * @param string s
	   * @return number Length of s in bytes when UTF-8 encoded
	   */


	  function getUTF8Length(s) {
	    var len = 0;

	    for (var i = 0; i < s.length; i++) {
	      var code = s.charCodeAt(i);

	      if (code <= 0x7f) {
	        len += 1;
	      } else if (code <= 0x7ff) {
	        len += 2;
	      } else if (code >= 0xd800 && code <= 0xdfff) {
	        // Surrogate pair: These take 4 bytes in UTF-8 and 2 chars in UCS-2
	        // (Assume next char is the other [valid] half and just skip it)
	        len += 4;
	        i++;
	      } else if (code < 0xffff) {
	        len += 3;
	      } else {
	        len += 4;
	      }
	    }

	    return len;
	  }
	  /*
	    * Queue an image beacon for submission to the collector.
	    * If we're not processing the queue, we'll start.
	    */


	  function enqueueRequest(request, url) {
	    configCollectorUrl = url + path;

	    if (usePost) {
	      var body = getBody(request);

	      if (body.bytes >= maxPostBytes) {
	        warn('Event of size ' + body.bytes + ' is too long - the maximum size is ' + maxPostBytes);
	        var xhr = initializeXMLHttpRequest(configCollectorUrl);
	        xhr.send(encloseInPayloadDataEnvelope(attachStmToEvent([body.evt])));
	        return;
	      }

	      outQueue.push(body);
	    } else {
	      outQueue.push(getQuerystring(request));
	    }

	    var savedToLocalStorage = false;

	    if (useLocalStorage) {
	      savedToLocalStorage = attemptWriteLocalStorage(queueName, JSON.stringify(outQueue));
	    }

	    if (!executingQueue && (!savedToLocalStorage || outQueue.length >= bufferSize)) {
	      executeQueue();
	    }
	  }
	  /*
	    * Run through the queue of image beacons, sending them one at a time.
	    * Stops processing when we run out of queued requests, or we get an error.
	    */


	  function executeQueue() {
	    // Failsafe in case there is some way for a bad value like "null" to end up in the outQueue
	    while (outQueue.length && typeof outQueue[0] !== 'string' && _typeof_1(outQueue[0]) !== 'object') {
	      outQueue.shift();
	    }

	    if (outQueue.length < 1) {
	      executingQueue = false;
	      return;
	    } // Let's check that we have a Url to ping


	    if (!isString(configCollectorUrl)) {
	      throw 'No Snowplow collector configured, cannot track';
	    }

	    executingQueue = true;
	    var nextRequest = outQueue[0];

	    if (usePost) {
	      var chooseHowManyToExecute = function chooseHowManyToExecute(q) {
	        var numberToSend = 0;
	        var byteCount = 0;

	        while (numberToSend < q.length) {
	          byteCount += q[numberToSend].bytes;

	          if (byteCount >= maxPostBytes) {
	            break;
	          } else {
	            numberToSend += 1;
	          }
	        }

	        return numberToSend;
	      }; // Keep track of number of events to delete from queue


	      var xhr = initializeXMLHttpRequest(configCollectorUrl); // Time out POST requests after 5 seconds

	      var xhrTimeout = setTimeout(function () {
	        xhr.abort();
	        executingQueue = false;
	      }, 5000);
	      var numberToSend = chooseHowManyToExecute(outQueue);

	      xhr.onreadystatechange = function () {
	        if (xhr.readyState === 4 && xhr.status >= 200 && xhr.status < 400) {
	          for (var deleteCount = 0; deleteCount < numberToSend; deleteCount++) {
	            outQueue.shift();
	          }

	          if (useLocalStorage) {
	            attemptWriteLocalStorage(queueName, JSON.stringify(outQueue));
	          }

	          clearTimeout(xhrTimeout);
	          executeQueue();
	        } else if (xhr.readyState === 4 && xhr.status >= 400) {
	          clearTimeout(xhrTimeout);
	          executingQueue = false;
	        }
	      };

	      var batch = map(outQueue.slice(0, numberToSend), function (x) {
	        return x.evt;
	      });

	      if (batch.length > 0) {
	        xhr.send(encloseInPayloadDataEnvelope(attachStmToEvent(batch)));
	      }
	    } else {
	      var image = new Image(1, 1);

	      image.onload = function () {
	        outQueue.shift();

	        if (useLocalStorage) {
	          attemptWriteLocalStorage(queueName, JSON.stringify(outQueue));
	        }

	        executeQueue();
	      };

	      image.onerror = function () {
	        executingQueue = false;
	      };

	      image.src = configCollectorUrl + nextRequest.replace('?', '?stm=' + new Date().getTime() + '&');
	    }
	  }
	  /**
	   * Open an XMLHttpRequest for a given endpoint with the correct credentials and header
	   *
	   * @param string url The destination URL
	   * @return object The XMLHttpRequest
	   */


	  function initializeXMLHttpRequest(url) {
	    var xhr = new XMLHttpRequest();
	    xhr.open('POST', url, true);
	    xhr.withCredentials = true;
	    xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
	    return xhr;
	  }
	  /**
	   * Enclose an array of events in a self-describing payload_data JSON string
	   *
	   * @param array events Batch of events
	   * @return string payload_data self-describing JSON
	   */


	  function encloseInPayloadDataEnvelope(events) {
	    return JSON.stringify({
	      schema: 'iglu:com.snowplowanalytics.snowplow/payload_data/jsonschema/1-0-4',
	      data: events
	    });
	  }
	  /**
	   * Attaches the STM field to outbound POST events.
	   *
	   * @param events the events to attach the STM to
	   */


	  function attachStmToEvent(events) {
	    var stm = new Date().getTime().toString();

	    for (var i = 0; i < events.length; i++) {
	      events[i]['stm'] = stm;
	    }

	    return events;
	  }

	  return {
	    enqueueRequest: enqueueRequest,
	    executeQueue: executeQueue
	  };
	};

	var rng;

	var crypto = commonjsGlobal.crypto || commonjsGlobal.msCrypto; // for IE 11
	if (crypto && crypto.getRandomValues) {
	  // WHATWG crypto-based RNG - http://wiki.whatwg.org/wiki/Crypto
	  // Moderately fast, high quality
	  var _rnds8 = new Uint8Array(16);
	  rng = function whatwgRNG() {
	    crypto.getRandomValues(_rnds8);
	    return _rnds8;
	  };
	}

	if (!rng) {
	  // Math.random()-based (RNG)
	  //
	  // If all else fails, use Math.random().  It's fast, but is of unspecified
	  // quality.
	  var  _rnds = new Array(16);
	  rng = function() {
	    for (var i = 0, r; i < 16; i++) {
	      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
	      _rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	    }

	    return _rnds;
	  };
	}

	var rngBrowser = rng;

	//     uuid.js
	//
	//     Copyright (c) 2010-2012 Robert Kieffer
	//     MIT License - http://opensource.org/licenses/mit-license.php

	// Unique ID creation requires a high quality random # generator.  We feature
	// detect to determine the best RNG source, normalizing to a function that
	// returns 128-bits of randomness, since that's what's usually required


	// Maps for number <-> hex string conversion
	var _byteToHex = [];
	var _hexToByte = {};
	for (var i$2 = 0; i$2 < 256; i$2++) {
	  _byteToHex[i$2] = (i$2 + 0x100).toString(16).substr(1);
	  _hexToByte[_byteToHex[i$2]] = i$2;
	}

	// **`parse()` - Parse a UUID into it's component bytes**
	function parse(s, buf, offset) {
	  var i = (buf && offset) || 0, ii = 0;

	  buf = buf || [];
	  s.toLowerCase().replace(/[0-9a-f]{2}/g, function(oct) {
	    if (ii < 16) { // Don't overflow!
	      buf[i + ii++] = _hexToByte[oct];
	    }
	  });

	  // Zero out remaining bytes if string was short
	  while (ii < 16) {
	    buf[i + ii++] = 0;
	  }

	  return buf;
	}

	// **`unparse()` - Convert UUID byte array (ala parse()) into a string**
	function unparse(buf, offset) {
	  var i = offset || 0, bth = _byteToHex;
	  return  bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]];
	}

	// **`v1()` - Generate time-based UUID**
	//
	// Inspired by https://github.com/LiosK/UUID.js
	// and http://docs.python.org/library/uuid.html

	// random #'s we need to init node and clockseq
	var _seedBytes = rngBrowser();

	// Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	var _nodeId = [
	  _seedBytes[0] | 0x01,
	  _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
	];

	// Per 4.2.2, randomize (14 bit) clockseq
	var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

	// Previous uuid creation time
	var _lastMSecs = 0, _lastNSecs = 0;

	// See https://github.com/broofa/node-uuid for API details
	function v1(options, buf, offset) {
	  var i = buf && offset || 0;
	  var b = buf || [];

	  options = options || {};

	  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

	  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

	  // Per 4.2.1.2, use count of uuid's generated during the current clock
	  // cycle to simulate higher resolution clock
	  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

	  // Time since last uuid creation (in msecs)
	  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

	  // Per 4.2.1.2, Bump clockseq on clock regression
	  if (dt < 0 && options.clockseq === undefined) {
	    clockseq = clockseq + 1 & 0x3fff;
	  }

	  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	  // time interval
	  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
	    nsecs = 0;
	  }

	  // Per 4.2.1.2 Throw error if too many uuids are requested
	  if (nsecs >= 10000) {
	    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	  }

	  _lastMSecs = msecs;
	  _lastNSecs = nsecs;
	  _clockseq = clockseq;

	  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	  msecs += 12219292800000;

	  // `time_low`
	  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	  b[i++] = tl >>> 24 & 0xff;
	  b[i++] = tl >>> 16 & 0xff;
	  b[i++] = tl >>> 8 & 0xff;
	  b[i++] = tl & 0xff;

	  // `time_mid`
	  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
	  b[i++] = tmh >>> 8 & 0xff;
	  b[i++] = tmh & 0xff;

	  // `time_high_and_version`
	  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	  b[i++] = tmh >>> 16 & 0xff;

	  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	  b[i++] = clockseq >>> 8 | 0x80;

	  // `clock_seq_low`
	  b[i++] = clockseq & 0xff;

	  // `node`
	  var node = options.node || _nodeId;
	  for (var n = 0; n < 6; n++) {
	    b[i + n] = node[n];
	  }

	  return buf ? buf : unparse(b);
	}

	// **`v4()` - Generate random UUID**

	// See https://github.com/broofa/node-uuid for API details
	function v4(options, buf, offset) {
	  // Deprecated - 'format' argument, as supported in v1.2
	  var i = buf && offset || 0;

	  if (typeof(options) == 'string') {
	    buf = options == 'binary' ? new Array(16) : null;
	    options = null;
	  }
	  options = options || {};

	  var rnds = options.random || (options.rng || rngBrowser)();

	  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	  rnds[6] = (rnds[6] & 0x0f) | 0x40;
	  rnds[8] = (rnds[8] & 0x3f) | 0x80;

	  // Copy bytes to buffer, if provided
	  if (buf) {
	    for (var ii = 0; ii < 16; ii++) {
	      buf[i + ii] = rnds[ii];
	    }
	  }

	  return buf || unparse(rnds);
	}

	// Export public API
	var uuid = v4;
	uuid.v1 = v1;
	uuid.v4 = v4;
	uuid.parse = parse;
	uuid.unparse = unparse;

	var uuid_1 = uuid;

	var base64 = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	function base64urldecode(data) {
	    if (!data) {
	        return data;
	    }
	    var padding = 4 - data.length % 4;
	    switch (padding) {
	        case 2:
	            data += "==";
	            break;
	        case 3:
	            data += "=";
	            break;
	    }
	    var b64Data = data.replace(/-/g, '+').replace(/_/g, '/');
	    return base64decode(b64Data);
	}
	exports.base64urldecode = base64urldecode;
	function base64encode(data) {
	    var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	    var o1, o2, o3, h1, h2, h3, h4, bits, i = 0, ac = 0, enc, tmp_arr = [];
	    if (!data) {
	        return data;
	    }
	    data = unescape(encodeURIComponent(data));
	    do {
	        o1 = data.charCodeAt(i++);
	        o2 = data.charCodeAt(i++);
	        o3 = data.charCodeAt(i++);
	        bits = o1 << 16 | o2 << 8 | o3;
	        h1 = bits >> 18 & 0x3f;
	        h2 = bits >> 12 & 0x3f;
	        h3 = bits >> 6 & 0x3f;
	        h4 = bits & 0x3f;
	        tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
	    } while (i < data.length);
	    enc = tmp_arr.join('');
	    var r = data.length % 3;
	    return (r ? enc.slice(0, r - 3) : enc) + '==='.slice(r || 3);
	}
	exports.base64encode = base64encode;
	function base64decode(encodedData) {
	    var decodeUTF8string = function (str) {
	        return decodeURIComponent(str.split('').map(function (c) {
	            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
	        }).join(''));
	    };
	    var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	    var o1, o2, o3, h1, h2, h3, h4, bits, i = 0, ac = 0, dec = '', tmpArr = [];
	    if (!encodedData) {
	        return encodedData;
	    }
	    encodedData += '';
	    do {
	        h1 = b64.indexOf(encodedData.charAt(i++));
	        h2 = b64.indexOf(encodedData.charAt(i++));
	        h3 = b64.indexOf(encodedData.charAt(i++));
	        h4 = b64.indexOf(encodedData.charAt(i++));
	        bits = h1 << 18 | h2 << 12 | h3 << 6 | h4;
	        o1 = bits >> 16 & 0xff;
	        o2 = bits >> 8 & 0xff;
	        o3 = bits & 0xff;
	        if (h3 === 64) {
	            tmpArr[ac++] = String.fromCharCode(o1);
	        }
	        else if (h4 === 64) {
	            tmpArr[ac++] = String.fromCharCode(o1, o2);
	        }
	        else {
	            tmpArr[ac++] = String.fromCharCode(o1, o2, o3);
	        }
	    } while (i < encodedData.length);
	    dec = tmpArr.join('');
	    return decodeUTF8string(dec.replace(/\0+$/, ''));
	}
	exports.base64decode = base64decode;

	});

	unwrapExports(base64);
	var base64_1 = base64.base64urldecode;
	var base64_2 = base64.base64encode;
	var base64_3 = base64.base64decode;

	var payload = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });

	function base64urlencode(data) {
	    if (!data) {
	        return data;
	    }
	    var enc = base64.base64encode(data);
	    return enc.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
	}
	function isNonEmptyJson(property) {
	    if (!isJson(property)) {
	        return false;
	    }
	    for (var key in property) {
	        if (property.hasOwnProperty(key)) {
	            return true;
	        }
	    }
	    return false;
	}
	exports.isNonEmptyJson = isNonEmptyJson;
	function isJson(property) {
	    return (typeof property !== 'undefined' && property !== null &&
	        (property.constructor === {}.constructor || property.constructor === [].constructor));
	}
	exports.isJson = isJson;
	function payloadBuilder(base64Encode) {
	    var dict = {};
	    var add = function (key, value) {
	        if (value != null && value !== '') {
	            dict[key] = value;
	        }
	    };
	    var addDict = function (dict) {
	        for (var key in dict) {
	            if (dict.hasOwnProperty(key)) {
	                add(key, dict[key]);
	            }
	        }
	    };
	    var addJson = function (keyIfEncoded, keyIfNotEncoded, json) {
	        if (isNonEmptyJson(json)) {
	            var str = JSON.stringify(json);
	            if (base64Encode) {
	                add(keyIfEncoded, base64urlencode(str));
	            }
	            else {
	                add(keyIfNotEncoded, str);
	            }
	        }
	    };
	    return {
	        add: add,
	        addDict: addDict,
	        addJson: addJson,
	        build: function () {
	            return dict;
	        }
	    };
	}
	exports.payloadBuilder = payloadBuilder;

	});

	unwrapExports(payload);
	var payload_1 = payload.isNonEmptyJson;
	var payload_2 = payload.isJson;
	var payload_3 = payload.payloadBuilder;

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear$1() {
	  this.__data__ = [];
	  this.size = 0;
	}

	var _listCacheClear = listCacheClear$1;

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq$1(value, other) {
	  return value === other || (value !== value && other !== other);
	}

	var eq_1 = eq$1;

	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf$1(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq_1(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}

	var _assocIndexOf = assocIndexOf$1;

	/** Used for built-in method references. */
	var arrayProto$1 = Array.prototype;

	/** Built-in value references. */
	var splice$1 = arrayProto$1.splice;

	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete$1(key) {
	  var data = this.__data__,
	      index = _assocIndexOf(data, key);

	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice$1.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}

	var _listCacheDelete = listCacheDelete$1;

	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet$1(key) {
	  var data = this.__data__,
	      index = _assocIndexOf(data, key);

	  return index < 0 ? undefined : data[index][1];
	}

	var _listCacheGet = listCacheGet$1;

	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas$1(key) {
	  return _assocIndexOf(this.__data__, key) > -1;
	}

	var _listCacheHas = listCacheHas$1;

	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet$1(key, value) {
	  var data = this.__data__,
	      index = _assocIndexOf(data, key);

	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}

	var _listCacheSet = listCacheSet$1;

	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache$1(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	// Add methods to `ListCache`.
	ListCache$1.prototype.clear = _listCacheClear;
	ListCache$1.prototype['delete'] = _listCacheDelete;
	ListCache$1.prototype.get = _listCacheGet;
	ListCache$1.prototype.has = _listCacheHas;
	ListCache$1.prototype.set = _listCacheSet;

	var _ListCache = ListCache$1;

	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear$1() {
	  this.__data__ = new _ListCache;
	  this.size = 0;
	}

	var _stackClear = stackClear$1;

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete$1(key) {
	  var data = this.__data__,
	      result = data['delete'](key);

	  this.size = data.size;
	  return result;
	}

	var _stackDelete = stackDelete$1;

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet$1(key) {
	  return this.__data__.get(key);
	}

	var _stackGet = stackGet$1;

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas$1(key) {
	  return this.__data__.has(key);
	}

	var _stackHas = stackHas$1;

	/** Detect free variable `global` from Node.js. */
	var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

	var _freeGlobal = freeGlobal$1;

	/** Detect free variable `self`. */
	var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;

	/** Used as a reference to the global object. */
	var root$1 = _freeGlobal || freeSelf$1 || Function('return this')();

	var _root = root$1;

	/** Built-in value references. */
	var Symbol$2 = _root.Symbol;

	var _Symbol = Symbol$2;

	/** Used for built-in method references. */
	var objectProto$c = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$a = objectProto$c.hasOwnProperty;

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString$2 = objectProto$c.toString;

	/** Built-in value references. */
	var symToStringTag$2 = _Symbol ? _Symbol.toStringTag : undefined;

	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag$1(value) {
	  var isOwn = hasOwnProperty$a.call(value, symToStringTag$2),
	      tag = value[symToStringTag$2];

	  try {
	    value[symToStringTag$2] = undefined;
	    var unmasked = true;
	  } catch (e) {}

	  var result = nativeObjectToString$2.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag$2] = tag;
	    } else {
	      delete value[symToStringTag$2];
	    }
	  }
	  return result;
	}

	var _getRawTag = getRawTag$1;

	/** Used for built-in method references. */
	var objectProto$d = Object.prototype;

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString$3 = objectProto$d.toString;

	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString$1(value) {
	  return nativeObjectToString$3.call(value);
	}

	var _objectToString = objectToString$1;

	/** `Object#toString` result references. */
	var nullTag$1 = '[object Null]',
	    undefinedTag$1 = '[object Undefined]';

	/** Built-in value references. */
	var symToStringTag$3 = _Symbol ? _Symbol.toStringTag : undefined;

	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag$1(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag$1 : nullTag$1;
	  }
	  return (symToStringTag$3 && symToStringTag$3 in Object(value))
	    ? _getRawTag(value)
	    : _objectToString(value);
	}

	var _baseGetTag = baseGetTag$1;

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject$1(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}

	var isObject_1 = isObject$1;

	/** `Object#toString` result references. */
	var asyncTag$1 = '[object AsyncFunction]',
	    funcTag$2 = '[object Function]',
	    genTag$1 = '[object GeneratorFunction]',
	    proxyTag$1 = '[object Proxy]';

	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction$1(value) {
	  if (!isObject_1(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = _baseGetTag(value);
	  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag$1 || tag == proxyTag$1;
	}

	var isFunction_1 = isFunction$1;

	/** Used to detect overreaching core-js shims. */
	var coreJsData$1 = _root['__core-js_shared__'];

	var _coreJsData = coreJsData$1;

	/** Used to detect methods masquerading as native. */
	var maskSrcKey$1 = (function() {
	  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());

	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked$1(func) {
	  return !!maskSrcKey$1 && (maskSrcKey$1 in func);
	}

	var _isMasked = isMasked$1;

	/** Used for built-in method references. */
	var funcProto$2 = Function.prototype;

	/** Used to resolve the decompiled source of functions. */
	var funcToString$2 = funcProto$2.toString;

	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource$1(func) {
	  if (func != null) {
	    try {
	      return funcToString$2.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}

	var _toSource = toSource$1;

	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar$1 = /[\\^$.*+?()[\]{}|]/g;

	/** Used to detect host constructors (Safari). */
	var reIsHostCtor$1 = /^\[object .+?Constructor\]$/;

	/** Used for built-in method references. */
	var funcProto$3 = Function.prototype,
	    objectProto$e = Object.prototype;

	/** Used to resolve the decompiled source of functions. */
	var funcToString$3 = funcProto$3.toString;

	/** Used to check objects for own properties. */
	var hasOwnProperty$b = objectProto$e.hasOwnProperty;

	/** Used to detect if a method is native. */
	var reIsNative$1 = RegExp('^' +
	  funcToString$3.call(hasOwnProperty$b).replace(reRegExpChar$1, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);

	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative$1(value) {
	  if (!isObject_1(value) || _isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction_1(value) ? reIsNative$1 : reIsHostCtor$1;
	  return pattern.test(_toSource(value));
	}

	var _baseIsNative = baseIsNative$1;

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue$1(object, key) {
	  return object == null ? undefined : object[key];
	}

	var _getValue = getValue$1;

	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative$1(object, key) {
	  var value = _getValue(object, key);
	  return _baseIsNative(value) ? value : undefined;
	}

	var _getNative = getNative$1;

	/* Built-in method references that are verified to be native. */
	var Map$1 = _getNative(_root, 'Map');

	var _Map = Map$1;

	/* Built-in method references that are verified to be native. */
	var nativeCreate$1 = _getNative(Object, 'create');

	var _nativeCreate = nativeCreate$1;

	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear$1() {
	  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
	  this.size = 0;
	}

	var _hashClear = hashClear$1;

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete$1(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}

	var _hashDelete = hashDelete$1;

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED$3 = '__lodash_hash_undefined__';

	/** Used for built-in method references. */
	var objectProto$f = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$c = objectProto$f.hasOwnProperty;

	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet$1(key) {
	  var data = this.__data__;
	  if (_nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED$3 ? undefined : result;
	  }
	  return hasOwnProperty$c.call(data, key) ? data[key] : undefined;
	}

	var _hashGet = hashGet$1;

	/** Used for built-in method references. */
	var objectProto$g = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$d = objectProto$g.hasOwnProperty;

	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas$1(key) {
	  var data = this.__data__;
	  return _nativeCreate ? (data[key] !== undefined) : hasOwnProperty$d.call(data, key);
	}

	var _hashHas = hashHas$1;

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED$4 = '__lodash_hash_undefined__';

	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet$1(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (_nativeCreate && value === undefined) ? HASH_UNDEFINED$4 : value;
	  return this;
	}

	var _hashSet = hashSet$1;

	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash$1(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	// Add methods to `Hash`.
	Hash$1.prototype.clear = _hashClear;
	Hash$1.prototype['delete'] = _hashDelete;
	Hash$1.prototype.get = _hashGet;
	Hash$1.prototype.has = _hashHas;
	Hash$1.prototype.set = _hashSet;

	var _Hash = Hash$1;

	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear$1() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new _Hash,
	    'map': new (_Map || _ListCache),
	    'string': new _Hash
	  };
	}

	var _mapCacheClear = mapCacheClear$1;

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable$1(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}

	var _isKeyable = isKeyable$1;

	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData$1(map, key) {
	  var data = map.__data__;
	  return _isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}

	var _getMapData = getMapData$1;

	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete$1(key) {
	  var result = _getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}

	var _mapCacheDelete = mapCacheDelete$1;

	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet$1(key) {
	  return _getMapData(this, key).get(key);
	}

	var _mapCacheGet = mapCacheGet$1;

	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas$1(key) {
	  return _getMapData(this, key).has(key);
	}

	var _mapCacheHas = mapCacheHas$1;

	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet$1(key, value) {
	  var data = _getMapData(this, key),
	      size = data.size;

	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}

	var _mapCacheSet = mapCacheSet$1;

	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache$1(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	// Add methods to `MapCache`.
	MapCache$1.prototype.clear = _mapCacheClear;
	MapCache$1.prototype['delete'] = _mapCacheDelete;
	MapCache$1.prototype.get = _mapCacheGet;
	MapCache$1.prototype.has = _mapCacheHas;
	MapCache$1.prototype.set = _mapCacheSet;

	var _MapCache = MapCache$1;

	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE$1 = 200;

	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet$1(key, value) {
	  var data = this.__data__;
	  if (data instanceof _ListCache) {
	    var pairs = data.__data__;
	    if (!_Map || (pairs.length < LARGE_ARRAY_SIZE$1 - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new _MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}

	var _stackSet = stackSet$1;

	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack$1(entries) {
	  var data = this.__data__ = new _ListCache(entries);
	  this.size = data.size;
	}

	// Add methods to `Stack`.
	Stack$1.prototype.clear = _stackClear;
	Stack$1.prototype['delete'] = _stackDelete;
	Stack$1.prototype.get = _stackGet;
	Stack$1.prototype.has = _stackHas;
	Stack$1.prototype.set = _stackSet;

	var _Stack = Stack$1;

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED$5 = '__lodash_hash_undefined__';

	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd$1(value) {
	  this.__data__.set(value, HASH_UNDEFINED$5);
	  return this;
	}

	var _setCacheAdd = setCacheAdd$1;

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas$1(value) {
	  return this.__data__.has(value);
	}

	var _setCacheHas = setCacheHas$1;

	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache$1(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;

	  this.__data__ = new _MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}

	// Add methods to `SetCache`.
	SetCache$1.prototype.add = SetCache$1.prototype.push = _setCacheAdd;
	SetCache$1.prototype.has = _setCacheHas;

	var _SetCache = SetCache$1;

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome$1(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;

	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}

	var _arraySome = arraySome$1;

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas$1(cache, key) {
	  return cache.has(key);
	}

	var _cacheHas = cacheHas$1;

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG$6 = 1,
	    COMPARE_UNORDERED_FLAG$4 = 2;

	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays$1(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$6,
	      arrLength = array.length,
	      othLength = other.length;

	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG$4) ? new _SetCache : undefined;

	  stack.set(array, other);
	  stack.set(other, array);

	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];

	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!_arraySome(other, function(othValue, othIndex) {
	            if (!_cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}

	var _equalArrays = equalArrays$1;

	/** Built-in value references. */
	var Uint8Array$2 = _root.Uint8Array;

	var _Uint8Array = Uint8Array$2;

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray$1(map) {
	  var index = -1,
	      result = Array(map.size);

	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}

	var _mapToArray = mapToArray$1;

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray$1(set) {
	  var index = -1,
	      result = Array(set.size);

	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}

	var _setToArray = setToArray$1;

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG$7 = 1,
	    COMPARE_UNORDERED_FLAG$5 = 2;

	/** `Object#toString` result references. */
	var boolTag$2 = '[object Boolean]',
	    dateTag$2 = '[object Date]',
	    errorTag$2 = '[object Error]',
	    mapTag$3 = '[object Map]',
	    numberTag$2 = '[object Number]',
	    regexpTag$2 = '[object RegExp]',
	    setTag$3 = '[object Set]',
	    stringTag$3 = '[object String]',
	    symbolTag$2 = '[object Symbol]';

	var arrayBufferTag$2 = '[object ArrayBuffer]',
	    dataViewTag$3 = '[object DataView]';

	/** Used to convert symbols to primitives and strings. */
	var symbolProto$2 = _Symbol ? _Symbol.prototype : undefined,
	    symbolValueOf$1 = symbolProto$2 ? symbolProto$2.valueOf : undefined;

	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag$3:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;

	    case arrayBufferTag$2:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new _Uint8Array(object), new _Uint8Array(other))) {
	        return false;
	      }
	      return true;

	    case boolTag$2:
	    case dateTag$2:
	    case numberTag$2:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq_1(+object, +other);

	    case errorTag$2:
	      return object.name == other.name && object.message == other.message;

	    case regexpTag$2:
	    case stringTag$3:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');

	    case mapTag$3:
	      var convert = _mapToArray;

	    case setTag$3:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$7;
	      convert || (convert = _setToArray);

	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG$5;

	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = _equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;

	    case symbolTag$2:
	      if (symbolValueOf$1) {
	        return symbolValueOf$1.call(object) == symbolValueOf$1.call(other);
	      }
	  }
	  return false;
	}

	var _equalByTag = equalByTag$1;

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush$1(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;

	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}

	var _arrayPush = arrayPush$1;

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray$1 = Array.isArray;

	var isArray_1 = isArray$1;

	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys$1(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray_1(object) ? result : _arrayPush(result, symbolsFunc(object));
	}

	var _baseGetAllKeys = baseGetAllKeys$1;

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter$1(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];

	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}

	var _arrayFilter = arrayFilter$1;

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray$1() {
	  return [];
	}

	var stubArray_1 = stubArray$1;

	/** Used for built-in method references. */
	var objectProto$h = Object.prototype;

	/** Built-in value references. */
	var propertyIsEnumerable$2 = objectProto$h.propertyIsEnumerable;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols$1 = !nativeGetSymbols$1 ? stubArray_1 : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return _arrayFilter(nativeGetSymbols$1(object), function(symbol) {
	    return propertyIsEnumerable$2.call(object, symbol);
	  });
	};

	var _getSymbols = getSymbols$1;

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes$1(n, iteratee) {
	  var index = -1,
	      result = Array(n);

	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}

	var _baseTimes = baseTimes$1;

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike$1(value) {
	  return value != null && typeof value == 'object';
	}

	var isObjectLike_1 = isObjectLike$1;

	/** `Object#toString` result references. */
	var argsTag$3 = '[object Arguments]';

	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments$1(value) {
	  return isObjectLike_1(value) && _baseGetTag(value) == argsTag$3;
	}

	var _baseIsArguments = baseIsArguments$1;

	/** Used for built-in method references. */
	var objectProto$i = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$e = objectProto$i.hasOwnProperty;

	/** Built-in value references. */
	var propertyIsEnumerable$3 = objectProto$i.propertyIsEnumerable;

	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments$1 = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
	  return isObjectLike_1(value) && hasOwnProperty$e.call(value, 'callee') &&
	    !propertyIsEnumerable$3.call(value, 'callee');
	};

	var isArguments_1 = isArguments$1;

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse$1() {
	  return false;
	}

	var stubFalse_1 = stubFalse$1;

	var isBuffer_1 = createCommonjsModule(function (module, exports) {
	/** Detect free variable `exports`. */
	var freeExports =  exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Built-in value references. */
	var Buffer = moduleExports ? _root.Buffer : undefined;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse_1;

	module.exports = isBuffer;
	});

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER$2 = 9007199254740991;

	/** Used to detect unsigned integer values. */
	var reIsUint$1 = /^(?:0|[1-9]\d*)$/;

	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex$1(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER$2 : length;

	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint$1.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}

	var _isIndex = isIndex$1;

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER$3 = 9007199254740991;

	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength$1(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$3;
	}

	var isLength_1 = isLength$1;

	/** `Object#toString` result references. */
	var argsTag$4 = '[object Arguments]',
	    arrayTag$2 = '[object Array]',
	    boolTag$3 = '[object Boolean]',
	    dateTag$3 = '[object Date]',
	    errorTag$3 = '[object Error]',
	    funcTag$3 = '[object Function]',
	    mapTag$4 = '[object Map]',
	    numberTag$3 = '[object Number]',
	    objectTag$3 = '[object Object]',
	    regexpTag$3 = '[object RegExp]',
	    setTag$4 = '[object Set]',
	    stringTag$4 = '[object String]',
	    weakMapTag$2 = '[object WeakMap]';

	var arrayBufferTag$3 = '[object ArrayBuffer]',
	    dataViewTag$4 = '[object DataView]',
	    float32Tag$1 = '[object Float32Array]',
	    float64Tag$1 = '[object Float64Array]',
	    int8Tag$1 = '[object Int8Array]',
	    int16Tag$1 = '[object Int16Array]',
	    int32Tag$1 = '[object Int32Array]',
	    uint8Tag$1 = '[object Uint8Array]',
	    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
	    uint16Tag$1 = '[object Uint16Array]',
	    uint32Tag$1 = '[object Uint32Array]';

	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags$1 = {};
	typedArrayTags$1[float32Tag$1] = typedArrayTags$1[float64Tag$1] =
	typedArrayTags$1[int8Tag$1] = typedArrayTags$1[int16Tag$1] =
	typedArrayTags$1[int32Tag$1] = typedArrayTags$1[uint8Tag$1] =
	typedArrayTags$1[uint8ClampedTag$1] = typedArrayTags$1[uint16Tag$1] =
	typedArrayTags$1[uint32Tag$1] = true;
	typedArrayTags$1[argsTag$4] = typedArrayTags$1[arrayTag$2] =
	typedArrayTags$1[arrayBufferTag$3] = typedArrayTags$1[boolTag$3] =
	typedArrayTags$1[dataViewTag$4] = typedArrayTags$1[dateTag$3] =
	typedArrayTags$1[errorTag$3] = typedArrayTags$1[funcTag$3] =
	typedArrayTags$1[mapTag$4] = typedArrayTags$1[numberTag$3] =
	typedArrayTags$1[objectTag$3] = typedArrayTags$1[regexpTag$3] =
	typedArrayTags$1[setTag$4] = typedArrayTags$1[stringTag$4] =
	typedArrayTags$1[weakMapTag$2] = false;

	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray$1(value) {
	  return isObjectLike_1(value) &&
	    isLength_1(value.length) && !!typedArrayTags$1[_baseGetTag(value)];
	}

	var _baseIsTypedArray = baseIsTypedArray$1;

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary$1(func) {
	  return function(value) {
	    return func(value);
	  };
	}

	var _baseUnary = baseUnary$1;

	var _nodeUtil = createCommonjsModule(function (module, exports) {
	/** Detect free variable `exports`. */
	var freeExports =  exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && _freeGlobal.process;

	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;

	    if (types) {
	      return types;
	    }

	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());

	module.exports = nodeUtil;
	});

	/* Node.js helper references. */
	var nodeIsTypedArray$1 = _nodeUtil && _nodeUtil.isTypedArray;

	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray$1 = nodeIsTypedArray$1 ? _baseUnary(nodeIsTypedArray$1) : _baseIsTypedArray;

	var isTypedArray_1 = isTypedArray$1;

	/** Used for built-in method references. */
	var objectProto$j = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$f = objectProto$j.hasOwnProperty;

	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys$1(value, inherited) {
	  var isArr = isArray_1(value),
	      isArg = !isArr && isArguments_1(value),
	      isBuff = !isArr && !isArg && isBuffer_1(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? _baseTimes(value.length, String) : [],
	      length = result.length;

	  for (var key in value) {
	    if ((inherited || hasOwnProperty$f.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           _isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}

	var _arrayLikeKeys = arrayLikeKeys$1;

	/** Used for built-in method references. */
	var objectProto$k = Object.prototype;

	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype$1(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$k;

	  return value === proto;
	}

	var _isPrototype = isPrototype$1;

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg$1(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}

	var _overArg = overArg$1;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys$1 = _overArg(Object.keys, Object);

	var _nativeKeys = nativeKeys$1;

	/** Used for built-in method references. */
	var objectProto$l = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$g = objectProto$l.hasOwnProperty;

	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys$1(object) {
	  if (!_isPrototype(object)) {
	    return _nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty$g.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}

	var _baseKeys = baseKeys$1;

	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike$1(value) {
	  return value != null && isLength_1(value.length) && !isFunction_1(value);
	}

	var isArrayLike_1 = isArrayLike$1;

	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys$3(object) {
	  return isArrayLike_1(object) ? _arrayLikeKeys(object) : _baseKeys(object);
	}

	var keys_1 = keys$3;

	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys$1(object) {
	  return _baseGetAllKeys(object, keys_1, _getSymbols);
	}

	var _getAllKeys = getAllKeys$1;

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG$8 = 1;

	/** Used for built-in method references. */
	var objectProto$m = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$h = objectProto$m.hasOwnProperty;

	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$8,
	      objProps = _getAllKeys(object),
	      objLength = objProps.length,
	      othProps = _getAllKeys(other),
	      othLength = othProps.length;

	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty$h.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);

	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];

	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;

	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}

	var _equalObjects = equalObjects$1;

	/* Built-in method references that are verified to be native. */
	var DataView$1 = _getNative(_root, 'DataView');

	var _DataView = DataView$1;

	/* Built-in method references that are verified to be native. */
	var Promise$1 = _getNative(_root, 'Promise');

	var _Promise = Promise$1;

	/* Built-in method references that are verified to be native. */
	var Set$1 = _getNative(_root, 'Set');

	var _Set = Set$1;

	/* Built-in method references that are verified to be native. */
	var WeakMap$1 = _getNative(_root, 'WeakMap');

	var _WeakMap = WeakMap$1;

	/** `Object#toString` result references. */
	var mapTag$5 = '[object Map]',
	    objectTag$4 = '[object Object]',
	    promiseTag$1 = '[object Promise]',
	    setTag$5 = '[object Set]',
	    weakMapTag$3 = '[object WeakMap]';

	var dataViewTag$5 = '[object DataView]';

	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString$1 = _toSource(_DataView),
	    mapCtorString$1 = _toSource(_Map),
	    promiseCtorString$1 = _toSource(_Promise),
	    setCtorString$1 = _toSource(_Set),
	    weakMapCtorString$1 = _toSource(_WeakMap);

	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag$2 = _baseGetTag;

	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((_DataView && getTag$2(new _DataView(new ArrayBuffer(1))) != dataViewTag$5) ||
	    (_Map && getTag$2(new _Map) != mapTag$5) ||
	    (_Promise && getTag$2(_Promise.resolve()) != promiseTag$1) ||
	    (_Set && getTag$2(new _Set) != setTag$5) ||
	    (_WeakMap && getTag$2(new _WeakMap) != weakMapTag$3)) {
	  getTag$2 = function(value) {
	    var result = _baseGetTag(value),
	        Ctor = result == objectTag$4 ? value.constructor : undefined,
	        ctorString = Ctor ? _toSource(Ctor) : '';

	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString$1: return dataViewTag$5;
	        case mapCtorString$1: return mapTag$5;
	        case promiseCtorString$1: return promiseTag$1;
	        case setCtorString$1: return setTag$5;
	        case weakMapCtorString$1: return weakMapTag$3;
	      }
	    }
	    return result;
	  };
	}

	var _getTag = getTag$2;

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG$9 = 1;

	/** `Object#toString` result references. */
	var argsTag$5 = '[object Arguments]',
	    arrayTag$3 = '[object Array]',
	    objectTag$5 = '[object Object]';

	/** Used for built-in method references. */
	var objectProto$n = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$i = objectProto$n.hasOwnProperty;

	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray_1(object),
	      othIsArr = isArray_1(other),
	      objTag = objIsArr ? arrayTag$3 : _getTag(object),
	      othTag = othIsArr ? arrayTag$3 : _getTag(other);

	  objTag = objTag == argsTag$5 ? objectTag$5 : objTag;
	  othTag = othTag == argsTag$5 ? objectTag$5 : othTag;

	  var objIsObj = objTag == objectTag$5,
	      othIsObj = othTag == objectTag$5,
	      isSameTag = objTag == othTag;

	  if (isSameTag && isBuffer_1(object)) {
	    if (!isBuffer_1(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new _Stack);
	    return (objIsArr || isTypedArray_1(object))
	      ? _equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : _equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG$9)) {
	    var objIsWrapped = objIsObj && hasOwnProperty$i.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty$i.call(other, '__wrapped__');

	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;

	      stack || (stack = new _Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new _Stack);
	  return _equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}

	var _baseIsEqualDeep = baseIsEqualDeep$1;

	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual$1(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike_1(value) && !isObjectLike_1(other))) {
	    return value !== value && other !== other;
	  }
	  return _baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$1, stack);
	}

	var _baseIsEqual = baseIsEqual$1;

	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return _baseIsEqual(value, other);
	}

	var isEqual_1 = isEqual;

	/** Used for built-in method references. */
	var objectProto$o = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$j = objectProto$o.hasOwnProperty;

	/**
	 * The base implementation of `_.has` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHas(object, key) {
	  return object != null && hasOwnProperty$j.call(object, key);
	}

	var _baseHas = baseHas;

	/** `Object#toString` result references. */
	var symbolTag$3 = '[object Symbol]';

	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol$2(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike_1(value) && _baseGetTag(value) == symbolTag$3);
	}

	var isSymbol_1 = isSymbol$2;

	/** Used to match property names within property paths. */
	var reIsDeepProp$1 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp$1 = /^\w*$/;

	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey$1(value, object) {
	  if (isArray_1(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol_1(value)) {
	    return true;
	  }
	  return reIsPlainProp$1.test(value) || !reIsDeepProp$1.test(value) ||
	    (object != null && value in Object(object));
	}

	var _isKey = isKey$1;

	/** Error message constants. */
	var FUNC_ERROR_TEXT$1 = 'Expected a function';

	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize$1(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT$1);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;

	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize$1.Cache || _MapCache);
	  return memoized;
	}

	// Expose `MapCache`.
	memoize$1.Cache = _MapCache;

	var memoize_1 = memoize$1;

	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE$1 = 500;

	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped$1(func) {
	  var result = memoize_1(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE$1) {
	      cache.clear();
	    }
	    return key;
	  });

	  var cache = result.cache;
	  return result;
	}

	var _memoizeCapped = memoizeCapped$1;

	/** Used to match property names within property paths. */
	var rePropName$1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

	/** Used to match backslashes in property paths. */
	var reEscapeChar$1 = /\\(\\)?/g;

	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath$1 = _memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName$1, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar$1, '$1') : (number || match));
	  });
	  return result;
	});

	var _stringToPath = stringToPath$1;

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap$1(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);

	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}

	var _arrayMap = arrayMap$1;

	/** Used as references for various `Number` constants. */
	var INFINITY$3 = 1 / 0;

	/** Used to convert symbols to primitives and strings. */
	var symbolProto$3 = _Symbol ? _Symbol.prototype : undefined,
	    symbolToString$1 = symbolProto$3 ? symbolProto$3.toString : undefined;

	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString$1(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray_1(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return _arrayMap(value, baseToString$1) + '';
	  }
	  if (isSymbol_1(value)) {
	    return symbolToString$1 ? symbolToString$1.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY$3) ? '-0' : result;
	}

	var _baseToString = baseToString$1;

	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString$3(value) {
	  return value == null ? '' : _baseToString(value);
	}

	var toString_1 = toString$3;

	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath$1(value, object) {
	  if (isArray_1(value)) {
	    return value;
	  }
	  return _isKey(value, object) ? [value] : _stringToPath(toString_1(value));
	}

	var _castPath = castPath$1;

	/** Used as references for various `Number` constants. */
	var INFINITY$4 = 1 / 0;

	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey$1(value) {
	  if (typeof value == 'string' || isSymbol_1(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY$4) ? '-0' : result;
	}

	var _toKey = toKey$1;

	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath$1(object, path, hasFunc) {
	  path = _castPath(path, object);

	  var index = -1,
	      length = path.length,
	      result = false;

	  while (++index < length) {
	    var key = _toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength_1(length) && _isIndex(key, length) &&
	    (isArray_1(object) || isArguments_1(object));
	}

	var _hasPath = hasPath$1;

	/**
	 * Checks if `path` is a direct property of `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = { 'a': { 'b': 2 } };
	 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.has(object, 'a');
	 * // => true
	 *
	 * _.has(object, 'a.b');
	 * // => true
	 *
	 * _.has(object, ['a', 'b']);
	 * // => true
	 *
	 * _.has(other, 'a');
	 * // => false
	 */
	function has(object, path) {
	  return object != null && _hasPath(object, path, _baseHas);
	}

	var has_1 = has;

	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet$1(object, path) {
	  path = _castPath(path, object);

	  var index = 0,
	      length = path.length;

	  while (object != null && index < length) {
	    object = object[_toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}

	var _baseGet = baseGet$1;

	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get$1(object, path, defaultValue) {
	  var result = object == null ? undefined : _baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}

	var get_1 = get$1;

	/** Built-in value references. */
	var getPrototype = _overArg(Object.getPrototypeOf, Object);

	var _getPrototype = getPrototype;

	/** `Object#toString` result references. */
	var objectTag$6 = '[object Object]';

	/** Used for built-in method references. */
	var funcProto$4 = Function.prototype,
	    objectProto$p = Object.prototype;

	/** Used to resolve the decompiled source of functions. */
	var funcToString$4 = funcProto$4.toString;

	/** Used to check objects for own properties. */
	var hasOwnProperty$k = objectProto$p.hasOwnProperty;

	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString$4.call(Object);

	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike_1(value) || _baseGetTag(value) != objectTag$6) {
	    return false;
	  }
	  var proto = _getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty$k.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString$4.call(Ctor) == objectCtorString;
	}

	var isPlainObject_1 = isPlainObject;

	/**
	 * A specialized version of `_.every` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 */
	function arrayEvery(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;

	  while (++index < length) {
	    if (!predicate(array[index], index, array)) {
	      return false;
	    }
	  }
	  return true;
	}

	var _arrayEvery = arrayEvery;

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor$1(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;

	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}

	var _createBaseFor = createBaseFor$1;

	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor$1 = _createBaseFor();

	var _baseFor = baseFor$1;

	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn$1(object, iteratee) {
	  return object && _baseFor(object, iteratee, keys_1);
	}

	var _baseForOwn = baseForOwn$1;

	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach$1(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike_1(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);

	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}

	var _createBaseEach = createBaseEach$1;

	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach$1 = _createBaseEach(_baseForOwn);

	var _baseEach = baseEach$1;

	/**
	 * The base implementation of `_.every` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`
	 */
	function baseEvery(collection, predicate) {
	  var result = true;
	  _baseEach(collection, function(value, index, collection) {
	    result = !!predicate(value, index, collection);
	    return result;
	  });
	  return result;
	}

	var _baseEvery = baseEvery;

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG$a = 1,
	    COMPARE_UNORDERED_FLAG$6 = 2;

	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch$1(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;

	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];

	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new _Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? _baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$a | COMPARE_UNORDERED_FLAG$6, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}

	var _baseIsMatch = baseIsMatch$1;

	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable$1(value) {
	  return value === value && !isObject_1(value);
	}

	var _isStrictComparable = isStrictComparable$1;

	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData$1(object) {
	  var result = keys_1(object),
	      length = result.length;

	  while (length--) {
	    var key = result[length],
	        value = object[key];

	    result[length] = [key, value, _isStrictComparable(value)];
	  }
	  return result;
	}

	var _getMatchData = getMatchData$1;

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable$1(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}

	var _matchesStrictComparable = matchesStrictComparable$1;

	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches$1(source) {
	  var matchData = _getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return _matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || _baseIsMatch(object, source, matchData);
	  };
	}

	var _baseMatches = baseMatches$1;

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn$1(object, key) {
	  return object != null && key in Object(object);
	}

	var _baseHasIn = baseHasIn$1;

	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn$1(object, path) {
	  return object != null && _hasPath(object, path, _baseHasIn);
	}

	var hasIn_1 = hasIn$1;

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG$b = 1,
	    COMPARE_UNORDERED_FLAG$7 = 2;

	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty$1(path, srcValue) {
	  if (_isKey(path) && _isStrictComparable(srcValue)) {
	    return _matchesStrictComparable(_toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get_1(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn_1(object, path)
	      : _baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$b | COMPARE_UNORDERED_FLAG$7);
	  };
	}

	var _baseMatchesProperty = baseMatchesProperty$1;

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity$1(value) {
	  return value;
	}

	var identity_1 = identity$1;

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty$1(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}

	var _baseProperty = baseProperty$1;

	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep$1(path) {
	  return function(object) {
	    return _baseGet(object, path);
	  };
	}

	var _basePropertyDeep = basePropertyDeep$1;

	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property$1(path) {
	  return _isKey(path) ? _baseProperty(_toKey(path)) : _basePropertyDeep(path);
	}

	var property_1 = property$1;

	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee$1(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity_1;
	  }
	  if (typeof value == 'object') {
	    return isArray_1(value)
	      ? _baseMatchesProperty(value[0], value[1])
	      : _baseMatches(value);
	  }
	  return property_1(value);
	}

	var _baseIteratee = baseIteratee$1;

	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject_1(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike_1(object) && _isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq_1(object[index], value);
	  }
	  return false;
	}

	var _isIterateeCall = isIterateeCall;

	/**
	 * Checks if `predicate` returns truthy for **all** elements of `collection`.
	 * Iteration is stopped once `predicate` returns falsey. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * **Note:** This method returns `true` for
	 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	 * elements of empty collections.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.every([true, 1, null, 'yes'], Boolean);
	 * // => false
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': false },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.every(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.every(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.every(users, 'active');
	 * // => false
	 */
	function every(collection, predicate, guard) {
	  var func = isArray_1(collection) ? _arrayEvery : _baseEvery;
	  if (guard && _isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, _baseIteratee(predicate));
	}

	var every_1 = every;

	/**
	 * Creates an array with all falsey values removed. The values `false`, `null`,
	 * `0`, `""`, `undefined`, and `NaN` are falsey.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to compact.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * _.compact([0, 1, false, 2, '', 3]);
	 * // => [1, 2, 3]
	 */
	function compact(array) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];

	  while (++index < length) {
	    var value = array[index];
	    if (value) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}

	var compact_1 = compact;

	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap$1(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike_1(collection) ? Array(collection.length) : [];

	  _baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}

	var _baseMap = baseMap$1;

	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map$1(collection, iteratee) {
	  var func = isArray_1(collection) ? _arrayMap : _baseMap;
	  return func(collection, _baseIteratee(iteratee));
	}

	var map_1 = map$1;

	var contexts = createCommonjsModule(function (module, exports) {
	var __assign = (commonjsGlobal && commonjsGlobal.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });









	function getSchemaParts(input) {
	    var re = new RegExp('^iglu:([a-zA-Z0-9-_\.]+)\/([a-zA-Z0-9-_]+)\/jsonschema\/([1-9][0-9]*)\-(0|[1-9][0-9]*)\-(0|[1-9][0-9]*)$');
	    var matches = re.exec(input);
	    if (matches !== null)
	        return matches.slice(1, 6);
	    return undefined;
	}
	exports.getSchemaParts = getSchemaParts;
	function validateVendorParts(parts) {
	    if (parts[0] === '*' || parts[1] === '*') {
	        return false;
	    }
	    if (parts.slice(2).length > 0) {
	        var asterisk = false;
	        for (var _i = 0, _a = parts.slice(2); _i < _a.length; _i++) {
	            var part = _a[_i];
	            if (part === '*')
	                asterisk = true;
	            else if (asterisk)
	                return false;
	        }
	        return true;
	    }
	    else if (parts.length == 2)
	        return true;
	    return false;
	}
	exports.validateVendorParts = validateVendorParts;
	function validateVendor(input) {
	    var parts = input.split('.');
	    if (parts && parts.length > 1)
	        return validateVendorParts(parts);
	    return false;
	}
	exports.validateVendor = validateVendor;
	function getRuleParts(input) {
	    var re = new RegExp('^iglu:((?:(?:[a-zA-Z0-9-_]+|\\*)\.)+(?:[a-zA-Z0-9-_]+|\\*))\/([a-zA-Z0-9-_.]+|\\*)\/jsonschema\/([1-9][0-9]*|\\*)-(0|[1-9][0-9]*|\\*)-(0|[1-9][0-9]*|\\*)$');
	    var matches = re.exec(input);
	    if (matches !== null && validateVendor(matches[1]))
	        return matches.slice(1, 6);
	    return undefined;
	}
	exports.getRuleParts = getRuleParts;
	function isValidRule(input) {
	    var ruleParts = getRuleParts(input);
	    if (ruleParts) {
	        var vendor = ruleParts[0];
	        return ruleParts.length === 5 && validateVendor(vendor);
	    }
	    return false;
	}
	exports.isValidRule = isValidRule;
	function isStringArray(input) {
	    return Array.isArray(input) && input.every(function (x) { return typeof x === 'string'; });
	}
	exports.isStringArray = isStringArray;
	function isValidRuleSetArg(input) {
	    if (isStringArray(input))
	        return input.every(function (x) { return isValidRule(x); });
	    else if (typeof input === 'string')
	        return isValidRule(input);
	    return false;
	}
	exports.isValidRuleSetArg = isValidRuleSetArg;
	function isSelfDescribingJson(input) {
	    if (payload.isNonEmptyJson(input))
	        if ('schema' in input && 'data' in input)
	            return (typeof (input.schema) === 'string' && typeof (input.data) === 'object');
	    return false;
	}
	exports.isSelfDescribingJson = isSelfDescribingJson;
	function isEventJson(input) {
	    if (payload.isNonEmptyJson(input) && ('e' in input))
	        return (typeof (input.e) === 'string');
	    return false;
	}
	exports.isEventJson = isEventJson;
	function isRuleSet(input) {
	    var ruleCount = 0;
	    if (isPlainObject_1(input)) {
	        if (has_1(input, 'accept')) {
	            if (isValidRuleSetArg(input['accept'])) {
	                ruleCount += 1;
	            }
	            else {
	                return false;
	            }
	        }
	        if (has_1(input, 'reject')) {
	            if (isValidRuleSetArg(input['reject'])) {
	                ruleCount += 1;
	            }
	            else {
	                return false;
	            }
	        }
	        return ruleCount > 0 && ruleCount <= 2;
	    }
	    return false;
	}
	exports.isRuleSet = isRuleSet;
	function isContextGenerator(input) {
	    return typeof (input) === 'function' && input.length <= 1;
	}
	exports.isContextGenerator = isContextGenerator;
	function isContextFilter(input) {
	    return typeof (input) === 'function' && input.length <= 1;
	}
	exports.isContextFilter = isContextFilter;
	function isContextPrimitive(input) {
	    return (isContextGenerator(input) || isSelfDescribingJson(input));
	}
	exports.isContextPrimitive = isContextPrimitive;
	function isFilterProvider(input) {
	    if (Array.isArray(input)) {
	        if (input.length === 2) {
	            if (Array.isArray(input[1])) {
	                return isContextFilter(input[0]) && every_1(input[1], isContextPrimitive);
	            }
	            return isContextFilter(input[0]) && isContextPrimitive(input[1]);
	        }
	    }
	    return false;
	}
	exports.isFilterProvider = isFilterProvider;
	function isRuleSetProvider(input) {
	    if (Array.isArray(input) && input.length === 2) {
	        if (!isRuleSet(input[0]))
	            return false;
	        if (Array.isArray(input[1]))
	            return every_1(input[1], isContextPrimitive);
	        return isContextPrimitive(input[1]);
	    }
	    return false;
	}
	exports.isRuleSetProvider = isRuleSetProvider;
	function isConditionalContextProvider(input) {
	    return isFilterProvider(input) || isRuleSetProvider(input);
	}
	exports.isConditionalContextProvider = isConditionalContextProvider;
	function matchSchemaAgainstRule(rule, schema) {
	    if (!isValidRule(rule))
	        return false;
	    var ruleParts = getRuleParts(rule);
	    var schemaParts = getSchemaParts(schema);
	    if (ruleParts && schemaParts) {
	        if (!matchVendor(ruleParts[0], schemaParts[0]))
	            return false;
	        for (var i = 1; i < 5; i++) {
	            if (!matchPart(ruleParts[i], schemaParts[i]))
	                return false;
	        }
	        return true;
	    }
	    return false;
	}
	exports.matchSchemaAgainstRule = matchSchemaAgainstRule;
	function matchVendor(rule, vendor) {
	    var vendorParts = vendor.split('.');
	    var ruleParts = rule.split('.');
	    if (vendorParts && ruleParts) {
	        if (vendorParts.length !== ruleParts.length)
	            return false;
	        for (var i = 0; i < ruleParts.length; i++) {
	            if (!matchPart(vendorParts[i], ruleParts[i]))
	                return false;
	        }
	        return true;
	    }
	    return false;
	}
	exports.matchVendor = matchVendor;
	function matchPart(rule, schema) {
	    return (rule && schema && rule === '*' || rule === schema);
	}
	exports.matchPart = matchPart;
	function matchSchemaAgainstRuleSet(ruleSet, schema) {
	    var rejectCount = 0;
	    var acceptCount = 0;
	    var acceptRules = get_1(ruleSet, 'accept');
	    if (Array.isArray(acceptRules)) {
	        if (ruleSet.accept.some(function (rule) { return (matchSchemaAgainstRule(rule, schema)); })) {
	            acceptCount++;
	        }
	    }
	    else if (typeof (acceptRules) === 'string') {
	        if (matchSchemaAgainstRule(acceptRules, schema)) {
	            acceptCount++;
	        }
	    }
	    var rejectRules = get_1(ruleSet, 'reject');
	    if (Array.isArray(rejectRules)) {
	        if (ruleSet.reject.some(function (rule) { return (matchSchemaAgainstRule(rule, schema)); })) {
	            rejectCount++;
	        }
	    }
	    else if (typeof (rejectRules) === 'string') {
	        if (matchSchemaAgainstRule(rejectRules, schema)) {
	            rejectCount++;
	        }
	    }
	    if (acceptCount > 0 && rejectCount === 0) {
	        return true;
	    }
	    else if (acceptCount === 0 && rejectCount > 0) {
	        return false;
	    }
	    return false;
	}
	exports.matchSchemaAgainstRuleSet = matchSchemaAgainstRuleSet;
	function getUsefulSchema(sb) {
	    if (typeof get_1(sb, 'ue_px.data.schema') === 'string')
	        return get_1(sb, 'ue_px.data.schema');
	    else if (typeof get_1(sb, 'ue_pr.data.schema') === 'string')
	        return get_1(sb, 'ue_pr.data.schema');
	    else if (typeof get_1(sb, 'schema') === 'string')
	        return get_1(sb, 'schema');
	    return '';
	}
	exports.getUsefulSchema = getUsefulSchema;
	function getDecodedEvent(sb) {
	    var decodedEvent = __assign({}, sb);
	    try {
	        if (has_1(decodedEvent, 'ue_px')) {
	            decodedEvent['ue_px'] = JSON.parse(base64.base64urldecode(get_1(decodedEvent, ['ue_px'])));
	        }
	    }
	    catch (e) { }
	    return decodedEvent;
	}
	exports.getDecodedEvent = getDecodedEvent;
	function getEventType(sb) {
	    return get_1(sb, 'e', '');
	}
	exports.getEventType = getEventType;
	function buildGenerator(generator, event, eventType, eventSchema) {
	    var contextGeneratorResult = undefined;
	    try {
	        var args = {
	            event: event,
	            eventType: eventType,
	            eventSchema: eventSchema
	        };
	        contextGeneratorResult = generator(args);
	        if (isSelfDescribingJson(contextGeneratorResult)) {
	            return contextGeneratorResult;
	        }
	        else if (Array.isArray(contextGeneratorResult) && every_1(contextGeneratorResult, isSelfDescribingJson)) {
	            return contextGeneratorResult;
	        }
	        else {
	            return undefined;
	        }
	    }
	    catch (error) {
	        contextGeneratorResult = undefined;
	    }
	    return contextGeneratorResult;
	}
	exports.buildGenerator = buildGenerator;
	function normalizeToArray(input) {
	    if (Array.isArray(input)) {
	        return input;
	    }
	    return Array.of(input);
	}
	exports.normalizeToArray = normalizeToArray;
	function generatePrimitives(contextPrimitives, event, eventType, eventSchema) {
	    var normalizedInputs = normalizeToArray(contextPrimitives);
	    var partialEvaluate = function (primitive) {
	        var result = evaluatePrimitive(primitive, event, eventType, eventSchema);
	        if (result && result.length !== 0) {
	            return result;
	        }
	    };
	    var generatedContexts = map_1(normalizedInputs, partialEvaluate);
	    return [].concat.apply([], compact_1(generatedContexts));
	}
	exports.generatePrimitives = generatePrimitives;
	function evaluatePrimitive(contextPrimitive, event, eventType, eventSchema) {
	    if (isSelfDescribingJson(contextPrimitive)) {
	        return [contextPrimitive];
	    }
	    else if (isContextGenerator(contextPrimitive)) {
	        var generatorOutput = buildGenerator(contextPrimitive, event, eventType, eventSchema);
	        if (isSelfDescribingJson(generatorOutput)) {
	            return [generatorOutput];
	        }
	        else if (Array.isArray(generatorOutput)) {
	            return generatorOutput;
	        }
	    }
	    return undefined;
	}
	exports.evaluatePrimitive = evaluatePrimitive;
	function evaluateProvider(provider, event, eventType, eventSchema) {
	    if (isFilterProvider(provider)) {
	        var filter = provider[0];
	        var filterResult = false;
	        try {
	            var args = {
	                event: event,
	                eventType: eventType,
	                eventSchema: eventSchema
	            };
	            filterResult = filter(args);
	        }
	        catch (error) {
	            filterResult = false;
	        }
	        if (filterResult === true) {
	            return generatePrimitives(provider[1], event, eventType, eventSchema);
	        }
	    }
	    else if (isRuleSetProvider(provider)) {
	        if (matchSchemaAgainstRuleSet(provider[0], eventSchema)) {
	            return generatePrimitives(provider[1], event, eventType, eventSchema);
	        }
	    }
	    return [];
	}
	exports.evaluateProvider = evaluateProvider;
	function generateConditionals(providers, event, eventType, eventSchema) {
	    var normalizedInput = normalizeToArray(providers);
	    var partialEvaluate = function (provider) {
	        var result = evaluateProvider(provider, event, eventType, eventSchema);
	        if (result && result.length !== 0) {
	            return result;
	        }
	    };
	    var generatedContexts = map_1(normalizedInput, partialEvaluate);
	    return [].concat.apply([], compact_1(generatedContexts));
	}
	exports.generateConditionals = generateConditionals;
	function contextModule() {
	    var globalPrimitives = [];
	    var conditionalProviders = [];
	    function assembleAllContexts(event) {
	        var eventSchema = getUsefulSchema(event);
	        var eventType = getEventType(event);
	        var contexts = [];
	        var generatedPrimitives = generatePrimitives(globalPrimitives, event, eventType, eventSchema);
	        contexts.push.apply(contexts, generatedPrimitives);
	        var generatedConditionals = generateConditionals(conditionalProviders, event, eventType, eventSchema);
	        contexts.push.apply(contexts, generatedConditionals);
	        return contexts;
	    }
	    return {
	        getGlobalPrimitives: function () {
	            return globalPrimitives;
	        },
	        getConditionalProviders: function () {
	            return conditionalProviders;
	        },
	        addGlobalContexts: function (contexts) {
	            var acceptedConditionalContexts = [];
	            var acceptedContextPrimitives = [];
	            for (var _i = 0, contexts_1 = contexts; _i < contexts_1.length; _i++) {
	                var context = contexts_1[_i];
	                if (isConditionalContextProvider(context)) {
	                    acceptedConditionalContexts.push(context);
	                }
	                else if (isContextPrimitive(context)) {
	                    acceptedContextPrimitives.push(context);
	                }
	            }
	            globalPrimitives = globalPrimitives.concat(acceptedContextPrimitives);
	            conditionalProviders = conditionalProviders.concat(acceptedConditionalContexts);
	        },
	        clearGlobalContexts: function () {
	            conditionalProviders = [];
	            globalPrimitives = [];
	        },
	        removeGlobalContexts: function (contexts) {
	            var _loop_1 = function (context) {
	                if (isConditionalContextProvider(context)) {
	                    conditionalProviders = conditionalProviders.filter(function (item) { return !isEqual_1(item, context); });
	                }
	                else if (isContextPrimitive(context)) {
	                    globalPrimitives = globalPrimitives.filter(function (item) { return !isEqual_1(item, context); });
	                }
	            };
	            for (var _i = 0, contexts_2 = contexts; _i < contexts_2.length; _i++) {
	                var context = contexts_2[_i];
	                _loop_1(context);
	            }
	        },
	        getApplicableContexts: function (event) {
	            var builtEvent = event.build();
	            if (isEventJson(builtEvent)) {
	                var decodedEvent = getDecodedEvent(builtEvent);
	                return assembleAllContexts(decodedEvent);
	            }
	            else {
	                return [];
	            }
	        }
	    };
	}
	exports.contextModule = contextModule;

	});

	unwrapExports(contexts);
	var contexts_1 = contexts.getSchemaParts;
	var contexts_2 = contexts.validateVendorParts;
	var contexts_3 = contexts.validateVendor;
	var contexts_4 = contexts.getRuleParts;
	var contexts_5 = contexts.isValidRule;
	var contexts_6 = contexts.isStringArray;
	var contexts_7 = contexts.isValidRuleSetArg;
	var contexts_8 = contexts.isSelfDescribingJson;
	var contexts_9 = contexts.isEventJson;
	var contexts_10 = contexts.isRuleSet;
	var contexts_11 = contexts.isContextGenerator;
	var contexts_12 = contexts.isContextFilter;
	var contexts_13 = contexts.isContextPrimitive;
	var contexts_14 = contexts.isFilterProvider;
	var contexts_15 = contexts.isRuleSetProvider;
	var contexts_16 = contexts.isConditionalContextProvider;
	var contexts_17 = contexts.matchSchemaAgainstRule;
	var contexts_18 = contexts.matchVendor;
	var contexts_19 = contexts.matchPart;
	var contexts_20 = contexts.matchSchemaAgainstRuleSet;
	var contexts_21 = contexts.getUsefulSchema;
	var contexts_22 = contexts.getDecodedEvent;
	var contexts_23 = contexts.getEventType;
	var contexts_24 = contexts.buildGenerator;
	var contexts_25 = contexts.normalizeToArray;
	var contexts_26 = contexts.generatePrimitives;
	var contexts_27 = contexts.evaluatePrimitive;
	var contexts_28 = contexts.evaluateProvider;
	var contexts_29 = contexts.generateConditionals;
	var contexts_30 = contexts.contextModule;

	var core = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });



	function getTimestamp(tstamp) {
	    if (tstamp == null) {
	        return { type: 'dtm', value: new Date().getTime() };
	    }
	    else if (typeof tstamp === 'number') {
	        return { type: 'dtm', value: tstamp };
	    }
	    else if (tstamp.type === 'ttm') {
	        return { type: 'ttm', value: tstamp.value };
	    }
	    else {
	        return { type: 'dtm', value: (tstamp.value || new Date().getTime()) };
	    }
	}
	function trackerCore(base64, callback) {
	    if (typeof base64 === 'undefined') {
	        base64 = true;
	    }
	    var payloadPairs = {};
	    var contextModule = contexts.contextModule();
	    function getAllContexts(event) {
	        return contextModule.getApplicableContexts(event);
	    }
	    function addPayloadPair(key, value) {
	        payloadPairs[key] = value;
	    }
	    function removeEmptyProperties(eventJson, exemptFields) {
	        var ret = {};
	        exemptFields = exemptFields || {};
	        for (var k in eventJson) {
	            if (exemptFields[k] || (eventJson[k] !== null && typeof eventJson[k] !== 'undefined')) {
	                ret[k] = eventJson[k];
	            }
	        }
	        return ret;
	    }
	    function completeContexts(contexts) {
	        if (contexts && contexts.length) {
	            return {
	                schema: 'iglu:com.snowplowanalytics.snowplow/contexts/jsonschema/1-0-0',
	                data: contexts
	            };
	        }
	    }
	    function attachGlobalContexts(sb, contexts) {
	        var globalContexts = getAllContexts(sb);
	        var returnedContexts = [];
	        if (contexts && contexts.length) {
	            returnedContexts.push.apply(returnedContexts, contexts);
	        }
	        if (globalContexts && globalContexts.length) {
	            returnedContexts.push.apply(returnedContexts, globalContexts);
	        }
	        return returnedContexts;
	    }
	    function track(sb, context, tstamp) {
	        sb.addDict(payloadPairs);
	        sb.add('eid', uuid_1.v4());
	        var timestamp = getTimestamp(tstamp);
	        sb.add(timestamp.type, timestamp.value.toString());
	        var allContexts = attachGlobalContexts(sb, context);
	        var wrappedContexts = completeContexts(allContexts);
	        if (wrappedContexts !== undefined) {
	            sb.addJson('cx', 'co', wrappedContexts);
	        }
	        if (typeof callback === 'function') {
	            callback(sb);
	        }
	        return sb;
	    }
	    function trackSelfDescribingEvent(properties, context, tstamp) {
	        var sb = payload.payloadBuilder(base64);
	        var ueJson = {
	            schema: 'iglu:com.snowplowanalytics.snowplow/unstruct_event/jsonschema/1-0-0',
	            data: properties
	        };
	        sb.add('e', 'ue');
	        sb.addJson('ue_px', 'ue_pr', ueJson);
	        return track(sb, context, tstamp);
	    }
	    return {
	        setBase64Encoding: function (encode) {
	            base64 = encode;
	        },
	        addPayloadPair: addPayloadPair,
	        addPayloadDict: function (dict) {
	            for (var key in dict) {
	                if (dict.hasOwnProperty(key)) {
	                    payloadPairs[key] = dict[key];
	                }
	            }
	        },
	        resetPayloadPairs: function (dict) {
	            payloadPairs = payload.isJson(dict) ? dict : {};
	        },
	        setTrackerVersion: function (version) {
	            addPayloadPair('tv', version);
	        },
	        setTrackerNamespace: function (name) {
	            addPayloadPair('tna', name);
	        },
	        setAppId: function (appId) {
	            addPayloadPair('aid', appId);
	        },
	        setPlatform: function (value) {
	            addPayloadPair('p', value);
	        },
	        setUserId: function (userId) {
	            addPayloadPair('uid', userId);
	        },
	        setScreenResolution: function (width, height) {
	            addPayloadPair('res', width + 'x' + height);
	        },
	        setViewport: function (width, height) {
	            addPayloadPair('vp', width + 'x' + height);
	        },
	        setColorDepth: function (depth) {
	            addPayloadPair('cd', depth);
	        },
	        setTimezone: function (timezone) {
	            addPayloadPair('tz', timezone);
	        },
	        setLang: function (lang) {
	            addPayloadPair('lang', lang);
	        },
	        setIpAddress: function (ip) {
	            addPayloadPair('ip', ip);
	        },
	        setUseragent: function (useragent) {
	            addPayloadPair('ua', useragent);
	        },
	        trackUnstructEvent: trackSelfDescribingEvent,
	        trackSelfDescribingEvent: trackSelfDescribingEvent,
	        trackPageView: function (pageUrl, pageTitle, referrer, context, tstamp) {
	            var sb = payload.payloadBuilder(base64);
	            sb.add('e', 'pv');
	            sb.add('url', pageUrl);
	            sb.add('page', pageTitle);
	            sb.add('refr', referrer);
	            return track(sb, context, tstamp);
	        },
	        trackPagePing: function (pageUrl, pageTitle, referrer, minXOffset, maxXOffset, minYOffset, maxYOffset, context, tstamp) {
	            var sb = payload.payloadBuilder(base64);
	            sb.add('e', 'pp');
	            sb.add('url', pageUrl);
	            sb.add('page', pageTitle);
	            sb.add('refr', referrer);
	            sb.add('pp_mix', minXOffset.toString());
	            sb.add('pp_max', maxXOffset.toString());
	            sb.add('pp_miy', minYOffset.toString());
	            sb.add('pp_may', maxYOffset.toString());
	            return track(sb, context, tstamp);
	        },
	        trackStructEvent: function (category, action, label, property, value, context, tstamp) {
	            var sb = payload.payloadBuilder(base64);
	            sb.add('e', 'se');
	            sb.add('se_ca', category);
	            sb.add('se_ac', action);
	            sb.add('se_la', label);
	            sb.add('se_pr', property);
	            sb.add('se_va', (value == null ? undefined : value.toString()));
	            return track(sb, context, tstamp);
	        },
	        trackEcommerceTransaction: function (orderId, affiliation, totalValue, taxValue, shipping, city, state, country, currency, context, tstamp) {
	            var sb = payload.payloadBuilder(base64);
	            sb.add('e', 'tr');
	            sb.add("tr_id", orderId);
	            sb.add("tr_af", affiliation);
	            sb.add("tr_tt", totalValue);
	            sb.add("tr_tx", taxValue);
	            sb.add("tr_sh", shipping);
	            sb.add("tr_ci", city);
	            sb.add("tr_st", state);
	            sb.add("tr_co", country);
	            sb.add("tr_cu", currency);
	            return track(sb, context, tstamp);
	        },
	        trackEcommerceTransactionItem: function (orderId, sku, name, category, price, quantity, currency, context, tstamp) {
	            var sb = payload.payloadBuilder(base64);
	            sb.add("e", "ti");
	            sb.add("ti_id", orderId);
	            sb.add("ti_sk", sku);
	            sb.add("ti_nm", name);
	            sb.add("ti_ca", category);
	            sb.add("ti_pr", price);
	            sb.add("ti_qu", quantity);
	            sb.add("ti_cu", currency);
	            return track(sb, context, tstamp);
	        },
	        trackScreenView: function (name, id, context, tstamp) {
	            return trackSelfDescribingEvent({
	                schema: 'iglu:com.snowplowanalytics.snowplow/screen_view/jsonschema/1-0-0',
	                data: removeEmptyProperties({
	                    name: name,
	                    id: id
	                })
	            }, context, tstamp);
	        },
	        trackLinkClick: function (targetUrl, elementId, elementClasses, elementTarget, elementContent, context, tstamp) {
	            var eventJson = {
	                schema: 'iglu:com.snowplowanalytics.snowplow/link_click/jsonschema/1-0-1',
	                data: removeEmptyProperties({
	                    targetUrl: targetUrl,
	                    elementId: elementId,
	                    elementClasses: elementClasses,
	                    elementTarget: elementTarget,
	                    elementContent: elementContent
	                })
	            };
	            return trackSelfDescribingEvent(eventJson, context, tstamp);
	        },
	        trackAdImpression: function (impressionId, costModel, cost, targetUrl, bannerId, zoneId, advertiserId, campaignId, context, tstamp) {
	            var eventJson = {
	                schema: 'iglu:com.snowplowanalytics.snowplow/ad_impression/jsonschema/1-0-0',
	                data: removeEmptyProperties({
	                    impressionId: impressionId,
	                    costModel: costModel,
	                    cost: cost,
	                    targetUrl: targetUrl,
	                    bannerId: bannerId,
	                    zoneId: zoneId,
	                    advertiserId: advertiserId,
	                    campaignId: campaignId
	                })
	            };
	            return trackSelfDescribingEvent(eventJson, context, tstamp);
	        },
	        trackAdClick: function (targetUrl, clickId, costModel, cost, bannerId, zoneId, impressionId, advertiserId, campaignId, context, tstamp) {
	            var eventJson = {
	                schema: 'iglu:com.snowplowanalytics.snowplow/ad_click/jsonschema/1-0-0',
	                data: removeEmptyProperties({
	                    targetUrl: targetUrl,
	                    clickId: clickId,
	                    costModel: costModel,
	                    cost: cost,
	                    bannerId: bannerId,
	                    zoneId: zoneId,
	                    impressionId: impressionId,
	                    advertiserId: advertiserId,
	                    campaignId: campaignId
	                })
	            };
	            return trackSelfDescribingEvent(eventJson, context, tstamp);
	        },
	        trackAdConversion: function (conversionId, costModel, cost, category, action, property, initialValue, advertiserId, campaignId, context, tstamp) {
	            var eventJson = {
	                schema: 'iglu:com.snowplowanalytics.snowplow/ad_conversion/jsonschema/1-0-0',
	                data: removeEmptyProperties({
	                    conversionId: conversionId,
	                    costModel: costModel,
	                    cost: cost,
	                    category: category,
	                    action: action,
	                    property: property,
	                    initialValue: initialValue,
	                    advertiserId: advertiserId,
	                    campaignId: campaignId
	                })
	            };
	            return trackSelfDescribingEvent(eventJson, context, tstamp);
	        },
	        trackSocialInteraction: function (action, network, target, context, tstamp) {
	            var eventJson = {
	                schema: 'iglu:com.snowplowanalytics.snowplow/social_interaction/jsonschema/1-0-0',
	                data: removeEmptyProperties({
	                    action: action,
	                    network: network,
	                    target: target
	                })
	            };
	            return trackSelfDescribingEvent(eventJson, context, tstamp);
	        },
	        trackAddToCart: function (sku, name, category, unitPrice, quantity, currency, context, tstamp) {
	            return trackSelfDescribingEvent({
	                schema: 'iglu:com.snowplowanalytics.snowplow/add_to_cart/jsonschema/1-0-0',
	                data: removeEmptyProperties({
	                    sku: sku,
	                    name: name,
	                    category: category,
	                    unitPrice: unitPrice,
	                    quantity: quantity,
	                    currency: currency
	                })
	            }, context, tstamp);
	        },
	        trackRemoveFromCart: function (sku, name, category, unitPrice, quantity, currency, context, tstamp) {
	            return trackSelfDescribingEvent({
	                schema: 'iglu:com.snowplowanalytics.snowplow/remove_from_cart/jsonschema/1-0-0',
	                data: removeEmptyProperties({
	                    sku: sku,
	                    name: name,
	                    category: category,
	                    unitPrice: unitPrice,
	                    quantity: quantity,
	                    currency: currency
	                })
	            }, context, tstamp);
	        },
	        trackFormFocusOrChange: function (schema, formId, elementId, nodeName, type, elementClasses, value, context, tstamp) {
	            var event_schema = '';
	            var event_data = { formId: formId, elementId: elementId, nodeName: nodeName, elementClasses: elementClasses, value: value };
	            if (schema === 'change_form') {
	                event_schema = 'iglu:com.snowplowanalytics.snowplow/change_form/jsonschema/1-0-0';
	                event_data.type = type;
	            }
	            else if (schema === 'focus_form') {
	                event_schema = 'iglu:com.snowplowanalytics.snowplow/focus_form/jsonschema/1-0-0';
	                event_data.elementType = type;
	            }
	            return trackSelfDescribingEvent({
	                schema: event_schema,
	                data: removeEmptyProperties(event_data, { value: true })
	            }, context, tstamp);
	        },
	        trackFormSubmission: function (formId, formClasses, elements, context, tstamp) {
	            return trackSelfDescribingEvent({
	                schema: 'iglu:com.snowplowanalytics.snowplow/submit_form/jsonschema/1-0-0',
	                data: removeEmptyProperties({
	                    formId: formId,
	                    formClasses: formClasses,
	                    elements: elements
	                })
	            }, context, tstamp);
	        },
	        trackSiteSearch: function (terms, filters, totalResults, pageResults, context, tstamp) {
	            return trackSelfDescribingEvent({
	                schema: 'iglu:com.snowplowanalytics.snowplow/site_search/jsonschema/1-0-0',
	                data: removeEmptyProperties({
	                    terms: terms,
	                    filters: filters,
	                    totalResults: totalResults,
	                    pageResults: pageResults
	                })
	            }, context, tstamp);
	        },
	        trackConsentWithdrawn: function (all, id, version, name, description, context, tstamp) {
	            var documentJson = {
	                schema: 'iglu:com.snowplowanalytics.snowplow/consent_document/jsonschema/1-0-0',
	                data: removeEmptyProperties({
	                    id: id,
	                    version: version,
	                    name: name,
	                    description: description
	                })
	            };
	            return trackSelfDescribingEvent({
	                schema: 'iglu:com.snowplowanalytics.snowplow/consent_withdrawn/jsonschema/1-0-0',
	                data: removeEmptyProperties({
	                    all: all
	                })
	            }, documentJson.data && context ? context.concat([documentJson]) : context, tstamp);
	        },
	        trackConsentGranted: function (id, version, name, description, expiry, context, tstamp) {
	            var documentJson = {
	                schema: 'iglu:com.snowplowanalytics.snowplow/consent_document/jsonschema/1-0-0',
	                data: removeEmptyProperties({
	                    id: id,
	                    version: version,
	                    name: name,
	                    description: description,
	                })
	            };
	            return trackSelfDescribingEvent({
	                schema: 'iglu:com.snowplowanalytics.snowplow/consent_granted/jsonschema/1-0-0',
	                data: removeEmptyProperties({
	                    expiry: expiry,
	                })
	            }, context ? context.concat([documentJson]) : [documentJson], tstamp);
	        },
	        addGlobalContexts: function (contexts) {
	            contextModule.addGlobalContexts(contexts);
	        },
	        clearGlobalContexts: function () {
	            contextModule.clearGlobalContexts();
	        },
	        removeGlobalContexts: function (contexts) {
	            contextModule.removeGlobalContexts(contexts);
	        }
	    };
	}
	exports.trackerCore = trackerCore;

	});

	unwrapExports(core);
	var core_1 = core.trackerCore;

	var snowplowTrackerCore = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });

	exports.trackerCore = core.trackerCore;

	});

	unwrapExports(snowplowTrackerCore);
	var snowplowTrackerCore_1 = snowplowTrackerCore.trackerCore;

	/**
	 * Snowplow Tracker class
	 *
	 * @param functionName global function name
	 * @param namespace The namespace of the tracker object
	 * @param version The current version of the JavaScript Tracker
	 * @param mutSnowplowState An object containing hasLoaded, registeredOnLoadHandlers, and expireDateTime
	 * 	      Passed in by reference in case they are altered by snowplow.js
	 * @param argmap Optional dictionary of configuration options. Supported fields and their default values:
	 *
	 * 1. encodeBase64, true
	 * 2. cookieDomain, null
	 * 3. cookieName, '_sp_'
	 * 4. appId, ''
	 * 5. platform, 'web'
	 * 6. respectDoNotTrack, false
	 * 7. userFingerprintSeed, 123412414
	 * 8. pageUnloadTimer, 500
	 * 9. forceSecureTracker, false
	 * 10. forceUnsecureTracker, false
	 * 11. useLocalStorage, true
	 * 12. useCookies, true
	 * 13. sessionCookieTimeout, 1800
	 * 14. contexts, {}
	 * 15. post, false
	 * 16. bufferSize, 1
	 * 17. crossDomainLinker, false
	 * 18. maxPostBytes, 40000
	 * 19. discoverRootDomain, false
	 * 20. cookieLifetime, 63072000
	 * 21. stateStorageStrategy, 'cookieAndLocalStorage'
	 */

	var Tracker = function Tracker(functionName, namespace, version, mutSnowplowState, argmap) {
	  /************************************************************
	   * Private members
	   ************************************************************/
	  var // Tracker core
	  core = snowplowTrackerCore_1(true, function (payload) {
	    addBrowserData(payload);
	    sendRequest(payload, configTrackerPause);
	  }); // Aliases

	  var documentAlias = document;
	  var windowAlias = window;
	  var navigatorAlias = navigator; // Current URL and Referrer URL

	  var locationArray = fixupUrl(documentAlias.domain, windowAlias.location.href, getReferrer());
	  var domainAlias = fixupDomain(locationArray[0]);
	  var locationHrefAlias = locationArray[1];
	  var configReferrerUrl = locationArray[2]; // Holder of the logPagePing interval

	  var pagePingInterval;
	  var customReferrer;
	  var argmap = argmap || {}; // Request method is always GET for Snowplow

	  var configPlatform = argmap.hasOwnProperty('platform') ? argmap.platform : 'web'; // Snowplow collector URL

	  var configCollectorUrl; // Site ID

	  var configTrackerSiteId = argmap.hasOwnProperty('appId') ? argmap.appId : ''; // Updated for Snowplow
	  // Document URL

	  var configCustomUrl; // Document title

	  var lastDocumentTitle = documentAlias.title; // Custom title

	  var lastConfigTitle; // Maximum delay to wait for web bug image to be fetched (in milliseconds)

	  var configTrackerPause = argmap.hasOwnProperty('pageUnloadTimer') ? argmap.pageUnloadTimer : 500; // Whether appropriate values have been supplied to enableActivityTracking

	  var activityTrackingEnabled = false; // Minimum visit time after initial page view (in milliseconds)

	  var configMinimumVisitTime; // Recurring heart beat after initial ping (in milliseconds)

	  var configHeartBeatTimer; // Disallow hash tags in URL. TODO: Should this be set to true by default?

	  var configDiscardHashTag; // First-party cookie name prefix

	  var configCookieNamePrefix = argmap.hasOwnProperty('cookieName') ? argmap.cookieName : '_sp_'; // First-party cookie domain
	  // User agent defaults to origin hostname

	  var configCookieDomain = argmap.hasOwnProperty('cookieDomain') ? argmap.cookieDomain : null; // First-party cookie path
	  // Default is user agent defined.

	  var configCookiePath = '/'; // Do Not Track browser feature

	  var dnt = navigatorAlias.doNotTrack || navigatorAlias.msDoNotTrack || windowAlias.doNotTrack; // Do Not Track

	  var configDoNotTrack = argmap.hasOwnProperty('respectDoNotTrack') ? argmap.respectDoNotTrack && (dnt === 'yes' || dnt === '1') : false; // Opt out of cookie tracking

	  var configOptOutCookie; // Count sites which are pre-rendered

	  var configCountPreRendered; // Life of the visitor cookie (in seconds)

	  var configVisitorCookieTimeout = argmap.hasOwnProperty('cookieLifetime') ? argmap.cookieLifetime : 63072000; // 2 years
	  // Life of the session cookie (in seconds)

	  var configSessionCookieTimeout = argmap.hasOwnProperty('sessionCookieTimeout') ? argmap.sessionCookieTimeout : 1800; // 30 minutes
	  // Default hash seed for MurmurHash3 in detectors.detectSignature

	  var configUserFingerprintHashSeed = argmap.hasOwnProperty('userFingerprintSeed') ? argmap.userFingerprintSeed : 123412414; // Document character set

	  var documentCharset = documentAlias.characterSet || documentAlias.charset; // This forces the tracker to be HTTPS even if the page is not secure

	  var forceSecureTracker = argmap.hasOwnProperty('forceSecureTracker') ? argmap.forceSecureTracker === true : false; // This forces the tracker to be HTTP even if the page is secure

	  var forceUnsecureTracker = !forceSecureTracker && argmap.hasOwnProperty('forceUnsecureTracker') ? argmap.forceUnsecureTracker === true : false; // Whether to use localStorage to store events between sessions while offline

	  var useLocalStorage = argmap.hasOwnProperty('useLocalStorage') ? (argmap.useLocalStorage) : true; // Whether to use cookies

	  var configUseCookies = argmap.hasOwnProperty('useCookies') ? (argmap.useCookies) : true; // Strategy defining how to store the state: cookie, localStorage or none

	  var configStateStorageStrategy = argmap.hasOwnProperty('stateStorageStrategy') ? argmap.stateStorageStrategy : !configUseCookies && !useLocalStorage ? 'none' : configUseCookies && useLocalStorage ? 'cookieAndLocalStorage' : configUseCookies ? 'cookie' : 'localStorage'; // Browser language (or Windows language for IE). Imperfect but CloudFront doesn't log the Accept-Language header

	  var browserLanguage = navigatorAlias.userLanguage || navigatorAlias.language; // Browser features via client-side data collection

	  var browserFeatures = detectBrowserFeatures(configStateStorageStrategy == 'cookie' || configStateStorageStrategy == 'cookieAndLocalStorage', getSnowplowCookieName('testcookie')); // Visitor fingerprint

	  var userFingerprint = argmap.userFingerprint === false ? '' : detectSignature(configUserFingerprintHashSeed); // Unique ID for the tracker instance used to mark links which are being tracked

	  var trackerId = functionName + '_' + namespace; // Guard against installing the activity tracker more than once per Tracker instance

	  var activityTrackingInstalled = false; // Last activity timestamp

	  var lastActivityTime; // The last time an event was fired on the page - used to invalidate session if cookies are disabled

	  var lastEventTime = new Date().getTime(); // How are we scrolling?

	  var minXOffset;
	  var maxXOffset;
	  var minYOffset;
	  var maxYOffset; // Hash function

	  var hash = sha1; // Domain hash value

	  var domainHash; // Domain unique user ID

	  var domainUserId; // ID for the current session

	  var memorizedSessionId; // Index for the current session - kept in memory in case cookies are disabled

	  var memorizedVisitCount = 1; // Business-defined unique user ID

	  var businessUserId; // Ecommerce transaction data
	  // Will be committed, sent and emptied by a call to trackTrans.

	  var ecommerceTransaction = ecommerceTransactionTemplate(); // Manager for automatic link click tracking

	  var linkTrackingManager = getLinkTrackingManager(core, trackerId, addCommonContexts); // Manager for automatic form tracking

	  var formTrackingManager = getFormTrackingManager(core, trackerId, addCommonContexts); // Manager for tracking unhandled exceptions

	  var errorManager$1 = errorManager(core); // Manager for local storage queue

	  var outQueueManager = new OutQueueManager(functionName, namespace, mutSnowplowState, configStateStorageStrategy == 'localStorage' || configStateStorageStrategy == 'cookieAndLocalStorage', argmap.post, argmap.bufferSize, argmap.maxPostBytes || 40000); // Flag to prevent the geolocation context being added multiple times

	  var geolocationContextAdded = false; // Set of contexts to be added to every event

	  var autoContexts = argmap.contexts || {}; // Context to be added to every event

	  var commonContexts = []; // Enhanced Ecommerce Contexts to be added on every `trackEnhancedEcommerceAction` call

	  var enhancedEcommerceContexts = []; // Whether pageViewId should be regenerated after each trackPageView. Affect web_page context

	  var _preservePageViewId = false; // Whether first trackPageView was fired and pageViewId should not be changed anymore until reload

	  var pageViewSent = false;

	  if (argmap.hasOwnProperty('discoverRootDomain') && argmap.discoverRootDomain) {
	    configCookieDomain = findRootDomain();
	  }

	  if (autoContexts.gaCookies) {
	    commonContexts.push(getGaCookiesContext());
	  }

	  if (autoContexts.geolocation) {
	    enableGeolocationContext();
	  } // Enable base 64 encoding for self-describing events and custom contexts


	  core.setBase64Encoding(argmap.hasOwnProperty('encodeBase64') ? argmap.encodeBase64 : true); // Set up unchanging name-value pairs

	  core.setTrackerVersion(version);
	  core.setTrackerNamespace(namespace);
	  core.setAppId(configTrackerSiteId);
	  core.setPlatform(configPlatform);
	  core.setTimezone(detectTimezone());
	  core.addPayloadPair('lang', browserLanguage);
	  core.addPayloadPair('cs', documentCharset); // Browser features. Cookies, color depth and resolution don't get prepended with f_ (because they're not optional features)

	  for (var i in browserFeatures) {
	    if (Object.prototype.hasOwnProperty.call(browserFeatures, i)) {
	      if (i === 'res' || i === 'cd' || i === 'cookie') {
	        core.addPayloadPair(i, browserFeatures[i]);
	      } else {
	        core.addPayloadPair('f_' + i, browserFeatures[i]);
	      }
	    }
	  }
	  /**
	   * Recalculate the domain, URL, and referrer
	   */


	  function refreshUrl() {
	    locationArray = fixupUrl(documentAlias.domain, windowAlias.location.href, getReferrer()); // If this is a single-page app and the page URL has changed, then:
	    //   - if the new URL's querystring contains a "refer(r)er" parameter, use it as the referrer
	    //   - otherwise use the old URL as the referer

	    if (locationArray[1] !== locationHrefAlias) {
	      configReferrerUrl = getReferrer(locationHrefAlias);
	    }

	    domainAlias = fixupDomain(locationArray[0]);
	    locationHrefAlias = locationArray[1];
	  }
	  /**
	   * Decorate the querystring of a single link
	   *
	   * @param event e The event targeting the link
	   */


	  function linkDecorationHandler() {
	    var tstamp = new Date().getTime();

	    if (this.href) {
	      this.href = decorateQuerystring(this.href, '_sp', domainUserId + '.' + tstamp);
	    }
	  }
	  /**
	   * Enable querystring decoration for links pasing a filter
	   * Whenever such a link is clicked on or navigated to via the keyboard,
	   * add "_sp={{duid}}.{{timestamp}}" to its querystring
	   *
	   * @param crossDomainLinker Function used to determine which links to decorate
	   */


	  function decorateLinks(crossDomainLinker) {
	    for (var _i = 0; _i < documentAlias.links.length; _i++) {
	      var elt = documentAlias.links[_i];

	      if (!elt.spDecorationEnabled && crossDomainLinker(elt)) {
	        addEventListener(elt, 'click', linkDecorationHandler, true);
	        addEventListener(elt, 'mousedown', linkDecorationHandler, true); // Don't add event listeners more than once

	        elt.spDecorationEnabled = true;
	      }
	    }
	  }
	  /*
	    * Initializes an empty ecommerce
	    * transaction and line items
	    */


	  function ecommerceTransactionTemplate() {
	    return {
	      transaction: {},
	      items: []
	    };
	  }
	  /*
	    * Removes hash tag from the URL
	    *
	    * URLs are purified before being recorded in the cookie,
	    * or before being sent as GET parameters
	    */


	  function purify(url) {
	    var targetPattern;

	    if (configDiscardHashTag) {
	      targetPattern = new RegExp('#.*');
	      return url.replace(targetPattern, '');
	    }

	    return url;
	  }
	  /*
	    * Extract scheme/protocol from URL
	    */


	  function getProtocolScheme(url) {
	    var e = new RegExp('^([a-z]+):');
	    var matches = e.exec(url);
	    return matches ? matches[1] : null;
	  }
	  /*
	    * Resolve relative reference
	    *
	    * Note: not as described in rfc3986 section 5.2
	    */


	  function resolveRelativeReference(baseUrl, url) {
	    var protocol = getProtocolScheme(url);
	    var i;

	    if (protocol) {
	      return url;
	    }

	    if (url.slice(0, 1) === '/') {
	      return getProtocolScheme(baseUrl) + '://' + getHostName(baseUrl) + url;
	    }

	    baseUrl = purify(baseUrl);

	    if ((i = baseUrl.indexOf('?')) >= 0) {
	      baseUrl = baseUrl.slice(0, i);
	    }

	    if ((i = baseUrl.lastIndexOf('/')) !== baseUrl.length - 1) {
	      baseUrl = baseUrl.slice(0, i + 1);
	    }

	    return baseUrl + url;
	  }
	  /*
	    * Send request
	    */


	  function sendRequest(request, delay) {
	    var now = new Date(); // Set to true if Opt-out cookie is defined

	    var toOptoutByCookie = !!cookie$1.cookie(configOptOutCookie);

	    if (!(configDoNotTrack || toOptoutByCookie)) {
	      outQueueManager.enqueueRequest(request.build(), configCollectorUrl);
	      mutSnowplowState.expireDateTime = now.getTime() + delay;
	    }
	  }
	  /*
	    * Get cookie name with prefix and domain hash
	    */


	  function getSnowplowCookieName(baseName) {
	    return configCookieNamePrefix + baseName + '.' + domainHash;
	  }
	  /*
	    * Cookie getter.
	    */


	  function getSnowplowCookieValue(cookieName) {
	    var fullName = getSnowplowCookieName(cookieName);

	    if (configStateStorageStrategy == 'localStorage') {
	      return attemptGetLocalStorage(fullName);
	    } else if (configStateStorageStrategy == 'cookie' || configStateStorageStrategy == 'cookieAndLocalStorage') {
	      return cookie$1.cookie(fullName);
	    }
	  }
	  /*
	    * Update domain hash
	    */


	  function updateDomainHash() {
	    refreshUrl();
	    domainHash = hash((configCookieDomain || domainAlias) + (configCookiePath || '/')).slice(0, 4); // 4 hexits = 16 bits
	  }
	  /*
	    * Process all "activity" events.
	    * For performance, this function must have low overhead.
	    */


	  function activityHandler() {
	    var now = new Date();
	    lastActivityTime = now.getTime();
	  }
	  /*
	    * Process all "scroll" events.
	    */


	  function scrollHandler() {
	    updateMaxScrolls();
	    activityHandler();
	  }
	  /*
	    * Returns [pageXOffset, pageYOffset].
	    * Adapts code taken from: http://www.javascriptkit.com/javatutors/static2.shtml
	    */


	  function getPageOffsets() {
	    var iebody = documentAlias.compatMode && documentAlias.compatMode !== 'BackCompat' ? documentAlias.documentElement : documentAlias.body;
	    return [iebody.scrollLeft || windowAlias.pageXOffset, iebody.scrollTop || windowAlias.pageYOffset];
	  }
	  /*
	   * Quick initialization/reset of max scroll levels
	   */


	  function resetMaxScrolls() {
	    var offsets = getPageOffsets();
	    var x = offsets[0];
	    minXOffset = x;
	    maxXOffset = x;
	    var y = offsets[1];
	    minYOffset = y;
	    maxYOffset = y;
	  }
	  /*
	   * Check the max scroll levels, updating as necessary
	   */


	  function updateMaxScrolls() {
	    var offsets = getPageOffsets();
	    var x = offsets[0];

	    if (x < minXOffset) {
	      minXOffset = x;
	    } else if (x > maxXOffset) {
	      maxXOffset = x;
	    }

	    var y = offsets[1];

	    if (y < minYOffset) {
	      minYOffset = y;
	    } else if (y > maxYOffset) {
	      maxYOffset = y;
	    }
	  }
	  /*
	   * Prevents offsets from being decimal or NaN
	   * See https://github.com/snowplow/snowplow-javascript-tracker/issues/324
	   * TODO: the NaN check should be moved into the core
	   */


	  function cleanOffset(offset) {
	    var rounded = Math.round(offset);

	    if (!isNaN(rounded)) {
	      return rounded;
	    }
	  }
	  /*
	   * Sets or renews the session cookie
	   */


	  function setSessionCookie() {
	    var cookieName = getSnowplowCookieName('ses');
	    var cookieValue = '*';
	    setCookie(cookieName, cookieValue, configSessionCookieTimeout);
	  }
	  /*
	   * Sets the Visitor ID cookie: either the first time loadDomainUserIdCookie is called
	   * or when there is a new visit or a new page view
	   */


	  function setDomainUserIdCookie(_domainUserId, createTs, visitCount, nowTs, lastVisitTs, sessionId) {
	    var cookieName = getSnowplowCookieName('id');
	    var cookieValue = _domainUserId + '.' + createTs + '.' + visitCount + '.' + nowTs + '.' + lastVisitTs + '.' + sessionId;
	    setCookie(cookieName, cookieValue, configVisitorCookieTimeout);
	  }
	  /*
	   * Sets a cookie based on the storage strategy:
	   * - if 'localStorage': attemps to write to local storage
	   * - if 'cookie': writes to cookies
	   * - otherwise: no-op
	   */


	  function setCookie(name, value, timeout) {
	    if (configStateStorageStrategy == 'localStorage') {
	      attemptWriteLocalStorage(name, value);
	    } else if (configStateStorageStrategy == 'cookie' || configStateStorageStrategy == 'cookieAndLocalStorage') {
	      cookie$1.cookie(name, value, timeout, configCookiePath, configCookieDomain);
	    }
	  }
	  /**
	   * Generate a pseudo-unique ID to fingerprint this user
	   */


	  function createNewDomainUserId() {
	    return uuid_1.v4();
	  }
	  /*
	   * Load the domain user ID and the session ID
	   * Set the cookies (if cookies are enabled)
	   */


	  function initializeIdsAndCookies() {
	    var sesCookieSet = configStateStorageStrategy != 'none' && !!getSnowplowCookieValue('ses');
	    var idCookieComponents = loadDomainUserIdCookie();

	    if (idCookieComponents[1]) {
	      domainUserId = idCookieComponents[1];
	    } else {
	      domainUserId = createNewDomainUserId();
	      idCookieComponents[1] = domainUserId;
	    }

	    memorizedSessionId = idCookieComponents[6];

	    if (!sesCookieSet) {
	      // Increment the session ID
	      idCookieComponents[3]++; // Create a new sessionId

	      memorizedSessionId = uuid_1.v4();
	      idCookieComponents[6] = memorizedSessionId; // Set lastVisitTs to currentVisitTs

	      idCookieComponents[5] = idCookieComponents[4];
	    }

	    if (configStateStorageStrategy != 'none') {
	      setSessionCookie(); // Update currentVisitTs

	      idCookieComponents[4] = Math.round(new Date().getTime() / 1000);
	      idCookieComponents.shift();
	      setDomainUserIdCookie.apply(null, idCookieComponents);
	    }
	  }
	  /*
	   * Load visitor ID cookie
	   */


	  function loadDomainUserIdCookie() {
	    if (configStateStorageStrategy == 'none') {
	      return [];
	    }

	    var now = new Date();
	    var nowTs = Math.round(now.getTime() / 1000);
	    var id = getSnowplowCookieValue('id');
	    var tmpContainer;

	    if (id) {
	      tmpContainer = id.split('.'); // cookies enabled

	      tmpContainer.unshift('0');
	    } else {
	      tmpContainer = [// cookies disabled
	      '1', // Domain user ID
	      domainUserId, // Creation timestamp - seconds since Unix epoch
	      nowTs, // visitCount - 0 = no previous visit
	      0, // Current visit timestamp
	      nowTs, // Last visit timestamp - blank meaning no previous visit
	      ''];
	    }

	    if (!tmpContainer[6]) {
	      // session id
	      tmpContainer[6] = uuid_1.v4();
	    }

	    return tmpContainer;
	  }
	  /*
	   * Attaches common web fields to every request
	   * (resolution, url, referrer, etc.)
	   * Also sets the required cookies.
	   */


	  function addBrowserData(sb) {
	    var nowTs = Math.round(new Date().getTime() / 1000);
	    var idname = getSnowplowCookieName('id');
	    var sesname = getSnowplowCookieName('ses');
	    var ses = getSnowplowCookieValue('ses');
	    var id = loadDomainUserIdCookie();
	    var cookiesDisabled = id[0];
	    var _domainUserId = id[1]; // We could use the global (domainUserId) but this is better etiquette

	    var createTs = id[2];
	    var visitCount = id[3];
	    var currentVisitTs = id[4];
	    var lastVisitTs = id[5];
	    var sessionIdFromCookie = id[6];
	    var toOptoutByCookie = !!cookie$1.cookie(configOptOutCookie);

	    if ((configDoNotTrack || toOptoutByCookie) && configStateStorageStrategy != 'none') {
	      if (configStateStorageStrategy == 'localStorage') {
	        attemptWriteLocalStorage(idname, '');
	        attemptWriteLocalStorage(sesName, '');
	      } else if (configStateStorageStrategy == 'cookie' || configStateStorageStrategy == 'cookieAndLocalStorage') {
	        cookie$1.cookie(idname, '', -1, configCookiePath, configCookieDomain);
	        cookie$1.cookie(sesname, '', -1, configCookiePath, configCookieDomain);
	      }

	      return;
	    } // If cookies are enabled, base visit count and session ID on the cookies


	    if (cookiesDisabled === '0') {
	      memorizedSessionId = sessionIdFromCookie; // New session?

	      if (!ses && configStateStorageStrategy != 'none') {
	        // New session (aka new visit)
	        visitCount++; // Update the last visit timestamp

	        lastVisitTs = currentVisitTs; // Regenerate the session ID

	        memorizedSessionId = uuid_1.v4();
	      }

	      memorizedVisitCount = visitCount; // Otherwise, a new session starts if configSessionCookieTimeout seconds have passed since the last event
	    } else {
	      if (new Date().getTime() - lastEventTime > configSessionCookieTimeout * 1000) {
	        memorizedSessionId = uuid_1.v4();
	        memorizedVisitCount++;
	      }
	    } // Build out the rest of the request


	    sb.add('vp', detectViewport());
	    sb.add('ds', detectDocumentSize());
	    sb.add('vid', memorizedVisitCount);
	    sb.add('sid', memorizedSessionId);
	    sb.add('duid', _domainUserId); // Set to our local variable

	    sb.add('fp', userFingerprint);
	    sb.add('uid', businessUserId);
	    refreshUrl();
	    sb.add('refr', purify(customReferrer || configReferrerUrl)); // Add the page URL last as it may take us over the IE limit (and we don't always need it)

	    sb.add('url', purify(configCustomUrl || locationHrefAlias)); // Update cookies

	    if (configStateStorageStrategy != 'none') {
	      setDomainUserIdCookie(_domainUserId, createTs, memorizedVisitCount, nowTs, lastVisitTs, memorizedSessionId);
	      setSessionCookie();
	    }

	    lastEventTime = new Date().getTime();
	  }
	  /**
	   * Builds a collector URL from a CloudFront distribution.
	   * We don't bother to support custom CNAMEs because Amazon CloudFront doesn't support that for SSL.
	   *
	   * @param string account The account ID to build the tracker URL from
	   *
	   * @return string The URL on which the collector is hosted
	   */


	  function collectorUrlFromCfDist(distSubdomain) {
	    return asCollectorUrl(distSubdomain + '.cloudfront.net');
	  }
	  /**
	   * Adds the protocol in front of our collector URL, and i to the end
	   *
	   * @param string rawUrl The collector URL without protocol
	   *
	   * @return string collectorUrl The tracker URL with protocol
	   */


	  function asCollectorUrl(rawUrl) {
	    if (forceSecureTracker) {
	      return 'https' + '://' + rawUrl;
	    }

	    if (forceUnsecureTracker) {
	      return 'http' + '://' + rawUrl;
	    }

	    return (documentAlias.location.protocol === 'https:' ? 'https' : 'http') + '://' + rawUrl;
	  }
	  /**
	   * Add common contexts to every event
	   * TODO: move this functionality into the core
	   *
	   * @param array userContexts List of user-defined contexts
	   * @return userContexts combined with commonContexts
	   */


	  function addCommonContexts(userContexts) {
	    var combinedContexts = commonContexts.concat(userContexts || []);

	    if (autoContexts.webPage) {
	      combinedContexts.push(getWebPageContext());
	    } // Add PerformanceTiming Context


	    if (autoContexts.performanceTiming) {
	      var performanceTimingContext = getPerformanceTimingContext();

	      if (performanceTimingContext) {
	        combinedContexts.push(performanceTimingContext);
	      }
	    } // Add Optimizely Contexts


	    if (windowAlias.optimizely) {
	      if (autoContexts.optimizelySummary) {
	        var activeExperiments = getOptimizelySummaryContexts();
	        forEach(activeExperiments, function (e) {
	          combinedContexts.push(e);
	        });
	      }

	      if (autoContexts.optimizelyXSummary) {
	        var activeExperiments = getOptimizelyXSummaryContexts();
	        forEach(activeExperiments, function (e) {
	          combinedContexts.push(e);
	        });
	      }

	      if (autoContexts.optimizelyExperiments) {
	        var experimentContexts = getOptimizelyExperimentContexts();

	        for (var i = 0; i < experimentContexts.length; i++) {
	          combinedContexts.push(experimentContexts[i]);
	        }
	      }

	      if (autoContexts.optimizelyStates) {
	        var stateContexts = getOptimizelyStateContexts();

	        for (var i = 0; i < stateContexts.length; i++) {
	          combinedContexts.push(stateContexts[i]);
	        }
	      }

	      if (autoContexts.optimizelyVariations) {
	        var variationContexts = getOptimizelyVariationContexts();

	        for (var i = 0; i < variationContexts.length; i++) {
	          combinedContexts.push(variationContexts[i]);
	        }
	      }

	      if (autoContexts.optimizelyVisitor) {
	        var optimizelyVisitorContext = getOptimizelyVisitorContext();

	        if (optimizelyVisitorContext) {
	          combinedContexts.push(optimizelyVisitorContext);
	        }
	      }

	      if (autoContexts.optimizelyAudiences) {
	        var audienceContexts = getOptimizelyAudienceContexts();

	        for (var i = 0; i < audienceContexts.length; i++) {
	          combinedContexts.push(audienceContexts[i]);
	        }
	      }

	      if (autoContexts.optimizelyDimensions) {
	        var dimensionContexts = getOptimizelyDimensionContexts();

	        for (var i = 0; i < dimensionContexts.length; i++) {
	          combinedContexts.push(dimensionContexts[i]);
	        }
	      }
	    } // Add Augur Context


	    if (autoContexts.augurIdentityLite) {
	      var augurIdentityLiteContext = getAugurIdentityLiteContext();

	      if (augurIdentityLiteContext) {
	        combinedContexts.push(augurIdentityLiteContext);
	      }
	    } // Add Parrable Context


	    if (autoContexts.parrable) {
	      var parrableContext = getParrableContext();

	      if (parrableContext) {
	        combinedContexts.push(parrableContext);
	      }
	    }

	    return combinedContexts;
	  }
	  /**
	   * Initialize new `pageViewId` if it shouldn't be preserved.
	   * Should be called when `trackPageView` is invoked
	   */


	  function resetPageView() {
	    if (!_preservePageViewId || mutSnowplowState.pageViewId == null) {
	      mutSnowplowState.pageViewId = uuid_1.v4();
	    }
	  }
	  /**
	   * Safe function to get `pageViewId`.
	   * Generates it if it wasn't initialized by other tracker
	   */


	  function _getPageViewId() {
	    if (mutSnowplowState.pageViewId == null) {
	      mutSnowplowState.pageViewId = uuid_1.v4();
	    }

	    return mutSnowplowState.pageViewId;
	  }
	  /**
	   * Put together a web page context with a unique UUID for the page view
	   *
	   * @return object web_page context
	   */


	  function getWebPageContext() {
	    return {
	      schema: 'iglu:com.snowplowanalytics.snowplow/web_page/jsonschema/1-0-0',
	      data: {
	        id: _getPageViewId()
	      }
	    };
	  }
	  /**
	   * Creates a context from the window.performance.timing object
	   *
	   * @return object PerformanceTiming context
	   */


	  function getPerformanceTimingContext() {
	    var allowedKeys = ['navigationStart', 'redirectStart', 'redirectEnd', 'fetchStart', 'domainLookupStart', 'domainLookupEnd', 'connectStart', 'secureConnectionStart', 'connectEnd', 'requestStart', 'responseStart', 'responseEnd', 'unloadEventStart', 'unloadEventEnd', 'domLoading', 'domInteractive', 'domContentLoadedEventStart', 'domContentLoadedEventEnd', 'domComplete', 'loadEventStart', 'loadEventEnd', 'msFirstPaint', 'chromeFirstPaint', 'requestEnd', 'proxyStart', 'proxyEnd'];
	    var performance = windowAlias.performance || windowAlias.mozPerformance || windowAlias.msPerformance || windowAlias.webkitPerformance;

	    if (performance) {
	      // On Safari, the fields we are interested in are on the prototype chain of
	      // performance.timing so we cannot copy them using clone
	      var performanceTiming = {};

	      for (var field in performance.timing) {
	        if (isValueInArray(field, allowedKeys) && performance.timing[field] !== null) {
	          performanceTiming[field] = performance.timing[field];
	        }
	      } // Old Chrome versions add an unwanted requestEnd field


	      delete performanceTiming.requestEnd; // Add the Chrome firstPaintTime to the performance if it exists

	      if (windowAlias.chrome && windowAlias.chrome.loadTimes && typeof windowAlias.chrome.loadTimes().firstPaintTime === 'number') {
	        performanceTiming.chromeFirstPaint = Math.round(windowAlias.chrome.loadTimes().firstPaintTime * 1000);
	      }

	      return {
	        schema: 'iglu:org.w3/PerformanceTiming/jsonschema/1-0-0',
	        data: performanceTiming
	      };
	    }
	  }
	  /**
	   * Check that *both* optimizely and optimizely.data exist and return
	   * optimizely.data.property
	   *
	   * @param property optimizely data property
	   * @param snd optional nested property
	   */


	  function getOptimizelyData(property, snd) {
	    var data;

	    if (windowAlias.optimizely && windowAlias.optimizely.data) {
	      data = windowAlias.optimizely.data[property];

	      if (typeof snd !== 'undefined' && data !== undefined) {
	        data = data[snd];
	      }
	    }

	    return data;
	  }
	  /**
	   * Check that *both* optimizely and optimizely.data exist
	   *
	   * @param property optimizely data property
	   * @param snd optional nested property
	   */


	  function getOptimizelyXData(property, snd) {
	    var data;

	    if (windowAlias.optimizely) {
	      data = windowAlias.optimizely.get(property);

	      if (typeof snd !== 'undefined' && data !== undefined) {
	        data = data[snd];
	      }
	    }

	    return data;
	  }
	  /**
	   * Get data for Optimizely "lite" contexts - active experiments on current page
	   *
	   * @returns Array content of lite optimizely lite context
	   */


	  function getOptimizelySummary() {
	    var state = getOptimizelyData('state');
	    var experiments = getOptimizelyData('experiments');
	    return map(state && experiments && state.activeExperiments, function (activeExperiment) {
	      var current = experiments[activeExperiment];
	      return {
	        activeExperimentId: activeExperiment.toString(),
	        // User can be only in one variation (don't know why is this array)
	        variation: state.variationIdsMap[activeExperiment][0].toString(),
	        conditional: current && current.conditional,
	        manual: current && current.manual,
	        name: current && current.name
	      };
	    });
	  }
	  /**
	   * Get data for OptimizelyX contexts - active experiments on current page
	   *
	   * @returns Array content of lite optimizely lite context
	   */


	  function getOptimizelyXSummary() {
	    var state = getOptimizelyXData('state');
	    var experiment_ids = state.getActiveExperimentIds();
	    var experiments = getOptimizelyXData('data', 'experiments');
	    var visitor = getOptimizelyXData('visitor');
	    return map(experiment_ids, function (activeExperiment) {
	      variation = state.getVariationMap()[activeExperiment];
	      variationName = variation.name;
	      variationId = variation.id;
	      visitorId = visitor.visitorId;
	      return {
	        experimentId: parseInt(activeExperiment),
	        variationName: variationName,
	        variation: parseInt(variationId),
	        visitorId: visitorId
	      };
	    });
	  }
	  /**
	   * Creates a context from the window['optimizely'].data.experiments object
	   *
	   * @return Array Experiment contexts
	   */


	  function getOptimizelyExperimentContexts() {
	    var experiments = getOptimizelyData('experiments');

	    if (experiments) {
	      var contexts = [];

	      for (var key in experiments) {
	        if (experiments.hasOwnProperty(key)) {
	          var context = {};
	          context.id = key;
	          var experiment = experiments[key];
	          context.code = experiment.code;
	          context.manual = experiment.manual;
	          context.conditional = experiment.conditional;
	          context.name = experiment.name;
	          context.variationIds = experiment.variation_ids;
	          contexts.push({
	            schema: 'iglu:com.optimizely/experiment/jsonschema/1-0-0',
	            data: context
	          });
	        }
	      }

	      return contexts;
	    }

	    return [];
	  }
	  /**
	   * Creates a context from the window['optimizely'].data.state object
	   *
	   * @return Array State contexts
	   */


	  function getOptimizelyStateContexts() {
	    var experimentIds = [];
	    var experiments = getOptimizelyData('experiments');

	    if (experiments) {
	      for (var key in experiments) {
	        if (experiments.hasOwnProperty(key)) {
	          experimentIds.push(key);
	        }
	      }
	    }

	    var state = getOptimizelyData('state');

	    if (state) {
	      var contexts = [];
	      var activeExperiments = state.activeExperiments || [];

	      for (var _i2 = 0; _i2 < experimentIds.length; _i2++) {
	        var experimentId = experimentIds[_i2];
	        var context = {};
	        context.experimentId = experimentId;
	        context.isActive = isValueInArray(experimentIds[_i2], activeExperiments);
	        var variationMap = state.variationMap || {};
	        context.variationIndex = variationMap[experimentId];
	        var variationNamesMap = state.variationNamesMap || {};
	        context.variationName = variationNamesMap[experimentId];
	        var variationIdsMap = state.variationIdsMap || {};

	        if (variationIdsMap[experimentId] && variationIdsMap[experimentId].length === 1) {
	          context.variationId = variationIdsMap[experimentId][0];
	        }

	        contexts.push({
	          schema: 'iglu:com.optimizely/state/jsonschema/1-0-0',
	          data: context
	        });
	      }

	      return contexts;
	    }

	    return [];
	  }
	  /**
	   * Creates a context from the window['optimizely'].data.variations object
	   *
	   * @return Array Variation contexts
	   */


	  function getOptimizelyVariationContexts() {
	    var variations = getOptimizelyData('variations');

	    if (variations) {
	      var contexts = [];

	      for (var key in variations) {
	        if (variations.hasOwnProperty(key)) {
	          var context = {};
	          context.id = key;
	          var _variation = variations[key];
	          context.name = _variation.name;
	          context.code = _variation.code;
	          contexts.push({
	            schema: 'iglu:com.optimizely/variation/jsonschema/1-0-0',
	            data: context
	          });
	        }
	      }

	      return contexts;
	    }

	    return [];
	  }
	  /**
	   * Creates a context from the window['optimizely'].data.visitor object
	   *
	   * @return object Visitor context
	   */


	  function getOptimizelyVisitorContext() {
	    var visitor = getOptimizelyData('visitor');

	    if (visitor) {
	      var context = {};
	      context.browser = visitor.browser;
	      context.browserVersion = visitor.browserVersion;
	      context.device = visitor.device;
	      context.deviceType = visitor.deviceType;
	      context.ip = visitor.ip;
	      var platform = visitor.platform || {};
	      context.platformId = platform.id;
	      context.platformVersion = platform.version;
	      var location = visitor.location || {};
	      context.locationCity = location.city;
	      context.locationRegion = location.region;
	      context.locationCountry = location.country;
	      context.mobile = visitor.mobile;
	      context.mobileId = visitor.mobileId;
	      context.referrer = visitor.referrer;
	      context.os = visitor.os;
	      return {
	        schema: 'iglu:com.optimizely/visitor/jsonschema/1-0-0',
	        data: context
	      };
	    }
	  }
	  /**
	   * Creates a context from the window['optimizely'].data.visitor.audiences object
	   *
	   * @return Array VisitorAudience contexts
	   */


	  function getOptimizelyAudienceContexts() {
	    var audienceIds = getOptimizelyData('visitor', 'audiences');

	    if (audienceIds) {
	      var contexts = [];

	      for (var key in audienceIds) {
	        if (audienceIds.hasOwnProperty(key)) {
	          var context = {
	            id: key,
	            isMember: audienceIds[key]
	          };
	          contexts.push({
	            schema: 'iglu:com.optimizely/visitor_audience/jsonschema/1-0-0',
	            data: context
	          });
	        }
	      }

	      return contexts;
	    }

	    return [];
	  }
	  /**
	   * Creates a context from the window['optimizely'].data.visitor.dimensions object
	   *
	   * @return Array VisitorDimension contexts
	   */


	  function getOptimizelyDimensionContexts() {
	    var dimensionIds = getOptimizelyData('visitor', 'dimensions');

	    if (dimensionIds) {
	      var contexts = [];

	      for (var key in dimensionIds) {
	        if (dimensionIds.hasOwnProperty(key)) {
	          var context = {
	            id: key,
	            value: dimensionIds[key]
	          };
	          contexts.push({
	            schema: 'iglu:com.optimizely/visitor_dimension/jsonschema/1-0-0',
	            data: context
	          });
	        }
	      }

	      return contexts;
	    }

	    return [];
	  }
	  /**
	   * Creates an Optimizely lite context containing only data required to join
	   * event to experiment data
	   *
	   * @returns Array of custom contexts
	   */


	  function getOptimizelySummaryContexts() {
	    return map(getOptimizelySummary(), function (experiment) {
	      return {
	        schema: 'iglu:com.optimizely.snowplow/optimizely_summary/jsonschema/1-0-0',
	        data: experiment
	      };
	    });
	  }
	  /**
	   * Creates an OptimizelyX context containing only data required to join
	   * event to experiment data
	   *
	   * @returns Array of custom contexts
	   */


	  function getOptimizelyXSummaryContexts() {
	    return map(getOptimizelyXSummary(), function (experiment) {
	      return {
	        schema: 'iglu:com.optimizely.optimizelyx/summary/jsonschema/1-0-0',
	        data: experiment
	      };
	    });
	  }
	  /**
	   * Creates a context from the window['augur'] object
	   *
	   * @return object The IdentityLite context
	   */


	  function getAugurIdentityLiteContext() {
	    var augur = windowAlias.augur;

	    if (augur) {
	      var context = {
	        consumer: {},
	        device: {}
	      };
	      var consumer = augur.consumer || {};
	      context.consumer.UUID = consumer.UID;
	      var device = augur.device || {};
	      context.device.ID = device.ID;
	      context.device.isBot = device.isBot;
	      context.device.isProxied = device.isProxied;
	      context.device.isTor = device.isTor;
	      var fingerprint = device.fingerprint || {};
	      context.device.isIncognito = fingerprint.browserHasIncognitoEnabled;
	      return {
	        schema: 'iglu:io.augur.snowplow/identity_lite/jsonschema/1-0-0',
	        data: context
	      };
	    }
	  }
	  /**
	   * Creates a context from the window['_hawk'] object
	   *
	   * @return object The Parrable context
	   */


	  function getParrableContext() {
	    var parrable = window['_hawk'];

	    if (parrable) {
	      var context = {
	        encryptedId: null,
	        optout: null
	      };
	      context['encryptedId'] = parrable.browserid;
	      var regex = new RegExp('(?:^|;)\\s?' + '_parrable_hawk_optout'.replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1') + '=(.*?)(?:;|$)', 'i');
	      var match = document.cookie.match(regex);
	      context['optout'] = match && decodeURIComponent(match[1]) ? match && decodeURIComponent(match[1]) : 'false';
	      return {
	        schema: 'iglu:com.parrable/encrypted_payload/jsonschema/1-0-0',
	        data: context
	      };
	    }
	  }
	  /**
	   * Expires current session and starts a new session.
	   */


	  function newSession() {
	    // If cookies are enabled, base visit count and session ID on the cookies
	    var nowTs = Math.round(new Date().getTime() / 1000);
	    var ses = getSnowplowCookieValue('ses');
	    var id = loadDomainUserIdCookie();
	    var cookiesDisabled = id[0];
	    var _domainUserId = id[1]; // We could use the global (domainUserId) but this is better etiquette

	    var createTs = id[2];
	    var visitCount = id[3];
	    var currentVisitTs = id[4];
	    var lastVisitTs = id[5];
	    var sessionIdFromCookie = id[6]; // When cookies are enabled

	    if (cookiesDisabled === '0') {
	      memorizedSessionId = sessionIdFromCookie; // When cookie/local storage is enabled - make a new session

	      if (configStateStorageStrategy != 'none') {
	        // New session (aka new visit)
	        visitCount++; // Update the last visit timestamp

	        lastVisitTs = currentVisitTs; // Regenerate the session ID

	        memorizedSessionId = uuid_1.v4();
	      }

	      memorizedVisitCount = visitCount; // Create a new session cookie

	      setSessionCookie();
	    } else {
	      memorizedSessionId = uuid_1.v4();
	      memorizedVisitCount++;
	    } // Update cookies


	    if (configStateStorageStrategy != 'none') {
	      setDomainUserIdCookie(_domainUserId, createTs, memorizedVisitCount, nowTs, lastVisitTs, memorizedSessionId);
	      setSessionCookie();
	    }

	    lastEventTime = new Date().getTime();
	  }
	  /**
	   * Attempts to create a context using the geolocation API and add it to commonContexts
	   */


	  function enableGeolocationContext() {
	    if (!geolocationContextAdded && navigatorAlias.geolocation && navigatorAlias.geolocation.getCurrentPosition) {
	      geolocationContextAdded = true;
	      navigatorAlias.geolocation.getCurrentPosition(function (position) {
	        var coords = position.coords;
	        var geolocationContext = {
	          schema: 'iglu:com.snowplowanalytics.snowplow/geolocation_context/jsonschema/1-1-0',
	          data: {
	            latitude: coords.latitude,
	            longitude: coords.longitude,
	            latitudeLongitudeAccuracy: coords.accuracy,
	            altitude: coords.altitude,
	            altitudeAccuracy: coords.altitudeAccuracy,
	            bearing: coords.heading,
	            speed: coords.speed,
	            timestamp: Math.round(position.timestamp)
	          }
	        };
	        commonContexts.push(geolocationContext);
	      });
	    }
	  }
	  /**
	   * Creates a context containing the values of the cookies set by GA
	   *
	   * @return object GA cookies context
	   */


	  function getGaCookiesContext() {
	    var gaCookieData = {};
	    forEach(['__utma', '__utmb', '__utmc', '__utmv', '__utmz', '_ga'], function (cookieType) {
	      var value = cookie$1.cookie(cookieType);

	      if (value) {
	        gaCookieData[cookieType] = value;
	      }
	    });
	    return {
	      schema: 'iglu:com.google.analytics/cookies/jsonschema/1-0-0',
	      data: gaCookieData
	    };
	  }
	  /**
	   * Combine an array of unchanging contexts with the result of a context-creating function
	   *
	   * @param staticContexts Array of custom contexts
	   * @param contextCallback Function returning an array of contexts
	   */


	  function finalizeContexts(staticContexts, contextCallback) {
	    return (staticContexts || []).concat(contextCallback ? contextCallback() : []);
	  }
	  /**
	   * Log the page view / visit
	   *
	   * @param customTitle string The user-defined page title to attach to this page view
	   * @param context object Custom context relating to the event
	   * @param contextCallback Function returning an array of contexts
	   * @param tstamp number
	   */


	  function logPageView(customTitle, context, contextCallback, tstamp) {
	    refreshUrl();

	    if (pageViewSent) {
	      // Do not reset pageViewId if previous events were not page_view
	      resetPageView();
	    }

	    pageViewSent = true; // So we know what document.title was at the time of trackPageView

	    lastDocumentTitle = documentAlias.title;
	    lastConfigTitle = customTitle; // Fixup page title

	    var pageTitle = fixupTitle(lastConfigTitle || lastDocumentTitle); // Log page view

	    core.trackPageView(purify(configCustomUrl || locationHrefAlias), pageTitle, purify(customReferrer || configReferrerUrl), addCommonContexts(finalizeContexts(context, contextCallback)), tstamp); // Send ping (to log that user has stayed on page)

	    var now = new Date();

	    if (activityTrackingEnabled && !activityTrackingInstalled) {
	      activityTrackingInstalled = true; // Add mousewheel event handler, detect passive event listeners for performance

	      var detectPassiveEvents = {
	        update: function update() {
	          if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
	            var passive = false;
	            var options = Object.defineProperty({}, 'passive', {
	              get: function get() {
	                passive = true;
	              }
	            }); // note: have to set and remove a no-op listener instead of null
	            // (which was used previously), becasue Edge v15 throws an error
	            // when providing a null callback.
	            // https://github.com/rafrex/detect-passive-events/pull/3

	            var noop = function noop() {};

	            window.addEventListener('testPassiveEventSupport', noop, options);
	            window.removeEventListener('testPassiveEventSupport', noop, options);
	            detectPassiveEvents.hasSupport = passive;
	          }
	        }
	      };
	      detectPassiveEvents.update(); // Detect available wheel event

	      var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : // Modern browsers support "wheel"
	      document.onmousewheel !== undefined ? 'mousewheel' : // Webkit and IE support at least "mousewheel"
	      'DOMMouseScroll'; // let's assume that remaining browsers are older Firefox

	      if (Object.prototype.hasOwnProperty.call(detectPassiveEvents, 'hasSupport')) {
	        addEventListener(documentAlias, wheelEvent, activityHandler, {
	          passive: true
	        });
	      } else {
	        addEventListener(documentAlias, wheelEvent, activityHandler);
	      } // Capture our initial scroll points


	      resetMaxScrolls(); // Add event handlers; cross-browser compatibility here varies significantly
	      // @see http://quirksmode.org/dom/events

	      addEventListener(documentAlias, 'click', activityHandler);
	      addEventListener(documentAlias, 'mouseup', activityHandler);
	      addEventListener(documentAlias, 'mousedown', activityHandler);
	      addEventListener(documentAlias, 'mousemove', activityHandler);
	      addEventListener(windowAlias, 'scroll', scrollHandler); // Will updateMaxScrolls() for us

	      addEventListener(documentAlias, 'keypress', activityHandler);
	      addEventListener(documentAlias, 'keydown', activityHandler);
	      addEventListener(documentAlias, 'keyup', activityHandler);
	      addEventListener(windowAlias, 'resize', activityHandler);
	      addEventListener(windowAlias, 'focus', activityHandler);
	      addEventListener(windowAlias, 'blur', activityHandler); // Periodic check for activity.

	      lastActivityTime = now.getTime();
	      clearInterval(pagePingInterval);
	      pagePingInterval = setInterval(function heartBeat() {
	        var now = new Date(); // There was activity during the heart beat period;
	        // on average, this is going to overstate the visitDuration by configHeartBeatTimer/2

	        if (lastActivityTime + configHeartBeatTimer > now.getTime()) {
	          // Send ping if minimum visit time has elapsed
	          if (configMinimumVisitTime < now.getTime()) {
	            logPagePing(finalizeContexts(context, contextCallback)); // Grab the min/max globals
	          }
	        }
	      }, configHeartBeatTimer);
	    }
	  }
	  /**
	   * Log that a user is still viewing a given page
	   * by sending a page ping.
	   * Not part of the public API - only called from
	   * logPageView() above.
	   *
	   * @param context object Custom context relating to the event
	   */


	  function logPagePing(context) {
	    refreshUrl();
	    var newDocumentTitle = documentAlias.title;

	    if (newDocumentTitle !== lastDocumentTitle) {
	      lastDocumentTitle = newDocumentTitle;
	      lastConfigTitle = null;
	    }

	    core.trackPagePing(purify(configCustomUrl || locationHrefAlias), fixupTitle(lastConfigTitle || lastDocumentTitle), purify(customReferrer || configReferrerUrl), cleanOffset(minXOffset), cleanOffset(maxXOffset), cleanOffset(minYOffset), cleanOffset(maxYOffset), addCommonContexts(context));
	    resetMaxScrolls();
	  }
	  /**
	   * Log ecommerce transaction metadata
	   *
	   * @param string orderId
	   * @param string affiliation
	   * @param string total
	   * @param string tax
	   * @param string shipping
	   * @param string city
	   * @param string state
	   * @param string country
	   * @param string currency The currency the total/tax/shipping are expressed in
	   * @param object context Custom context relating to the event
	   * @param tstamp number or Timestamp object
	   */


	  function logTransaction(orderId, affiliation, total, tax, shipping, city, state, country, currency, context, tstamp) {
	    core.trackEcommerceTransaction(orderId, affiliation, total, tax, shipping, city, state, country, currency, addCommonContexts(context), tstamp);
	  }
	  /**
	   * Log ecommerce transaction item
	   *
	   * @param string orderId
	   * @param string sku
	   * @param string name
	   * @param string category
	   * @param string price
	   * @param string quantity
	   * @param string currency The currency the price is expressed in
	   * @param object context Custom context relating to the event
	   */


	  function logTransactionItem(orderId, sku, name, category, price, quantity, currency, context, tstamp) {
	    core.trackEcommerceTransactionItem(orderId, sku, name, category, price, quantity, currency, addCommonContexts(context), tstamp);
	  }
	  /**
	   * Construct a browser prefix
	   *
	   * E.g: (moz, hidden) -> mozHidden
	   */


	  function prefixPropertyName(prefix, propertyName) {
	    if (prefix !== '') {
	      return prefix + propertyName.charAt(0).toUpperCase() + propertyName.slice(1);
	    }

	    return propertyName;
	  }
	  /**
	   * Check for pre-rendered web pages, and log the page view/link
	   * according to the configuration and/or visibility
	   *
	   * @see http://dvcs.w3.org/hg/webperf/raw-file/tip/specs/PageVisibility/Overview.html
	   */


	  function trackCallback(callback) {
	    var isPreRendered;
	    var i; // Chrome 13, IE10, FF10

	    var prefixes = ['', 'webkit', 'ms', 'moz'];
	    var prefix; // If configPrerendered == true - we'll never set `isPreRendered` to true and fire immediately,
	    // otherwise we need to check if this is just prerendered

	    if (!configCountPreRendered) {
	      // true by default
	      for (i = 0; i < prefixes.length; i++) {
	        prefix = prefixes[i]; // does this browser support the page visibility API? (drop this check along with IE9 and iOS6)

	        if (documentAlias[prefixPropertyName(prefix, 'hidden')]) {
	          // if pre-rendered, then defer callback until page visibility changes
	          if (documentAlias[prefixPropertyName(prefix, 'visibilityState')] === 'prerender') {
	            isPreRendered = true;
	          }

	          break;
	        } else if (documentAlias[prefixPropertyName(prefix, 'hidden')] === false) {
	          break;
	        }
	      }
	    } // Implies configCountPreRendered = false


	    if (isPreRendered) {
	      // note: the event name doesn't follow the same naming convention as vendor properties
	      addEventListener(documentAlias, prefix + 'visibilitychange', function ready() {
	        documentAlias.removeEventListener(prefix + 'visibilitychange', ready, false);
	        callback();
	      });
	      return;
	    } // configCountPreRendered === true || isPreRendered === false


	    callback();
	  }
	  /************************************************************
	   * Constructor
	   ************************************************************/

	  /*
	   * Initialize tracker
	   */


	  updateDomainHash();
	  initializeIdsAndCookies();

	  if (argmap.crossDomainLinker) {
	    decorateLinks(argmap.crossDomainLinker);
	  }
	  /************************************************************
	   * Public data and methods
	   ************************************************************/


	  return {
	    /**
	    * Get the domain session index also known as current memorized visit count.
	    *
	    * @return int Domain session index
	    */
	    getDomainSessionIndex: function getDomainSessionIndex() {
	      return memorizedVisitCount;
	    },

	    /**
	    * Get the page view ID as generated or provided by mutSnowplowState.pageViewId.
	    *
	    * @return string Page view ID
	    */
	    getPageViewId: function getPageViewId() {
	      return _getPageViewId();
	    },

	    /**
	    * Expires current session and starts a new session.
	    */
	    newSession: newSession,

	    /**
	    * Get the cookie name as cookieNamePrefix + basename + . + domain.
	    *
	    * @return string Cookie name
	    */
	    getCookieName: function getCookieName(basename) {
	      return getSnowplowCookieName(basename);
	    },

	    /**
	    * Get the current user ID (as set previously
	    * with setUserId()).
	    *
	    * @return string Business-defined user ID
	    */
	    getUserId: function getUserId() {
	      return businessUserId;
	    },

	    /**
	    * Get visitor ID (from first party cookie)
	    *
	    * @return string Visitor ID in hexits (or null, if not yet known)
	    */
	    getDomainUserId: function getDomainUserId() {
	      return loadDomainUserIdCookie()[1];
	    },

	    /**
	    * Get the visitor information (from first party cookie)
	    *
	    * @return array
	    */
	    getDomainUserInfo: function getDomainUserInfo() {
	      return loadDomainUserIdCookie();
	    },

	    /**
	    * Get the user fingerprint
	    *
	    * @return string The user fingerprint
	    */
	    getUserFingerprint: function getUserFingerprint() {
	      return userFingerprint;
	    },

	    /**
	    * Specify the app ID
	    *
	    * @param int|string appId
	    */
	    setAppId: function setAppId(appId) {
	      core.setAppId(appId);
	    },

	    /**
	    * Override referrer
	    *
	    * @param string url
	    */
	    setReferrerUrl: function setReferrerUrl(url) {
	      customReferrer = url;
	    },

	    /**
	    * Override url
	    *
	    * @param string url
	    */
	    setCustomUrl: function setCustomUrl(url) {
	      refreshUrl();
	      configCustomUrl = resolveRelativeReference(locationHrefAlias, url);
	    },

	    /**
	    * Override document.title
	    *
	    * @param string title
	    */
	    setDocumentTitle: function setDocumentTitle(title) {
	      // So we know what document.title was at the time of trackPageView
	      lastDocumentTitle = documentAlias.title;
	      lastConfigTitle = title;
	      core.addPayloadPair('page', title);
	    },

	    /**
	    * Strip hash tag (or anchor) from URL
	    *
	    * @param bool enableFilter
	    */
	    discardHashTag: function discardHashTag(enableFilter) {
	      configDiscardHashTag = enableFilter;
	    },

	    /**
	    * Set first-party cookie name prefix
	    *
	    * @param string cookieNamePrefix
	    */
	    setCookieNamePrefix: function setCookieNamePrefix(cookieNamePrefix) {
	      configCookieNamePrefix = cookieNamePrefix;
	    },

	    /**
	    * Set first-party cookie domain
	    *
	    * @param string domain
	    */
	    setCookieDomain: function setCookieDomain(domain) {
	      configCookieDomain = fixupDomain(domain);
	      updateDomainHash();
	    },

	    /**
	    * Set first-party cookie path
	    *
	    * @param string domain
	    */
	    setCookiePath: function setCookiePath(path) {
	      configCookiePath = path;
	      updateDomainHash();
	    },

	    /**
	    * Set visitor cookie timeout (in seconds)
	    *
	    * @param int timeout
	    */
	    setVisitorCookieTimeout: function setVisitorCookieTimeout(timeout) {
	      configVisitorCookieTimeout = timeout;
	    },

	    /**
	    * Set session cookie timeout (in seconds)
	    *
	    * @param int timeout
	    */
	    setSessionCookieTimeout: function setSessionCookieTimeout(timeout) {
	      configSessionCookieTimeout = timeout;
	    },

	    /**
	    * @param number seed The seed used for MurmurHash3
	    */
	    setUserFingerprintSeed: function setUserFingerprintSeed(seed) {
	      configUserFingerprintHashSeed = seed;
	      userFingerprint = detectSignature(configUserFingerprintHashSeed);
	    },

	    /**
	    * Enable/disable user fingerprinting. User fingerprinting is enabled by default.
	    * @param bool enable If false, turn off user fingerprinting
	    */
	    enableUserFingerprint: function enableUserFingerprint(enable) {

	      if (!enable) {
	        userFingerprint = '';
	      }
	    },

	    /**
	    * Prevent tracking if user's browser has Do Not Track feature enabled,
	    * where tracking is:
	    * 1) Sending events to a collector
	    * 2) Setting first-party cookies
	    * @param bool enable If true and Do Not Track feature enabled, don't track.
	    */
	    respectDoNotTrack: function respectDoNotTrack(enable) {
	      var dnt = navigatorAlias.doNotTrack || navigatorAlias.msDoNotTrack;
	      configDoNotTrack = enable && (dnt === 'yes' || dnt === '1');
	    },

	    /**
	    * Enable querystring decoration for links pasing a filter
	    *
	    * @param function crossDomainLinker Function used to determine which links to decorate
	    */
	    crossDomainLinker: function crossDomainLinker(crossDomainLinkerCriterion) {
	      decorateLinks(crossDomainLinkerCriterion);
	    },

	    /**
	    * Add click listener to a specific link element.
	    * When clicked, Piwik will log the click automatically.
	    *
	    * @param DOMElement element
	    * @param bool enable If true, use pseudo click-handler (mousedown+mouseup)
	    */
	    addListener: function addListener(element, pseudoClicks, context) {
	      addClickListener(element, pseudoClicks, context);
	    },

	    /**
	    * Install link tracker
	    *
	    * The default behaviour is to use actual click events. However, some browsers
	    * (e.g., Firefox, Opera, and Konqueror) don't generate click events for the middle mouse button.
	    *
	    * To capture more "clicks", the pseudo click-handler uses mousedown + mouseup events.
	    * This is not industry standard and is vulnerable to false positives (e.g., drag events).
	    *
	    * There is a Safari/Chrome/Webkit bug that prevents tracking requests from being sent
	    * by either click handler.  The workaround is to set a target attribute (which can't
	    * be "_self", "_top", or "_parent").
	    *
	    * @see https://bugs.webkit.org/show_bug.cgi?id=54783
	    *
	    * @param object criterion Criterion by which it will be decided whether a link will be tracked
	    * @param bool pseudoClicks If true, use pseudo click-handler (mousedown+mouseup)
	    * @param bool trackContent Whether to track the innerHTML of the link element
	    * @param array context Context for all link click events
	    */
	    enableLinkClickTracking: function enableLinkClickTracking(criterion, pseudoClicks, trackContent, context) {
	      if (mutSnowplowState.hasLoaded) {
	        // the load event has already fired, add the click listeners now
	        linkTrackingManager.configureLinkClickTracking(criterion, pseudoClicks, trackContent, context);
	        linkTrackingManager.addClickListeners();
	      } else {
	        // defer until page has loaded
	        mutSnowplowState.registeredOnLoadHandlers.push(function () {
	          linkTrackingManager.configureLinkClickTracking(criterion, pseudoClicks, trackContent, context);
	          linkTrackingManager.addClickListeners();
	        });
	      }
	    },

	    /**
	    * Add click event listeners to links which have been added to the page since the
	    * last time enableLinkClickTracking or refreshLinkClickTracking was used
	    */
	    refreshLinkClickTracking: function refreshLinkClickTracking() {
	      if (mutSnowplowState.hasLoaded) {
	        linkTrackingManager.addClickListeners();
	      } else {
	        mutSnowplowState.registeredOnLoadHandlers.push(function () {
	          linkTrackingManager.addClickListeners();
	        });
	      }
	    },

	    /**
	    * Enables page activity tracking (sends page
	    * pings to the Collector regularly).
	    *
	    * @param int minimumVisitLength Seconds to wait before sending first page ping
	    * @param int heartBeatDelay Seconds to wait between pings
	    */
	    enableActivityTracking: function enableActivityTracking(minimumVisitLength, heartBeatDelay) {
	      if (minimumVisitLength === parseInt(minimumVisitLength, 10) && heartBeatDelay === parseInt(heartBeatDelay, 10)) {
	        activityTrackingEnabled = true;
	        configMinimumVisitTime = new Date().getTime() + minimumVisitLength * 1000;
	        configHeartBeatTimer = heartBeatDelay * 1000;
	      }
	    },

	    /**
	    * Triggers the activityHandler manually to allow external user defined
	    * activity. i.e. While watching a video
	    */
	    updatePageActivity: function updatePageActivity() {
	      activityHandler();
	    },

	    /**
	    * Enables automatic form tracking.
	    * An event will be fired when a form field is changed or a form submitted.
	    * This can be called multiple times: only forms not already tracked will be tracked.
	    *
	    * @param object config Configuration object determining which forms and fields to track.
	    *                      Has two properties: "forms" and "fields"
	    * @param array context Context for all form tracking events
	    */
	    enableFormTracking: function enableFormTracking(config, context) {
	      if (mutSnowplowState.hasLoaded) {
	        formTrackingManager.configureFormTracking(config);
	        formTrackingManager.addFormListeners(context);
	      } else {
	        mutSnowplowState.registeredOnLoadHandlers.push(function () {
	          formTrackingManager.configureFormTracking(config);
	          formTrackingManager.addFormListeners(context);
	        });
	      }
	    },

	    /**
	    * Frame buster
	    */
	    killFrame: function killFrame() {
	      if (windowAlias.location !== windowAlias.top.location) {
	        windowAlias.top.location = windowAlias.location;
	      }
	    },

	    /**
	    * Redirect if browsing offline (aka file: buster)
	    *
	    * @param string url Redirect to this URL
	    */
	    redirectFile: function redirectFile(url) {
	      if (windowAlias.location.protocol === 'file:') {
	        windowAlias.location = url;
	      }
	    },

	    /**
	    * Sets the opt out cookie.
	    *
	    * @param string name of the opt out cookie
	    */
	    setOptOutCookie: function setOptOutCookie(name) {
	      configOptOutCookie = name;
	    },

	    /**
	    * Count sites in pre-rendered state
	    *
	    * @param bool enable If true, track when in pre-rendered state
	    */
	    setCountPreRendered: function setCountPreRendered(enable) {
	      configCountPreRendered = enable;
	    },

	    /**
	    * Set the business-defined user ID for this user.
	    *
	    * @param string userId The business-defined user ID
	    */
	    setUserId: function setUserId(userId) {
	      businessUserId = userId;
	    },

	    /**
	    * Alias for setUserId.
	    *
	    * @param string userId The business-defined user ID
	    */
	    identifyUser: function identifyUser(userId) {
	      setUserId(userId);
	    },

	    /**
	    * Set the business-defined user ID for this user using the location querystring.
	    *
	    * @param string queryName Name of a querystring name-value pair
	    */
	    setUserIdFromLocation: function setUserIdFromLocation(querystringField) {
	      refreshUrl();
	      businessUserId = fromQuerystring(querystringField, locationHrefAlias);
	    },

	    /**
	    * Set the business-defined user ID for this user using the referrer querystring.
	    *
	    * @param string queryName Name of a querystring name-value pair
	    */
	    setUserIdFromReferrer: function setUserIdFromReferrer(querystringField) {
	      refreshUrl();
	      businessUserId = fromQuerystring(querystringField, configReferrerUrl);
	    },

	    /**
	    * Set the business-defined user ID for this user to the value of a cookie.
	    *
	    * @param string cookieName Name of the cookie whose value will be assigned to businessUserId
	    */
	    setUserIdFromCookie: function setUserIdFromCookie(cookieName) {
	      businessUserId = cookie$1.cookie(cookieName);
	    },

	    /**
	    * Configure this tracker to log to a CloudFront collector.
	    *
	    * @param string distSubdomain The subdomain on your CloudFront collector's distribution
	    */
	    setCollectorCf: function setCollectorCf(distSubdomain) {
	      configCollectorUrl = collectorUrlFromCfDist(distSubdomain);
	    },

	    /**
	    *
	    * Specify the Snowplow collector URL. No need to include HTTP
	    * or HTTPS - we will add this.
	    *
	    * @param string rawUrl The collector URL minus protocol and /i
	    */
	    setCollectorUrl: function setCollectorUrl(rawUrl) {
	      configCollectorUrl = asCollectorUrl(rawUrl);
	    },

	    /**
	    * Specify the platform
	    *
	    * @param string platform Overrides the default tracking platform
	    */
	    setPlatform: function setPlatform(platform) {
	      core.setPlatform(platform);
	    },

	    /**
	    *
	    * Enable Base64 encoding for self-describing event payload
	    *
	    * @param bool enabled A boolean value indicating if the Base64 encoding for self-describing events should be enabled or not
	    */
	    encodeBase64: function encodeBase64(enabled) {
	      core.setBase64Encoding(enabled);
	    },

	    /**
	    * Send all events in the outQueue
	    * Use only when sending POSTs with a bufferSize of at least 2
	    */
	    flushBuffer: function flushBuffer() {
	      outQueueManager.executeQueue();
	    },

	    /**
	    * Add the geolocation context to all events
	    */
	    enableGeolocationContext: enableGeolocationContext,

	    /**
	    * Log visit to this page
	    *
	    * @param string customTitle
	    * @param object Custom context relating to the event
	    * @param object contextCallback Function returning an array of contexts
	    * @param tstamp number or Timestamp object
	    */
	    trackPageView: function trackPageView(customTitle, context, contextCallback, tstamp) {
	      trackCallback(function () {
	        logPageView(customTitle, context, contextCallback, tstamp);
	      });
	    },

	    /**
	    * Track a structured event happening on this page.
	    *
	    * Replaces trackEvent, making clear that the type
	    * of event being tracked is a structured one.
	    *
	    * @param string category The name you supply for the group of objects you want to track
	    * @param string action A string that is uniquely paired with each category, and commonly used to define the type of user interaction for the web object
	    * @param string label (optional) An optional string to provide additional dimensions to the event data
	    * @param string property (optional) Describes the object or the action performed on it, e.g. quantity of item added to basket
	    * @param int|float|string value (optional) An integer that you can use to provide numerical data about the user event
	    * @param object Custom context relating to the event
	    * @param tstamp number or Timestamp object
	    */
	    trackStructEvent: function trackStructEvent(category, action, label, property, value, context, tstamp) {
	      trackCallback(function () {
	        core.trackStructEvent(category, action, label, property, value, addCommonContexts(context), tstamp);
	      });
	    },

	    /**
	    * Track a self-describing event (previously unstructured event) happening on this page.
	    *
	    * @param object eventJson Contains the properties and schema location for the event
	    * @param object context Custom context relating to the event
	    * @param tstamp number or Timestamp object
	    */
	    trackSelfDescribingEvent: function trackSelfDescribingEvent(eventJson, context, tstamp) {
	      trackCallback(function () {
	        core.trackSelfDescribingEvent(eventJson, addCommonContexts(context), tstamp);
	      });
	    },

	    /**
	    * Alias for `trackSelfDescribingEvent`, left for compatibility
	    */
	    trackUnstructEvent: function trackUnstructEvent(eventJson, context, tstamp) {
	      trackCallback(function () {
	        core.trackSelfDescribingEvent(eventJson, addCommonContexts(context), tstamp);
	      });
	    },

	    /**
	    * Track an ecommerce transaction
	    *
	    * @param string orderId Required. Internal unique order id number for this transaction.
	    * @param string affiliation Optional. Partner or store affiliation.
	    * @param string total Required. Total amount of the transaction.
	    * @param string tax Optional. Tax amount of the transaction.
	    * @param string shipping Optional. Shipping charge for the transaction.
	    * @param string city Optional. City to associate with transaction.
	    * @param string state Optional. State to associate with transaction.
	    * @param string country Optional. Country to associate with transaction.
	    * @param string currency Optional. Currency to associate with this transaction.
	    * @param object context Optional. Context relating to the event.
	    * @param tstamp number or Timestamp object
	    */
	    addTrans: function addTrans(orderId, affiliation, total, tax, shipping, city, state, country, currency, context, tstamp) {
	      ecommerceTransaction.transaction = {
	        orderId: orderId,
	        affiliation: affiliation,
	        total: total,
	        tax: tax,
	        shipping: shipping,
	        city: city,
	        state: state,
	        country: country,
	        currency: currency,
	        context: context,
	        tstamp: tstamp
	      };
	    },

	    /**
	    * Track an ecommerce transaction item
	    *
	    * @param string orderId Required Order ID of the transaction to associate with item.
	    * @param string sku Required. Item's SKU code.
	    * @param string name Optional. Product name.
	    * @param string category Optional. Product category.
	    * @param string price Required. Product price.
	    * @param string quantity Required. Purchase quantity.
	    * @param string currency Optional. Product price currency.
	    * @param object context Optional. Context relating to the event.
	    * @param tstamp number or Timestamp object
	    */
	    addItem: function addItem(orderId, sku, name, category, price, quantity, currency, context, tstamp) {
	      ecommerceTransaction.items.push({
	        orderId: orderId,
	        sku: sku,
	        name: name,
	        category: category,
	        price: price,
	        quantity: quantity,
	        currency: currency,
	        context: context,
	        tstamp: tstamp
	      });
	    },

	    /**
	    * Commit the ecommerce transaction
	    *
	    * This call will send the data specified with addTrans,
	    * addItem methods to the tracking server.
	    */
	    trackTrans: function trackTrans() {
	      trackCallback(function () {
	        logTransaction(ecommerceTransaction.transaction.orderId, ecommerceTransaction.transaction.affiliation, ecommerceTransaction.transaction.total, ecommerceTransaction.transaction.tax, ecommerceTransaction.transaction.shipping, ecommerceTransaction.transaction.city, ecommerceTransaction.transaction.state, ecommerceTransaction.transaction.country, ecommerceTransaction.transaction.currency, ecommerceTransaction.transaction.context, ecommerceTransaction.transaction.tstamp);

	        for (var _i3 = 0; _i3 < ecommerceTransaction.items.length; _i3++) {
	          var item = ecommerceTransaction.items[_i3];
	          logTransactionItem(item.orderId, item.sku, item.name, item.category, item.price, item.quantity, item.currency, item.context, item.tstamp);
	        }

	        ecommerceTransaction = ecommerceTransactionTemplate();
	      });
	    },

	    /**
	    * Manually log a click from your own code
	    *
	    * @param string elementId
	    * @param array elementClasses
	    * @param string elementTarget
	    * @param string targetUrl
	    * @param string elementContent innerHTML of the element
	    * @param object Custom context relating to the event
	    * @param tstamp number or Timestamp object
	    */
	    // TODO: break this into trackLink(destUrl) and trackDownload(destUrl)
	    trackLinkClick: function trackLinkClick(targetUrl, elementId, elementClasses, elementTarget, elementContent, context, tstamp) {
	      trackCallback(function () {
	        core.trackLinkClick(targetUrl, elementId, elementClasses, elementTarget, elementContent, addCommonContexts(context), tstamp);
	      });
	    },

	    /**
	    * Track an ad being served
	    *
	    * @param string impressionId Identifier for a particular ad impression
	    * @param string costModel The cost model. 'cpa', 'cpc', or 'cpm'
	    * @param number cost Cost
	    * @param string bannerId Identifier for the ad banner displayed
	    * @param string zoneId Identifier for the ad zone
	    * @param string advertiserId Identifier for the advertiser
	    * @param string campaignId Identifier for the campaign which the banner belongs to
	    * @param object Custom context relating to the event
	    * @param tstamp number or Timestamp object
	    */
	    trackAdImpression: function trackAdImpression(impressionId, costModel, cost, targetUrl, bannerId, zoneId, advertiserId, campaignId, context, tstamp) {
	      trackCallback(function () {
	        core.trackAdImpression(impressionId, costModel, cost, targetUrl, bannerId, zoneId, advertiserId, campaignId, addCommonContexts(context), tstamp);
	      });
	    },

	    /**
	    * Track an ad being clicked
	    *
	    * @param string clickId Identifier for the ad click
	    * @param string costModel The cost model. 'cpa', 'cpc', or 'cpm'
	    * @param number cost Cost
	    * @param string targetUrl (required) The link's target URL
	    * @param string bannerId Identifier for the ad banner displayed
	    * @param string zoneId Identifier for the ad zone
	    * @param string impressionId Identifier for a particular ad impression
	    * @param string advertiserId Identifier for the advertiser
	    * @param string campaignId Identifier for the campaign which the banner belongs to
	    * @param object Custom context relating to the event
	    * @param tstamp number or Timestamp object
	    */
	    trackAdClick: function trackAdClick(targetUrl, clickId, costModel, cost, bannerId, zoneId, impressionId, advertiserId, campaignId, context, tstamp) {
	      trackCallback(function () {
	        core.trackAdClick(targetUrl, clickId, costModel, cost, bannerId, zoneId, impressionId, advertiserId, campaignId, addCommonContexts(context), tstamp);
	      });
	    },

	    /**
	    * Track an ad conversion event
	    *
	    * @param string conversionId Identifier for the ad conversion event
	    * @param number cost Cost
	    * @param string category The name you supply for the group of objects you want to track
	    * @param string action A string that is uniquely paired with each category
	    * @param string property Describes the object of the conversion or the action performed on it
	    * @param number initialValue Revenue attributable to the conversion at time of conversion
	    * @param string advertiserId Identifier for the advertiser
	    * @param string costModel The cost model. 'cpa', 'cpc', or 'cpm'
	    * @param string campaignId Identifier for the campaign which the banner belongs to
	    * @param object Custom context relating to the event
	    * @param tstamp number or Timestamp object
	    */
	    trackAdConversion: function trackAdConversion(conversionId, costModel, cost, category, action, property, initialValue, advertiserId, campaignId, context, tstamp) {
	      trackCallback(function () {
	        core.trackAdConversion(conversionId, costModel, cost, category, action, property, initialValue, advertiserId, campaignId, addCommonContexts(context), tstamp);
	      });
	    },

	    /**
	    * Track a social interaction event
	    *
	    * @param string action (required) Social action performed
	    * @param string network (required) Social network
	    * @param string target Object of the social action e.g. the video liked, the tweet retweeted
	    * @param object Custom context relating to the event
	    * @param tstamp number or Timestamp object
	    */
	    trackSocialInteraction: function trackSocialInteraction(action, network, target, context, tstamp) {
	      trackCallback(function () {
	        core.trackSocialInteraction(action, network, target, addCommonContexts(context), tstamp);
	      });
	    },

	    /**
	    * Track an add-to-cart event
	    *
	    * @param string sku Required. Item's SKU code.
	    * @param string name Optional. Product name.
	    * @param string category Optional. Product category.
	    * @param string unitPrice Optional. Product price.
	    * @param string quantity Required. Quantity added.
	    * @param string currency Optional. Product price currency.
	    * @param array context Optional. Context relating to the event.
	    * @param tstamp number or Timestamp object
	    */
	    trackAddToCart: function trackAddToCart(sku, name, category, unitPrice, quantity, currency, context, tstamp) {
	      trackCallback(function () {
	        core.trackAddToCart(sku, name, category, unitPrice, quantity, currency, addCommonContexts(context), tstamp);
	      });
	    },

	    /**
	    * Track a remove-from-cart event
	    *
	    * @param string sku Required. Item's SKU code.
	    * @param string name Optional. Product name.
	    * @param string category Optional. Product category.
	    * @param string unitPrice Optional. Product price.
	    * @param string quantity Required. Quantity removed.
	    * @param string currency Optional. Product price currency.
	    * @param array context Optional. Context relating to the event.
	    * @param tstamp Opinal number or Timestamp object
	    */
	    trackRemoveFromCart: function trackRemoveFromCart(sku, name, category, unitPrice, quantity, currency, context, tstamp) {
	      trackCallback(function () {
	        core.trackRemoveFromCart(sku, name, category, unitPrice, quantity, currency, addCommonContexts(context), tstamp);
	      });
	    },

	    /**
	    * Track an internal search event
	    *
	    * @param array terms Search terms
	    * @param object filters Search filters
	    * @param number totalResults Number of results
	    * @param number pageResults Number of results displayed on page
	    * @param array context Optional. Context relating to the event.
	    * @param tstamp Opinal number or Timestamp object
	    */
	    trackSiteSearch: function trackSiteSearch(terms, filters, totalResults, pageResults, context, tstamp) {
	      trackCallback(function () {
	        core.trackSiteSearch(terms, filters, totalResults, pageResults, addCommonContexts(context), tstamp);
	      });
	    },

	    /**
	    * Track a timing event (such as the time taken for a resource to load)
	    *
	    * @param string category Required.
	    * @param string variable Required.
	    * @param number timing Required.
	    * @param string label Optional.
	    * @param array context Optional. Context relating to the event.
	    * @param tstamp Opinal number or Timestamp object
	    */
	    trackTiming: function trackTiming(category, variable, timing, label, context, tstamp) {
	      trackCallback(function () {
	        core.trackSelfDescribingEvent({
	          schema: 'iglu:com.snowplowanalytics.snowplow/timing/jsonschema/1-0-0',
	          data: {
	            category: category,
	            variable: variable,
	            timing: timing,
	            label: label
	          }
	        }, addCommonContexts(context), tstamp);
	      });
	    },

	    /**
	    * Track a consent withdrawn action
	    *
	    * @param {boolean} all - Indicates user withdraws all consent regardless of context documents.
	    * @param {string} [id] - Number associated with document.
	    * @param {string} [version] - Document version number.
	    * @param {string} [name] - Document name.
	    * @param {string} [description] - Document description.
	    * @param {array} [context] - Context relating to the event.
	    * @param {number|Timestamp} [tstamp] - Number or Timestamp export const
	    */
	    trackConsentWithdrawn: function trackConsentWithdrawn(all, id, version, name, description, context, tstamp) {
	      trackCallback(function () {
	        core.trackConsentWithdrawn(all, id, version, name, description, addCommonContexts(context), tstamp);
	      });
	    },

	    /**
	    * Track a consent granted action
	    *
	    * @param {string} id - ID number associated with document.
	    * @param {string} version - Document version number.
	    * @param {string} [name] - Document name.
	    * @param {string} [description] - Document description.
	    * @param {string} [expiry] - Date-time when consent document(s) expire.
	    * @param {array} [context] - Context containing consent documents.
	    * @param {Timestamp|number} [tstamp] - number or Timestamp export const
	    */
	    trackConsentGranted: function trackConsentGranted(id, version, name, description, expiry, context, tstamp) {
	      trackCallback(function () {
	        core.trackConsentGranted(id, version, name, description, expiry, addCommonContexts(context), tstamp);
	      });
	    },

	    /**
	    * Track a GA Enhanced Ecommerce Action with all stored
	    * Enhanced Ecommerce contexts
	    *
	    * @param string action
	    * @param array context Optional. Context relating to the event.
	    * @param tstamp Opinal number or Timestamp object
	    */
	    trackEnhancedEcommerceAction: function trackEnhancedEcommerceAction(action, context, tstamp) {
	      var combinedEnhancedEcommerceContexts = enhancedEcommerceContexts.concat(context || []);
	      enhancedEcommerceContexts.length = 0;
	      trackCallback(function () {
	        core.trackSelfDescribingEvent({
	          schema: 'iglu:com.google.analytics.enhanced-ecommerce/action/jsonschema/1-0-0',
	          data: {
	            action: action
	          }
	        }, addCommonContexts(combinedEnhancedEcommerceContexts), tstamp);
	      });
	    },

	    /**
	    * Adds a GA Enhanced Ecommerce Action Context
	    *
	    * @param string id
	    * @param string affiliation
	    * @param number revenue
	    * @param number tax
	    * @param number shipping
	    * @param string coupon
	    * @param string list
	    * @param integer step
	    * @param string option
	    * @param string currency
	    */
	    addEnhancedEcommerceActionContext: function addEnhancedEcommerceActionContext(id, affiliation, revenue, tax, shipping, coupon, list, step, option, currency) {
	      enhancedEcommerceContexts.push({
	        schema: 'iglu:com.google.analytics.enhanced-ecommerce/actionFieldObject/jsonschema/1-0-0',
	        data: {
	          id: id,
	          affiliation: affiliation,
	          revenue: parseFloat(),
	          tax: parseFloat(),
	          shipping: parseFloat(),
	          coupon: coupon,
	          list: list,
	          step: parseInt$1(),
	          option: option,
	          currency: currency
	        }
	      });
	    },

	    /**
	    * Adds a GA Enhanced Ecommerce Impression Context
	    *
	    * @param string id
	    * @param string name
	    * @param string list
	    * @param string brand
	    * @param string category
	    * @param string variant
	    * @param integer position
	    * @param number price
	    * @param string currency
	    */
	    addEnhancedEcommerceImpressionContext: function addEnhancedEcommerceImpressionContext(id, name, list, brand, category, variant, position, price, currency) {
	      enhancedEcommerceContexts.push({
	        schema: 'iglu:com.google.analytics.enhanced-ecommerce/impressionFieldObject/jsonschema/1-0-0',
	        data: {
	          id: id,
	          name: name,
	          list: list,
	          brand: brand,
	          category: category,
	          variant: variant,
	          position: parseInt$1(),
	          price: parseFloat(),
	          currency: currency
	        }
	      });
	    },

	    /**
	    * Adds a GA Enhanced Ecommerce Product Context
	    *
	    * @param string id
	    * @param string name
	    * @param string list
	    * @param string brand
	    * @param string category
	    * @param string variant
	    * @param number price
	    * @param integer quantity
	    * @param string coupon
	    * @param integer position
	    * @param string currency
	    */
	    addEnhancedEcommerceProductContext: function addEnhancedEcommerceProductContext(id, name, list, brand, category, variant, price, quantity, coupon, position, currency) {
	      enhancedEcommerceContexts.push({
	        schema: 'iglu:com.google.analytics.enhanced-ecommerce/productFieldObject/jsonschema/1-0-0',
	        data: {
	          id: id,
	          name: name,
	          list: list,
	          brand: brand,
	          category: category,
	          variant: variant,
	          price: parseFloat(),
	          quantity: parseInt$1(),
	          coupon: coupon,
	          position: parseInt$1(),
	          currency: currency
	        }
	      });
	    },

	    /**
	    * Adds a GA Enhanced Ecommerce Promo Context
	    *
	    * @param string id
	    * @param string name
	    * @param string creative
	    * @param string position
	    * @param string currency
	    */
	    addEnhancedEcommercePromoContext: function addEnhancedEcommercePromoContext(id, name, creative, position, currency) {
	      enhancedEcommerceContexts.push({
	        schema: 'iglu:com.google.analytics.enhanced-ecommerce/promoFieldObject/jsonschema/1-0-0',
	        data: {
	          id: id,
	          name: name,
	          creative: creative,
	          position: position,
	          currency: currency
	        }
	      });
	    },

	    /**
	    * Enable tracking of unhandled exceptions with custom contexts
	    *
	    * @param filter Function ErrorEvent => Bool to check whether error should be tracker
	    * @param contextsAdder Function ErrorEvent => Array<Context> to add custom contexts with
	    *		             internal state based on particular error
	    */
	    enableErrorTracking: function enableErrorTracking(filter, contextsAdder) {
	      errorManager$1.enableErrorTracking(filter, contextsAdder, addCommonContexts());
	    },

	    /**
	    * Track unhandled exception.
	    * This method supposed to be used inside try/catch block
	    *
	    * @param message string Message appeared in console
	    * @param filename string Source file (not used)
	    * @param lineno number Line number
	    * @param colno number Column number (not used)
	    * @param error Error error object (not present in all browsers)
	    * @param contexts Array of custom contexts
	    */
	    trackError: function trackError(message, filename, lineno, colno, error, contexts) {
	      var enrichedContexts = addCommonContexts(contexts);
	      errorManager$1.trackError(message, filename, lineno, colno, error, enrichedContexts);
	    },

	    /**
	    * Stop regenerating `pageViewId` (available from `web_page` context)
	    */
	    preservePageViewId: function preservePageViewId() {
	      _preservePageViewId = true;
	    }
	  };
	};

	var Snowplow = function Snowplow(asynchronousQueue, functionName) {
	  var documentAlias = document;
	  var windowAlias = window;
	  /* Tracker identifier with version */

	  var version = 'js-2.10.2'; // Update banner.js too

	  /* Contains four variables that are shared with tracker.js and must be passed by reference */

	  var mutSnowplowState = {
	    /* List of request queues - one per Tracker instance */
	    outQueues: [],
	    bufferFlushers: [],

	    /* Time at which to stop blocking excecution */
	    expireDateTime: null,

	    /* DOM Ready */
	    hasLoaded: false,
	    registeredOnLoadHandlers: [],

	    /* pageViewId, which can changed by other trackers on page;
	      * initialized by tracker sent first event */
	    pageViewId: null
	  };
	  /************************************************************
	   * Private methods
	   ************************************************************/

	  /*
	    * Handle beforeunload event
	    *
	    * Subject to Safari's "Runaway JavaScript Timer" and
	    * Chrome V8 extension that terminates JS that exhibits
	    * "slow unload", i.e., calling getTime() > 1000 times
	    */

	  function beforeUnloadHandler() {
	    var now; // Flush all POST queues

	    forEach(mutSnowplowState.bufferFlushers, function (flusher) {
	      flusher();
	    });
	    /*
	      * Delay/pause (blocks UI)
	      */

	    if (mutSnowplowState.expireDateTime) {
	      // the things we do for backwards compatibility...
	      // in ECMA-262 5th ed., we could simply use:
	      //     while (Date.now() < mutSnowplowState.expireDateTime) { }
	      do {
	        now = new Date();

	        if (filter(mutSnowplowState.outQueues, function (queue) {
	          return queue.length > 0;
	        }).length === 0) {
	          break;
	        }
	      } while (now.getTime() < mutSnowplowState.expireDateTime);
	    }
	  }
	  /*
	    * Handler for onload event
	    */


	  function loadHandler() {
	    var i;

	    if (!mutSnowplowState.hasLoaded) {
	      mutSnowplowState.hasLoaded = true;

	      for (i = 0; i < mutSnowplowState.registeredOnLoadHandlers.length; i++) {
	        mutSnowplowState.registeredOnLoadHandlers[i]();
	      }
	    }

	    return true;
	  }
	  /*
	    * Add onload or DOM ready handler
	    */


	  function addReadyListener() {
	    var _timer;

	    if (documentAlias.addEventListener) {
	      addEventListener(documentAlias, 'DOMContentLoaded', function ready() {
	        documentAlias.removeEventListener('DOMContentLoaded', ready, false);
	        loadHandler();
	      });
	    } else if (documentAlias.attachEvent) {
	      documentAlias.attachEvent('onreadystatechange', function ready() {
	        if (documentAlias.readyState === 'complete') {
	          documentAlias.detachEvent('onreadystatechange', ready);
	          loadHandler();
	        }
	      });

	      if (documentAlias.documentElement.doScroll && windowAlias === windowAlias.top) {
	        (function ready() {
	          if (!mutSnowplowState.hasLoaded) {
	            try {
	              documentAlias.documentElement.doScroll('left');
	            } catch (error) {
	              setTimeout(ready, 0);
	              return;
	            }

	            loadHandler();
	          }
	        })();
	      }
	    } // sniff for older WebKit versions


	    if (new RegExp('WebKit').test(navigator.userAgent)) {
	      _timer = setInterval(function () {
	        if (mutSnowplowState.hasLoaded || /loaded|complete/.test(documentAlias.readyState)) {
	          clearInterval(_timer);
	          loadHandler();
	        }
	      }, 10);
	    } // fallback


	    addEventListener(windowAlias, 'load', loadHandler, false);
	  }
	  /************************************************************
	   * Public data and methods
	   ************************************************************/


	  windowAlias.Snowplow = {
	    /**
	     * Returns a Tracker object, configured with a
	     * CloudFront collector.
	     *
	     * @param string distSubdomain The subdomain on your CloudFront collector's distribution
	     */
	    getTrackerCf: function getTrackerCf(distSubdomain) {
	      var t = new Tracker(functionName, '', version, mutSnowplowState, {});
	      t.setCollectorCf(distSubdomain);
	      return t;
	    },

	    /**
	     * Returns a Tracker object, configured with the
	     * URL to the collector to use.
	     *
	     * @param string rawUrl The collector URL minus protocol and /i
	     */
	    getTrackerUrl: function getTrackerUrl(rawUrl) {
	      var t = new Tracker(functionName, '', version, mutSnowplowState, {});
	      t.setCollectorUrl(rawUrl);
	      return t;
	    },

	    /**
	     * Get internal asynchronous tracker object
	     *
	     * @return Tracker
	     */
	    getAsyncTracker: function getAsyncTracker() {
	      return new Tracker(functionName, '', version, mutSnowplowState, {});
	    }
	  };
	  /************************************************************
	   * Constructor
	   ************************************************************/
	  // initialize the Snowplow singleton

	  addEventListener(windowAlias, 'beforeunload', beforeUnloadHandler, false);
	  addReadyListener(); // Now replace initialization array with queue manager object

	  return new InQueueManager(Tracker, version, mutSnowplowState, asynchronousQueue, functionName);
	};

	var getUrlSearchParam = function getUrlSearchParam(name) {
	  var url = location.href; // const newName = name.replace(/[\[\]]/g, '\\$&')

	  var regexp = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
	  var results = regexp.exec(url);
	  if (!results) return null;
	  if (!results[2]) return '';
	  return decodeURIComponent(results[2].replace(/\+/g, ' '));
	};
	/**
	 * 分割出一级域名
	 * @param {string} val - 二级域名，例：www.xhqb.com
	 * @returns {string} - 一级域名，返回 xhqb.com
	 */

	var splitHost = function splitHost(val) {
	  if (!val) return '';
	  var arr = val.split('.');
	  arr.shift();
	  return arr.join('.');
	};

	// 7.2.9 SameValue(x, y)
	var _sameValue = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

	// @@search logic
	_fixReWks('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
	  return [
	    // `String.prototype.search` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.search
	    function search(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[SEARCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	    },
	    // `RegExp.prototype[@@search]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
	    function (regexp) {
	      var res = maybeCallNative($search, regexp, this);
	      if (res.done) return res.value;
	      var rx = _anObject(regexp);
	      var S = String(this);
	      var previousLastIndex = rx.lastIndex;
	      if (!_sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
	      var result = _regexpExecAbstract(rx, S);
	      if (!_sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
	      return result === null ? -1 : result.index;
	    }
	  ];
	});

	_export(_export.P + _export.F * _fails(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = _toObject(this);
	    var pv = _toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});

	/* eslint-disable */
	var sd = {
	  modules: {}
	},
	    _ = sd._ = {};

	"object" != (typeof JSON === "undefined" ? "undefined" : _typeof_1(JSON)) && (JSON = {}), function () {

	  var rx_one = /^[\],:{}\s]*$/,
	      rx_two = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g,
	      rx_three = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,
	      rx_four = /(?:^|:|,)(?:\s*\[)+/g,
	      rx_escapable = /[\\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
	      rx_dangerous = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
	      gap,
	      indent,
	      meta,
	      rep;

	  function f(e) {
	    return e < 10 ? "0" + e : e;
	  }

	  function this_value() {
	    return this.valueOf();
	  }

	  function quote(e) {
	    return rx_escapable.lastIndex = 0, rx_escapable.test(e) ? '"' + e.replace(rx_escapable, function (e) {
	      var t = meta[e];
	      return "string" == typeof t ? t : "\\u" + ("0000" + e.charCodeAt(0).toString(16)).slice(-4);
	    }) + '"' : '"' + e + '"';
	  }

	  function str(e, t) {
	    var r,
	        s,
	        a,
	        n,
	        i,
	        o = gap,
	        d = t[e];

	    switch (d && "object" == _typeof_1(d) && "function" == typeof d.toJSON && (d = d.toJSON(e)), "function" == typeof rep && (d = rep.call(t, e, d)), _typeof_1(d)) {
	      case "string":
	        return quote(d);

	      case "number":
	        return isFinite(d) ? String(d) : "null";

	      case "boolean":
	      case "null":
	        return String(d);

	      case "object":
	        if (!d) return "null";

	        if (gap += indent, i = [], "[object Array]" === Object.prototype.toString.apply(d)) {
	          for (n = d.length, r = 0; r < n; r += 1) {
	            i[r] = str(r, d) || "null";
	          }

	          return a = 0 === i.length ? "[]" : gap ? "[\n" + gap + i.join(",\n" + gap) + "\n" + o + "]" : "[" + i.join(",") + "]", gap = o, a;
	        }

	        if (rep && "object" == _typeof_1(rep)) for (n = rep.length, r = 0; r < n; r += 1) {
	          "string" == typeof rep[r] && (a = str(s = rep[r], d)) && i.push(quote(s) + (gap ? ": " : ":") + a);
	        } else for (s in d) {
	          Object.prototype.hasOwnProperty.call(d, s) && (a = str(s, d)) && i.push(quote(s) + (gap ? ": " : ":") + a);
	        }
	        return a = 0 === i.length ? "{}" : gap ? "{\n" + gap + i.join(",\n" + gap) + "\n" + o + "}" : "{" + i.join(",") + "}", gap = o, a;
	    }
	  }

	  "function" != typeof Date.prototype.toJSON && (Date.prototype.toJSON = function () {
	    return isFinite(this.valueOf()) ? this.getUTCFullYear() + "-" + f(this.getUTCMonth() + 1) + "-" + f(this.getUTCDate()) + "T" + f(this.getUTCHours()) + ":" + f(this.getUTCMinutes()) + ":" + f(this.getUTCSeconds()) + "Z" : null;
	  }, Boolean.prototype.toJSON = this_value, Number.prototype.toJSON = this_value, String.prototype.toJSON = this_value), "function" != typeof JSON.stringify && (meta = {
	    "\b": "\\b",
	    "\t": "\\t",
	    "\n": "\\n",
	    "\f": "\\f",
	    "\r": "\\r",
	    '"': '\\"',
	    "\\": "\\\\"
	  }, JSON.stringify = function (e, t, r) {
	    var s;
	    if (gap = "", indent = "", "number" == typeof r) for (s = 0; s < r; s += 1) {
	      indent += " ";
	    } else "string" == typeof r && (indent = r);
	    if (rep = t, t && "function" != typeof t && ("object" != _typeof_1(t) || "number" != typeof t.length)) throw new Error("JSON.stringify");
	    return str("", {
	      "": e
	    });
	  }), "function" != typeof JSON.parse && (JSON.parse = function (text, reviver) {
	    var j;

	    function walk(e, t) {
	      var r,
	          s,
	          a = e[t];
	      if (a && "object" == _typeof_1(a)) for (r in a) {
	        Object.prototype.hasOwnProperty.call(a, r) && (void 0 !== (s = walk(a, r)) ? a[r] = s : delete a[r]);
	      }
	      return reviver.call(e, t, a);
	    }

	    if (text = String(text), rx_dangerous.lastIndex = 0, rx_dangerous.test(text) && (text = text.replace(rx_dangerous, function (e) {
	      return "\\u" + ("0000" + e.charCodeAt(0).toString(16)).slice(-4);
	    })), rx_one.test(text.replace(rx_two, "@").replace(rx_three, "]").replace(rx_four, ""))) return j = eval("(" + text + ")"), "function" == typeof reviver ? walk({
	      "": j
	    }, "") : j;
	    throw new SyntaxError("JSON.parse");
	  });
	}(), function () {
	  var e,
	      t = Array.prototype,
	      s = Object.prototype,
	      a = t.slice,
	      n = s.toString,
	      i = s.hasOwnProperty,
	      o = (t.forEach),
	      d = (Array.isArray),
	      c = {},
	      u = _.each = function (e, t, r) {
	    if (null == e) return !1;
	    if (o && e.forEach === o) e.forEach(t, r);else if (e.length === +e.length) {
	      for (var s = 0, a = e.length; s < a; s++) {
	        if (s in e && t.call(r, e[s], s, e) === c) return !1;
	      }
	    } else for (var n in e) {
	      if (i.call(e, n) && t.call(r, e[n], n, e) === c) return !1;
	    }
	  };

	  _.extend = function (e) {
	    return u(a.call(arguments, 1), function (t) {
	      for (var r in t) {
	        void 0 !== t[r] && (e[r] = t[r]);
	      }
	    }), e;
	  }, _.extend2Lev = function (e) {
	    return u(a.call(arguments, 1), function (t) {
	      for (var r in t) {
	        void 0 !== t[r] && (_.isObject(t[r]) && _.isObject(e[r]) ? _.extend(e[r], t[r]) : e[r] = t[r]);
	      }
	    }), e;
	  }, _.coverExtend = function (e) {
	    return u(a.call(arguments, 1), function (t) {
	      for (var r in t) {
	        void 0 !== t[r] && void 0 === e[r] && (e[r] = t[r]);
	      }
	    }), e;
	  }, _.isArray = d || function (e) {
	    return "[object Array]" === n.call(e);
	  }, _.isFunction = function (e) {
	    if (!e) return !1;

	    try {
	      return /^\s*\bfunction\b/.test(e);
	    } catch (e) {
	      return !1;
	    }
	  }, _.isArguments = function (e) {
	    return !(!e || !i.call(e, "callee"));
	  }, _.toArray = function (e) {
	    return e ? e.toArray ? e.toArray() : _.isArray(e) ? a.call(e) : _.isArguments(e) ? a.call(e) : _.values(e) : [];
	  }, _.values = function (e) {
	    var t = [];
	    return null == e ? t : (u(e, function (e) {
	      t[t.length] = e;
	    }), t);
	  }, _.indexOf = function (e, t) {
	    var r = e.indexOf;
	    if (r) return r.call(e, t);

	    for (var s = 0; s < e.length; s++) {
	      if (t === e[s]) return s;
	    }

	    return -1;
	  }, _.hasAttribute = function (e, t) {
	    return e.hasAttribute ? e.hasAttribute(t) : !(!e.attributes[t] || !e.attributes[t].specified);
	  }, _.filter = function (e, t, r) {
	    var s = Object.prototype.hasOwnProperty;
	    if (e.filter) return e.filter(t);

	    for (var a = [], n = 0; n < e.length; n++) {
	      if (s.call(e, n)) {
	        var i = e[n];
	        t.call(r, i, n, e) && a.push(i);
	      }
	    }

	    return a;
	  }, _.inherit = function (e, t) {
	    return e.prototype = new t(), e.prototype.constructor = e, e.superclass = t.prototype, e;
	  }, _.trim = function (e) {
	    return e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
	  }, _.isObject = function (e) {
	    return null != e && "[object Object]" == n.call(e);
	  }, _.isEmptyObject = function (e) {
	    if (_.isObject(e)) {
	      for (var t in e) {
	        if (i.call(e, t)) return !1;
	      }

	      return !0;
	    }

	    return !1;
	  }, _.isUndefined = function (e) {
	    return void 0 === e;
	  }, _.isString = function (e) {
	    return "[object String]" == n.call(e);
	  }, _.isDate = function (e) {
	    return "[object Date]" == n.call(e);
	  }, _.isBoolean = function (e) {
	    return "[object Boolean]" == n.call(e);
	  }, _.isNumber = function (e) {
	    return "[object Number]" == n.call(e) && /[\d\.]+/.test(String(e));
	  }, _.isElement = function (e) {
	    return !(!e || 1 !== e.nodeType);
	  }, _.isJSONString = function (e) {
	    try {
	      JSON.parse(e);
	    } catch (e) {
	      return !1;
	    }

	    return !0;
	  }, _.safeJSONParse = function (e) {
	    var t = null;

	    try {
	      t = JSON.parse(e);
	    } catch (e) {
	      return !1;
	    }

	    return t;
	  }, _.decodeURIComponent = function (e) {
	    var t = e;

	    try {
	      t = decodeURIComponent(e);
	    } catch (r) {
	      t = e;
	    }

	    return t;
	  }, _.encodeDates = function (e) {
	    return _.each(e, function (t, r) {
	      _.isDate(t) ? e[r] = _.formatDate(t) : _.isObject(t) && (e[r] = _.encodeDates(t));
	    }), e;
	  }, _.mediaQueriesSupported = function () {
	    return void 0 !== window.matchMedia || void 0 !== window.msMatchMedia;
	  }, _.getScreenOrientation = function () {
	    var e = screen.msOrientation || screen.mozOrientation || (screen.orientation || {}).type,
	        t = "\u672A\u53D6\u5230\u503C";
	    if (e) t = e.indexOf("landscape") > -1 ? "landscape" : "portrait";else if (_.mediaQueriesSupported()) {
	      var r = window.matchMedia || window.msMatchMedia;
	      r("(orientation: landscape)").matches ? t = "landscape" : r("(orientation: portrait)").matches && (t = "portrait");
	    }
	    return t;
	  }, _.now = Date.now || function () {
	    return new Date().getTime();
	  }, _.throttle = function (e, t, r) {
	    var s,
	        a,
	        n,
	        i = null,
	        o = 0;
	    r || (r = {});

	    var d = function d() {
	      o = !1 === r.leading ? 0 : _.now(), i = null, n = e.apply(s, a), i || (s = a = null);
	    };

	    return function () {
	      var c = _.now();

	      o || !1 !== r.leading || (o = c);
	      var u = t - (c - o);
	      return s = this, a = arguments, u <= 0 || u > t ? (i && (clearTimeout(i), i = null), o = c, n = e.apply(s, a), i || (s = a = null)) : i || !1 === r.trailing || (i = setTimeout(d, u)), n;
	    };
	  }, _.hashCode = function (e) {
	    if ("string" != typeof e) return 0;
	    var t = 0;
	    if (0 == e.length) return t;

	    for (var r = 0; r < e.length; r++) {
	      t = (t << 5) - t + e.charCodeAt(r), t &= t;
	    }

	    return t;
	  }, _.formatDate = function (e) {
	    function t(e) {
	      return e < 10 ? "0" + e : e;
	    }

	    return e.getFullYear() + "-" + t(e.getMonth() + 1) + "-" + t(e.getDate()) + " " + t(e.getHours()) + ":" + t(e.getMinutes()) + ":" + t(e.getSeconds()) + "." + t(e.getMilliseconds());
	  }, _.searchObjDate = function (e) {
	    _.isObject(e) && _.each(e, function (t, r) {
	      _.isObject(t) ? _.searchObjDate(e[r]) : _.isDate(t) && (e[r] = _.formatDate(t));
	    });
	  }, _.searchZZAppStyle = function (e) {
	    void 0 !== e.properties.$project && (e.project = e.properties.$project, delete e.properties.$project), void 0 !== e.properties.$token && (e.token = e.properties.$token, delete e.properties.$token);
	  }, _.formatJsonString = function (e) {
	    try {
	      return JSON.stringify(e, null, "  ");
	    } catch (t) {
	      return JSON.stringify(e);
	    }
	  }, _.formatString = function (e) {
	    return e.length > sd.para.max_string_length ? (sd.log("\u5B57\u7B26\u4E32\u957F\u5EA6\u8D85\u8FC7\u9650\u5236\uFF0C\u5DF2\u7ECF\u505A\u622A\u53D6--" + e), e.slice(0, sd.para.max_string_length)) : e;
	  }, _.searchObjString = function (e) {
	    _.isObject(e) && _.each(e, function (t, r) {
	      _.isObject(t) ? _.searchObjString(e[r]) : _.isString(t) && (e[r] = _.formatString(t));
	    });
	  }, _.parseSuperProperties = function (e) {
	    _.isObject(e) && (_.each(e, function (t, r) {
	      if (_.isFunction(t)) try {
	        e[r] = t(), _.isFunction(e[r]) && (sd.log("\u60A8\u7684\u5C5E\u6027- " + r + " \u683C\u5F0F\u4E0D\u6EE1\u8DB3\u8981\u6C42\uFF0C\u6211\u4EEC\u5DF2\u7ECF\u5C06\u5176\u5220\u9664"), delete e[r]);
	      } catch (t) {
	        delete e[r], sd.log("\u60A8\u7684\u5C5E\u6027- " + r + " \u629B\u51FA\u4E86\u5F02\u5E38\uFF0C\u6211\u4EEC\u5DF2\u7ECF\u5C06\u5176\u5220\u9664");
	      }
	    }), _.strip_sa_properties(e));
	  }, _.filterReservedProperties = function (e) {
	    _.isObject(e) && _.each(["distinct_id", "user_id", "id", "date", "datetime", "event", "events", "first_id", "original_id", "device_id", "properties", "second_id", "time", "users"], function (t, r) {
	      t in e && (r < 3 ? (delete e[t], sd.log("\u60A8\u7684\u5C5E\u6027- " + t + "\u662F\u4FDD\u7559\u5B57\u6BB5\uFF0C\u6211\u4EEC\u5DF2\u7ECF\u5C06\u5176\u5220\u9664")) : sd.log("\u60A8\u7684\u5C5E\u6027- " + t + "\u662F\u4FDD\u7559\u5B57\u6BB5\uFF0C\u8BF7\u907F\u514D\u5176\u4F5C\u4E3A\u5C5E\u6027\u540D"));
	    });
	  }, _.searchConfigData = function (e) {
	    if ("object" == _typeof_1(e) && e.$option) {
	      var t = e.$option;
	      return delete e.$option, t;
	    }

	    return {};
	  }, _.unique = function (e) {
	    for (var t, r = [], s = {}, a = 0; a < e.length; a++) {
	      (t = e[a]) in s || (s[t] = !0, r.push(t));
	    }

	    return r;
	  }, _.strip_sa_properties = function (e) {
	    return _.isObject(e) ? (_.each(e, function (t, r) {
	      if (_.isArray(t)) {
	        var s = [];
	        _.each(t, function (e) {
	          _.isString(e) ? s.push(e) : sd.log("\u60A8\u7684\u6570\u636E-", r, t, "\u7684\u6570\u7EC4\u91CC\u7684\u503C\u5FC5\u987B\u662F\u5B57\u7B26\u4E32,\u5DF2\u7ECF\u5C06\u5176\u5220\u9664");
	        }), 0 !== s.length ? e[r] = s : (delete e[r], sd.log("\u5DF2\u7ECF\u5220\u9664\u7A7A\u7684\u6570\u7EC4"));
	      }

	      _.isString(t) || _.isNumber(t) || _.isDate(t) || _.isBoolean(t) || _.isArray(t) || _.isFunction(t) || "$option" === r || (sd.log("\u60A8\u7684\u6570\u636E-", r, t, "-\u683C\u5F0F\u4E0D\u6EE1\u8DB3\u8981\u6C42\uFF0C\u6211\u4EEC\u5DF2\u7ECF\u5C06\u5176\u5220\u9664"), delete e[r]);
	    }), e) : e;
	  }, _.strip_empty_properties = function (e) {
	    var t = {};
	    return _.each(e, function (e, r) {
	      null != e && (t[r] = e);
	    }), t;
	  }, _.utf8Encode = function (e) {
	    var t,
	        r,
	        s,
	        a,
	        n = "";

	    for (t = r = 0, s = (e = (e + "").replace(/\r\n/g, "\n").replace(/\r/g, "\n")).length, a = 0; a < s; a++) {
	      var i = e.charCodeAt(a),
	          o = null;
	      i < 128 ? r++ : o = i > 127 && i < 2048 ? String.fromCharCode(i >> 6 | 192, 63 & i | 128) : String.fromCharCode(i >> 12 | 224, i >> 6 & 63 | 128, 63 & i | 128), null !== o && (r > t && (n += e.substring(t, r)), n += o, t = r = a + 1);
	    }

	    return r > t && (n += e.substring(t, e.length)), n;
	  }, _.base64Encode = function (e) {
	    if ("function" == typeof btoa) return btoa(encodeURIComponent(e).replace(/%([0-9A-F]{2})/g, function (e, t) {
	      return String.fromCharCode("0x" + t);
	    }));
	    var t,
	        r,
	        s,
	        a,
	        n,
	        i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
	        o = 0,
	        d = 0,
	        c = "",
	        u = [];
	    if (!(e = String(e))) return e;
	    e = _.utf8Encode(e);

	    do {
	      t = (n = e.charCodeAt(o++) << 16 | e.charCodeAt(o++) << 8 | e.charCodeAt(o++)) >> 18 & 63, r = n >> 12 & 63, s = n >> 6 & 63, a = 63 & n, u[d++] = i.charAt(t) + i.charAt(r) + i.charAt(s) + i.charAt(a);
	    } while (o < e.length);

	    switch (c = u.join(""), e.length % 3) {
	      case 1:
	        c = c.slice(0, -2) + "==";
	        break;

	      case 2:
	        c = c.slice(0, -1) + "=";
	    }

	    return c;
	  }, _.UUID = (e = function e() {
	    for (var e = 1 * new Date(), t = 0; e == 1 * new Date();) {
	      t++;
	    }

	    return e.toString(16) + t.toString(16);
	  }, function () {
	    var t = String(screen.height * screen.width);
	    t = t && /\d{5,}/.test(t) ? t.toString(16) : String(31242 * Math.random()).replace(".", "").slice(0, 8);

	    var r = e() + "-" + Math.random().toString(16).replace(".", "") + "-" + function (e) {
	      var t,
	          r,
	          s = navigator.userAgent,
	          a = [],
	          n = 0;

	      function i(e, t) {
	        var r,
	            s = 0;

	        for (r = 0; r < t.length; r++) {
	          s |= a[r] << 8 * r;
	        }

	        return e ^ s;
	      }

	      for (t = 0; t < s.length; t++) {
	        r = s.charCodeAt(t), a.unshift(255 & r), a.length >= 4 && (n = i(n, a), a = []);
	      }

	      return a.length > 0 && (n = i(n, a)), n.toString(16);
	    }() + "-" + t + "-" + e();

	    return r || (String(Math.random()) + String(Math.random()) + String(Math.random())).slice(2, 15);
	  }), _.getQueryParam = function (e, t) {
	    t = t.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]"), e = _.decodeURIComponent(e);
	    var r = new RegExp("[\\?&]" + t + "=([^&#]*)").exec(e);
	    return null === r || r && "string" != typeof r[1] && r[1].length ? "" : _.decodeURIComponent(r[1]);
	  }, _.urlParse = function (e) {
	    var t = function t(e) {
	      this._fields = {
	        Username: 4,
	        Password: 5,
	        Port: 7,
	        Protocol: 2,
	        Host: 6,
	        Path: 8,
	        URL: 0,
	        QueryString: 9,
	        Fragment: 10
	      }, this._values = {}, this._regex = null, this._regex = /^((\w+):\/\/)?((\w+):?(\w+)?@)?([^\/\?:]+):?(\d+)?(\/?[^\?#]+)?\??([^#]+)?#?(\w*)/, void 0 !== e && this._parse(e);
	    };

	    return t.prototype.setUrl = function (e) {
	      this._parse(e);
	    }, t.prototype._initValues = function () {
	      for (var e in this._fields) {
	        this._values[e] = "";
	      }
	    }, t.prototype.addQueryString = function (e) {
	      if ("object" != _typeof_1(e)) return !1;
	      var t = this._values.QueryString || "";

	      for (var r in e) {
	        t = new RegExp(r + "[^&]+").test(t) ? t.replace(new RegExp(r + "[^&]+"), r + "=" + e[r]) : "&" === t.slice(-1) ? t + r + "=" + e[r] : "" === t ? r + "=" + e[r] : t + "&" + r + "=" + e[r];
	      }

	      this._values.QueryString = t;
	    }, t.prototype.getUrl = function () {
	      var e = "";
	      return e += this._values.Origin, e += this._values.Port ? ":" + this._values.Port : "", e += this._values.Path, e += this._values.QueryString ? "?" + this._values.QueryString : "", e += this._values.Fragment ? "#" + this._values.Fragment : "";
	    }, t.prototype.getUrl = function () {
	      var e = "";
	      return e += this._values.Origin, e += this._values.Port ? ":" + this._values.Port : "", e += this._values.Path, e += this._values.QueryString ? "?" + this._values.QueryString : "";
	    }, t.prototype._parse = function (e) {
	      this._initValues();

	      var t = this._regex.exec(e);

	      if (!t) throw "DPURLParser::_parse -> Invalid URL";

	      for (var r in this._fields) {
	        void 0 !== t[this._fields[r]] && (this._values[r] = t[this._fields[r]]);
	      }

	      this._values.Hostname = this._values.Host.replace(/:\d+$/, ""), this._values.Origin = this._values.Protocol + "://" + this._values.Hostname;
	    }, new t(e);
	  }, _.addEvent = function () {
	    function e(t) {
	      return t && (t.preventDefault = e.preventDefault, t.stopPropagation = e.stopPropagation, t._getPath = e._getPath), t;
	    }

	    e._getPath = function () {
	      var e = this;
	      return this.path || this.composedPath && this.composedPath() || function () {
	        try {
	          var t = e.target,
	              r = [t];
	          if (null === t || null === t.parentElement) return [];

	          for (; null !== t.parentElement;) {
	            t = t.parentElement, r.unshift(t);
	          }

	          return r;
	        } catch (e) {
	          return [];
	        }
	      }();
	    }, e.preventDefault = function () {
	      this.returnValue = !1;
	    }, e.stopPropagation = function () {
	      this.cancelBubble = !0;
	    };
	    (function (t, r, s) {
	      var a = !(!_.isObject(sd.para.heatmap) || !sd.para.heatmap.useCapture);
	      if (_.isObject(sd.para.heatmap) && void 0 === sd.para.heatmap.useCapture && "click" === r && (a = !0), t && t.addEventListener) t.addEventListener(r, function (t) {
	        t._getPath = e._getPath, s.call(this, t);
	      }, a);else {
	        var n = "on" + r,
	            i = t[n];

	        t[n] = function (t, r, s) {
	          return function (a) {
	            if (a = a || e(window.event)) {
	              a.target = a.srcElement;
	              var n,
	                  i,
	                  o = !0;
	              return "function" == typeof s && (n = s(a)), i = r.call(t, a), !1 !== n && !1 !== i || (o = !1), o;
	            }
	          };
	        }(t, s, i);
	      }
	    }).apply(null, arguments);
	  }, _.addHashEvent = function (e) {
	    var t = "pushState" in window.history ? "popstate" : "hashchange";

	    _.addEvent(window, t, e);
	  }, _.addSinglePageEvent = function (e) {
	    var t = location.href,
	        r = window.history.pushState,
	        s = window.history.replaceState;
	    window.history.pushState = function () {
	      r.apply(window.history, arguments), e(t), t = location.href;
	    }, window.history.replaceState = function () {
	      s.apply(window.history, arguments), e(t), t = location.href;
	    };
	    var a = r ? "popstate" : "hashchange";

	    _.addEvent(window, a, function () {
	      e(t), t = location.href;
	    });
	  }, _.cookie = {
	    get: function get(e) {
	      for (var t = e + "=", r = document.cookie.split(";"), s = 0; s < r.length; s++) {
	        for (var a = r[s]; " " == a.charAt(0);) {
	          a = a.substring(1, a.length);
	        }

	        if (0 == a.indexOf(t)) return _.decodeURIComponent(a.substring(t.length, a.length));
	      }

	      return null;
	    },
	    set: function set(e, t, r, s, a) {
	      var n = "",
	          i = "",
	          o = "";

	      if (r = null == r ? 73e3 : r, s = void 0 === s ? sd.para.cross_subdomain : s) {
	        var d = _.getCurrentDomain(location.href);

	        "url\u89E3\u6790\u5931\u8D25" === d && (d = ""), n = d ? "; domain=" + d : "";
	      }

	      if (0 !== r) {
	        var c = new Date();
	        "s" === String(r).slice(-1) ? c.setTime(c.getTime() + 1e3 * Number(String(r).slice(0, -1))) : c.setTime(c.getTime() + 24 * r * 60 * 60 * 1e3), i = "; expires=" + c.toGMTString();
	      }

	      a && (o = "; secure"), document.cookie = e + "=" + encodeURIComponent(t) + i + "; path=/" + n + o;
	    },
	    remove: function remove(e, t) {
	      t = void 0 === t ? sd.para.cross_subdomain : t, _.cookie.set(e, "", -1, t);
	    },
	    getCookieName: function getCookieName(e, t) {
	      var r = "";

	      if (t = t || location.href, !1 === sd.para.cross_subdomain) {
	        try {
	          r = _.URL(t).hostname;
	        } catch (e) {
	          sd.log(e);
	        }

	        r = "string" == typeof r && "" !== r ? "sajssdk_2015_" + e + "_" + r.replace(/\./g, "_") : "sajssdk_2015_root_" + e;
	      } else r = "sajssdk_2015_cross_" + e;

	      return r;
	    },
	    getNewUser: function getNewUser() {
	      return null !== this.get("sensorsdata_is_new_user") || null !== this.get(this.getCookieName("new_user"));
	    }
	  }, _.getElementContent = function (e, t) {
	    var r = "",
	        s = "";
	    return e.textContent ? r = _.trim(e.textContent) : e.innerText && (r = _.trim(e.innerText)), r && (r = r.replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255)), s = r || "", "input" !== t && "INPUT" !== t || ("button" === e.type || "submit" === e.type ? s = e.value || "" : sd.para.heatmap && "function" == typeof sd.para.heatmap.collect_input && sd.para.heatmap.collect_input(e) && (s = e.value || "")), s;
	  }, _.getEleInfo = function (e) {
	    if (!e.target) return !1;
	    var t = e.target,
	        r = t.tagName.toLowerCase(),
	        s = {};
	    return s.$element_type = r, s.$element_name = t.getAttribute("name"), s.$element_id = t.getAttribute("id"), s.$element_class_name = "string" == typeof t.className ? t.className : null, s.$element_target_url = t.getAttribute("href"), s.$element_content = _.getElementContent(t, r), (s = _.strip_empty_properties(s)).$url = location.href, s.$url_path = location.pathname, s.$title = document.title, s.$viewport_width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth || 0, s;
	  }, _.localStorage = {
	    get: function get(e) {
	      return window.localStorage.getItem(e);
	    },
	    parse: function parse(e) {
	      var t;

	      try {
	        t = JSON.parse(_.localStorage.get(e)) || null;
	      } catch (e) {
	        sd.log(e);
	      }

	      return t;
	    },
	    set: function set(e, t) {
	      window.localStorage.setItem(e, t);
	    },
	    remove: function remove(e) {
	      window.localStorage.removeItem(e);
	    },
	    isSupport: function isSupport() {
	      var e = !0;

	      try {
	        var t = "__sensorsdatasupport__",
	            r = "testIsSupportStorage";
	        _.localStorage.set(t, r), _.localStorage.get(t) !== r && (e = !1), _.localStorage.remove(t);
	      } catch (t) {
	        e = !1;
	      }

	      return e;
	    }
	  }, _.sessionStorage = {
	    isSupport: function isSupport() {
	      var e = !0,
	          t = "__sensorsdatasupport__",
	          r = "testIsSupportStorage";

	      try {
	        sessionStorage && sessionStorage.setItem ? (sessionStorage.setItem(t, r), sessionStorage.removeItem(t, r), e = !0) : e = !1;
	      } catch (t) {
	        e = !1;
	      }

	      return e;
	    }
	  }, _.isSupportCors = function () {
	    return void 0 !== window.XMLHttpRequest && ("withCredentials" in new XMLHttpRequest() || "undefined" != typeof XDomainRequest);
	  }, _.xhr = function (e) {
	    if (e) return void 0 !== window.XMLHttpRequest && "withCredentials" in new XMLHttpRequest() ? new XMLHttpRequest() : "undefined" != typeof XDomainRequest ? new XDomainRequest() : null;
	    if (void 0 !== window.XMLHttpRequest) return new XMLHttpRequest();
	    if (window.ActiveXObject) try {
	      return new ActiveXObject("Msxml2.XMLHTTP");
	    } catch (e) {
	      try {
	        return new ActiveXObject("Microsoft.XMLHTTP");
	      } catch (e) {
	        sd.log(e);
	      }
	    }
	  }, _.ajax = function (e) {
	    function t(e) {
	      if (!e) return "";

	      try {
	        return JSON.parse(e);
	      } catch (e) {
	        return {};
	      }
	    }

	    e.timeout = e.timeout || 2e4, e.credentials = void 0 === e.credentials || e.credentials;

	    var r = _.xhr(e.cors);

	    if (!r) return !1;
	    e.type || (e.type = e.data ? "POST" : "GET"), e = _.extend({
	      success: function success() {},
	      error: function error() {}
	    }, e);

	    try {
	      "object" == _typeof_1(r) && "timeout" in r ? r.timeout = e.timeout : setTimeout(function () {
	        r.abort();
	      }, e.timeout + 500);
	    } catch (t) {
	      try {
	        setTimeout(function () {
	          r.abort();
	        }, e.timeout + 500);
	      } catch (e) {
	        sd.log(e);
	      }
	    }

	    r.onreadystatechange = function () {
	      try {
	        4 == r.readyState && (r.status >= 200 && r.status < 300 || 304 == r.status ? e.success(t(r.responseText)) : e.error(t(r.responseText), r.status), r.onreadystatechange = null, r.onload = null);
	      } catch (e) {
	        r.onreadystatechange = null, r.onload = null;
	      }
	    }, r.open(e.type, e.url, !0);

	    try {
	      if (e.credentials && (r.withCredentials = !0), _.isObject(e.header)) for (var s in e.header) {
	        r.setRequestHeader(s, e.header[s]);
	      }
	      e.data && (e.cors || r.setRequestHeader("X-Requested-With", "XMLHttpRequest"), "application/json" === e.contentType ? r.setRequestHeader("Content-type", "application/json; charset=UTF-8") : r.setRequestHeader("Content-type", "application/x-www-form-urlencoded"));
	    } catch (e) {
	      sd.log(e);
	    }

	    r.send(e.data || null);
	  }, _.loadScript = function (e) {
	    e = _.extend({
	      success: function success() {},
	      error: function error() {},
	      appendCall: function appendCall(e) {
	        document.getElementsByTagName("head")[0].appendChild(e);
	      }
	    }, e);
	    var t = null;
	    "css" === e.type && ((t = document.createElement("link")).rel = "stylesheet", t.href = e.url), "js" === e.type && ((t = document.createElement("script")).async = "async", t.setAttribute("charset", "UTF-8"), t.src = e.url, t.type = "text/javascript"), t.onload = t.onreadystatechange = function () {
	      this.readyState && "loaded" !== this.readyState && "complete" !== this.readyState || (e.success(), t.onload = t.onreadystatechange = null);
	    }, t.onerror = function () {
	      e.error(), t.onerror = null;
	    }, e.appendCall(t);
	  }, _.getHostname = function (e, t) {
	    t && "string" == typeof t || (t = "hostname\u89E3\u6790\u5F02\u5E38");
	    var r = null;

	    try {
	      r = _.URL(e).hostname;
	    } catch (e) {
	      sd.log(e);
	    }

	    return r || t;
	  }, _.getQueryParamsFromUrl = function (e) {
	    var t = {},
	        r = e.split("?")[1] || "";
	    return r && (t = _.getURLSearchParams("?" + r)), t;
	  }, _.getURLSearchParams = function (e) {
	    for (var t = function t(e) {
	      return decodeURIComponent(e);
	    }, r = {}, s = (e = e || "").substring(1).split("&"), a = 0; a < s.length; a++) {
	      var n = s[a].indexOf("=");

	      if (-1 !== n) {
	        var i = s[a].substring(0, n),
	            o = s[a].substring(n + 1);
	        i = t(i), o = t(o), r[i] = o;
	      }
	    }

	    return r;
	  }, _.URL = function (e) {
	    var t,
	        r = {},
	        s = ["hash", "host", "hostname", "href", "origin", "password", "pathname", "port", "protocol", "search", "username"];
	    if ("function" == typeof window.URL && function () {
	      try {
	        return "http://modernizr.com/" === new URL("http://modernizr.com/").href;
	      } catch (e) {
	        return !1;
	      }
	    }()) (r = new URL(e)).searchParams || (r.searchParams = (t = _.getURLSearchParams(r.search), {
	      get: function get(e) {
	        return t[e];
	      }
	    }));else {
	      if (!1 === /^https?:\/\/.+/.test(e)) throw "Invalid URL";
	      var a = document.createElement("a");
	      a.href = e;

	      for (var n = s.length - 1; n >= 0; n--) {
	        var i = s[n];
	        r[i] = a[i];
	      }

	      r.hostname && "string" == typeof r.pathname && 0 !== r.pathname.indexOf("/") && (r.pathname = "/" + r.pathname), r.searchParams = function () {
	        var e = _.getURLSearchParams(r.search);

	        return {
	          get: function get(t) {
	            return e[t];
	          }
	        };
	      }();
	    }
	    return r;
	  }, _.getCurrentDomain = function (e) {
	    var t = sd.para.current_domain;

	    switch (_typeof_1(t)) {
	      case "function":
	        var r = t();
	        return "" === r || "" === _.trim(r) ? "url\u89E3\u6790\u5931\u8D25" : -1 !== r.indexOf(".") ? r : "url\u89E3\u6790\u5931\u8D25";

	      case "string":
	        return "" === t || "" === _.trim(t) ? "url\u89E3\u6790\u5931\u8D25" : -1 !== t.indexOf(".") ? t : "url\u89E3\u6790\u5931\u8D25";

	      default:
	        var s = _.getCookieTopLevelDomain();

	        return "" === e ? "url\u89E3\u6790\u5931\u8D25" : "" === s ? "url\u89E3\u6790\u5931\u8D25" : s;
	    }
	  }, _.getCookieTopLevelDomain = function (e) {
	    var t = (e = e || window.location.hostname).split(".");
	    if (_.isArray(t) && t.length >= 2 && !/^(\d+\.)+\d+$/.test(e)) for (var r = "." + t.splice(t.length - 1, 1); t.length > 0;) {
	      if (r = "." + t.splice(t.length - 1, 1) + r, document.cookie = "sensorsdata_domain_test=true; path=/; domain=" + r, -1 !== document.cookie.indexOf("sensorsdata_domain_test=true")) {
	        var s = new Date();
	        return s.setTime(s.getTime() - 1e3), document.cookie = "sensorsdata_domain_test=true; expires=" + s.toGMTString() + "; path=/; domain=" + r, r;
	      }
	    }
	    return "";
	  }, _.isReferralTraffic = function (e) {
	    return "" === (e = e || document.referrer) || _.getCookieTopLevelDomain(_.getHostname(e)) !== _.getCookieTopLevelDomain();
	  }, _.ry = function (e) {
	    return new _.ry.init(e);
	  }, _.ry.init = function (e) {
	    this.ele = e;
	  }, _.ry.init.prototype = {
	    addClass: function addClass(e) {
	      return -1 === (" " + this.ele.className + " ").indexOf(" " + e + " ") && (this.ele.className = this.ele.className + ("" === this.ele.className ? "" : " ") + e), this;
	    },
	    removeClass: function removeClass(e) {
	      var t = " " + this.ele.className + " ";
	      return -1 !== t.indexOf(" " + e + " ") && (this.ele.className = t.replace(" " + e + " ", " ").slice(1, -1)), this;
	    },
	    hasClass: function hasClass(e) {
	      return -1 !== (" " + this.ele.className + " ").indexOf(" " + e + " ");
	    },
	    attr: function attr(e, t) {
	      return "string" == typeof e && _.isUndefined(t) ? this.ele.getAttribute(e) : ("string" == typeof e && (t = String(t), this.ele.setAttribute(e, t)), this);
	    },
	    offset: function offset() {
	      var e = this.ele.getBoundingClientRect();

	      if (e.width || e.height) {
	        var t = this.ele.ownerDocument.documentElement;
	        return {
	          top: e.top + window.pageYOffset - t.clientTop,
	          left: e.left + window.pageXOffset - t.clientLeft
	        };
	      }

	      return {
	        top: 0,
	        left: 0
	      };
	    },
	    getSize: function getSize() {
	      if (!window.getComputedStyle) return {
	        width: this.ele.offsetWidth,
	        height: this.ele.offsetHeight
	      };

	      try {
	        var e = this.ele.getBoundingClientRect();
	        return {
	          width: e.width,
	          height: e.height
	        };
	      } catch (e) {
	        return {
	          width: 0,
	          height: 0
	        };
	      }
	    },
	    getStyle: function getStyle(e) {
	      return this.ele.currentStyle ? this.ele.currentStyle[e] : this.ele.ownerDocument.defaultView.getComputedStyle(this.ele, null).getPropertyValue(e);
	    },
	    wrap: function wrap(e) {
	      var t = document.createElement(e);
	      return this.ele.parentNode.insertBefore(t, this.ele), t.appendChild(this.ele), _.ry(t);
	    },
	    getCssStyle: function getCssStyle(e) {
	      var t = this.ele.style.getPropertyValue(e);
	      if (t) return t;
	      var r = null;
	      if ("function" == typeof window.getMatchedCSSRules && (r = getMatchedCSSRules(this.ele)), !r || !_.isArray(r)) return null;

	      for (var s = r.length - 1; s >= 0; s--) {
	        if (t = r[s].style.getPropertyValue(e)) return t;
	      }
	    },
	    sibling: function sibling(e, t) {
	      for (; (e = e[t]) && 1 !== e.nodeType;) {
	      }

	      return e;
	    },
	    next: function next() {
	      return this.sibling(this.ele, "nextSibling");
	    },
	    prev: function prev(e) {
	      return this.sibling(this.ele, "previousSibling");
	    },
	    siblings: function siblings(e) {
	      return this.siblings((this.ele.parentNode || {}).firstChild, this.ele);
	    },
	    children: function children(e) {
	      return this.siblings(this.ele.firstChild);
	    },
	    parent: function parent() {
	      var e = this.ele.parentNode;
	      return e = e && 11 !== e.nodeType ? e : null, _.ry(e);
	    }
	  }, _.strToUnicode = function (e) {
	    if ("string" != typeof e) return sd.log("\u8F6C\u6362unicode\u9519\u8BEF", e), e;

	    for (var t = "", r = 0; r < e.length; r++) {
	      t += "\\" + e.charCodeAt(r).toString(16);
	    }

	    return t;
	  }, _.getReferrer = function (e) {
	    return "string" != typeof (e = e || document.referrer) ? "\u53D6\u503C\u5F02\u5E38_referrer\u5F02\u5E38_" + String(e) : (0 === e.indexOf("https://www.baidu.com/") && (e = e.split("?")[0]), "string" == typeof (e = e.slice(0, sd.para.max_referrer_string_length)) ? e : "");
	  }, _.getKeywordFromReferrer = function (e) {
	    e = e || document.referrer;
	    var t = sd.para.source_type.keyword;

	    if (document && "string" == typeof e) {
	      if (0 === e.indexOf("http")) {
	        var r = _.getReferSearchEngine(e),
	            s = _.getQueryParamsFromUrl(e);

	        if (_.isEmptyObject(s)) return "\u672A\u53D6\u5230\u503C";
	        var a = null;

	        for (var n in t) {
	          if (r === n && "object" == _typeof_1(s)) if (a = t[n], _.isArray(a)) for (n = 0; n < a.length; n++) {
	            var i = s[a[n]];
	            if (i) return i;
	          } else if (s[a]) return s[a];
	        }

	        return "\u672A\u53D6\u5230\u503C";
	      }

	      return "" === e ? "\u672A\u53D6\u5230\u503C_\u76F4\u63A5\u6253\u5F00" : "\u672A\u53D6\u5230\u503C_\u975Ehttp\u7684url";
	    }

	    return "\u53D6\u503C\u5F02\u5E38_referrer\u5F02\u5E38_" + String(e);
	  }, _.getReferSearchEngine = function (e) {
	    var t = _.getHostname(e);

	    if (!t || "hostname\u89E3\u6790\u5F02\u5E38" === t) return "";
	    sd.para.source_type.keyword;
	    var r = {
	      baidu: [/^.*\.baidu\.com$/],
	      bing: [/^.*\.bing\.com$/],
	      google: [/^www\.google\.com$/, /^www\.google\.com\.[a-z]{2}$/, /^www\.google\.[a-z]{2}$/],
	      sm: [/^m\.sm\.cn$/],
	      so: [/^.+\.so\.com$/],
	      sogou: [/^.*\.sogou\.com$/],
	      yahoo: [/^.*\.yahoo\.com$/]
	    };

	    for (var s in r) {
	      for (var a = r[s], n = 0, i = a.length; n < i; n++) {
	        if (a[n].test(t)) return s;
	      }
	    }

	    return "\u672A\u77E5\u641C\u7D22\u5F15\u64CE";
	  }, _.getSourceFromReferrer = function () {
	    function e(e, t) {
	      for (var r = 0; r < e.length; r++) {
	        if (-1 !== t.split("?")[0].indexOf(e[r])) return !0;
	      }
	    }

	    var t = "(" + sd.para.source_type.utm.join("|") + ")\\=[^&]+",
	        r = sd.para.source_type.search,
	        s = sd.para.source_type.social,
	        a = document.referrer || "",
	        n = _.info.pageProp.url;

	    if (n) {
	      var i = n.match(new RegExp(t));
	      return i && i[0] ? "\u4ED8\u8D39\u5E7F\u544A\u6D41\u91CF" : e(r, a) ? "\u81EA\u7136\u641C\u7D22\u6D41\u91CF" : e(s, a) ? "\u793E\u4EA4\u7F51\u7AD9\u6D41\u91CF" : "" === a ? "\u76F4\u63A5\u6D41\u91CF" : "\u5F15\u8350\u6D41\u91CF";
	    }

	    return "\u83B7\u53D6url\u5F02\u5E38";
	  }, _.info = {
	    initPage: function initPage() {
	      var e = _.getReferrer(),
	          t = location.href,
	          r = _.getCurrentDomain(t);

	      r || sd.debug.jssdkDebug("url_domain\u5F02\u5E38_" + t + "_" + r), this.pageProp = {
	        referrer: e,
	        referrer_host: e ? _.getHostname(e) : "",
	        url: t,
	        url_host: _.getHostname(t, "url_host\u53D6\u503C\u5F02\u5E38"),
	        url_domain: r
	      };
	    },
	    pageProp: {},
	    campaignParams: function campaignParams() {
	      var e = sd.source_channel_standard.split(" "),
	          t = "",
	          r = {};
	      return _.isArray(sd.para.source_channel) && sd.para.source_channel.length > 0 && (e = e.concat(sd.para.source_channel), e = _.unique(e)), _.each(e, function (e) {
	        (t = _.getQueryParam(location.href, e)).length && (r[e] = t);
	      }), r;
	    },
	    campaignParamsStandard: function campaignParamsStandard(e, t) {
	      e = e || "", t = t || "";

	      var r = _.info.campaignParams(),
	          s = {},
	          a = {};

	      for (var n in r) {
	        -1 !== (" " + sd.source_channel_standard + " ").indexOf(" " + n + " ") ? s[e + n] = r[n] : a[t + n] = r[n];
	      }

	      return {
	        $utms: s,
	        otherUtms: a
	      };
	    },
	    properties: function properties() {
	      return {
	        $timezone_offset: new Date().getTimezoneOffset(),
	        $screen_height: Number(screen.height) || 0,
	        $screen_width: Number(screen.width) || 0,
	        $lib: "js",
	        $lib_version: String(sd.lib_version)
	      };
	    },
	    currentProps: {},
	    register: function register(e) {
	      _.extend(_.info.currentProps, e);
	    }
	  }, _.autoExeQueue = function () {
	    return {
	      items: [],
	      enqueue: function enqueue(e) {
	        this.items.push(e), this.start();
	      },
	      dequeue: function dequeue() {
	        return this.items.shift();
	      },
	      getCurrentItem: function getCurrentItem() {
	        return this.items[0];
	      },
	      isRun: !1,
	      start: function start() {
	        this.items.length > 0 && !this.isRun && (this.isRun = !0, this.getCurrentItem().start());
	      },
	      close: function close() {
	        this.dequeue(), this.isRun = !1, this.start();
	      }
	    };
	  }, _.trackLink = function (e, t, r) {
	    var s = null;
	    if ((e = e || {}).ele && (s = e.ele), e.event && (s = e.target ? e.target : e.event.target), r = r || {}, !s || "object" != _typeof_1(s)) return !1;
	    if (!s.href || /^javascript/.test(s.href) || s.target || s.download || s.onclick) return sd.track(t, r), !1;

	    function a(e) {
	      e.stopPropagation(), e.preventDefault();
	      var a = !1;

	      function n() {
	        a || (a = !0, location.href = s.href);
	      }

	      setTimeout(n, 1e3), sd.track(t, r, n);
	    }

	    e.event && a(e.event), e.ele && _.addEvent(e.ele, "click", function (e) {
	      a(e);
	    });
	  }, _.eventEmitter = function () {
	    this._events = [], this.pendingEvents = [];
	  }, _.eventEmitter.prototype = {
	    emit: function emit(e) {
	      var t = [].slice.call(arguments, 1);

	      _.each(this._events, function (r) {
	        r.type === e && r.callback.apply(r.context, t);
	      });
	    },
	    on: function on(e, t, r) {
	      "function" == typeof t && this._events.push({
	        type: e,
	        callback: t,
	        context: r || this
	      });
	    },
	    tempAdd: function tempAdd(e, t) {
	      t && e && (this.pendingEvents.push({
	        type: e,
	        data: t
	      }), this.pendingEvents.length > 20 && this.pendingEvents.shift());
	    },
	    isReady: function isReady() {
	      var e = this;
	      this.tempAdd = this.emit, 0 !== this.pendingEvents.length && (_.each(this.pendingEvents, function (t) {
	        e.emit(t.type, t.data);
	      }), this.pendingEvents = []);
	    }
	  }, _.rot13obfs = function (e, t) {
	    t = "number" == typeof t ? t : 13;

	    for (var r = (e = String(e)).split(""), s = 0, a = r.length; s < a; s++) {
	      r[s].charCodeAt(0) < 126 && (r[s] = String.fromCharCode((r[s].charCodeAt(0) + t) % 126));
	    }

	    return r.join("");
	  }, _.rot13defs = function (e) {
	    e = String(e);
	    return _.rot13obfs(e, 113);
	  };
	}(), sd.para_default = {
	  preset_properties: {
	    latest_utm: !0,
	    latest_traffic_source_type: !0,
	    latest_search_keyword: !0,
	    latest_referrer: !0,
	    latest_referrer_host: !1,
	    latest_landing_page: !1,
	    url: !1,
	    title: !1
	  },
	  img_use_crossorigin: !1,
	  name: "sa",
	  max_referrer_string_length: 200,
	  max_string_length: 500,
	  cross_subdomain: !0,
	  show_log: !0,
	  is_debug: !1,
	  debug_mode: !1,
	  debug_mode_upload: !1,
	  session_time: 0,
	  use_client_time: !1,
	  source_channel: [],
	  send_type: "image",
	  vtrack_ignore: {},
	  auto_init: !0,
	  is_track_single_page: !1,
	  is_single_page: !1,
	  batch_send: !1,
	  source_type: {},
	  callback_timeout: 200,
	  datasend_timeout: 3e3,
	  queue_timeout: 300,
	  is_track_device_id: !1,
	  ignore_oom: !0,
	  app_js_bridge: !1
	}, sd.addReferrerHost = function (e) {
	  _.isObject(e.properties) && (e.properties.$first_referrer && (e.properties.$first_referrer_host = _.getHostname(e.properties.$first_referrer, "\u53D6\u503C\u5F02\u5E38")), "track" !== e.type && "track_signup" !== e.type || ("$referrer" in e.properties && (e.properties.$referrer_host = "" === e.properties.$referrer ? "" : _.getHostname(e.properties.$referrer, "\u53D6\u503C\u5F02\u5E38")), sd.para.preset_properties.latest_referrer && sd.para.preset_properties.latest_referrer_host && (e.properties.$latest_referrer_host = "" === e.properties.$latest_referrer ? "" : _.getHostname(e.properties.$latest_referrer, "\u53D6\u503C\u5F02\u5E38"))));
	}, sd.addPropsHook = function (e) {
	  sd.para.preset_properties && sd.para.preset_properties.url && ("track" === e.type || "track_signup" === e.type) && void 0 === e.properties.$url && (e.properties.$url = window.location.href), sd.para.preset_properties && sd.para.preset_properties.title && ("track" === e.type || "track_signup" === e.type) && void 0 === e.properties.$title && (e.properties.$title = document.title);
	}, sd.initPara = function (e) {
	  sd.para = e || sd.para || {};
	  var t,
	      r = {};
	  if (_.isObject(sd.para.is_track_latest)) for (var s in sd.para.is_track_latest) {
	    r["latest_" + s] = sd.para.is_track_latest[s];
	  }

	  for (t in sd.para.preset_properties = _.extend({}, sd.para_default.preset_properties, r, sd.para.preset_properties || {}), sd.para_default) {
	    void 0 === sd.para[t] && (sd.para[t] = sd.para_default[t]);
	  }

	  "string" == typeof sd.para.server_url && "://" === sd.para.server_url.slice(0, 3) && (sd.para.server_url = location.protocol.slice(-1) + sd.para.server_url), "string" == typeof sd.para.web_url && "://" === sd.para.web_url.slice(0, 3) && (sd.para.web_url = location.protocol.slice(-1) + sd.para.web_url), "image" !== sd.para.send_type && "ajax" !== sd.para.send_type && "beacon" !== sd.para.send_type && (sd.para.send_type = "image"), sd.bridge.initPara(), sd.bridge.initState();
	  var a = {
	    datasend_timeout: 6e3,
	    send_interval: 6e3,
	    one_send_max_length: 6
	  };
	  _.localStorage.isSupport() && _.isSupportCors() && "object" == (typeof localStorage === "undefined" ? "undefined" : _typeof_1(localStorage)) ? !0 === sd.para.batch_send ? (sd.para.batch_send = _.extend({}, a), sd.para.use_client_time = !0) : "object" == _typeof_1(sd.para.batch_send) && (sd.para.use_client_time = !0, sd.para.batch_send = _.extend({}, a, sd.para.batch_send)) : sd.para.batch_send = !1;
	  var n = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"],
	      i = ["www.baidu.", "m.baidu.", "m.sm.cn", "so.com", "sogou.com", "youdao.com", "google.", "yahoo.com/", "bing.com/", "ask.com/"],
	      o = ["weibo.com", "renren.com", "kaixin001.com", "douban.com", "qzone.qq.com", "zhihu.com", "tieba.baidu.com", "weixin.qq.com"],
	      d = {
	    baidu: ["wd", "word", "kw", "keyword"],
	    google: "q",
	    bing: "q",
	    yahoo: "p",
	    sogou: ["query", "keyword"],
	    so: "q",
	    sm: "q"
	  };
	  if ("object" == _typeof_1(sd.para.source_type) && (sd.para.source_type.utm = _.isArray(sd.para.source_type.utm) ? sd.para.source_type.utm.concat(n) : n, sd.para.source_type.search = _.isArray(sd.para.source_type.search) ? sd.para.source_type.search.concat(i) : i, sd.para.source_type.social = _.isArray(sd.para.source_type.social) ? sd.para.source_type.social.concat(o) : o, sd.para.source_type.keyword = _.isObject(sd.para.source_type.keyword) ? _.extend(d, sd.para.source_type.keyword) : d), _.isObject(sd.para.heatmap) && (sd.para.heatmap.clickmap = sd.para.heatmap.clickmap || "default", sd.para.heatmap.scroll_notice_map = sd.para.heatmap.scroll_notice_map || "default", sd.para.heatmap.scroll_delay_time = sd.para.heatmap.scroll_delay_time || 4e3, sd.para.heatmap.scroll_event_duration = sd.para.heatmap.scroll_event_duration || 18e3, sd.para.heatmap.renderRefreshTime = sd.para.heatmap.renderRefreshTime || 1e3, sd.para.heatmap.loadTimeout = sd.para.heatmap.loadTimeout || 1e3), "object" == _typeof_1(sd.para.server_url) && sd.para.server_url.length) for (t = 0; t < sd.para.server_url.length; t++) {
	    /sa\.gif[^\/]*$/.test(sd.para.server_url[t]) || (sd.para.server_url[t] = sd.para.server_url[t].replace(/\/sa$/, "/sa.gif").replace(/(\/sa)(\?[^\/]+)$/, "/sa.gif$2"));
	  } else /sa\.gif[^\/]*$/.test(sd.para.server_url) || (sd.para.server_url = sd.para.server_url.replace(/\/sa$/, "/sa.gif").replace(/(\/sa)(\?[^\/]+)$/, "/sa.gif$2"));
	  "string" == typeof sd.para.server_url && (sd.para.debug_mode_url = sd.para.debug_mode_url || sd.para.server_url.replace("sa.gif", "debug")), !0 === sd.para.noCache ? sd.para.noCache = "?" + new Date().getTime() : sd.para.noCache = "", sd.para.callback_timeout > sd.para.datasend_timeout && (sd.para.datasend_timeout = sd.para.callback_timeout), sd.para.callback_timeout > sd.para.queue_timeout && (sd.para.queue_timeout = sd.para.callback_timeout), sd.para.queue_timeout > sd.para.datasend_timeout && (sd.para.datasend_timeout = sd.para.queue_timeout);
	}, sd.readyState = {
	  state: 0,
	  historyState: [],
	  stateType: {
	    1: "1-init\u672A\u5F00\u59CB",
	    2: "2-init\u5F00\u59CB",
	    3: "3-store\u5B8C\u6210"
	  },
	  getState: function getState() {
	    return this.historyState.join("\n");
	  },
	  setState: function setState(e) {
	    String(e) in this.stateType && (this.state = e), this.historyState.push(this.stateType[e]);
	  }
	}, sd.setPreConfig = function (e) {
	  sd.para = e.para, sd._q = e._q;
	}, sd.setInitVar = function () {
	  sd._t = sd._t || 1 * new Date(), sd.lib_version = "1.15.12", sd.is_first_visitor = !1, sd.source_channel_standard = "utm_source utm_medium utm_campaign utm_content utm_term";
	}, sd.log = function () {
	  if ((_.sessionStorage.isSupport() && "true" === sessionStorage.getItem("sensorsdata_jssdk_debug") || sd.para.show_log) && (!0 !== sd.para.show_log && "string" !== sd.para.show_log && !1 !== sd.para.show_log || (arguments[0] = _.formatJsonString(arguments[0])), "object" == (typeof console === "undefined" ? "undefined" : _typeof_1(console)) && console.log)) try {
	    return console.log.apply(console, arguments);
	  } catch (e) {}
	}, sd.enableLocalLog = function () {
	  if (_.sessionStorage.isSupport()) try {
	    sessionStorage.setItem("sensorsdata_jssdk_debug", "true");
	  } catch (e) {
	    sd.log("enableLocalLog error: " + e.message);
	  }
	}, sd.disableLocalLog = function () {
	  _.sessionStorage.isSupport() && sessionStorage.removeItem("sensorsdata_jssdk_debug");
	}, sd.debug = {
	  distinct_id: function distinct_id() {},
	  jssdkDebug: function jssdkDebug() {},
	  _sendDebug: function _sendDebug(e) {
	    sd.track("_sensorsdata2019_debug", {
	      _jssdk_debug_info: e
	    });
	  },
	  apph5: function apph5(e) {
	    var t = "app_h5\u6253\u901A\u5931\u8D25-",
	        r = {
	      1: t + "use_app_track\u4E3Afalse",
	      2: t + "Android\u6216\u8005iOS\uFF0C\u6CA1\u6709\u66B4\u9732\u76F8\u5E94\u65B9\u6CD5",
	      3.1: t + "Android\u6821\u9A8Cserver_url\u5931\u8D25",
	      3.2: t + "iOS\u6821\u9A8Cserver_url\u5931\u8D25",
	      4.1: t + "H5 \u6821\u9A8C iOS server_url \u5931\u8D25",
	      4.2: t + "H5 \u6821\u9A8C Android server_url \u5931\u8D25"
	    },
	        s = e.output,
	        a = e.step,
	        n = e.data || "";
	    "all" !== s && "console" !== s || sd.log(r[a]), ("all" === s || "code" === s) && _.isObject(sd.para.is_debug) && sd.para.is_debug.apph5 && (n.type && "profile" === n.type.slice(0, 7) || (n.properties._jssdk_debug_info = "apph5-" + String(a)));
	  },
	  defineMode: function defineMode(e) {
	    var t = {
	      1: {
	        title: "\u5F53\u524D\u9875\u9762\u65E0\u6CD5\u8FDB\u884C\u53EF\u89C6\u5316\u5168\u57CB\u70B9",
	        message: "App SDK \u4E0E Web JS SDK \u6CA1\u6709\u8FDB\u884C\u6253\u901A\uFF0C\u8BF7\u8054\u7CFB\u8D35\u65B9\u6280\u672F\u4EBA\u5458\u4FEE\u6B63 App SDK \u7684\u914D\u7F6E\uFF0C\u8BE6\u7EC6\u4FE1\u606F\u8BF7\u67E5\u770B\u6587\u6863\u3002",
	        link_text: "\u914D\u7F6E\u6587\u6863",
	        link_url: "https://manual.sensorsdata.cn/sa/latest/tech_sdk_client_link-1573913.html"
	      },
	      2: {
	        title: "\u5F53\u524D\u9875\u9762\u65E0\u6CD5\u8FDB\u884C\u53EF\u89C6\u5316\u5168\u57CB\u70B9",
	        message: "App SDK \u4E0E Web JS SDK \u6CA1\u6709\u8FDB\u884C\u6253\u901A\uFF0C\u8BF7\u8054\u7CFB\u8D35\u65B9\u6280\u672F\u4EBA\u5458\u4FEE\u6B63 Web JS SDK \u7684\u914D\u7F6E\uFF0C\u8BE6\u7EC6\u4FE1\u606F\u8BF7\u67E5\u770B\u6587\u6863\u3002",
	        link_text: "\u914D\u7F6E\u6587\u6863",
	        link_url: "https://manual.sensorsdata.cn/sa/latest/tech_sdk_client_link-1573913.html"
	      },
	      3: {
	        title: "\u5F53\u524D\u9875\u9762\u65E0\u6CD5\u8FDB\u884C\u53EF\u89C6\u5316\u5168\u57CB\u70B9",
	        message: "Web JS SDK \u6CA1\u6709\u5F00\u542F\u5168\u57CB\u70B9\u914D\u7F6E\uFF0C\u8BF7\u8054\u7CFB\u8D35\u65B9\u5DE5\u4F5C\u4EBA\u5458\u4FEE\u6B63 SDK \u7684\u914D\u7F6E\uFF0C\u8BE6\u7EC6\u4FE1\u606F\u8BF7\u67E5\u770B\u6587\u6863\u3002",
	        link_text: "\u914D\u7F6E\u6587\u6863",
	        link_url: "https://manual.sensorsdata.cn/sa/latest/tech_sdk_client_web_all-1573964.html"
	      },
	      4: {
	        title: "\u5F53\u524D\u9875\u9762\u65E0\u6CD5\u8FDB\u884C\u53EF\u89C6\u5316\u5168\u57CB\u70B9",
	        message: "Web JS SDK \u914D\u7F6E\u7684\u6570\u636E\u6821\u9A8C\u5730\u5740\u4E0E App SDK \u914D\u7F6E\u7684\u6570\u636E\u6821\u9A8C\u5730\u5740\u4E0D\u4E00\u81F4\uFF0C\u8BF7\u8054\u7CFB\u8D35\u65B9\u5DE5\u4F5C\u4EBA\u5458\u4FEE\u6B63 SDK \u7684\u914D\u7F6E\uFF0C\u8BE6\u7EC6\u4FE1\u606F\u8BF7\u67E5\u770B\u6587\u6863\u3002",
	        link_text: "\u914D\u7F6E\u6587\u6863",
	        link_url: "https://manual.sensorsdata.cn/sa/latest/tech_sdk_client_link-1573913.html"
	      }
	    };
	    return !(!e || !t[e]) && t[e];
	  }
	};
	var commonWays = {
	  setOnlineState: function setOnlineState(e) {
	    if (!0 === e && _.isObject(sd.para.jsapp) && "function" == typeof sd.para.jsapp.getData) {
	      sd.para.jsapp.isOnline = !0;
	      var t = sd.para.jsapp.getData();
	      _.isArray(t) && t.length > 0 && _.each(t, function (e) {
	        _.isJSONString(e) && sd.sendState.pushSend(JSON.parse(e));
	      });
	    } else sd.para.jsapp.isOnline = !1;
	  },
	  autoTrackIsUsed: !1,
	  isReady: function isReady(e) {
	    e();
	  },
	  getUtm: function getUtm() {
	    return _.info.campaignParams();
	  },
	  getStayTime: function getStayTime() {
	    return (new Date() - sd._t) / 1e3;
	  },
	  setProfileLocal: function setProfileLocal(e) {
	    if (!_.localStorage.isSupport()) return sd.setProfile(e), !1;
	    if (!_.isObject(e) || _.isEmptyObject(e)) return !1;

	    var t = _.localStorage.parse("sensorsdata_2015_jssdk_profile"),
	        r = !1;

	    if (_.isObject(t) && !_.isEmptyObject(t)) {
	      for (var s in e) {
	        !(s in t && t[s] !== e[s]) && s in t || (t[s] = e[s], r = !0);
	      }

	      r && (_.localStorage.set("sensorsdata_2015_jssdk_profile", JSON.stringify(t)), sd.setProfile(e));
	    } else _.localStorage.set("sensorsdata_2015_jssdk_profile", JSON.stringify(e)), sd.setProfile(e);
	  },
	  setInitReferrer: function setInitReferrer() {
	    var e = _.getReferrer();

	    sd.setOnceProfile({
	      _init_referrer: e,
	      _init_referrer_host: _.info.pageProp.referrer_host
	    });
	  },
	  setSessionReferrer: function setSessionReferrer() {
	    var e = _.getReferrer();

	    store.setSessionPropsOnce({
	      _session_referrer: e,
	      _session_referrer_host: _.info.pageProp.referrer_host
	    });
	  },
	  setDefaultAttr: function setDefaultAttr() {
	    _.info.register({
	      _current_url: location.href,
	      _referrer: _.getReferrer(),
	      _referring_host: _.info.pageProp.referrer_host
	    });
	  },
	  trackHeatMap: function trackHeatMap(e, t, r) {
	    if ("object" == _typeof_1(e) && e.tagName) {
	      var s = e.tagName.toLowerCase(),
	          a = e.parentNode.tagName.toLowerCase();
	      "button" === s || "a" === s || "a" === a || "button" === a || "input" === s || "textarea" === s || _.hasAttribute(e, "data-sensors-click") || heatmap.start(null, e, s, t, r);
	    }
	  },
	  trackAllHeatMap: function trackAllHeatMap(e, t, r) {
	    if ("object" == _typeof_1(e) && e.tagName) {
	      var s = e.tagName.toLowerCase();
	      heatmap.start(null, e, s, t, r);
	    }
	  },
	  autoTrackSinglePage: function autoTrackSinglePage(e, t) {
	    if (this.autoTrackIsUsed) var r = _.info.pageProp.url;else r = _.info.pageProp.referrer;

	    function s() {
	      var e = _.info.campaignParams(),
	          t = {};

	      for (var r in e) {
	        -1 !== (" " + sd.source_channel_standard + " ").indexOf(" " + r + " ") ? t["$" + r] = e[r] : t[r] = e[r];
	      }

	      return t;
	    }

	    function a(e, t) {
	      sd.track("$pageview", _.extend({
	        $referrer: r,
	        $url: location.href,
	        $url_path: location.pathname,
	        $title: document.title
	      }, e, s()), t), r = location.href;
	    }

	    e = _.isObject(e) ? e : {}, e = _.isObject(e) ? e : {}, sd.is_first_visitor && !e.not_set_profile && (sd.setOnceProfile(_.extend({
	      $first_visit_time: new Date(),
	      $first_referrer: _.getReferrer(),
	      $first_browser_language: navigator.language || "\u53D6\u503C\u5F02\u5E38",
	      $first_browser_charset: "string" == typeof document.charset ? document.charset.toUpperCase() : "\u53D6\u503C\u5F02\u5E38",
	      $first_traffic_source_type: _.getSourceFromReferrer(),
	      $first_search_keyword: _.getKeywordFromReferrer()
	    }, s())), sd.is_first_visitor = !1), e.not_set_profile && delete e.not_set_profile, a(e, t), this.autoTrackSinglePage = a;
	  },
	  autoTrackWithoutProfile: function autoTrackWithoutProfile(e, t) {
	    e = _.isObject(e) ? e : {}, this.autoTrack(_.extend(e, {
	      not_set_profile: !0
	    }), t);
	  },
	  autoTrack: function autoTrack(e, t) {
	    e = _.isObject(e) ? e : {};

	    var r = _.info.campaignParams(),
	        s = {};

	    for (var a in r) {
	      -1 !== (" " + sd.source_channel_standard + " ").indexOf(" " + a + " ") ? s["$" + a] = r[a] : s[a] = r[a];
	    }

	    sd.is_first_visitor && !e.not_set_profile && (sd.setOnceProfile(_.extend({
	      $first_visit_time: new Date(),
	      $first_referrer: _.getReferrer(),
	      $first_browser_language: navigator.language || "\u53D6\u503C\u5F02\u5E38",
	      $first_browser_charset: "string" == typeof document.charset ? document.charset.toUpperCase() : "\u53D6\u503C\u5F02\u5E38",
	      $first_traffic_source_type: _.getSourceFromReferrer(),
	      $first_search_keyword: _.getKeywordFromReferrer()
	    }, s)), sd.is_first_visitor = !1), e.not_set_profile && delete e.not_set_profile;
	    var n = location.href;
	    sd.para.is_single_page && _.addHashEvent(function () {
	      var r = _.getReferrer(n);

	      sd.track("$pageview", _.extend({
	        $referrer: r,
	        $url: location.href,
	        $url_path: location.pathname,
	        $title: document.title
	      }, s, e), t), n = location.href;
	    }), sd.track("$pageview", _.extend({
	      $referrer: _.getReferrer(),
	      $url: location.href,
	      $url_path: location.pathname,
	      $title: document.title
	    }, s, e), t), this.autoTrackIsUsed = !0;
	  },
	  getAnonymousID: function getAnonymousID() {
	    return _.isEmptyObject(sd.store._state) ? "\u8BF7\u5148\u521D\u59CB\u5316SDK" : sd.store._state._first_id || sd.store._state.first_id || sd.store._state._distinct_id || sd.store._state.distinct_id;
	  },
	  setPlugin: function setPlugin(e) {
	    if (!_.isObject(e)) return !1;

	    _.each(e, function (e, t) {
	      _.isFunction(e) && (_.isObject(window.SensorsDataWebJSSDKPlugin) && window.SensorsDataWebJSSDKPlugin[t] ? e(window.SensorsDataWebJSSDKPlugin[t]) : sd.log(t + "\u6CA1\u6709\u83B7\u53D6\u5230,\u8BF7\u67E5\u9605\u6587\u6863\uFF0C\u8C03\u6574" + t + "\u7684\u5F15\u5165\u987A\u5E8F\uFF01"));
	    });
	  },
	  useModulePlugin: function useModulePlugin() {
	    sd.use.apply(sd, arguments);
	  },
	  useAppPlugin: function useAppPlugin() {
	    this.setPlugin.apply(this, arguments);
	  }
	};

	function BatchSend() {
	  this.sendingData = 0;
	}

	sd.quick = function () {
	  var e = Array.prototype.slice.call(arguments),
	      t = e[0],
	      r = e.slice(1);
	  if ("string" == typeof t && commonWays[t]) return commonWays[t].apply(commonWays, r);
	  "function" == typeof t ? t.apply(sd, r) : sd.log("quick\u65B9\u6CD5\u4E2D\u6CA1\u6709\u8FD9\u4E2A\u529F\u80FD" + e[0]);
	}, sd.use = function (e, t) {
	  _.isObject(sd.modules) && _.isObject(sd.modules[e]) && _.isFunction(sd.modules[e].init) && (t = t || {}, sd.modules[e].init(sd, t));
	}, sd.track = function (e, t, r) {
	  saEvent.check({
	    event: e,
	    properties: t
	  }) && saEvent.send({
	    type: "track",
	    event: e,
	    properties: t
	  }, r);
	}, sd.trackLink = function (e, t, r) {
	  "object" == _typeof_1(e) && e.tagName ? _.trackLink({
	    ele: e
	  }, t, r) : "object" == _typeof_1(e) && e.target && e.event && _.trackLink(e, t, r);
	}, sd.trackLinks = function (e, t, r) {
	  return r = r || {}, !(!e || "object" != _typeof_1(e)) && !(!e.href || /^javascript/.test(e.href) || e.target) && void _.addEvent(e, "click", function (s) {
	    s.preventDefault();
	    var a = !1;

	    function n() {
	      a || (a = !0, location.href = e.href);
	    }

	    setTimeout(n, 1e3), sd.track(t, r, n);
	  });
	}, sd.setProfile = function (e, t) {
	  saEvent.check({
	    propertiesMust: e
	  }) && saEvent.send({
	    type: "profile_set",
	    properties: e
	  }, t);
	}, sd.setOnceProfile = function (e, t) {
	  saEvent.check({
	    propertiesMust: e
	  }) && saEvent.send({
	    type: "profile_set_once",
	    properties: e
	  }, t);
	}, sd.appendProfile = function (e, t) {
	  saEvent.check({
	    propertiesMust: e
	  }) && (_.each(e, function (t, r) {
	    _.isString(t) ? e[r] = [t] : _.isArray(t) ? e[r] = t : (delete e[r], sd.log("appendProfile\u5C5E\u6027\u7684\u503C\u5FC5\u987B\u662F\u5B57\u7B26\u4E32\u6216\u8005\u6570\u7EC4"));
	  }), _.isEmptyObject(e) || saEvent.send({
	    type: "profile_append",
	    properties: e
	  }, t));
	}, sd.incrementProfile = function (e, t) {
	  var r = e;
	  _.isString(e) && ((e = {})[r] = 1), saEvent.check({
	    propertiesMust: e
	  }) && (!function (e) {
	    for (var t in e) {
	      if (!/-*\d+/.test(String(e[t]))) return !1;
	    }

	    return !0;
	  }(e) ? sd.log("profile_increment\u7684\u503C\u53EA\u80FD\u662F\u6570\u5B57") : saEvent.send({
	    type: "profile_increment",
	    properties: e
	  }, t));
	}, sd.deleteProfile = function (e) {
	  saEvent.send({
	    type: "profile_delete"
	  }, e), store.set("distinct_id", _.UUID()), store.set("first_id", "");
	}, sd.unsetProfile = function (e, t) {
	  var r = e,
	      s = {};
	  _.isString(e) && (e = []).push(r), _.isArray(e) ? (_.each(e, function (e) {
	    _.isString(e) ? s[e] = !0 : sd.log("profile_unset\u7ED9\u7684\u6570\u7EC4\u91CC\u9762\u7684\u503C\u5FC5\u987B\u65F6string,\u5DF2\u7ECF\u8FC7\u6EE4\u6389", e);
	  }), saEvent.send({
	    type: "profile_unset",
	    properties: s
	  }, t)) : sd.log("profile_unset\u7684\u53C2\u6570\u662F\u6570\u7EC4");
	}, sd.identify = function (e, t) {
	  "number" == typeof e && (e = String(e));
	  var r = store.getFirstId();

	  if (void 0 === e) {
	    var s = _.UUID();

	    r ? store.set("first_id", s) : store.set("distinct_id", s);
	  } else saEvent.check({
	    distinct_id: e
	  }) ? !0 === t ? r ? store.set("first_id", e) : store.set("distinct_id", e) : r ? store.change("first_id", e) : store.change("distinct_id", e) : sd.log("identify\u7684\u53C2\u6570\u5FC5\u987B\u662F\u5B57\u7B26\u4E32");
	}, sd.trackSignup = function (e, t, r, s) {
	  if (saEvent.check({
	    distinct_id: e,
	    event: t,
	    properties: r
	  })) {
	    var a = store.getFirstId() || store.getDistinctId();
	    store.set("distinct_id", e), saEvent.send({
	      original_id: a,
	      distinct_id: e,
	      type: "track_signup",
	      event: t,
	      properties: r
	    }, s);
	  }
	}, sd.trackAbtest = function (e, t) {}, sd.registerPage = function (e) {
	  saEvent.check({
	    properties: e
	  }) ? _.extend(_.info.currentProps, e) : sd.log("register\u8F93\u5165\u7684\u53C2\u6570\u6709\u8BEF");
	}, sd.clearAllRegister = function (e) {
	  store.clearAllProps(e);
	}, sd.register = function (e) {
	  saEvent.check({
	    properties: e
	  }) ? store.setProps(e) : sd.log("register\u8F93\u5165\u7684\u53C2\u6570\u6709\u8BEF");
	}, sd.registerOnce = function (e) {
	  saEvent.check({
	    properties: e
	  }) ? store.setPropsOnce(e) : sd.log("registerOnce\u8F93\u5165\u7684\u53C2\u6570\u6709\u8BEF");
	}, sd.registerSession = function (e) {
	  saEvent.check({
	    properties: e
	  }) ? store.setSessionProps(e) : sd.log("registerSession\u8F93\u5165\u7684\u53C2\u6570\u6709\u8BEF");
	}, sd.registerSessionOnce = function (e) {
	  saEvent.check({
	    properties: e
	  }) ? store.setSessionPropsOnce(e) : sd.log("registerSessionOnce\u8F93\u5165\u7684\u53C2\u6570\u6709\u8BEF");
	}, sd.login = function (e, t) {
	  if ("number" == typeof e && (e = String(e)), saEvent.check({
	    distinct_id: e
	  })) {
	    var r = store.getFirstId(),
	        s = store.getDistinctId();
	    e !== s ? (r || store.set("first_id", s), sd.trackSignup(e, "$SignUp", {}, t)) : t && t();
	  } else sd.log("login\u7684\u53C2\u6570\u5FC5\u987B\u662F\u5B57\u7B26\u4E32"), t && t();
	}, sd.logout = function (e) {
	  var t = store.getFirstId();
	  if (t) {
	    if (store.set("first_id", ""), !0 === e) {
	      var r = _.UUID();

	      store.set("distinct_id", r);
	    } else store.set("distinct_id", t);
	  } else sd.log("\u6CA1\u6709first_id\uFF0Clogout\u5931\u8D25");
	}, sd.getPresetProperties = function () {
	  var e = {
	    $referrer: _.info.pageProp.referrer || "",
	    $referrer_host: _.info.pageProp.referrer ? _.getHostname(_.info.pageProp.referrer) : "",
	    $url: location.href,
	    $url_path: location.pathname,
	    $title: document.title || "",
	    _distinct_id: store.getDistinctId()
	  },
	      t = _.extend({}, _.info.properties(), sd.store.getProps(), function () {
	    var e = _.info.campaignParams(),
	        t = {};

	    for (var r in e) {
	      -1 !== (" " + sd.source_channel_standard + " ").indexOf(" " + r + " ") ? t["$" + r] = e[r] : t[r] = e[r];
	    }

	    return t;
	  }(), e);

	  return sd.para.preset_properties.latest_referrer && sd.para.preset_properties.latest_referrer_host && (t.$latest_referrer_host = "" === t.$latest_referrer ? "" : _.getHostname(t.$latest_referrer)), t;
	}, sd.detectMode = function () {
	  var e = {
	    searchKeywordMatch: location.search.match(/sa-request-id=([^&#]+)/),
	    isSeachHasKeyword: function isSeachHasKeyword() {
	      var e = this.searchKeywordMatch;
	      return e && e[0] && e[1];
	    },
	    hasKeywordHandle: function hasKeywordHandle() {
	      var e = this.searchKeywordMatch,
	          t = location.search.match(/sa-request-type=([^&#]+)/),
	          r = location.search.match(/sa-request-url=([^&#]+)/);
	      heatmap.setNotice(r), _.sessionStorage.isSupport() && (r && r[0] && r[1] && sessionStorage.setItem("sensors_heatmap_url", decodeURIComponent(r[1])), sessionStorage.setItem("sensors_heatmap_id", e[1]), t && t[0] && t[1] ? "1" === t[1] || "2" === t[1] || "3" === t[1] ? (t = t[1], sessionStorage.setItem("sensors_heatmap_type", t)) : t = null : t = null !== sessionStorage.getItem("sensors_heatmap_type") ? sessionStorage.getItem("sensors_heatmap_type") : null), this.isReady(e[1], t);
	    },
	    isReady: function isReady(e, t, r) {
	      sd.para.heatmap_url ? _.loadScript({
	        success: function success() {
	          setTimeout(function () {
	            "undefined" != typeof sa_jssdk_heatmap_render && (sa_jssdk_heatmap_render(sd, e, t, r), "object" == (typeof console === "undefined" ? "undefined" : _typeof_1(console)) && "function" == typeof console.log && (sd.heatmap_version && sd.heatmap_version === sd.lib_version || void 0));
	          }, 0);
	        },
	        error: function error() {},
	        type: "js",
	        url: sd.para.heatmap_url
	      }) : sd.log("\u6CA1\u6709\u6307\u5B9Aheatmap_url\u7684\u8DEF\u5F84");
	    },
	    isStoregeHasKeyword: function isStoregeHasKeyword() {
	      return _.sessionStorage.isSupport() && "string" == typeof sessionStorage.getItem("sensors_heatmap_id");
	    },
	    storageHasKeywordHandle: function storageHasKeywordHandle() {
	      heatmap.setNotice(), e.isReady(sessionStorage.getItem("sensors_heatmap_id"), sessionStorage.getItem("sensors_heatmap_type"), location.href);
	    }
	  },
	      t = {
	    isVtrackMode: !1,
	    loadVtrack: function loadVtrack() {
	      _.loadScript({
	        success: function success() {},
	        error: function error() {},
	        type: "js",
	        url: location.protocol + "//static.sensorsdata.cn/sdk/" + sd.lib_version + "/vtrack.min.js"
	      });
	    },
	    messageListener: function messageListener(e) {
	      if ("sa-fe" !== e.data.source) return !1;
	      "v-track-mode" === e.data.type && (e.data.data && e.data.data.isVtrack && (t.isVtrackMode = !0, t.loadVtrack()), window.removeEventListener("message", t.messageListener, !1));
	    },
	    removeMessageHandle: function removeMessageHandle() {
	      window.removeEventListener && window.removeEventListener("message", t.messageListener, !1);
	    },
	    verifyVtrackMode: function verifyVtrackMode() {
	      window.addEventListener && window.addEventListener("message", t.messageListener, !1), window.parent && window.parent.postMessage && window.parent.postMessage({
	        source: "sa-web-sdk",
	        type: "v-is-vtrack",
	        data: {}
	      }, "*");
	    }
	  },
	      r = function r(e) {
	    var t = sd.bridge.initDefineBridgeInfo();

	    function r() {
	      var e = [];
	      t.touch_app_bridge || e.push(sd.debug.defineMode("1")), _.isObject(sd.para.app_js_bridge) || (e.push(sd.debug.defineMode("2")), t.verify_success = !1), _.isObject(sd.para.heatmap) && "default" == sd.para.heatmap.clickmap || e.push(sd.debug.defineMode("3")), "fail" === t.verify_success && e.push(sd.debug.defineMode("4"));
	      var r = {
	        callType: "app_alert",
	        data: e
	      };
	      SensorsData_App_Visual_Bridge && SensorsData_App_Visual_Bridge.sensorsdata_visualized_alert_info ? SensorsData_App_Visual_Bridge.sensorsdata_visualized_alert_info(JSON.stringify(r)) : window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.sensorsdataNativeTracker && window.webkit.messageHandlers.sensorsdataNativeTracker.postMessage && window.webkit.messageHandlers.sensorsdataNativeTracker.postMessage(JSON.stringify(r));
	    }

	    if (_.isObject(window.SensorsData_App_Visual_Bridge) && window.SensorsData_App_Visual_Bridge.sensorsdata_visualized_mode && (!0 === window.SensorsData_App_Visual_Bridge.sensorsdata_visualized_mode || window.SensorsData_App_Visual_Bridge.sensorsdata_visualized_mode())) if (_.isObject(sd.para.heatmap) && "default" == sd.para.heatmap.clickmap) {
	      if (_.isObject(sd.para.app_js_bridge) && "success" === t.verify_success) {
	        if (e) sa_jssdk_app_define_mode(sd, e);else {
	          var s = location.protocol;
	          s = _.indexOf(["http:", "https:"], s) > -1 ? s : "https:", _.loadScript({
	            success: function success() {
	              setTimeout(function () {
	                "undefined" != typeof sa_jssdk_app_define_mode && sa_jssdk_app_define_mode(sd, e);
	              }, 0);
	            },
	            error: function error() {},
	            type: "js",
	            url: s + "//static.sensorsdata.cn/sdk/" + sd.lib_version + "/vapph5define.min.js"
	          });
	        }
	      } else r();
	    } else r();
	  };

	  function s() {
	    sd.readyState.setState(3), window.sensorsdata_app_call_js = function (e) {
	      e && "visualized" == e && ("undefined" != typeof sa_jssdk_app_define_mode ? r(!0) : r(!1));
	    }, r(!1), sd.bridge.app_js_bridge_v1(), _.info.initPage(), sd.para.is_track_single_page && _.addSinglePageEvent(function (e) {
	      var t = function t(_t) {
	        _t = _t || {}, e !== location.href && (_.info.pageProp.referrer = e, sd.quick("autoTrack", _.extend({
	          $url: location.href,
	          $referrer: e
	        }, _t)));
	      };

	      if ("boolean" == typeof sd.para.is_track_single_page) t();else if ("function" == typeof sd.para.is_track_single_page) {
	        var r = sd.para.is_track_single_page();
	        _.isObject(r) ? t(r) : !0 === r && t();
	      }
	    }), sd.para.batch_send && sd.batchSend.batchInterval(), sd.store.init(), sd.readyState.setState(4), sd._q && _.isArray(sd._q) && sd._q.length > 0 && _.each(sd._q, function (e) {
	      sd[e[0]].apply(sd, Array.prototype.slice.call(e[1]));
	    }), _.isObject(sd.para.heatmap) && (heatmap.initHeatmap(), heatmap.initScrollmap());
	  }

	  e.isSeachHasKeyword() ? e.hasKeywordHandle() : window.parent !== self ? (t.verifyVtrackMode(), setTimeout(function () {
	    if (t.isVtrackMode) return !1;
	    t.removeMessageHandle(), e.isStoregeHasKeyword() ? e.storageHasKeywordHandle() : s();
	  }, 1e3)) : s();
	}, BatchSend.prototype = {
	  add: function add(e) {
	    _.isObject(e) && (this.writeStore(e), "track_signup" !== e.type && "$pageview" !== e.event || this.sendStrategy());
	  },
	  remove: function remove(e) {
	    this.sendingData > 0 && --this.sendingData, _.isArray(e) && e.length > 0 && _.each(e, function (e) {
	      _.localStorage.remove(e);
	    });
	  },
	  send: function send(e) {
	    var t = this,
	        r = _.isArray(sd.para.server_url) ? sd.para.server_url[0] : sd.para.server_url;

	    _.ajax({
	      url: r,
	      type: "POST",
	      data: "data_list=" + encodeURIComponent(_.base64Encode(JSON.stringify(e.vals))),
	      credentials: !1,
	      timeout: sd.para.batch_send.datasend_timeout,
	      cors: !0,
	      success: function success() {
	        t.remove(e.keys);
	      },
	      error: function error() {
	        t.sendingData > 0 && --t.sendingData;
	      }
	    });
	  },
	  sendPrepare: function sendPrepare(e) {
	    var t = e.vals,
	        r = sd.para.batch_send.one_send_max_length,
	        s = t.length;
	    if (s > 0) if (s <= r) this.send({
	      keys: e.keys,
	      vals: t
	    });else for (var a = 0; a * r < s; a++) {
	      this.send({
	        keys: e.keys.splice(0, r),
	        vals: t.splice(0, r)
	      });
	    }
	  },
	  sendStrategy: function sendStrategy() {
	    var e = this.readStore();
	    e.keys.length > 0 && 0 === this.sendingData && (this.sendingData = Math.ceil(e.vals.length / sd.para.batch_send.one_send_max_length), this.sendPrepare(e));
	  },
	  batchInterval: function batchInterval() {
	    var e = this;
	    setInterval(function () {
	      e.sendStrategy();
	    }, sd.para.batch_send.send_interval);
	  },
	  readStore: function readStore() {
	    for (var e = [], t = [], r = null, s = new Date().getTime(), a = localStorage.length, n = 0; n < a; n++) {
	      var i = localStorage.key(n);
	      0 === i.indexOf("sawebjssdk-") && /^sawebjssdk\-\d+$/.test(i) && ((r = localStorage.getItem(i)) ? (r = _.safeJSONParse(r)) && _.isObject(r) ? (r._flush_time = s, e.push(i), t.push(r)) : (localStorage.removeItem(i), sd.log("localStorage-\u6570\u636Eparse\u5F02\u5E38" + r)) : (localStorage.removeItem(i), sd.log("localStorage-\u6570\u636E\u53D6\u503C\u5F02\u5E38" + r)));
	    }

	    return {
	      keys: e,
	      vals: t
	    };
	  },
	  writeStore: function writeStore(e) {
	    var t = String(Math.random()).slice(2, 5) + String(Math.random()).slice(2, 5) + String(new Date().getTime()).slice(3);
	    localStorage.setItem("sawebjssdk-" + t, JSON.stringify(e));
	  }
	}, sd.batchSend = new BatchSend();
	var dataSend = {
	  getSendUrl: function getSendUrl(e, t) {
	    var r = _.base64Encode(t),
	        s = "crc=" + _.hashCode(r);

	    return -1 !== e.indexOf("?") ? e + "&data=" + encodeURIComponent(r) + "&ext=" + encodeURIComponent(s) : e + "?data=" + encodeURIComponent(r) + "&ext=" + encodeURIComponent(s);
	  },
	  getSendData: function getSendData(e) {
	    var t = _.base64Encode(e),
	        r = "crc=" + _.hashCode(t);

	    return "data=" + encodeURIComponent(t) + "&ext=" + encodeURIComponent(r);
	  },
	  getInstance: function getInstance(e) {
	    var t = new this[this.getSendType(e)](e),
	        r = t.start;
	    return t.start = function () {
	      _.isObject(sd.para.is_debug) && sd.para.is_debug.storage && sd.store.requests && sd.store.requests.push({
	        name: this.server_url,
	        initiatorType: this.img ? "img" : "xmlhttprequest",
	        entryType: "resource",
	        requestData: this.data
	      });
	      var e = this;
	      r.apply(this, arguments), setTimeout(function () {
	        e.isEnd(!0);
	      }, sd.para.callback_timeout);
	    }, t.end = function () {
	      this.callback && this.callback();
	      var e = this;
	      setTimeout(function () {
	        e.lastClear && e.lastClear();
	      }, sd.para.datasend_timeout - sd.para.callback_timeout);
	    }, t.isEnd = function (e) {
	      if (!this.received) {
	        this.received = !0, this.end();
	        var t = this;
	        e ? sd.para.queue_timeout - sd.para.callback_timeout <= 0 ? t.close() : setTimeout(function () {
	          t.close();
	        }, sd.para.queue_timeout - sd.para.callback_timeout) : t.close();
	      }
	    }, t;
	  },
	  getSendType: function getSendType(e) {
	    var t = ["image", "ajax", "beacon"],
	        r = t[0];
	    return "beacon" === (r = e.config && _.indexOf(t, e.config.send_type) > -1 ? e.config.send_type : sd.para.send_type) && "function" != typeof navigator.sendBeacon && (r = "image"), "ajax" === r && !1 === _.isSupportCors() && (r = "image"), r;
	  },
	  image: function image(e) {
	    this.callback = e.callback, this.img = document.createElement("img"), this.img.width = 1, this.img.height = 1, sd.para.img_use_crossorigin && (this.img.crossOrigin = "anonymous"), this.data = e.data, this.server_url = dataSend.getSendUrl(e.server_url, e.data);
	  }
	};
	dataSend.image.prototype.start = function () {
	  var e = this;
	  sd.para.ignore_oom && (this.img.onload = function () {
	    this.onload = null, this.onerror = null, this.onabort = null, e.isEnd();
	  }, this.img.onerror = function () {
	    this.onload = null, this.onerror = null, this.onabort = null, e.isEnd();
	  }, this.img.onabort = function () {
	    this.onload = null, this.onerror = null, this.onabort = null, e.isEnd();
	  }), this.img.src = this.server_url;
	}, dataSend.image.prototype.lastClear = function () {
	  this.img.src = "";
	}, dataSend.ajax = function (e) {
	  this.callback = e.callback, this.server_url = e.server_url, this.data = dataSend.getSendData(e.data);
	}, dataSend.ajax.prototype.start = function () {
	  var e = this;

	  _.ajax({
	    url: this.server_url,
	    type: "POST",
	    data: this.data,
	    credentials: !1,
	    timeout: sd.para.datasend_timeout,
	    cors: !0,
	    success: function success() {
	      e.isEnd();
	    },
	    error: function error() {
	      e.isEnd();
	    }
	  });
	}, dataSend.beacon = function (e) {
	  this.callback = e.callback, this.server_url = e.server_url, this.data = dataSend.getSendData(e.data);
	}, dataSend.beacon.prototype.start = function () {
	  var e = this;
	  "object" == (typeof navigator === "undefined" ? "undefined" : _typeof_1(navigator)) && "function" == typeof navigator.sendBeacon && navigator.sendBeacon(this.server_url, this.data), setTimeout(function () {
	    e.isEnd();
	  }, 40);
	};
	var sendState = {};
	sd.sendState = sendState, sd.events = new _.eventEmitter(), sendState.queue = _.autoExeQueue(), sendState.requestData = null, sendState.getSendCall = function (e, t, r) {
	  if (sd.is_heatmap_render_mode) return !1;
	  if (sd.readyState.state < 3) return sd.log("\u521D\u59CB\u5316\u6CA1\u6709\u5B8C\u6210"), !1;
	  e._track_id = Number(String(Math.random()).slice(2, 5) + String(Math.random()).slice(2, 4) + String(new Date().getTime()).slice(-4)), sd.para.use_client_time && (e._flush_time = new Date().getTime());
	  var s = e;
	  if (e = JSON.stringify(e), this.requestData = {
	    data: s,
	    config: t,
	    callback: r
	  }, sd.events.tempAdd("send", s), !sd.para.app_js_bridge && sd.para.batch_send && localStorage.length < 200) return sd.log(s), sd.batchSend.add(this.requestData.data), !1;
	  sd.bridge.dataSend(s, this, r), sd.log(s);
	}, sendState.prepareServerUrl = function () {
	  if ("object" == _typeof_1(this.requestData.config) && this.requestData.config.server_url) this.sendCall(this.requestData.config.server_url, this.requestData.callback);else if (_.isArray(sd.para.server_url)) for (var e = 0; e < sd.para.server_url.length; e++) {
	    this.sendCall(sd.para.server_url[e]);
	  } else this.sendCall(sd.para.server_url, this.requestData.callback);
	}, sendState.sendCall = function (e, t) {
	  var r = {
	    server_url: e,
	    data: JSON.stringify(this.requestData.data),
	    callback: t,
	    config: this.requestData.config
	  };
	  _.isObject(sd.para.jsapp) && !sd.para.jsapp.isOnline && "function" == typeof sd.para.jsapp.setData ? (delete r.callback, r = JSON.stringify(r), sd.para.jsapp.setData(r)) : this.pushSend(r);
	}, sendState.pushSend = function (e) {
	  var t = dataSend.getInstance(e),
	      r = this;
	  t.close = function () {
	    r.queue.close();
	  }, this.queue.enqueue(t);
	};
	var saEvent = {};
	sd.saEvent = saEvent, saEvent.checkOption = {
	  regChecks: {
	    regName: /^((?!^distinct_id$|^original_id$|^time$|^properties$|^id$|^first_id$|^second_id$|^users$|^events$|^event$|^user_id$|^date$|^datetime$)[a-zA-Z_$][a-zA-Z\d_$]{0,99})$/i
	  },
	  checkPropertiesKey: function checkPropertiesKey(e) {
	    var t = this,
	        r = !0;
	    return _.each(e, function (e, s) {
	      t.regChecks.regName.test(s) || (r = !1);
	    }), r;
	  },
	  check: function check(e, t) {
	    return "string" == typeof this[e] ? this[this[e]](t) : this[e](t);
	  },
	  str: function str(e) {
	    return !!_.isString(e) || (sd.log("\u8BF7\u68C0\u67E5\u53C2\u6570\u683C\u5F0F,\u5FC5\u987B\u662F\u5B57\u7B26\u4E32"), !0);
	  },
	  properties: function properties(e) {
	    return _.strip_sa_properties(e), !e || (_.isObject(e) ? !!this.checkPropertiesKey(e) || (sd.log("properties \u91CC\u7684\u81EA\u5B9A\u4E49\u5C5E\u6027\u540D\u9700\u8981\u662F\u5408\u6CD5\u7684\u53D8\u91CF\u540D\uFF0C\u4E0D\u80FD\u4EE5\u6570\u5B57\u5F00\u5934\uFF0C\u4E14\u53EA\u5305\u542B\uFF1A\u5927\u5C0F\u5199\u5B57\u6BCD\u3001\u6570\u5B57\u3001\u4E0B\u5212\u7EBF\uFF0C\u81EA\u5B9A\u4E49\u5C5E\u6027\u4E0D\u80FD\u4EE5 $ \u5F00\u5934"), !0) : (sd.log("properties\u53EF\u4EE5\u6CA1\u6709\uFF0C\u4F46\u6709\u7684\u8BDD\u5FC5\u987B\u662F\u5BF9\u8C61"), !0));
	  },
	  propertiesMust: function propertiesMust(e) {
	    return _.strip_sa_properties(e), void 0 === e || !_.isObject(e) || _.isEmptyObject(e) ? (sd.log("properties\u5FC5\u987B\u662F\u5BF9\u8C61\u4E14\u6709\u503C"), !0) : !!this.checkPropertiesKey(e) || (sd.log("properties \u91CC\u7684\u81EA\u5B9A\u4E49\u5C5E\u6027\u540D\u9700\u8981\u662F\u5408\u6CD5\u7684\u53D8\u91CF\u540D\uFF0C\u4E0D\u80FD\u4EE5\u6570\u5B57\u5F00\u5934\uFF0C\u4E14\u53EA\u5305\u542B\uFF1A\u5927\u5C0F\u5199\u5B57\u6BCD\u3001\u6570\u5B57\u3001\u4E0B\u5212\u7EBF\uFF0C\u81EA\u5B9A\u4E49\u5C5E\u6027\u4E0D\u80FD\u4EE5 $ \u5F00\u5934"), !0);
	  },
	  event: function event(e) {
	    return !(!_.isString(e) || !this.regChecks.regName.test(e)) || (sd.log("\u8BF7\u68C0\u67E5\u53C2\u6570\u683C\u5F0F\uFF0CeventName \u5FC5\u987B\u662F\u5B57\u7B26\u4E32\uFF0C\u4E14\u9700\u662F\u5408\u6CD5\u7684\u53D8\u91CF\u540D\uFF0C\u5373\u4E0D\u80FD\u4EE5\u6570\u5B57\u5F00\u5934\uFF0C\u4E14\u53EA\u5305\u542B\uFF1A\u5927\u5C0F\u5199\u5B57\u6BCD\u3001\u6570\u5B57\u3001\u4E0B\u5212\u7EBF\u548C $,\u5176\u4E2D\u4EE5 $ \u5F00\u5934\u7684\u8868\u660E\u662F\u7CFB\u7EDF\u7684\u4FDD\u7559\u5B57\u6BB5\uFF0C\u81EA\u5B9A\u4E49\u4E8B\u4EF6\u540D\u8BF7\u4E0D\u8981\u4EE5 $ \u5F00\u5934"), !0);
	  },
	  test_id: "str",
	  group_id: "str",
	  distinct_id: function distinct_id(e) {
	    return !(!_.isString(e) || !/^.{1,255}$/.test(e)) || (sd.log("distinct_id\u5FC5\u987B\u662F\u4E0D\u80FD\u4E3A\u7A7A\uFF0C\u4E14\u5C0F\u4E8E255\u4F4D\u7684\u5B57\u7B26\u4E32"), !1);
	  }
	}, saEvent.check = function (e) {
	  for (var t in e) {
	    if (!this.checkOption.check(t, e[t])) return !1;
	  }

	  return !0;
	}, saEvent.send = function (e, t) {
	  var r = {
	    distinct_id: store.getDistinctId(),
	    lib: {
	      $lib: "js",
	      $lib_method: "code",
	      $lib_version: String(sd.lib_version)
	    },
	    properties: {}
	  };
	  _.isObject(e) && _.isObject(e.properties) && !_.isEmptyObject(e.properties) && e.properties.$lib_detail && (r.lib.$lib_detail = e.properties.$lib_detail, delete e.properties.$lib_detail), _.extend(r, sd.store.getUnionId(), e), _.isObject(e.properties) && !_.isEmptyObject(e.properties) && _.extend(r.properties, e.properties), e.type && "profile" === e.type.slice(0, 7) || (r.properties = _.extend({}, _.info.properties(), store.getProps(), store.getSessionProps(), _.info.currentProps, r.properties), sd.para.preset_properties.latest_referrer && !_.isString(r.properties.$latest_referrer) && (r.properties.$latest_referrer = "\u53D6\u503C\u5F02\u5E38"), sd.para.preset_properties.latest_search_keyword && !_.isString(r.properties.$latest_search_keyword) && (r.properties.$latest_search_keyword = "\u53D6\u503C\u5F02\u5E38"), sd.para.preset_properties.latest_traffic_source_type && !_.isString(r.properties.$latest_traffic_source_type) && (r.properties.$latest_traffic_source_type = "\u53D6\u503C\u5F02\u5E38"), sd.para.preset_properties.latest_landing_page && !_.isString(r.properties.$latest_landing_page) && (r.properties.$latest_landing_page = "\u53D6\u503C\u5F02\u5E38")), r.properties.$time && _.isDate(r.properties.$time) ? (r.time = 1 * r.properties.$time, delete r.properties.$time) : sd.para.use_client_time && (r.time = 1 * new Date()), _.parseSuperProperties(r.properties), _.filterReservedProperties(r.properties), _.searchObjDate(r), _.searchObjString(r), _.searchZZAppStyle(r);

	  var s = _.searchConfigData(r.properties);

	  saNewUser.checkIsAddSign(r), saNewUser.checkIsFirstTime(r), sd.addReferrerHost(r), sd.addPropsHook(r), !0 === sd.para.debug_mode ? (sd.log(r), this.debugPath(JSON.stringify(r), t)) : sd.sendState.getSendCall(r, s, t);
	}, saEvent.debugPath = function (e, t) {
	  var r = e,
	      s = "";
	  s = -1 !== sd.para.debug_mode_url.indexOf("?") ? sd.para.debug_mode_url + "&data=" + encodeURIComponent(_.base64Encode(e)) : sd.para.debug_mode_url + "?data=" + encodeURIComponent(_.base64Encode(e)), _.ajax({
	    url: s,
	    type: "GET",
	    cors: !0,
	    header: {
	      "Dry-Run": String(sd.para.debug_mode_upload)
	    },
	    success: function success(e) {
	      !0 === _.isEmptyObject(e) ? alert("debug\u6570\u636E\u53D1\u9001\u6210\u529F" + r) : alert("debug\u5931\u8D25 \u9519\u8BEF\u539F\u56E0" + JSON.stringify(e));
	    }
	  });
	};
	var store = sd.store = {
	  requests: [],
	  _sessionState: {},
	  _state: {
	    distinct_id: "",
	    first_id: "",
	    props: {}
	  },
	  getProps: function getProps() {
	    return this._state.props || {};
	  },
	  getSessionProps: function getSessionProps() {
	    return this._sessionState;
	  },
	  getDistinctId: function getDistinctId() {
	    return this._state._distinct_id || this._state.distinct_id;
	  },
	  getUnionId: function getUnionId() {
	    var e = {},
	        t = this._state._first_id || this._state.first_id,
	        r = this._state._distinct_id || this._state.distinct_id;
	    return t && r ? (e.login_id = r, e.anonymous_id = t) : e.anonymous_id = r, e;
	  },
	  getFirstId: function getFirstId() {
	    return this._state._first_id || this._state.first_id;
	  },
	  toState: function toState(e) {
	    var t = null;
	    if (null != e && _.isJSONString(e)) {
	      if (t = JSON.parse(e), this._state = _.extend(t), t.distinct_id) {
	        if ("object" == _typeof_1(t.props)) {
	          for (var r in t.props) {
	            "string" == typeof t.props[r] && (t.props[r] = t.props[r].slice(0, sd.para.max_referrer_string_length));
	          }

	          this.save();
	        }
	      } else this.set("distinct_id", _.UUID()), sd.debug.distinct_id("1", e);
	    } else this.set("distinct_id", _.UUID()), sd.debug.distinct_id("2", e);
	  },
	  initSessionState: function initSessionState() {
	    var e = _.cookie.get("sensorsdata2015session"),
	        t = null;

	    null !== e && "object" == _typeof_1(t = JSON.parse(e)) && (this._sessionState = t || {});
	  },
	  setOnce: function setOnce(e, t) {
	    e in this._state || this.set(e, t);
	  },
	  set: function set(e, t) {
	    this._state = this._state || {}, "distinct_id" === e && this._state.distinct_id && sd.events.tempAdd("changeDistinctId", t), this._state[e] = t, "first_id" === e ? delete this._state._first_id : "distinct_id" === e && delete this._state._distinct_id, this.save();
	  },
	  change: function change(e, t) {
	    this._state["_" + e] = t;
	  },
	  setSessionProps: function setSessionProps(e) {
	    var t = this._sessionState;
	    _.extend(t, e), this.sessionSave(t);
	  },
	  setSessionPropsOnce: function setSessionPropsOnce(e) {
	    var t = this._sessionState;
	    _.coverExtend(t, e), this.sessionSave(t);
	  },
	  setProps: function setProps(e, t) {
	    var r = {};

	    for (var s in r = t ? e : _.extend(this._state.props || {}, e)) {
	      "string" == typeof r[s] && (r[s] = r[s].slice(0, sd.para.max_referrer_string_length));
	    }

	    this.set("props", r);
	  },
	  setPropsOnce: function setPropsOnce(e) {
	    var t = this._state.props || {};
	    _.coverExtend(t, e), this.set("props", t);
	  },
	  clearAllProps: function clearAllProps(e) {
	    if (this._sessionState = {}, _.isArray(e) && e.length > 0) for (var t = 0; t < e.length; t++) {
	      _.isString(e[t]) && -1 === e[t].indexOf("latest_") && e[t] in this._state.props && delete this._state.props[e[t]];
	    } else for (var t in this._state.props) {
	      1 !== t.indexOf("latest_") && delete this._state.props[t];
	    }
	    this.sessionSave({}), this.save();
	  },
	  sessionSave: function sessionSave(e) {
	    this._sessionState = e, _.cookie.set("sensorsdata2015session", JSON.stringify(this._sessionState), 0);
	  },
	  save: function save() {
	    var e = JSON.parse(JSON.stringify(this._state));
	    delete e._first_id, delete e._distinct_id, _.cookie.set(this.getCookieName(), JSON.stringify(e), 73e3, sd.para.cross_subdomain);
	  },
	  getCookieName: function getCookieName() {
	    var e = "";

	    if (!1 === sd.para.cross_subdomain) {
	      try {
	        e = _.URL(location.href).hostname;
	      } catch (e) {
	        sd.log(e);
	      }

	      e = "string" == typeof e && "" !== e ? "sa_jssdk_2015_" + e.replace(/\./g, "_") : "sa_jssdk_2015_root";
	    } else e = "sensorsdata2015jssdkcross";

	    return e;
	  },
	  init: function init() {
	    this.initSessionState();

	    var e = _.UUID(),
	        t = _.cookie.get(this.getCookieName());

	    null === t ? (sd.is_first_visitor = !0, this.set("distinct_id", e)) : (_.isJSONString(t) && JSON.parse(t).distinct_id || (sd.is_first_visitor = !0), this.toState(t)), saNewUser.setDeviceId(e), saNewUser.storeInitCheck(), saNewUser.checkIsFirstLatest();
	  }
	},
	    saNewUser = {
	  checkIsAddSign: function checkIsAddSign(e) {
	    "track" === e.type && (_.cookie.getNewUser() ? e.properties.$is_first_day = !0 : e.properties.$is_first_day = !1);
	  },
	  is_first_visit_time: !1,
	  checkIsFirstTime: function checkIsFirstTime(e) {
	    "track" === e.type && "$pageview" === e.event && (this.is_first_visit_time ? (e.properties.$is_first_time = !0, this.is_first_visit_time = !1) : e.properties.$is_first_time = !1);
	  },
	  setDeviceId: function setDeviceId(e) {
	    var t = null,
	        r = _.cookie.get("sensorsdata2015jssdkcross"),
	        s = {};

	    null != r && _.isJSONString(r) && (s = JSON.parse(r)).$device_id && (t = s.$device_id), t = t || e, !0 === sd.para.cross_subdomain ? store.set("$device_id", t) : (s.$device_id = t, _.cookie.set("sensorsdata2015jssdkcross", JSON.stringify(s), null, !0)), sd.para.is_track_device_id && (_.info.currentProps.$device_id = t);
	  },
	  storeInitCheck: function storeInitCheck() {
	    if (sd.is_first_visitor) {
	      var e = new Date(),
	          t = {
	        h: 23 - e.getHours(),
	        m: 59 - e.getMinutes(),
	        s: 59 - e.getSeconds()
	      };
	      _.cookie.set(_.cookie.getCookieName("new_user"), "1", 3600 * t.h + 60 * t.m + t.s + "s"), this.is_first_visit_time = !0;
	    } else _.cookie.getNewUser() || (this.checkIsAddSign = function (e) {
	      "track" === e.type && (e.properties.$is_first_day = !1);
	    }), this.checkIsFirstTime = function (e) {
	      "track" === e.type && "$pageview" === e.event && (e.properties.$is_first_time = !1);
	    };
	  },
	  checkIsFirstLatest: function checkIsFirstLatest() {
	    for (var e = _.info.pageProp.url_domain, t = ["$utm_source", "$utm_medium", "$utm_campaign", "$utm_content", "$utm_term"], r = store.getProps(), s = 0; s < t.length; s++) {
	      t[s] in r && delete r[t[s]];
	    }

	    store.setProps(r, !0);
	    var a = {};

	    if ("" === e && (e = "url\u89E3\u6790\u5931\u8D25"), _.each(sd.para.preset_properties, function (t, r) {
	      if (-1 === r.indexOf("latest_")) return !1;

	      if (r = r.slice(7), t) {
	        if ("utm" !== r && "url\u89E3\u6790\u5931\u8D25" === e) a["$latest_" + r] = "url\u7684domain\u89E3\u6790\u5931\u8D25";else if (_.isReferralTraffic(document.referrer)) switch (r) {
	          case "traffic_source_type":
	            a.$latest_traffic_source_type = _.getSourceFromReferrer();
	            break;

	          case "referrer":
	            a.$latest_referrer = _.info.pageProp.referrer;
	            break;

	          case "search_keyword":
	            a.$latest_search_keyword = _.getKeywordFromReferrer();
	            break;

	          case "landing_page":
	            a.$latest_landing_page = location.href;
	        }
	      } else if ("utm" === r && sd.store._state.props) for (var s in sd.store._state.props) {
	        0 !== s.indexOf("$latest_utm") && 0 !== s.indexOf("_latest_") || delete sd.store._state.props[s];
	      } else sd.store._state.props && "$latest_" + r in sd.store._state.props && delete sd.store._state.props["$latest_" + r];
	    }), sd.register(a), sd.para.preset_properties.latest_utm) {
	      var n = _.info.campaignParamsStandard("$latest_", "_latest_"),
	          i = n.$utms,
	          o = n.otherUtms;

	      _.isEmptyObject(i) || sd.register(i), _.isEmptyObject(o) || sd.register(o);
	    }
	  }
	};
	sd.bridge = {
	  is_verify_success: !1,
	  initPara: function initPara() {
	    var e = {
	      is_send: !0,
	      white_list: [],
	      is_mui: !1
	    };
	    "object" == _typeof_1(sd.para.app_js_bridge) ? sd.para.app_js_bridge = _.extend({}, e, sd.para.app_js_bridge) : !0 === sd.para.use_app_track || !0 === sd.para.app_js_bridge || "only" === sd.para.use_app_track ? (!1 !== sd.para.use_app_track_is_send && "only" !== sd.para.use_app_track || (e.is_send = !1), sd.para.app_js_bridge = _.extend({}, e)) : "mui" === sd.para.use_app_track && (e.is_mui = !0, sd.para.app_js_bridge = _.extend({}, e)), !1 === sd.para.app_js_bridge.is_send && sd.log("\u8BBE\u7F6E\u4E86 is_send:false,\u5982\u679C\u6253\u901A\u5931\u8D25\uFF0C\u6570\u636E\u5C06\u88AB\u4E22\u5F03\uFF01");
	  },
	  initState: function initState() {
	    function e(e) {
	      function t(e) {
	        var t = {
	          hostname: "",
	          project: ""
	        };

	        try {
	          t.hostname = _.URL(e).hostname, t.project = _.URL(e).searchParams.get("project") || "default";
	        } catch (e) {
	          sd.log(e);
	        }

	        return t;
	      }

	      var r = t(e),
	          s = t(sd.para.server_url);
	      if (r.hostname === s.hostname && r.project === s.project) return !0;
	      if (sd.para.app_js_bridge.white_list.length > 0) for (var a = 0; a < sd.para.app_js_bridge.white_list.length; a++) {
	        var n = t(sd.para.app_js_bridge.white_list[a]);
	        if (n.hostname === r.hostname && n.project === r.project) return !0;
	      }
	      return !1;
	    }

	    if (_.isObject(sd.para.app_js_bridge) && !sd.para.app_js_bridge.is_mui) if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.sensorsdataNativeTracker && _.isObject(window.SensorsData_iOS_JS_Bridge) && window.SensorsData_iOS_JS_Bridge.sensorsdata_app_server_url) e(window.SensorsData_iOS_JS_Bridge.sensorsdata_app_server_url) && (sd.bridge.is_verify_success = !0);else if (_.isObject(window.SensorsData_APP_New_H5_Bridge) && window.SensorsData_APP_New_H5_Bridge.sensorsdata_get_server_url && window.SensorsData_APP_New_H5_Bridge.sensorsdata_track) {
	      var t = window.SensorsData_APP_New_H5_Bridge.sensorsdata_get_server_url();
	      t && e(t) && (sd.bridge.is_verify_success = !0);
	    }
	  },
	  initDefineBridgeInfo: function initDefineBridgeInfo() {
	    var e = {
	      touch_app_bridge: !0,
	      verify_success: !1
	    };
	    return window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.sensorsdataNativeTracker && window.webkit.messageHandlers.sensorsdataNativeTracker.postMessage && _.isObject(window.SensorsData_iOS_JS_Bridge) && window.SensorsData_iOS_JS_Bridge.sensorsdata_app_server_url ? sd.bridge.is_verify_success ? e.verify_success = "success" : e.verify_success = "fail" : _.isObject(window.SensorsData_APP_New_H5_Bridge) && window.SensorsData_APP_New_H5_Bridge.sensorsdata_get_server_url && window.SensorsData_APP_New_H5_Bridge.sensorsdata_track ? sd.bridge.is_verify_success ? e.verify_success = "success" : e.verify_success = "fail" : "object" == (typeof SensorsData_APP_JS_Bridge === "undefined" ? "undefined" : _typeof_1(SensorsData_APP_JS_Bridge)) && (SensorsData_APP_JS_Bridge.sensorsdata_verify && SensorsData_APP_JS_Bridge.sensorsdata_visual_verify || SensorsData_APP_JS_Bridge.sensorsdata_track) ? SensorsData_APP_JS_Bridge.sensorsdata_verify && SensorsData_APP_JS_Bridge.sensorsdata_visual_verify ? SensorsData_APP_JS_Bridge.sensorsdata_visual_verify(JSON.stringify({
	      server_url: sd.para.server_url
	    })) ? e.verify_success = "success" : e.verify_success = "fail" : e.verify_success = "success" : !/sensors-verify/.test(navigator.userAgent) && !/sa-sdk-ios/.test(navigator.userAgent) || window.MSStream ? e.touch_app_bridge = !1 : sd.bridge.iOS_UA_bridge() ? e.verify_success = "success" : e.verify_success = "fail", e;
	  },
	  iOS_UA_bridge: function iOS_UA_bridge() {
	    if (/sensors-verify/.test(navigator.userAgent)) {
	      var e = navigator.userAgent.match(/sensors-verify\/([^\s]+)/);

	      if (e && e[0] && "string" == typeof e[1] && 2 === e[1].split("?").length) {
	        e = e[1].split("?");
	        var t = null,
	            r = null;

	        try {
	          t = _.URL(sd.para.server_url).hostname, r = _.URL(sd.para.server_url).searchParams.get("project") || "default";
	        } catch (e) {
	          sd.log(e);
	        }

	        return !(!t || t !== e[0] || !r || r !== e[1]);
	      }

	      return !1;
	    }

	    return !!/sa-sdk-ios/.test(navigator.userAgent);
	  },
	  dataSend: function dataSend(e, t, r) {
	    if (_.isObject(sd.para.app_js_bridge) && !sd.para.app_js_bridge.is_mui) {
	      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.sensorsdataNativeTracker && window.webkit.messageHandlers.sensorsdataNativeTracker.postMessage && _.isObject(window.SensorsData_iOS_JS_Bridge) && window.SensorsData_iOS_JS_Bridge.sensorsdata_app_server_url) sd.bridge.is_verify_success ? (window.webkit.messageHandlers.sensorsdataNativeTracker.postMessage(JSON.stringify({
	        callType: "app_h5_track",
	        data: _.extend({
	          server_url: sd.para.server_url
	        }, e)
	      })), "function" == typeof r && r()) : sd.para.app_js_bridge.is_send ? (sd.debug.apph5({
	        data: e,
	        step: "4.1",
	        output: "all"
	      }), t.prepareServerUrl()) : "function" == typeof r && r();else if (_.isObject(window.SensorsData_APP_New_H5_Bridge) && window.SensorsData_APP_New_H5_Bridge.sensorsdata_get_server_url && window.SensorsData_APP_New_H5_Bridge.sensorsdata_track) sd.bridge.is_verify_success ? (SensorsData_APP_New_H5_Bridge.sensorsdata_track(JSON.stringify(_.extend({
	        server_url: sd.para.server_url
	      }, e))), "function" == typeof r && r()) : sd.para.app_js_bridge.is_send ? (sd.debug.apph5({
	        data: e,
	        step: "4.2",
	        output: "all"
	      }), t.prepareServerUrl()) : "function" == typeof r && r();else if ("object" == (typeof SensorsData_APP_JS_Bridge === "undefined" ? "undefined" : _typeof_1(SensorsData_APP_JS_Bridge)) && (SensorsData_APP_JS_Bridge.sensorsdata_verify || SensorsData_APP_JS_Bridge.sensorsdata_track)) SensorsData_APP_JS_Bridge.sensorsdata_verify ? SensorsData_APP_JS_Bridge.sensorsdata_verify(JSON.stringify(_.extend({
	        server_url: sd.para.server_url
	      }, e))) ? "function" == typeof r && r() : sd.para.app_js_bridge.is_send ? (sd.debug.apph5({
	        data: e,
	        step: "3.1",
	        output: "all"
	      }), t.prepareServerUrl()) : "function" == typeof r && r() : (SensorsData_APP_JS_Bridge.sensorsdata_track(JSON.stringify(_.extend({
	        server_url: sd.para.server_url
	      }, e))), "function" == typeof r && r());else if (!/sensors-verify/.test(navigator.userAgent) && !/sa-sdk-ios/.test(navigator.userAgent) || window.MSStream) _.isObject(sd.para.app_js_bridge) && !0 === sd.para.app_js_bridge.is_send ? (sd.debug.apph5({
	        data: e,
	        step: "2",
	        output: "all"
	      }), t.prepareServerUrl()) : "function" == typeof r && r();else {
	        var s = null;
	        sd.bridge.iOS_UA_bridge() ? ((s = document.createElement("iframe")).setAttribute("src", "sensorsanalytics://trackEvent?event=" + encodeURIComponent(JSON.stringify(_.extend({
	          server_url: sd.para.server_url
	        }, e)))), document.documentElement.appendChild(s), s.parentNode.removeChild(s), s = null, "function" == typeof r && r()) : sd.para.app_js_bridge.is_send ? (sd.debug.apph5({
	          data: e,
	          step: "3.2",
	          output: "all"
	        }), t.prepareServerUrl()) : "function" == typeof r && r();
	      }
	    } else _.isObject(sd.para.app_js_bridge) && sd.para.app_js_bridge.is_mui ? _.isObject(window.plus) && window.plus.SDAnalytics && window.plus.SDAnalytics.trackH5Event ? (window.plus.SDAnalytics.trackH5Event(data), "function" == typeof r && r()) : _.isObject(sd.para.app_js_bridge) && !0 === sd.para.app_js_bridge.is_send ? t.prepareServerUrl() : "function" == typeof r && r() : (sd.debug.apph5({
	      data: e,
	      step: "1",
	      output: "code"
	    }), t.prepareServerUrl());
	  },
	  app_js_bridge_v1: function app_js_bridge_v1() {
	    var e = null,
	        t = null;
	    window.sensorsdata_app_js_bridge_call_js = function (r) {
	      !function (r) {
	        e = r, _.isJSONString(e) && (e = JSON.parse(e)), t && (t(e), t = null, e = null);
	      }(r);
	    }, sd.getAppStatus = function (r) {
	      if (function () {
	        if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
	          var e = document.createElement("iframe");
	          e.setAttribute("src", "sensorsanalytics://getAppInfo"), document.documentElement.appendChild(e), e.parentNode.removeChild(e), e = null;
	        }
	      }(), "object" == _typeof_1(window.SensorsData_APP_JS_Bridge) && window.SensorsData_APP_JS_Bridge.sensorsdata_call_app && (e = SensorsData_APP_JS_Bridge.sensorsdata_call_app(), _.isJSONString(e) && (e = JSON.parse(e))), !r) return e;
	      null === e ? t = r : (r(e), e = null);
	    };
	  }
	};
	var heatmap = sd.heatmap = {
	  setNotice: function setNotice(e) {
	    sd.is_heatmap_render_mode = !0, sd.para.heatmap || (sd.errorMsg = "\u60A8SDK\u6CA1\u6709\u914D\u7F6E\u5F00\u542F\u70B9\u51FB\u56FE\uFF0C\u53EF\u80FD\u6CA1\u6709\u6570\u636E\uFF01"), e && e[0] && e[1] && "http:" === e[1].slice(0, 5) && "https:" === location.protocol && (sd.errorMsg = "\u60A8\u7684\u5F53\u524D\u9875\u9762\u662Fhttps\u7684\u5730\u5740\uFF0C\u795E\u7B56\u5206\u6790\u73AF\u5883\u4E5F\u5FC5\u987B\u662Fhttps\uFF01"), sd.para.heatmap_url || (sd.para.heatmap_url = location.protocol + "//static.sensorsdata.cn/sdk/" + sd.lib_version + "/heatmap.min.js");
	  },
	  getDomIndex: function getDomIndex(e) {
	    if (!e.parentNode) return -1;

	    for (var t = 0, r = e.tagName, s = e.parentNode.children, a = 0; a < s.length; a++) {
	      if (s[a].tagName === r) {
	        if (e === s[a]) return t;
	        t++;
	      }
	    }

	    return -1;
	  },
	  selector: function selector(e) {
	    var t = e.parentNode && 9 == e.parentNode.nodeType ? -1 : this.getDomIndex(e);
	    return e.getAttribute && e.getAttribute("id") && (!sd.para.heatmap || sd.para.heatmap && "not_use_id" !== sd.para.heatmap.element_selector) ? "#" + e.getAttribute("id") : e.tagName.toLowerCase() + (~t ? ":nth-of-type(" + (t + 1) + ")" : "");
	  },
	  getDomSelector: function getDomSelector(e, t) {
	    if (!e || !e.parentNode || !e.parentNode.children) return !1;
	    t = t && t.join ? t : [];
	    var r = e.nodeName.toLowerCase();
	    return e && "body" !== r && 1 == e.nodeType ? (t.unshift(this.selector(e)), e.getAttribute && e.getAttribute("id") && sd.para.heatmap && "not_use_id" !== sd.para.heatmap.element_selector ? t.join(" > ") : this.getDomSelector(e.parentNode, t)) : (t.unshift("body"), t.join(" > "));
	  },
	  na: function na() {
	    var e = document.documentElement.scrollLeft || window.pageXOffset;
	    return parseInt(isNaN(e) ? 0 : e, 10);
	  },
	  i: function i() {
	    var e = 0;

	    try {
	      e = o.documentElement && o.documentElement.scrollTop || m.pageYOffset, e = isNaN(e) ? 0 : e;
	    } catch (t) {
	      e = 0;
	    }

	    return parseInt(e, 10);
	  },
	  getBrowserWidth: function getBrowserWidth() {
	    var e = window.innerWidth || document.body.clientWidth;
	    return isNaN(e) ? 0 : parseInt(e, 10);
	  },
	  getBrowserHeight: function getBrowserHeight() {
	    var e = window.innerHeight || document.body.clientHeight;
	    return isNaN(e) ? 0 : parseInt(e, 10);
	  },
	  getScrollWidth: function getScrollWidth() {
	    var e = parseInt(document.body.scrollWidth, 10);
	    return isNaN(e) ? 0 : e;
	  },
	  W: function W(e) {
	    var t = parseInt(+e.clientX + +this.na(), 10);
	    e = parseInt(+e.clientY + +this.i(), 10);
	    return {
	      x: isNaN(t) ? 0 : t,
	      y: isNaN(e) ? 0 : e
	    };
	  },
	  start: function start(e, t, r, s, a) {
	    var n = _.isObject(s) ? s : {},
	        i = _.isFunction(a) ? a : _.isFunction(s) ? s : void 0;
	    if (sd.para.heatmap && sd.para.heatmap.collect_element && !sd.para.heatmap.collect_element(t)) return !1;

	    var o = this.getDomSelector(t),
	        d = _.getEleInfo({
	      target: t
	    });

	    if (d.$element_selector = o || "", sd.para.heatmap && sd.para.heatmap.custom_property) {
	      var c = sd.para.heatmap.custom_property(t);
	      _.isObject(c) && (d = _.extend(d, c));
	    }

	    d = _.extend(d, n), "a" === r && sd.para.heatmap && !0 === sd.para.heatmap.isTrackLink ? _.trackLink({
	      event: e,
	      target: t
	    }, "$WebClick", d) : sd.track("$WebClick", d, i);
	  },
	  hasElement: function hasElement(e) {
	    var t = e._getPath();

	    if (_.isArray(t) && t.length > 0) for (var r = 0; r < t.length; r++) {
	      if (t[r] && t[r].tagName && "a" === t[r].tagName.toLowerCase()) return t[r];
	    }
	    return !1;
	  },
	  initScrollmap: function initScrollmap() {
	    if (!_.isObject(sd.para.heatmap) || "default" !== sd.para.heatmap.scroll_notice_map) return !1;

	    var e = function e() {
	      return !(sd.para.scrollmap && _.isFunction(sd.para.scrollmap.collect_url) && !sd.para.scrollmap.collect_url());
	    },
	        t = function (e) {
	      var t = {};
	      return t.timeout = e.timeout || 1e3, t.func = e.func, t.hasInit = !1, t.inter = null, t.main = function (e, t) {
	        this.func(e, t), this.inter = null;
	      }, t.go = function (e) {
	        var r = {};
	        this.inter || (r.$viewport_position = document.documentElement && document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop || 0, r.$viewport_position = Math.round(r.$viewport_position) || 0, r.$viewport_height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 0, r.$viewport_width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth || 0, e ? t.main(r, !0) : this.inter = setTimeout(function () {
	          t.main(r);
	        }, this.timeout));
	      }, t;
	    }({
	      timeout: 1e3,
	      func: function func(e, t) {
	        var r = document.documentElement && document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop || 0,
	            s = new Date(),
	            a = s - this.current_time;
	        (a > sd.para.heatmap.scroll_delay_time && r - e.$viewport_position != 0 || t) && (e.$url = location.href, e.$title = document.title, e.$url_path = location.pathname, e.event_duration = Math.min(sd.para.heatmap.scroll_event_duration, parseInt(a) / 1e3), sd.track("$WebStay", e)), this.current_time = s;
	      }
	    });

	    t.current_time = new Date(), _.addEvent(window, "scroll", function () {
	      if (!e()) return !1;
	      t.go();
	    }), _.addEvent(window, "unload", function () {
	      if (!e()) return !1;
	      t.go("notime");
	    });
	  },
	  initHeatmap: function initHeatmap() {
	    var e = this;
	    return !(!_.isObject(sd.para.heatmap) || "default" !== sd.para.heatmap.clickmap) && !(_.isFunction(sd.para.heatmap.collect_url) && !sd.para.heatmap.collect_url()) && ("all" === sd.para.heatmap.collect_elements ? sd.para.heatmap.collect_elements = "all" : sd.para.heatmap.collect_elements = "interact", void ("all" === sd.para.heatmap.collect_elements ? _.addEvent(document, "click", function (t) {
	      var r = t || window.event;
	      if (!r) return !1;
	      var s = r.target || r.srcElement;
	      if ("object" != _typeof_1(s)) return !1;
	      if ("string" != typeof s.tagName) return !1;
	      var a = s.tagName.toLowerCase();
	      if ("body" === a || "html" === a) return !1;
	      if (!s || !s.parentNode || !s.parentNode.children) return !1;
	      var n = s.parentNode.tagName.toLowerCase();
	      "a" === n || "button" === n ? e.start(r, s.parentNode, n) : e.start(r, s, a);
	    }) : _.addEvent(document, "click", function (t) {
	      var r = t || window.event;
	      if (!r) return !1;
	      var s = r.target || r.srcElement;
	      if ("object" != _typeof_1(s)) return !1;
	      if ("string" != typeof s.tagName) return !1;
	      var a = s.tagName.toLowerCase();
	      if ("body" === a.toLowerCase() || "html" === a.toLowerCase()) return !1;
	      if (!s || !s.parentNode || !s.parentNode.children) return !1;
	      var n = s.parentNode;
	      if ("a" === a || "button" === a || "input" === a || "textarea" === a || _.hasAttribute(s, "data-sensors-click")) e.start(r, s, a);else if ("button" === n.tagName.toLowerCase() || "a" === n.tagName.toLowerCase()) e.start(r, n, s.parentNode.tagName.toLowerCase());else if ("area" === a && "map" === n.tagName.toLowerCase() && _.ry(n).prev().tagName && "img" === _.ry(n).prev().tagName.toLowerCase()) e.start(r, _.ry(n).prev(), _.ry(n).prev().tagName.toLowerCase());else {
	        var i = e.hasElement(t);
	        i && e.start(r, i, i.tagName.toLowerCase());
	      }
	    })));
	  }
	};

	sd.init = function (e) {
	  if (sd.readyState && sd.readyState.state && sd.readyState.state >= 2) return !1;
	  sd.setInitVar(), sd.readyState.setState(2), sd.initPara(e), sd.detectMode();
	};

	var methods = ["track", "quick", "register", "registerPage", "registerOnce", "trackSignup", "setProfile", "setOnceProfile", "appendProfile", "incrementProfile", "deleteProfile", "unsetProfile", "identify", "login", "logout", "trackLink", "clearAllRegister"];
	_.each(methods, function (e) {
	  var t = sd[e];

	  sd[e] = function () {
	    if (sd.readyState.state < 3) return _.isArray(sd._q) || (sd._q = []), sd._q.push([e, arguments]), !1;
	    if (sd.readyState.getState()) return t.apply(sd, arguments);
	  };
	}), "string" == typeof window.sensorsDataAnalytic201505 ? (sd.setPreConfig(window[sensorsDataAnalytic201505]), window[sensorsDataAnalytic201505] = sd, window.sensorsDataAnalytic201505 = sd, sd.init()) : void 0 === window.sensorsDataAnalytic201505 ? window.sensorsDataAnalytic201505 = sd : sd = window.sensorsDataAnalytic201505;
	var sd$1 = sd;

	var APP_BASE_INFO_SCHEMA = 'iglu:com.xhqb/app_base_info/jsonschema/2-0-0';
	var PAGE_ENTER_SCHEMA = 'iglu:com.xhqb/page_enter/jsonschema/2-0-0';
	var PAGE_LEAVE_SCHEMA = 'iglu:com.xhqb/page_leave/jsonschema/2-0-0';
	var CLICK_SCHEMA = 'iglu:com.xhqb/click/jsonschema/2-0-0';
	var LOG_SCHEMA = 'iglu:com.xhqb/log/jsonschema/2-0-0';
	var INPUT_SCHEMA = 'iglu:com.xhqb/input/jsonschema/2-0-0';
	var MODAL_SCHEMA = 'iglu:com.xhqb/modal/jsonschema/2-0-0';
	var TOAST_SCHEMA = 'iglu:com.xhqb/toast/jsonschema/2-0-0';
	var SHARE_SCHEMA = 'iglu:com.xhqb/share/jsonschema/2-0-0';
	var SEARCH_SCHEMA = 'iglu:com.xhqb/search/jsonschema/2-0-0';
	var FETCH_SCHEMA = 'iglu:com.xhqb/fetch/jsonschema/2-0-0';
	var ERROR_SCHEMA = 'iglu:com.xhqb/error/jsonschema/2-0-0';

	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	var uuidv4 = uuid_1.v4; // 事件和schema的映射

	var schema = {
	  page_enter: PAGE_ENTER_SCHEMA,
	  page_leave: PAGE_LEAVE_SCHEMA,
	  click: CLICK_SCHEMA,
	  log: LOG_SCHEMA,
	  input: INPUT_SCHEMA,
	  modal: MODAL_SCHEMA,
	  toast: TOAST_SCHEMA,
	  share: SHARE_SCHEMA,
	  search: SEARCH_SCHEMA,
	  fetch: FETCH_SCHEMA,
	  error: ERROR_SCHEMA
	};

	var XhAnalysis =
	/*#__PURE__*/
	function () {
	  function XhAnalysis(config) {
	    classCallCheck(this, XhAnalysis);

	    this._hmt = window._hmt = this._hmt || []; // 配置

	    this.config = Object.assign({}, {
	      appId: 'h5.xhqb.com',
	      platform: 'web',
	      post: true,
	      cookieName: '_xh_',
	      pageUnloadTimer: 500,
	      encodeBase64: true,
	      api: '//test.xiaohuaai.com/sp',
	      env: 'production',
	      contexts: {
	        webPage: true,
	        performanceTiming: true
	      },
	      snowplow: false,
	      // 是否发送snowplow埋点
	      exclude: []
	    }, config);
	    if (this.config.snowplow) this.q = new Snowplow(this.q || [], 'xhTracker'); // 路由时间记录

	    this._router = {}; // 当前路由url记录

	    this._currentRoute = '';
	    this.init();
	  }

	  createClass(XhAnalysis, [{
	    key: "init",
	    value: function init() {
	      if (this.config.snowplow) this.q.push(['newTracker', 'xhqb', this.config.api, this.config]);

	      this._hmt.push(['_setAccount', 'b5fd34049c03e83048124740e1a9f7f9']);

	      this._bdtrack();

	      this._sdInit();

	      this._createTraceID();

	      this._errorInterceptor();

	      this._fetchInterceptor();

	      if (this.config.snowplow) this.bindEvents();
	    }
	  }, {
	    key: "_sdInit",
	    value: function _sdInit() {
	      var host = splitHost(location.host);
	      sd$1.init({
	        heatmap: {
	          clickmap: 'default',
	          scroll_notice_map: 'default'
	        },
	        server_url: ['production', 'uat'].includes(this.config.env) ? 'https://sp.' + host + '/sa?project=production' : 'https://sp.xiaohuaai.com/sa',
	        app_js_bridge: true,
	        show_log: false,
	        send_type: 'beacon'
	      });
	      sd$1.quick('autoTrack');
	    }
	  }, {
	    key: "_bdtrack",
	    value: function _bdtrack() {
	      var hm = document.createElement('script');
	      hm.src = 'https://hm.baidu.com/hm.js?b5fd34049c03e83048124740e1a9f7f9';
	      var s = document.getElementsByTagName('script')[0];
	      s.parentNode.insertBefore(hm, s);
	    }
	  }, {
	    key: "bindEvents",
	    value: function bindEvents() {
	      var _this2 = this;

	      ['setUserId', 'setCustomUrl', 'setReferrerUrl', 'setDocumentTitle'].forEach(function (method) {
	        _this2[method] = function (params) {
	          _this2.q.push([method, params]);
	        };
	      });
	    }
	  }, {
	    key: "_createTraceID",
	    value: function _createTraceID() {
	      this._traceID = sessionStorage.getItem('_xha_trace_id') || uuidv4();
	      sessionStorage.setItem('_xha_trace_id', this._traceID);
	    }
	  }, {
	    key: "_errorInterceptor",
	    value: function _errorInterceptor() {
	      var _this3 = this;

	      window.addEventListener('error', function (e) {
	        var data = JSON.stringify({
	          colno: e.colno,
	          lineno: e.lineno,
	          filename: e.filename,
	          message: e.message,
	          name: e.error && e.error.name || '',
	          stack: e.error && e.error.stack || ''
	        });

	        _this3.trackError({
	          business: '',
	          code: 9900001,
	          name: '系统错误',
	          description: "\u6355\u83B7".concat(e.error && e.error.name || '', "\u9519\u8BEF"),
	          type: 'runtime_error',
	          data: data
	        });
	      }, true);
	      window.addEventListener('unhandledrejection', function (e) {
	        var data = JSON.stringify({
	          reason: e.reason,
	          promise: e.promise
	        });

	        _this3.trackError({
	          business: '',
	          code: 9900001,
	          name: '未处理的 Promise 错误',
	          description: '捕获未处理的 Promise 错误',
	          type: 'unhandledrejection_error',
	          data: data
	        });
	      });
	    }
	  }, {
	    key: "_fetchInterceptor",
	    value: function _fetchInterceptor() {
	      var _this = this;

	      var nativeXhrOpen = XMLHttpRequest.prototype.open;
	      var nativeXhrSend = XMLHttpRequest.prototype.send;
	      var nativeAbort = XMLHttpRequest.prototype.abort;

	      XMLHttpRequest.prototype.open = function (method, url) {
	        this._url = url;
	        this._timestamp = Date.now();

	        for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	          args[_key - 2] = arguments[_key];
	        }

	        return nativeXhrOpen.apply(this, [method, url].concat(args));
	      };

	      XMLHttpRequest.prototype.send = function (payload) {
	        var originOnreadystatechange = this.onreadystatechange;
	        this.addEventListener('readystatechange', function () {
	          var _this4 = this;

	          if (this.readyState === 4 && !this._url.includes(_this.config.api) && !_this.config.exclude.find(function (excludeUrl) {
	            return _this4._url.includes(excludeUrl);
	          })) {
	            var result = {
	              status: this.status,
	              message: '接口请求成功',
	              url: this._url,
	              time: Date.now() - this._timestamp
	            };

	            if (this.status === 0) {
	              result.message = '接口取消请求';
	            } else if (this.status !== 200 && this.status !== 304) {
	              result.message = "\u63A5\u53E3\u5F02\u5E38\uFF1A".concat(this.statusText);
	            } // _this.log('fetch', {
	            //   id: 'fetch_status',
	            //   name: '接口请求',
	            //   description: `${this._url}接口请求状态`,
	            //   data: result
	            // })


	            _this.trackFetch(_objectSpread({
	              business: '',
	              code: 9900002,
	              name: '接口请求',
	              description: "".concat(this._url, "\u63A5\u53E3\u8BF7\u6C42\u72B6\u6001")
	            }, result));
	          }

	          originOnreadystatechange && originOnreadystatechange.apply(this, arguments);
	        });
	        return nativeXhrSend.call(this, payload);
	      };

	      XMLHttpRequest.prototype.abort = function () {
	        nativeAbort.apply(this);
	        this._isAbort = true;
	      };
	    }
	  }, {
	    key: "_getCustomContext",
	    value: function _getCustomContext() {
	      var customContexts = [];
	      customContexts.push({
	        schema: APP_BASE_INFO_SCHEMA,
	        data: {
	          appversion: this._appVersion || '',
	          fingerprint: this._fingerprint || localStorage.getItem('_xha_fingerprint') || '',
	          deviceid: ''
	        }
	      });
	      return customContexts;
	    }
	  }, {
	    key: "_trackUnstructEvent",
	    value: function _trackUnstructEvent(schema) {
	      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	      var customContexts = this._getCustomContext();

	      this.q.push(['trackUnstructEvent', {
	        schema: schema,
	        data: data
	      }, customContexts]);
	    }
	  }, {
	    key: "setFingerPrint",
	    value: function setFingerPrint(fp) {
	      this._fingerprint = fp;
	      localStorage.setItem('_xha_fingerprint', fp);
	    }
	  }, {
	    key: "setAppInfo",
	    value: function setAppInfo(_ref) {
	      var name = _ref.name,
	          version = _ref.version;
	      this._appName = name;
	      this._appVersion = version;
	    }
	  }, {
	    key: "track",
	    value: function track(eventName, data) {
	      if (this.config.snowplow) {
	        // snowplow 为 true 才上报埋点
	        this._trackUnstructEvent(schema[eventName], _objectSpread({
	          trace_id: this._traceID
	        }, data));
	      } // 神策代码埋点追踪事件


	      sd$1.track(eventName, data);
	    }
	  }, {
	    key: "trackPageEnter",
	    value: function trackPageEnter(data) {
	      this._currentRoute = location.href;

	      if (!this._router[this._currentRoute]) {
	        this._router[this._currentRoute] = [];
	      }

	      this._router[this._currentRoute][0] = Date.now();
	      this.track('page_enter', _objectSpread({
	        name: '页面访问',
	        xtm_from: getUrlSearchParam('xtm_from') || ''
	      }, data));
	    }
	  }, {
	    key: "trackPageLeave",
	    value: function trackPageLeave(data) {
	      if (!this._router[this._currentRoute]) {
	        this._router[this._currentRoute] = [];
	      }

	      var currentRouter = this._router[this._currentRoute];
	      currentRouter[1] = Date.now();
	      this._router[this._currentRoute] = null;
	      this._currentRoute = null;
	      this.track('page_leave', _objectSpread({
	        name: '页面离开',
	        time: currentRouter[1] - currentRouter[0]
	      }, data));
	    }
	  }, {
	    key: "trackClick",
	    value: function trackClick(data) {
	      this.track('click', data);
	    }
	  }, {
	    key: "trackInput",
	    value: function trackInput(data) {
	      this.track('input', data);
	    }
	  }, {
	    key: "trackModal",
	    value: function trackModal(data) {
	      this.track('modal', _objectSpread({
	        name: '弹框',
	        description: '弹出弹框'
	      }, data));
	    }
	  }, {
	    key: "trackToast",
	    value: function trackToast(data) {
	      this.track('toast', _objectSpread({
	        name: '消息提示',
	        description: '消息提示'
	      }, data));
	    }
	  }, {
	    key: "trackShare",
	    value: function trackShare(data) {
	      this.track('share', data);
	    }
	  }, {
	    key: "trackSearch",
	    value: function trackSearch(data) {
	      this.track('search', data);
	    }
	  }, {
	    key: "trackPageView",
	    value: function trackPageView() {
	      var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.title;
	      this.q.push(['trackPageView', title]);
	    }
	  }, {
	    key: "trackFetch",
	    value: function trackFetch(data) {
	      this.track('fetch', data);
	    }
	  }, {
	    key: "trackError",
	    value: function trackError(data) {
	      this.track('error', data);
	    }
	    /**
	     * 触发自定义事件
	     * @param {string} eventName 自定义事件英文名
	     * @param {object} data 事件属性
	     */

	  }, {
	    key: "trackEvent",
	    value: function trackEvent(eventName, data) {
	      this.track(eventName, data);
	    }
	  }, {
	    key: "log",
	    value: function log(type, data) {
	      this.track('log', _objectSpread({
	        type: type
	      }, data));
	    }
	  }, {
	    key: "sdLogin",
	    value: function sdLogin(userId) {
	      sd$1.login(userId);
	    }
	  }, {
	    key: "sdRegisterPage",
	    value: function sdRegisterPage(data) {
	      var parm = Object.assign({}, {
	        platform_type: 'web'
	      }, data);
	      sd$1.registerPage(parm);
	    } // 设置用户属性

	  }, {
	    key: "sdSetProfile",
	    value: function sdSetProfile(data) {
	      sd$1.setProfile(data);
	    }
	  }]);

	  return XhAnalysis;
	}();

	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;

	// length should be 1, old FF problem
	_export(_export.S + _export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (_toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});

	_export(_export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = _toIobject(callSite.raw);
	    var len = _toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});

	// 21.1.3.25 String.prototype.trim()
	_stringTrim('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});

	var $at = _stringAt(true);

	// 21.1.3.27 String.prototype[@@iterator]()
	_iterDefine(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});

	var $at$1 = _stringAt(false);
	_export(_export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at$1(this, pos);
	  }
	});

	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];

	_export(_export.P + _export.F * _failsIsRegexp(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = _stringContext(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = _toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(_toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});

	var _stringRepeat = function repeat(count) {
	  var str = String(_defined(this));
	  var res = '';
	  var n = _toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};

	_export(_export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: _stringRepeat
	});

	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];

	_export(_export.P + _export.F * _failsIsRegexp(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = _stringContext(this, searchString, STARTS_WITH);
	    var index = _toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});

	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(_defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	var _stringHtml = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  _export(_export.P + _export.F * _fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};

	// B.2.3.2 String.prototype.anchor(name)
	_stringHtml('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});

	// B.2.3.3 String.prototype.big()
	_stringHtml('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});

	// B.2.3.4 String.prototype.blink()
	_stringHtml('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});

	// B.2.3.5 String.prototype.bold()
	_stringHtml('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});

	// B.2.3.6 String.prototype.fixed()
	_stringHtml('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});

	// B.2.3.7 String.prototype.fontcolor(color)
	_stringHtml('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});

	// B.2.3.8 String.prototype.fontsize(size)
	_stringHtml('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});

	// B.2.3.9 String.prototype.italics()
	_stringHtml('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});

	// B.2.3.10 String.prototype.link(url)
	_stringHtml('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});

	// B.2.3.11 String.prototype.small()
	_stringHtml('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});

	// B.2.3.12 String.prototype.strike()
	_stringHtml('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});

	// B.2.3.13 String.prototype.sub()
	_stringHtml('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});

	// B.2.3.14 String.prototype.sup()
	_stringHtml('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});

	var string = _core.String;

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	_export(_export.S, 'Object', { create: _objectCreate });

	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	_export(_export.S + _export.F * !_descriptors, 'Object', { defineProperty: _objectDp.f });

	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	_export(_export.S + _export.F * !_descriptors, 'Object', { defineProperties: _objectDps });

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)

	var $getOwnPropertyDescriptor$1 = _objectGopd.f;

	_objectSap('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor$1(_toIobject(it), key);
	  };
	});

	// 19.1.2.9 Object.getPrototypeOf(O)



	_objectSap('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return _objectGpo(_toObject(it));
	  };
	});

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	_objectSap('getOwnPropertyNames', function () {
	  return _objectGopnExt.f;
	});

	// 19.1.2.5 Object.freeze(O)

	var meta = _meta.onFreeze;

	_objectSap('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && _isObject(it) ? $freeze(meta(it)) : it;
	  };
	});

	// 19.1.2.17 Object.seal(O)

	var meta$1 = _meta.onFreeze;

	_objectSap('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && _isObject(it) ? $seal(meta$1(it)) : it;
	  };
	});

	// 19.1.2.15 Object.preventExtensions(O)

	var meta$2 = _meta.onFreeze;

	_objectSap('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && _isObject(it) ? $preventExtensions(meta$2(it)) : it;
	  };
	});

	// 19.1.2.12 Object.isFrozen(O)


	_objectSap('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return _isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});

	// 19.1.2.13 Object.isSealed(O)


	_objectSap('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return _isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});

	// 19.1.2.11 Object.isExtensible(O)


	_objectSap('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return _isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});

	// 19.1.3.10 Object.is(value1, value2)

	_export(_export.S, 'Object', { is: _sameValue });

	// 19.1.3.19 Object.setPrototypeOf(O, proto)

	_export(_export.S, 'Object', { setPrototypeOf: _setProto.set });

	var object = _core.Object;

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)


	_export(_export.S, 'Array', { isArray: _isArray });

	// call something on iterator step with safe closing on error

	var _iterCall = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(_anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) _anObject(ret.call(iterator));
	    throw e;
	  }
	};

	// check on default Array iterator

	var ITERATOR$2 = _wks('iterator');
	var ArrayProto$1 = Array.prototype;

	var _isArrayIter = function (it) {
	  return it !== undefined && (_iterators.Array === it || ArrayProto$1[ITERATOR$2] === it);
	};

	var ITERATOR$3 = _wks('iterator');

	var core_getIteratorMethod = _core.getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR$3]
	    || it['@@iterator']
	    || _iterators[_classof(it)];
	};

	var ITERATOR$4 = _wks('iterator');
	var SAFE_CLOSING = false;

	try {
	  var riter = [7][ITERATOR$4]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }

	var _iterDetect = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR$4]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR$4] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};

	_export(_export.S + _export.F * !_iterDetect(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = _toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = core_getIteratorMethod(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = _ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && _isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        _createProperty(result, index, mapping ? _iterCall(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = _toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        _createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});

	// WebKit Array.of isn't generic
	_export(_export.S + _export.F * _fails(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) _createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});

	// 22.1.3.13 Array.prototype.join(separator)


	var arrayJoin = [].join;

	// fallback for not array-like strings
	_export(_export.P + _export.F * (_iobject != Object || !_strictMethod(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(_toIobject(this), separator === undefined ? ',' : separator);
	  }
	});

	var arraySlice = [].slice;

	// fallback for not array-like ES3 strings and DOM objects
	_export(_export.P + _export.F * _fails(function () {
	  if (_html) arraySlice.call(_html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = _toLength(this.length);
	    var klass = _cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = _toAbsoluteIndex(begin, len);
	    var upTo = _toAbsoluteIndex(end, len);
	    var size = _toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});

	var $forEach = _arrayMethods(0);
	var STRICT = _strictMethod([].forEach, true);

	_export(_export.P + _export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});

	var $map = _arrayMethods(1);

	_export(_export.P + _export.F * !_strictMethod([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});

	var $filter = _arrayMethods(2);

	_export(_export.P + _export.F * !_strictMethod([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});

	var $some = _arrayMethods(3);

	_export(_export.P + _export.F * !_strictMethod([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});

	var $every = _arrayMethods(4);

	_export(_export.P + _export.F * !_strictMethod([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});

	var _arrayReduce = function (that, callbackfn, aLen, memo, isRight) {
	  _aFunction(callbackfn);
	  var O = _toObject(that);
	  var self = _iobject(O);
	  var length = _toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};

	_export(_export.P + _export.F * !_strictMethod([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return _arrayReduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});

	_export(_export.P + _export.F * !_strictMethod([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return _arrayReduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});

	var $indexOf = _arrayIncludes(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

	_export(_export.P + _export.F * (NEGATIVE_ZERO || !_strictMethod($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});

	var $native$1 = [].lastIndexOf;
	var NEGATIVE_ZERO$1 = !!$native$1 && 1 / [1].lastIndexOf(1, -0) < 0;

	_export(_export.P + _export.F * (NEGATIVE_ZERO$1 || !_strictMethod($native$1)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO$1) return $native$1.apply(this, arguments) || 0;
	    var O = _toIobject(this);
	    var length = _toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, _toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});

	var _arrayCopyWithin = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = _toObject(this);
	  var len = _toLength(O.length);
	  var to = _toAbsoluteIndex(target, len);
	  var from = _toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : _toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)


	_export(_export.P, 'Array', { copyWithin: _arrayCopyWithin });

	_addToUnscopables('copyWithin');

	var _arrayFill = function fill(value /* , start = 0, end = @length */) {
	  var O = _toObject(this);
	  var length = _toLength(O.length);
	  var aLen = arguments.length;
	  var index = _toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : _toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)


	_export(_export.P, 'Array', { fill: _arrayFill });

	_addToUnscopables('fill');

	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)

	var $find$1 = _arrayMethods(6);
	var KEY$1 = 'findIndex';
	var forced$1 = true;
	// Shouldn't skip holes
	if (KEY$1 in []) Array(1)[KEY$1](function () { forced$1 = false; });
	_export(_export.P + _export.F * forced$1, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	_addToUnscopables(KEY$1);

	_setSpecies('Array');

	var array = _core.Array;

	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray




	var IS_CONCAT_SPREADABLE = _wks('isConcatSpreadable');

	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? _ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;

	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

	      spreadable = false;
	      if (_isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : _isArray(element);
	      }

	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, _toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }

	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}

	var _flattenIntoArray = flattenIntoArray;

	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap







	_export(_export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = _toObject(this);
	    var sourceLen, A;
	    _aFunction(callbackfn);
	    sourceLen = _toLength(O.length);
	    A = _arraySpeciesCreate(O, 0);
	    _flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});

	_addToUnscopables('flatMap');

	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten







	_export(_export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = _toObject(this);
	    var sourceLen = _toLength(O.length);
	    var A = _arraySpeciesCreate(O, 0);
	    _flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : _toInteger(depthArg));
	    return A;
	  }
	});

	_addToUnscopables('flatten');

	var array$1 = _core.Array;

	var instance = null;
	var xha = {
	  init: function init(config) {
	    if (!instance) {
	      instance = new XhAnalysis(config);
	      this.config = instance.config;
	      this.version = "2.1.1";
	    }
	  },
	  _check: function _check() {
	    if (!instance) {
	      return false;
	    }

	    return true;
	  },
	  setUserId: function setUserId(userId) {
	    this._check() && instance.setUserId(userId);
	  },
	  setCustomUrl: function setCustomUrl(url) {
	    this._check() && instance.setCustomUrl(url);
	  },
	  setReferrerUrl: function setReferrerUrl(url) {
	    this._check() && instance.setReferrerUrl(url);
	  },
	  setDocumentTitle: function setDocumentTitle(title) {
	    this._check() && instance.setDocumentTitle(title);
	  },
	  setFingerPrint: function setFingerPrint(fp) {
	    this._check() && instance.setFingerPrint(fp);
	  },
	  setAppInfo: function setAppInfo(appInfo) {
	    this._check() && instance.setAppInfo(appInfo);
	  },
	  trackPageEnter: function trackPageEnter(data) {
	    this._check() && instance.trackPageEnter(data);
	  },
	  trackPageLeave: function trackPageLeave(data) {
	    this._check() && instance.trackPageLeave(data);
	  },
	  trackClick: function trackClick(data) {
	    this._check() && instance.trackClick(data);
	  },
	  trackInput: function trackInput(data) {
	    this._check() && instance.trackInput(data);
	  },
	  trackModal: function trackModal(data) {
	    this._check() && instance.trackModal(data);
	  },
	  trackToast: function trackToast(data) {
	    this._check() && instance.trackToast(data);
	  },
	  trackShare: function trackShare(data) {
	    this._check() && instance.trackShare(data);
	  },
	  trackSearch: function trackSearch(data) {
	    this._check() && instance.trackSearch(data);
	  },
	  trackFetch: function trackFetch(data) {
	    this._check() && instance.trackFetch(data);
	  },
	  trackError: function trackError(data) {
	    this._check() && instance.trackError(data);
	  },
	  trackEvent: function trackEvent(eventName, data) {
	    this._check() && instance.trackEvent(eventName, data);
	  },
	  log: function log(type, data) {
	    this._check() && instance.log(type, data);
	  },
	  sdLogin: function sdLogin(userId) {
	    this._check() && instance.sdLogin(userId);
	  },
	  sdRegisterPage: function sdRegisterPage(data) {
	    this._check() && instance.sdRegisterPage(data);
	  },
	  sdSetProfile: function sdSetProfile(data) {
	    this._check() && instance.sdSetProfile(data);
	  }
	};

	return xha;

})));



//////////////////
// WEBPACK FOOTER
// ./~/@xhtech/xhanalysis-sdk/dist/xha-sdk.umd.js
// module id = 220
// module chunks = 3 4 17 18 26 31 39 41 43 44 46 48 62 64 78 79 82 87 143 154 164